import { jsx as c, Fragment as ae, jsxs as N } from "react/jsx-runtime";
import { ColorsEnum as le } from "@gojasper/brand-standards";
import { h as Ds, _ as pe, j as jn, k as on, A as U, C as V, b as x, u as h0, I as se, X as pn, i as v0, f as m0, a as $s, g as g0, e as nu, c as Ls, d as Fr, S as w0, E as C0, l as hn, m as vn, n as rc } from "./CheckCircle-e19fee39.mjs";
import * as a from "react";
import ne, { useRef as _e, useMemo as ie, useState as he, forwardRef as Ye, useEffect as Pe, useLayoutEffect as y0, createContext as ru, useContext as Is, useCallback as me, useReducer as E0, useImperativeHandle as ou, Fragment as b0 } from "react";
import * as st from "react-dom";
import iu, { createPortal as su } from "react-dom";
import F from "clsx";
import { noop as S0, isString as x0, uniqueId as at, isEmpty as R0, debounce as T0 } from "lodash-es";
function A0(e) {
  const { width: t } = Ds(), n = _e(null), r = ie(() => !e || !t || !n.current ? !1 : n.current.scrollWidth > n.current.clientWidth, [t, e]);
  return {
    truncateRef: n,
    showTooltip: r
  };
}
var Fs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Pn(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function N0(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function au(...e) {
  return (t) => e.forEach((n) => N0(n, t));
}
function Ws(...e) {
  return a.useCallback(au(...e), e);
}
function k0(e, t) {
  const n = a.createContext(t);
  function r(i) {
    const { children: s, ...l } = i, u = a.useMemo(() => l, Object.values(l));
    return /* @__PURE__ */ c(n.Provider, { value: u, children: s });
  }
  function o(i) {
    const s = a.useContext(n);
    if (s)
      return s;
    if (t !== void 0)
      return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [r, o];
}
function P0(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, M0(o, ...t)];
}
function M0(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var _0 = globalThis?.document ? a.useLayoutEffect : () => {
}, O0 = a["useId".toString()] || (() => {
}), D0 = 0;
function qo(e) {
  const [t, n] = a.useState(O0());
  return _0(() => {
    e || n((r) => r ?? String(D0++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function cu(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function $0({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = L0({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = cu(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function L0({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = cu(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
function Xo(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function I0(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function lu(...e) {
  return (t) => e.forEach((n) => I0(n, t));
}
function uu(...e) {
  return a.useCallback(lu(...e), e);
}
var du = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(W0);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(Ti, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(Ti, { ...r, ref: t, children: n });
});
du.displayName = "Slot";
var Ti = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = H0(n);
    return a.cloneElement(n, {
      ...B0(r, n.props),
      // @ts-ignore
      ref: t ? lu(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Ti.displayName = "SlotClone";
var F0 = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function W0(e) {
  return a.isValidElement(e) && e.type === F0;
}
function B0(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function H0(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var V0 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], fu = V0.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? du : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function U0(e, t) {
  e && st.flushSync(() => e.dispatchEvent(t));
}
function Bs(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function j0(e, t = globalThis?.document) {
  const n = Bs(e);
  a.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var G0 = "DismissableLayer", Ai = "dismissableLayer.update", z0 = "dismissableLayer.pointerDownOutside", K0 = "dismissableLayer.focusOutside", oc, pu = a.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), vt = a.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: l,
      ...u
    } = e, d = a.useContext(pu), [h, f] = a.useState(null), w = h?.ownerDocument ?? globalThis?.document, [, g] = a.useState({}), v = uu(t, (O) => f(O)), p = Array.from(d.layers), [m] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), C = p.indexOf(m), y = h ? p.indexOf(h) : -1, b = d.layersWithOutsidePointerEventsDisabled.size > 0, S = y >= C, E = q0((O) => {
      const $ = O.target, H = [...d.branches].some((j) => j.contains($));
      !S || H || (o?.(O), s?.(O), O.defaultPrevented || l?.());
    }, w), R = X0((O) => {
      const $ = O.target;
      [...d.branches].some((j) => j.contains($)) || (i?.(O), s?.(O), O.defaultPrevented || l?.());
    }, w);
    return j0((O) => {
      y === d.layers.size - 1 && (r?.(O), !O.defaultPrevented && l && (O.preventDefault(), l()));
    }, w), a.useEffect(() => {
      if (h)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (oc = w.body.style.pointerEvents, w.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(h)), d.layers.add(h), ic(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (w.body.style.pointerEvents = oc);
        };
    }, [h, w, n, d]), a.useEffect(() => () => {
      h && (d.layers.delete(h), d.layersWithOutsidePointerEventsDisabled.delete(h), ic());
    }, [h, d]), a.useEffect(() => {
      const O = () => g({});
      return document.addEventListener(Ai, O), () => document.removeEventListener(Ai, O);
    }, []), /* @__PURE__ */ c(
      fu.div,
      {
        ...u,
        ref: v,
        style: {
          pointerEvents: b ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Xo(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: Xo(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: Xo(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
vt.displayName = G0;
var Y0 = "DismissableLayerBranch", hu = a.forwardRef((e, t) => {
  const n = a.useContext(pu), r = a.useRef(null), o = uu(t, r);
  return a.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ c(fu.div, { ...e, ref: o });
});
hu.displayName = Y0;
function q0(e, t = globalThis?.document) {
  const n = Bs(e), r = a.useRef(!1), o = a.useRef(() => {
  });
  return a.useEffect(() => {
    const i = (l) => {
      if (l.target && !r.current) {
        let u = function() {
          vu(
            z0,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: l };
        l.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function X0(e, t = globalThis?.document) {
  const n = Bs(e), r = a.useRef(!1);
  return a.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && vu(K0, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function ic() {
  const e = new CustomEvent(Ai);
  document.dispatchEvent(e);
}
function vu(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? U0(o, i) : o.dispatchEvent(i);
}
var Z0 = vt, J0 = hu;
function Q0(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function mu(...e) {
  return (t) => e.forEach((n) => Q0(n, t));
}
function ev(...e) {
  return a.useCallback(mu(...e), e);
}
var gu = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(nv);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(Ni, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(Ni, { ...r, ref: t, children: n });
});
gu.displayName = "Slot";
var Ni = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = ov(n);
    return a.cloneElement(n, {
      ...rv(r, n.props),
      // @ts-ignore
      ref: t ? mu(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Ni.displayName = "SlotClone";
var tv = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function nv(e) {
  return a.isValidElement(e) && e.type === tv;
}
function rv(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ov(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var iv = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], sv = iv.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? gu : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function sc(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
var Zo = "focusScope.autoFocusOnMount", Jo = "focusScope.autoFocusOnUnmount", ac = { bubbles: !1, cancelable: !0 }, av = "FocusScope", Gn = a.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [l, u] = a.useState(null), d = sc(o), h = sc(i), f = a.useRef(null), w = ev(t, (p) => u(p)), g = a.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  a.useEffect(() => {
    if (r) {
      let p = function(b) {
        if (g.paused || !l)
          return;
        const S = b.target;
        l.contains(S) ? f.current = S : dt(f.current, { select: !0 });
      }, m = function(b) {
        if (g.paused || !l)
          return;
        const S = b.relatedTarget;
        S !== null && (l.contains(S) || dt(f.current, { select: !0 }));
      }, C = function(b) {
        if (document.activeElement === document.body)
          for (const E of b)
            E.removedNodes.length > 0 && dt(l);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", m);
      const y = new MutationObserver(C);
      return l && y.observe(l, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", m), y.disconnect();
      };
    }
  }, [r, l, g.paused]), a.useEffect(() => {
    if (l) {
      lc.add(g);
      const p = document.activeElement;
      if (!l.contains(p)) {
        const C = new CustomEvent(Zo, ac);
        l.addEventListener(Zo, d), l.dispatchEvent(C), C.defaultPrevented || (cv(pv(wu(l)), { select: !0 }), document.activeElement === p && dt(l));
      }
      return () => {
        l.removeEventListener(Zo, d), setTimeout(() => {
          const C = new CustomEvent(Jo, ac);
          l.addEventListener(Jo, h), l.dispatchEvent(C), C.defaultPrevented || dt(p ?? document.body, { select: !0 }), l.removeEventListener(Jo, h), lc.remove(g);
        }, 0);
      };
    }
  }, [l, d, h, g]);
  const v = a.useCallback(
    (p) => {
      if (!n && !r || g.paused)
        return;
      const m = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, C = document.activeElement;
      if (m && C) {
        const y = p.currentTarget, [b, S] = lv(y);
        b && S ? !p.shiftKey && C === S ? (p.preventDefault(), n && dt(b, { select: !0 })) : p.shiftKey && C === b && (p.preventDefault(), n && dt(S, { select: !0 })) : C === y && p.preventDefault();
      }
    },
    [n, r, g.paused]
  );
  return /* @__PURE__ */ c(sv.div, { tabIndex: -1, ...s, ref: w, onKeyDown: v });
});
Gn.displayName = av;
function cv(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (dt(r, { select: t }), document.activeElement !== n)
      return;
}
function lv(e) {
  const t = wu(e), n = cc(t, e), r = cc(t.reverse(), e);
  return [n, r];
}
function wu(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function cc(e, t) {
  for (const n of e)
    if (!uv(n, { upTo: t }))
      return n;
}
function uv(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function dv(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function dt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && dv(e) && t && e.select();
  }
}
var lc = fv();
function fv() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = uc(e, t), e.unshift(t);
    },
    remove(t) {
      e = uc(e, t), e[0]?.resume();
    }
  };
}
function uc(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function pv(e) {
  return e.filter((t) => t.tagName !== "A");
}
function hv(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function vv(...e) {
  return (t) => e.forEach((n) => hv(n, t));
}
var Cu = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(gv);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(ki, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(ki, { ...r, ref: t, children: n });
});
Cu.displayName = "Slot";
var ki = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = Cv(n);
    return a.cloneElement(n, {
      ...wv(r, n.props),
      // @ts-ignore
      ref: t ? vv(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
ki.displayName = "SlotClone";
var mv = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function gv(e) {
  return a.isValidElement(e) && e.type === mv;
}
function wv(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Cv(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var yv = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ev = yv.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? Cu : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), bv = globalThis?.document ? a.useLayoutEffect : () => {
}, Sv = "Portal", mn = a.forwardRef((e, t) => {
  const { container: n, ...r } = e, [o, i] = a.useState(!1);
  bv(() => i(!0), []);
  const s = n || o && globalThis?.document?.body;
  return s ? iu.createPortal(/* @__PURE__ */ c(Ev.div, { ...r, ref: t }), s) : null;
});
mn.displayName = Sv;
function xv(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Rv(...e) {
  return (t) => e.forEach((n) => xv(n, t));
}
function Tv(...e) {
  return a.useCallback(Rv(...e), e);
}
var dc = globalThis?.document ? a.useLayoutEffect : () => {
};
function Av(e, t) {
  return a.useReducer((n, r) => t[n][r] ?? n, e);
}
var be = (e) => {
  const { present: t, children: n } = e, r = Nv(t), o = typeof n == "function" ? n({ present: r.isPresent }) : a.Children.only(n), i = Tv(r.ref, kv(o));
  return typeof n == "function" || r.isPresent ? a.cloneElement(o, { ref: i }) : null;
};
be.displayName = "Presence";
function Nv(e) {
  const [t, n] = a.useState(), r = a.useRef({}), o = a.useRef(e), i = a.useRef("none"), s = e ? "mounted" : "unmounted", [l, u] = Av(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return a.useEffect(() => {
    const d = lr(r.current);
    i.current = l === "mounted" ? d : "none";
  }, [l]), dc(() => {
    const d = r.current, h = o.current;
    if (h !== e) {
      const w = i.current, g = lr(d);
      e ? u("MOUNT") : g === "none" || d?.display === "none" ? u("UNMOUNT") : u(h && w !== g ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, u]), dc(() => {
    if (t) {
      const d = (f) => {
        const g = lr(r.current).includes(f.animationName);
        f.target === t && g && st.flushSync(() => u("ANIMATION_END"));
      }, h = (f) => {
        f.target === t && (i.current = lr(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: a.useCallback((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function lr(e) {
  return e?.animationName || "none";
}
function kv(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Hs = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(Mv);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(Pi, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(Pi, { ...r, ref: t, children: n });
});
Hs.displayName = "Slot";
var Pi = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = Ov(n);
    return a.cloneElement(n, {
      ..._v(r, n.props),
      // @ts-ignore
      ref: t ? au(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Pi.displayName = "SlotClone";
var Pv = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function Mv(e) {
  return a.isValidElement(e) && e.type === Pv;
}
function _v(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Ov(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Dv = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], zn = Dv.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? Hs : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Qo = 0;
function $v() {
  a.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? fc()), document.body.insertAdjacentElement("beforeend", e[1] ?? fc()), Qo++, () => {
      Qo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Qo--;
    };
  }, []);
}
function fc() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var xt = "right-scroll-bar-position", Rt = "width-before-scroll-bar", Lv = "with-scroll-bars-hidden", Iv = "--removed-body-scroll-bar-size";
function Fv(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Wv(e, t) {
  var n = he(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function lo(e, t) {
  return Wv(t || null, function(n) {
    return e.forEach(function(r) {
      return Fv(r, n);
    });
  });
}
function Bv(e) {
  return e;
}
function Hv(e, t) {
  t === void 0 && (t = Bv);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(l) {
          return l !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(l) {
          return i(l);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var l = n;
        n = [], l.forEach(i), s = n;
      }
      var u = function() {
        var h = s;
        s = [], h.forEach(i);
      }, d = function() {
        return Promise.resolve().then(u);
      };
      d(), n = {
        push: function(h) {
          s.push(h), d();
        },
        filter: function(h) {
          return s = s.filter(h), n;
        }
      };
    }
  };
  return o;
}
function uo(e) {
  e === void 0 && (e = {});
  var t = Hv(null);
  return t.options = pe({ async: !0, ssr: !1 }, e), t;
}
var yu = function(e) {
  var t = e.sideCar, n = jn(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return a.createElement(r, pe({}, n));
};
yu.isSideCarExport = !0;
function fo(e, t) {
  return e.useMedium(t), yu;
}
var Eu = uo(), ei = function() {
}, po = a.forwardRef(function(e, t) {
  var n = a.useRef(null), r = a.useState({
    onScrollCapture: ei,
    onWheelCapture: ei,
    onTouchMoveCapture: ei
  }), o = r[0], i = r[1], s = e.forwardProps, l = e.children, u = e.className, d = e.removeScrollBar, h = e.enabled, f = e.shards, w = e.sideCar, g = e.noIsolation, v = e.inert, p = e.allowPinchZoom, m = e.as, C = m === void 0 ? "div" : m, y = e.gapMode, b = jn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = w, E = lo([n, t]), R = pe(pe({}, b), o);
  return a.createElement(
    a.Fragment,
    null,
    h && a.createElement(S, { sideCar: Eu, removeScrollBar: d, shards: f, noIsolation: g, inert: v, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: y }),
    s ? a.cloneElement(a.Children.only(l), pe(pe({}, R), { ref: E })) : a.createElement(C, pe({}, R, { className: u, ref: E }), l)
  );
});
po.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
po.classNames = {
  fullWidth: Rt,
  zeroRight: xt
};
var pc, Vv = function() {
  if (pc)
    return pc;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Uv() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Vv();
  return t && e.setAttribute("nonce", t), e;
}
function jv(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Gv(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var zv = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Uv()) && (jv(t, n), Gv(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Kv = function() {
  var e = zv();
  return function(t, n) {
    a.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Kn = function() {
  var e = Kv(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Yv = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ti = function(e) {
  return parseInt(e || "", 10) || 0;
}, qv = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ti(n), ti(r), ti(o)];
}, Xv = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Yv;
  var t = qv(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Zv = Kn(), Jv = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, l = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Lv, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(l, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(l, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(xt, ` {
    right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(Rt, ` {
    margin-right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(xt, " .").concat(xt, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Rt, " .").concat(Rt, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(Iv, ": ").concat(l, `px;
  }
`);
}, ho = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r, i = a.useMemo(function() {
    return Xv(o);
  }, [o]);
  return a.createElement(Zv, { styles: Jv(i, !t, o, n ? "" : "!important") });
}, Mi = !1;
if (typeof window < "u")
  try {
    var ur = Object.defineProperty({}, "passive", {
      get: function() {
        return Mi = !0, !0;
      }
    });
    window.addEventListener("test", ur, ur), window.removeEventListener("test", ur, ur);
  } catch {
    Mi = !1;
  }
var Ft = Mi ? { passive: !1 } : !1, Qv = function(e) {
  return e.tagName === "TEXTAREA";
}, bu = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Qv(e) && n[t] === "visible")
  );
}, em = function(e) {
  return bu(e, "overflowY");
}, tm = function(e) {
  return bu(e, "overflowX");
}, hc = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Su(e, r);
    if (o) {
      var i = xu(e, r), s = i[1], l = i[2];
      if (s > l)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, nm = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, rm = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Su = function(e, t) {
  return e === "v" ? em(t) : tm(t);
}, xu = function(e, t) {
  return e === "v" ? nm(t) : rm(t);
}, om = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, im = function(e, t, n, r, o) {
  var i = om(e, window.getComputedStyle(t).direction), s = i * r, l = n.target, u = t.contains(l), d = !1, h = s > 0, f = 0, w = 0;
  do {
    var g = xu(e, l), v = g[0], p = g[1], m = g[2], C = p - m - i * v;
    (v || C) && Su(e, l) && (f += C, w += v), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !u && l !== document.body || // self content
    u && (t.contains(l) || t === l)
  );
  return (h && (o && Math.abs(f) < 1 || !o && s > f) || !h && (o && Math.abs(w) < 1 || !o && -s > w)) && (d = !0), d;
}, dr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, vc = function(e) {
  return [e.deltaX, e.deltaY];
}, mc = function(e) {
  return e && "current" in e ? e.current : e;
}, sm = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, am = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, cm = 0, Wt = [];
function lm(e) {
  var t = a.useRef([]), n = a.useRef([0, 0]), r = a.useRef(), o = a.useState(cm++)[0], i = a.useState(Kn)[0], s = a.useRef(e);
  a.useEffect(function() {
    s.current = e;
  }, [e]), a.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var p = on([e.lockRef.current], (e.shards || []).map(mc), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = a.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2)
      return !s.current.allowPinchZoom;
    var C = dr(p), y = n.current, b = "deltaX" in p ? p.deltaX : y[0] - C[0], S = "deltaY" in p ? p.deltaY : y[1] - C[1], E, R = p.target, O = Math.abs(b) > Math.abs(S) ? "h" : "v";
    if ("touches" in p && O === "h" && R.type === "range")
      return !1;
    var $ = hc(O, R);
    if (!$)
      return !0;
    if ($ ? E = O : (E = O === "v" ? "h" : "v", $ = hc(O, R)), !$)
      return !1;
    if (!r.current && "changedTouches" in p && (b || S) && (r.current = E), !E)
      return !0;
    var H = r.current || E;
    return im(H, m, p, H === "h" ? b : S, !0);
  }, []), u = a.useCallback(function(p) {
    var m = p;
    if (!(!Wt.length || Wt[Wt.length - 1] !== i)) {
      var C = "deltaY" in m ? vc(m) : dr(m), y = t.current.filter(function(E) {
        return E.name === m.type && (E.target === m.target || m.target === E.shadowParent) && sm(E.delta, C);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var b = (s.current.shards || []).map(mc).filter(Boolean).filter(function(E) {
          return E.contains(m.target);
        }), S = b.length > 0 ? l(m, b[0]) : !s.current.noIsolation;
        S && m.cancelable && m.preventDefault();
      }
    }
  }, []), d = a.useCallback(function(p, m, C, y) {
    var b = { name: p, delta: m, target: C, should: y, shadowParent: um(C) };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== b;
      });
    }, 1);
  }, []), h = a.useCallback(function(p) {
    n.current = dr(p), r.current = void 0;
  }, []), f = a.useCallback(function(p) {
    d(p.type, vc(p), p.target, l(p, e.lockRef.current));
  }, []), w = a.useCallback(function(p) {
    d(p.type, dr(p), p.target, l(p, e.lockRef.current));
  }, []);
  a.useEffect(function() {
    return Wt.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: w
    }), document.addEventListener("wheel", u, Ft), document.addEventListener("touchmove", u, Ft), document.addEventListener("touchstart", h, Ft), function() {
      Wt = Wt.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", u, Ft), document.removeEventListener("touchmove", u, Ft), document.removeEventListener("touchstart", h, Ft);
    };
  }, []);
  var g = e.removeScrollBar, v = e.inert;
  return a.createElement(
    a.Fragment,
    null,
    v ? a.createElement(i, { styles: am(o) }) : null,
    g ? a.createElement(ho, { gapMode: e.gapMode }) : null
  );
}
function um(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const dm = fo(Eu, lm);
var Ru = a.forwardRef(function(e, t) {
  return a.createElement(po, pe({}, e, { ref: t, sideCar: dm }));
});
Ru.classNames = po.classNames;
const fm = Ru;
var pm = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Bt = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap(), pr = {}, ni = 0, Tu = function(e) {
  return e && (e.host || Tu(e.parentNode));
}, hm = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Tu(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, vm = function(e, t, n, r) {
  var o = hm(t, Array.isArray(e) ? e : [e]);
  pr[n] || (pr[n] = /* @__PURE__ */ new WeakMap());
  var i = pr[n], s = [], l = /* @__PURE__ */ new Set(), u = new Set(o), d = function(f) {
    !f || l.has(f) || (l.add(f), d(f.parentNode));
  };
  o.forEach(d);
  var h = function(f) {
    !f || u.has(f) || Array.prototype.forEach.call(f.children, function(w) {
      if (l.has(w))
        h(w);
      else {
        var g = w.getAttribute(r), v = g !== null && g !== "false", p = (Bt.get(w) || 0) + 1, m = (i.get(w) || 0) + 1;
        Bt.set(w, p), i.set(w, m), s.push(w), p === 1 && v && fr.set(w, !0), m === 1 && w.setAttribute(n, "true"), v || w.setAttribute(r, "true");
      }
    });
  };
  return h(t), l.clear(), ni++, function() {
    s.forEach(function(f) {
      var w = Bt.get(f) - 1, g = i.get(f) - 1;
      Bt.set(f, w), i.set(f, g), w || (fr.has(f) || f.removeAttribute(r), fr.delete(f)), g || f.removeAttribute(n);
    }), ni--, ni || (Bt = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap(), pr = {});
  };
}, vo = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || pm(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), vm(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Vs = "Dialog", [Au, aT] = P0(Vs), [mm, qe] = Au(Vs), Nu = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, l = a.useRef(null), u = a.useRef(null), [d = !1, h] = $0({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ c(
    mm,
    {
      scope: t,
      triggerRef: l,
      contentRef: u,
      contentId: qo(),
      titleId: qo(),
      descriptionId: qo(),
      open: d,
      onOpenChange: h,
      onOpenToggle: a.useCallback(() => h((f) => !f), [h]),
      modal: s,
      children: n
    }
  );
};
Nu.displayName = Vs;
var ku = "DialogTrigger", gm = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = qe(ku, n), i = Ws(t, o.triggerRef);
    return /* @__PURE__ */ c(
      zn.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": js(o.open),
        ...r,
        ref: i,
        onClick: Pn(e.onClick, o.onOpenToggle)
      }
    );
  }
);
gm.displayName = ku;
var wm = "DialogPortal", [cT, Pu] = Au(wm, {
  forceMount: void 0
}), Wr = "DialogOverlay", Mu = a.forwardRef(
  (e, t) => {
    const n = Pu(Wr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = qe(Wr, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ c(be, { present: r || i.open, children: /* @__PURE__ */ c(Cm, { ...o, ref: t }) }) : null;
  }
);
Mu.displayName = Wr;
var Cm = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = qe(Wr, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ c(fm, { as: Hs, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ c(
        zn.div,
        {
          "data-state": js(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Nt = "DialogContent", _u = a.forwardRef(
  (e, t) => {
    const n = Pu(Nt, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = qe(Nt, e.__scopeDialog);
    return /* @__PURE__ */ c(be, { present: r || i.open, children: i.modal ? /* @__PURE__ */ c(ym, { ...o, ref: t }) : /* @__PURE__ */ c(Em, { ...o, ref: t }) });
  }
);
_u.displayName = Nt;
var ym = a.forwardRef(
  (e, t) => {
    const n = qe(Nt, e.__scopeDialog), r = a.useRef(null), o = Ws(t, n.contentRef, r);
    return a.useEffect(() => {
      const i = r.current;
      if (i)
        return vo(i);
    }, []), /* @__PURE__ */ c(
      Ou,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Pn(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Pn(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || l) && i.preventDefault();
        }),
        onFocusOutside: Pn(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), Em = a.forwardRef(
  (e, t) => {
    const n = qe(Nt, e.__scopeDialog), r = a.useRef(!1), o = a.useRef(!1);
    return /* @__PURE__ */ c(
      Ou,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (r.current || n.triggerRef.current?.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          n.triggerRef.current?.contains(s) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), Ou = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, l = qe(Nt, n), u = a.useRef(null), d = Ws(t, u);
    return $v(), /* @__PURE__ */ N(ae, { children: [
      /* @__PURE__ */ c(
        Gn,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ c(
            vt,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": js(l.open),
              ...s,
              ref: d,
              onDismiss: () => l.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ N(ae, { children: [
        /* @__PURE__ */ c(Sm, { titleId: l.titleId }),
        /* @__PURE__ */ c(Rm, { contentRef: u, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), Us = "DialogTitle", Du = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = qe(Us, n);
    return /* @__PURE__ */ c(zn.h2, { id: o.titleId, ...r, ref: t });
  }
);
Du.displayName = Us;
var $u = "DialogDescription", Lu = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = qe($u, n);
    return /* @__PURE__ */ c(zn.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Lu.displayName = $u;
var Iu = "DialogClose", bm = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = qe(Iu, n);
    return /* @__PURE__ */ c(
      zn.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Pn(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
bm.displayName = Iu;
function js(e) {
  return e ? "open" : "closed";
}
var Fu = "DialogTitleWarning", [lT, Wu] = k0(Fu, {
  contentName: Nt,
  titleName: Us,
  docsSlug: "dialog"
}), Sm = ({ titleId: e }) => {
  const t = Wu(Fu), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return a.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, xm = "DialogDescriptionWarning", Rm = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Wu(xm).contentName}}.`;
  return a.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, Tm = Nu, Am = Mu, Nm = _u, km = Du, Pm = Lu;
const Mm = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
}, _m = {
  small: "w-[440px] max-w-[80vw]",
  medium: "w-[640px] max-w-[80vw]",
  large: "w-[840px] max-w-[80vw]"
};
var Jt = /* @__PURE__ */ ((e) => (e.MODAL_TITLE = "modal-title", e.MODAL_DESCRIPTION = "modal-description", e.MODAL_CLOSE_BUTTON = "modal-close-button", e.MODAL_PRIMARY_BUTTON = "modal-primary-button", e.MODAL_SECONDARY_BUTTON = "modal-secondary-button", e.MODAL_OVERLAY = "modal-overlay", e.MODAL_CONTENT_OVERLAY = "modal-content-overlay", e))(Jt || {});
const Om = "z-[95]", Dm = "z-[96]", Yn = "z-[97]", $m = "z-[98]", Lm = "z-[99]", Im = "z-[100]", hr = {
  ERROR: "error",
  INFO: "info",
  WARNING: "warning",
  PRIMARY: "primary"
}, Fm = {
  [hr.INFO]: "bg-khaki-150",
  [hr.WARNING]: "bg-yellow-200",
  [hr.ERROR]: "bg-red-300",
  [hr.PRIMARY]: "bg-indigo-200"
}, et = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  KHAKI: "khaki",
  DESTRUCTIVE: "destructive"
}, ge = {
  SMALL: "small",
  MEDIUM: "medium",
  ICON: "icon"
}, Ae = {
  ACTIVE: "active",
  DEFAULT: "default",
  DISABLED: "disabled"
}, Wm = {
  BUTTON: "button",
  RESET: "reset",
  SUBMIT: "submit"
}, ye = {
  NONE: "none",
  CENTER: "center",
  LEFT: "left",
  RIGHT: "right"
}, Mn = {
  NONE: "none",
  LEFT: "left",
  RIGHT: "right"
};
var On = /* @__PURE__ */ ((e) => (e.BUTTON_BASE = "button-base", e.BUTTON_LOADER = "button-loader", e.BUTTON_ICON = "button-icon", e.BUTTON_TEXT = "button-text", e))(On || {});
const ri = "flex justify-center items-center", Ze = "flex justify-center items-center gap-1.5", vr = "h-7 text-caption font-medium tracking-button", mr = "h-9 text-small font-medium tracking-button", gr = "text-small font-medium tracking-button", Bm = {
  [ge.SMALL]: U.XS,
  [ge.MEDIUM]: U.S,
  [ge.ICON]: U.S
}, Hm = {
  [ge.SMALL]: {
    [ye.NONE]: F("px-3.5 py-2", vr, ri),
    [ye.LEFT]: F("pl-2 pr-3.5 py-1.5", vr, Ze),
    [ye.RIGHT]: F("pr-2 pl-3.5 py-1.5", vr, Ze),
    [ye.CENTER]: F("px-2 py-2", vr, Ze)
  },
  [ge.MEDIUM]: {
    [ye.NONE]: F("px-4 py-2", mr, ri),
    [ye.LEFT]: F("pl-3 pr-4 py-2", mr, Ze),
    [ye.RIGHT]: F("pr-3 pl-4 py-2", mr, Ze),
    [ye.CENTER]: F("px-3 py-3", mr, Ze)
  },
  [ge.ICON]: {
    [ye.NONE]: F("p-1 h-auto", gr, ri),
    [ye.LEFT]: F("p-1 h-auto", gr, Ze),
    [ye.RIGHT]: F("p-1 h-auto", gr, Ze),
    [ye.CENTER]: F("p-1 h-auto", gr, Ze)
  }
}, Vm = {
  [Mn.NONE]: "rounded",
  [Mn.LEFT]: "rounded-l",
  [Mn.RIGHT]: "rounded-r"
}, Zt = "focus-visible:ring-2 focus-visible:ring-indigo-200 outline-none", gc = "focus-visible:ring-2 focus-visible:ring-red-200 outline-none", Um = "focus-visible:ring-2 focus-visible:ring-indigo-200 focus-visible:ring-offset-1 focus-visible:active:ring-offset-2 focus-visible:outline-indigo-500", wc = "focus-visible:ring-2 focus-visible:ring-indigo-200 focus-visible:ring-offset-1 focus-visible:outline focus-visible:outline-indigo-500", Cc = "hover:bg-indigo-500", yc = "hover:bg-khaki-100", _i = "hover:bg-khaki-100", Ec = "hover:bg-khaki-500", bc = "hover:bg-red-500", jm = {
  [et.PRIMARY]: {
    [Ae.ACTIVE]: F("bg-indigo-800 text-white", Cc, Zt),
    [Ae.DEFAULT]: F("bg-indigo-700 text-white active:bg-indigo-800", Cc, Zt),
    [Ae.DISABLED]: F("bg-indigo-200 text-white")
  },
  [et.SECONDARY]: {
    [Ae.ACTIVE]: F(
      "bg-khaki-150 text-khaki-900 outline outline-offset-0 outline-khaki-600 outline-2",
      yc,
      Zt
    ),
    [Ae.DEFAULT]: F(
      "outline outline-1 outline-offset-0 outline-khaki-600 bg-khaki-50 active:bg-khaki-150 active:outline-2",
      yc,
      Um
    ),
    [Ae.DISABLED]: F("bg-khaki-50 text-khaki-400 border border-khaki-400")
  },
  [et.TERTIARY]: {
    [Ae.ACTIVE]: F("bg-khaki-150 text-khaki-900", _i, wc),
    [Ae.DEFAULT]: F("bg-khaki-50 text-khaki-900 active:bg-khaki-150", _i, wc),
    [Ae.DISABLED]: F("bg-khaki-50 text-khaki-400")
  },
  [et.KHAKI]: {
    [Ae.ACTIVE]: F("bg-khaki-800 text-white", Ec, Zt),
    [Ae.DEFAULT]: F("bg-khaki-900 text-white active:bg-khaki-800", Ec, Zt),
    [Ae.DISABLED]: F("bg-khaki-200 text-white")
  },
  [et.DESTRUCTIVE]: {
    [Ae.ACTIVE]: F("bg-red-700 text-white", bc, gc),
    [Ae.DEFAULT]: F("bg-red-600 text-white active:bg-red-700", bc, gc),
    [Ae.DISABLED]: F("bg-red-200 text-white")
  }
}, Gm = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "M12.833 7H10.5l-1.75 5.25-3.5-10.5L3.5 7H1.167"
  }
) }) }), zm = Gm, Km = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "M12.833 7H10.5l-1.75 5.25-3.5-10.5L3.5 7H1.167"
  }
) }) }), Ym = Km, qm = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "M14.667 8H12l-2 6L6 2 4 8H1.334" }) }) }), Xm = qm, Zm = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "M14.667 8H12l-2 6L6 2 4 8H1.334" }) }) }), Jm = Zm, Qm = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M18.333 10H15l-2.5 7.5-5-15L5 10H1.667" }) }) }), eg = Qm, tg = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M18.333 10H15l-2.5 7.5-5-15L5 10H1.667" }) }) }), ng = tg, rg = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M22 12h-4l-3 9L9 3l-3 9H2" }) }), Sc = rg, og = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M22 12h-4l-3 9L9 3l-3 9H2" }) }), xc = og, ig = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c(zm, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Ym, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Xm, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Jm, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(eg, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(ng, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Sc, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(xc, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Sc, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(xc, { color: e }),
    [x.Filled]: (e) => null
  }
}, sg = ({ size: e, style: t, color: n }) => ig[e][t](n), ag = "loader", Pr = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
}, cg = {
  [Pr.SMALL]: 50,
  [Pr.MEDIUM]: 80,
  [Pr.LARGE]: 100
}, Dn = ({ size: e = Pr.MEDIUM, color: t = le.Khaki900 }) => {
  const n = process.env.NODE_ENV === "test";
  return h0(() => {
    n || (async () => {
      const { dotStream: i } = await import("./index-562bc3bb.mjs");
      i.register();
    })();
  }), /* @__PURE__ */ c("div", { className: "text-center", children: /* @__PURE__ */ c(n ? "div" : "l-dot-stream", { "data-testid": ag, size: cg[e], speed: "2.5", color: t }) });
}, lg = () => /* @__PURE__ */ c("div", { className: "w-6 h-6 relative overflow-hidden text-center animate-[spin_0.4s_linear_infinite]", children: /* @__PURE__ */ c(
  "svg",
  {
    id: "Layer_1",
    className: "inset-0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "currentColor",
        d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
      }
    )
  }
) }), Me = Ye(
  ({
    text: e,
    variant: t,
    onClick: n = null,
    type: r = Wm.BUTTON,
    size: o = ge.MEDIUM,
    icon: i = { position: ye.NONE, Component: sg },
    active: s = !1,
    loading: l = !1,
    disabled: u = !1,
    fluid: d = !1,
    hideLabel: h = !1,
    inlineAlignment: f = Mn.NONE,
    testIdOverride: w = On.BUTTON_BASE
  }, g) => {
    const { position: v } = i, { active: p, default: m, disabled: C } = jm[t], y = Hm[o][v], b = Vm[f], S = ie(() => u || l ? C : s ? p : m, [u, l, s, p, m, C]);
    return /* @__PURE__ */ N(
      "button",
      {
        ref: g,
        "data-testid": w,
        className: F(
          "relative transition-all duration-100 whitespace-nowrap",
          S,
          y,
          b,
          d && "w-full"
        ),
        disabled: l || u,
        type: r,
        onClick: (E) => n?.(E),
        "aria-label": e,
        children: [
          l && /* @__PURE__ */ c(ug, { isIconOnly: v === ye.CENTER, className: F(S) }),
          v === ye.LEFT && /* @__PURE__ */ c(oi, { Component: i.Component, size: o }),
          v === ye.CENTER ? /* @__PURE__ */ c(oi, { Component: i.Component, size: o }) : /* @__PURE__ */ c("span", { "data-testid": On.BUTTON_TEXT, className: F(h && "sr-only"), children: e }),
          v === ye.RIGHT && /* @__PURE__ */ c(oi, { Component: i.Component, size: o })
        ]
      }
    );
  }
), oi = ({ Component: e, size: t }) => {
  const n = Bm[t];
  return /* @__PURE__ */ c("span", { "data-testid": On.BUTTON_ICON, children: /* @__PURE__ */ c(se, { Component: e, size: n, style: x.Line, color: le.CurrentColor }) });
}, ug = ({ className: e, isIconOnly: t }) => /* @__PURE__ */ c(
  "span",
  {
    "data-testid": On.BUTTON_LOADER,
    className: F(e, "absolute inset-0 flex items-center justify-center border-0 rounded"),
    children: t ? /* @__PURE__ */ c(lg, {}) : /* @__PURE__ */ c(Dn, { size: "small", color: le.CurrentColor })
  }
), dg = ({ text: e, type: t, actionButton: n, onClose: r }) => {
  const o = Fm[t];
  return /* @__PURE__ */ N(
    "div",
    {
      role: "banner",
      className: F(
        "flex justify-between p-2 text-center text-khaki-900 text-body font-medium gap-2 md:gap-4",
        o
      ),
      children: [
        /* @__PURE__ */ c("div", {}),
        /* @__PURE__ */ N("div", { className: "flex gap-4 items-center", children: [
          /* @__PURE__ */ c("span", { className: "text-small md:text-body", children: e }),
          n && /* @__PURE__ */ c(Me, { ...n })
        ] }),
        /* @__PURE__ */ c("div", { className: "flex items-center", children: r && /* @__PURE__ */ c("button", { type: "button", onClick: (i) => r(i), "aria-label": "dismiss", children: /* @__PURE__ */ c(se, { Component: pn, color: le.Khaki900, size: U.M }) }) })
      ]
    }
  );
}, fg = `
  @keyframes wave {
    0% { transform: translateY(0); }
    50% { transform: translateY(-6px); }
    100% { transform: translateY(0); }
  }
`, Rc = ({ loadingConfig: e }) => {
  const [t, n] = he(0), r = e?.completed, o = e?.items || [];
  return Pe(() => {
    if (r)
      return;
    const i = setInterval(() => {
      n((s) => {
        const l = s + 1;
        return l >= o.length ? (clearInterval(i), s) : l;
      });
    }, 2e3);
    return () => clearInterval(i);
  }, [r, o.length]), /* @__PURE__ */ c("div", { className: "flex items-center justify-center h-48", children: o.length > 0 ? (() => {
    const { text: i, icon: s } = o[t];
    return /* @__PURE__ */ N("div", { className: "flex flex-col items-center justify-center gap-1", children: [
      s && /* @__PURE__ */ c("div", { children: s }),
      /* @__PURE__ */ c("div", { className: "text-body font-medium text-center mb-2", children: i }),
      /* @__PURE__ */ N("div", { className: "relative w-9 h-9 flex items-center justify-center bg-gray-200", children: [
        r ? /* @__PURE__ */ c(
          se,
          {
            color: le.Indigo600,
            size: U.XL,
            Component: v0,
            style: x.Duo
          }
        ) : /* @__PURE__ */ N("div", { className: "flex gap-1 absolute inset-0 items-center justify-center", children: [
          /* @__PURE__ */ c(
            "div",
            {
              className: "w-1 h-1 bg-black rounded-full",
              style: { animation: "wave 0.75s ease-in-out infinite", animationDelay: "0s" }
            }
          ),
          /* @__PURE__ */ c(
            "div",
            {
              className: "w-1 h-1 bg-black rounded-full",
              style: { animation: "wave 0.75s ease-in-out infinite", animationDelay: "0.2s" }
            }
          ),
          /* @__PURE__ */ c(
            "div",
            {
              className: "w-1 h-1 bg-black rounded-full",
              style: { animation: "wave 0.75s ease-in-out infinite", animationDelay: "0.4s" }
            }
          )
        ] }),
        /* @__PURE__ */ c("style", { children: fg })
      ] })
    ] });
  })() : /* @__PURE__ */ c(Dn, {}) });
}, Tc = ({
  loading: e,
  error: t,
  children: n,
  primaryAction: r,
  secondaryAction: o,
  loadingConfig: i
}) => {
  const s = e && i?.transparentOverlay;
  return /* @__PURE__ */ N(ae, { children: [
    e && (i?.transparentOverlay ? /* @__PURE__ */ N(
      "div",
      {
        "data-testid": Jt.MODAL_CONTENT_OVERLAY,
        className: "absolute h-full w-full top-0 left-0 z-10 min-h-48",
        children: [
          /* @__PURE__ */ c("div", { className: "h-full w-full top-0 left-0 absolute inset-0 bg-white opacity-90 rounded-b-xl" }),
          /* @__PURE__ */ c("div", { className: "h-full w-full relative flex items-center justify-center min-h-48", children: /* @__PURE__ */ c(Rc, { loadingConfig: i }) })
        ]
      }
    ) : /* @__PURE__ */ c(Rc, { loadingConfig: i })),
    (!e || s) && /* @__PURE__ */ c("div", { className: "overflow-auto p-8 text-khaki-800", children: /* @__PURE__ */ N("div", { className: "flex flex-col gap-4", children: [
      t.show && /* @__PURE__ */ c(dg, { type: "error", text: t.message ?? "Oops, there was an issue loading your content." }),
      n
    ] }) }),
    (r || o) && (!e || s) && /* @__PURE__ */ N("div", { className: "flex items-center justify-end gap-4 relative p-8 bg-white border-t border-khaki-50 rounded-b-xl", children: [
      o && /* @__PURE__ */ c(Me, { ...o, fluid: !1, size: "medium" }),
      r && /* @__PURE__ */ c(Me, { ...r, fluid: !1, size: "medium" })
    ] })
  ] });
}, pg = ({
  title: e,
  loading: t,
  error: n,
  closeModal: r,
  children: o,
  primaryAction: i = null,
  secondaryAction: s = null,
  size: l = Mm.MEDIUM,
  description: u = "",
  onSubmit: d = null,
  closeDisabled: h = !1,
  loadingConfig: f = {
    items: null,
    transparentOverlay: !1
  }
}) => {
  const w = _m[l], g = h ? S0 : r;
  return /* @__PURE__ */ N(Tm, { open: !0, children: [
    /* @__PURE__ */ c(
      Am,
      {
        onClick: () => g(),
        "data-testid": Jt.MODAL_OVERLAY,
        className: F("fixed inset-0 bg-khaki-900 opacity-50", Om)
      }
    ),
    /* @__PURE__ */ c(
      Nm,
      {
        onClick: (v) => v.stopPropagation(),
        onEscapeKeyDown: () => g(),
        className: F(
          "fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl focus-visible:outline-none",
          w,
          Dm
        ),
        children: /* @__PURE__ */ N("div", { className: "flex flex-col max-h-[calc(100vh-100px)]", children: [
          /* @__PURE__ */ N("div", { className: "flex gap-1 flex-col rounded-t-xl px-8 py-6 bg-khaki-50", children: [
            /* @__PURE__ */ N("div", { className: "flex justify-between items-center", children: [
              /* @__PURE__ */ c(
                km,
                {
                  "data-testid": Jt.MODAL_TITLE,
                  className: "text-h4 font-medium text-khaki-800",
                  children: e
                }
              ),
              !h && /* @__PURE__ */ c("button", { "data-testid": Jt.MODAL_CLOSE_BUTTON, onClick: () => g(), children: /* @__PURE__ */ c(se, { Component: pn, color: le.Khaki800 }) })
            ] }),
            u && /* @__PURE__ */ c(
              Pm,
              {
                "data-testid": Jt.MODAL_DESCRIPTION,
                className: "text-small text-khaki-800",
                children: u
              }
            )
          ] }),
          d ? /* @__PURE__ */ c("form", { className: "overflow-auto flex flex-col relative", onSubmit: d, children: /* @__PURE__ */ c(
            Tc,
            {
              loading: t,
              loadingConfig: f,
              error: n,
              primaryAction: i,
              secondaryAction: s,
              children: o
            }
          ) }) : /* @__PURE__ */ c("div", { className: "overflow-auto flex flex-col relative", children: /* @__PURE__ */ c(
            Tc,
            {
              loading: t,
              loadingConfig: f,
              error: n,
              primaryAction: i,
              secondaryAction: s,
              children: o
            }
          ) })
        ] })
      }
    )
  ] });
}, uT = ({
  title: e,
  closeModal: t,
  message: n,
  icon: r,
  primaryAction: o = null,
  secondaryAction: i = null
}) => /* @__PURE__ */ c(
  pg,
  {
    closeModal: t,
    title: e,
    primaryAction: o,
    secondaryAction: i,
    loading: !1,
    error: { show: !1 },
    children: /* @__PURE__ */ N("div", { className: "text-center", children: [
      r && /* @__PURE__ */ c("div", { className: "flex justify-center mb-2", children: /* @__PURE__ */ c(se, { color: le.Khaki600, Component: r, size: U.L, style: x.Duo }) }),
      /* @__PURE__ */ c("p", { className: "text-khaki-600", children: n })
    ] })
  }
);
function hg(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, vg(o, ...t)];
}
function vg(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function mg(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
var Bu = globalThis?.document ? a.useLayoutEffect : () => {
};
function gg(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function wg(...e) {
  return (t) => e.forEach((n) => gg(n, t));
}
var Hu = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(yg);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(Oi, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(Oi, { ...r, ref: t, children: n });
});
Hu.displayName = "Slot";
var Oi = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = bg(n);
    return a.cloneElement(n, {
      ...Eg(r, n.props),
      // @ts-ignore
      ref: t ? wg(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Oi.displayName = "SlotClone";
var Cg = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function yg(e) {
  return a.isValidElement(e) && e.type === Cg;
}
function Eg(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function bg(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Sg = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Gs = Sg.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? Hu : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), zs = "Avatar", [xg, dT] = hg(zs), [Rg, Vu] = xg(zs), Uu = a.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...r } = e, [o, i] = a.useState("idle");
    return /* @__PURE__ */ c(
      Rg,
      {
        scope: n,
        imageLoadingStatus: o,
        onImageLoadingStatusChange: i,
        children: /* @__PURE__ */ c(Gs.span, { ...r, ref: t })
      }
    );
  }
);
Uu.displayName = zs;
var ju = "AvatarImage", Gu = a.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: r, onLoadingStatusChange: o = () => {
    }, ...i } = e, s = Vu(ju, n), l = Tg(r), u = mg((d) => {
      o(d), s.onImageLoadingStatusChange(d);
    });
    return Bu(() => {
      l !== "idle" && u(l);
    }, [l, u]), l === "loaded" ? /* @__PURE__ */ c(Gs.img, { ...i, ref: t, src: r }) : null;
  }
);
Gu.displayName = ju;
var zu = "AvatarFallback", Ku = a.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: r, ...o } = e, i = Vu(zu, n), [s, l] = a.useState(r === void 0);
    return a.useEffect(() => {
      if (r !== void 0) {
        const u = window.setTimeout(() => l(!0), r);
        return () => window.clearTimeout(u);
      }
    }, [r]), s && i.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ c(Gs.span, { ...o, ref: t }) : null;
  }
);
Ku.displayName = zu;
function Tg(e) {
  const [t, n] = a.useState("idle");
  return Bu(() => {
    if (!e) {
      n("error");
      return;
    }
    let r = !0;
    const o = new window.Image(), i = (s) => () => {
      r && n(s);
    };
    return n("loading"), o.onload = i("loaded"), o.onerror = i("error"), o.src = e, () => {
      r = !1;
    };
  }, [e]), t;
}
var Yu = Uu, Ag = Gu, qu = Ku;
const Qt = {
  XS: "xs",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
}, Xu = {
  [Qt.XS]: "w-6 h-6 text-caption font-medium",
  [Qt.SMALL]: "w-8 h-8 text-small font-medium",
  [Qt.MEDIUM]: "w-12 h-12 text-body font-bold",
  [Qt.LARGE]: "w-16 h-16 text-h3 font-medium"
}, Di = "flex items-center justify-center w-full h-full", Ng = (e) => e.split(" ").length >= 2 ? e.split(" ").map((t) => t.slice(0, 1)).slice(0, 2).join("").toUpperCase() : e.length > 1 ? e.slice(0, 2).toUpperCase() : e.slice(0, 1).toUpperCase(), Zu = ({ image: e, size: t = Qt.MEDIUM, name: n }) => {
  const r = Xu[t];
  return /* @__PURE__ */ N(
    Yu,
    {
      className: F(
        "inline-flex items-center justify-center bg-khaki-150 text-khaki-900 rounded-full overflow-hidden",
        r
      ),
      children: [
        e && /* @__PURE__ */ c(
          Ag,
          {
            className: F(Di, "object-cover border-inherit"),
            src: e,
            alt: n
          }
        ),
        /* @__PURE__ */ c(qu, { className: Di, children: Ng(n) })
      ]
    }
  );
}, kg = F(
  "rounded transition-all duration-100 text-khaki-900 px-2 py-1.5",
  _i,
  Zt
), fT = ({
  avatars: e,
  size: t = Qt.MEDIUM,
  limit: n = 4,
  asButton: r = !1
}) => {
  const o = e.slice(0, e.length >= n ? n : e.length).map((s, l) => {
    if (l + 1 === n && e.length > n) {
      const d = Xu[t];
      return /* @__PURE__ */ c(
        Yu,
        {
          className: F("inline-flex items-center justify-center bg-khaki-900 text-white rounded-full", d),
          children: /* @__PURE__ */ N(qu, { className: Di, children: [
            "+",
            e.length - n + 1
          ] })
        }
      );
    }
    const u = x0(s);
    return /* @__PURE__ */ c(
      Zu,
      {
        name: u ? s : s.name,
        image: u ? void 0 : s.imageUrl,
        size: t
      },
      u ? s : s.name
    );
  });
  return /* @__PURE__ */ c(r ? "button" : "span", { className: F("flex", r && kg), children: o.map((s, l) => /* @__PURE__ */ c("span", { className: "flex items-center -mx-1 rounded-full border border-white", children: s }, l)) });
}, Pg = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "M7 4.667V7m0 2.333h.006m-5.84-4.361v4.056c0 .143 0 .214.017.282q.02.09.07.168c.036.059.086.11.187.21L4.31 12.56c.101.1.152.151.21.187q.08.048.17.07c.066.016.138.016.28.016h4.057c.143 0 .214 0 .281-.016a.6.6 0 0 0 .169-.07c.059-.036.11-.086.21-.187l2.872-2.872c.1-.1.151-.151.187-.21a.6.6 0 0 0 .07-.168c.016-.068.016-.139.016-.282V4.972c0-.143 0-.214-.016-.282a.6.6 0 0 0-.07-.168 1.3 1.3 0 0 0-.187-.21L9.688 1.44c-.1-.1-.151-.151-.21-.187a.6.6 0 0 0-.169-.07c-.067-.016-.138-.016-.28-.016H4.97c-.142 0-.214 0-.28.016a.6.6 0 0 0-.17.07c-.058.036-.109.086-.21.187L1.44 4.312c-.101.1-.151.15-.188.21a.6.6 0 0 0-.07.168c-.015.068-.015.139-.015.282Z"
  }
) }) }), Mg = Pg, _g = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ N("g", { children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M4.311 1.44c.101-.1.152-.151.21-.187a.6.6 0 0 1 .17-.07c.066-.016.138-.016.28-.016h4.057c.143 0 .214 0 .281.016q.09.021.169.07c.059.036.11.086.21.187l2.872 2.872c.1.1.151.15.187.21q.048.079.07.168c.016.068.016.139.016.282v4.056c0 .143 0 .214-.016.282a.6.6 0 0 1-.07.168c-.036.059-.086.11-.187.21L9.688 12.56c-.1.1-.151.151-.21.187a.6.6 0 0 1-.169.07 1.3 1.3 0 0 1-.28.016H4.97c-.142 0-.214 0-.28-.016a.6.6 0 0 1-.17-.07c-.058-.036-.109-.086-.21-.187L1.44 9.688c-.101-.1-.151-.151-.188-.21a.6.6 0 0 1-.07-.168c-.015-.068-.015-.139-.015-.282V4.972c0-.143 0-.214.016-.282a.6.6 0 0 1 .07-.168c.036-.06.086-.11.187-.21z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "M7 4.667V7m0 2.333h.006m-5.84-4.361v4.056c0 .143 0 .214.017.282q.02.09.07.168c.036.059.086.11.187.21L4.31 12.56c.101.1.152.151.21.187q.08.048.17.07c.066.016.138.016.28.016h4.057c.143 0 .214 0 .281-.016a.6.6 0 0 0 .169-.07c.059-.036.11-.086.21-.187l2.872-2.872c.1-.1.151-.151.187-.21a.6.6 0 0 0 .07-.168c.016-.068.016-.139.016-.282V4.972c0-.143 0-.214-.016-.282a.6.6 0 0 0-.07-.168 1.3 1.3 0 0 0-.187-.21L9.688 1.44c-.1-.1-.151-.151-.21-.187a.6.6 0 0 0-.169-.07c-.067-.016-.138-.016-.28-.016H4.97c-.142 0-.214 0-.28.016a.6.6 0 0 0-.17.07c-.058.036-.109.086-.21.187L1.44 4.312c-.101.1-.151.15-.188.21a.6.6 0 0 0-.07.168c-.015.068-.015.139-.015.282Z"
    }
  )
] }) }), Og = _g, Dg = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.5",
    d: "M8 5.333V8m0 2.667h.007M1.334 5.682v4.636c0 .163 0 .245.018.322a.7.7 0 0 0 .08.192c.041.067.099.125.214.24l3.282 3.282c.115.116.173.173.24.215q.09.054.193.08c.076.018.158.018.321.018h4.636c.163 0 .245 0 .322-.019a.7.7 0 0 0 .192-.08c.068-.04.125-.098.24-.214l3.282-3.281c.116-.116.173-.174.215-.24a.7.7 0 0 0 .08-.194c.018-.076.018-.158.018-.32V5.681c0-.163 0-.245-.019-.321a.7.7 0 0 0-.08-.193c-.04-.067-.098-.125-.214-.24l-3.281-3.282a1.4 1.4 0 0 0-.24-.214.7.7 0 0 0-.193-.08c-.077-.019-.159-.019-.322-.019H5.682c-.163 0-.245 0-.321.019a.7.7 0 0 0-.193.08c-.067.04-.125.098-.24.214L1.646 4.928a1.4 1.4 0 0 0-.214.24.7.7 0 0 0-.08.193c-.019.076-.019.158-.019.32Z"
  }
) }) }), $g = Dg, Lg = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ N("g", { children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M4.928 1.646c.115-.116.173-.173.24-.214a.7.7 0 0 1 .193-.08c.076-.019.158-.019.321-.019h4.636c.163 0 .245 0 .322.019a.7.7 0 0 1 .192.08c.068.04.125.098.24.214l3.282 3.282c.116.115.173.173.215.24q.054.09.08.193c.018.076.018.158.018.32v4.637c0 .163 0 .245-.019.322a.7.7 0 0 1-.08.192 1.4 1.4 0 0 1-.214.24l-3.281 3.282a1.4 1.4 0 0 1-.24.215.7.7 0 0 1-.193.08c-.077.018-.159.018-.322.018H5.682c-.163 0-.245 0-.321-.019a.7.7 0 0 1-.193-.08 1.4 1.4 0 0 1-.24-.214l-3.282-3.281a1.4 1.4 0 0 1-.214-.24.7.7 0 0 1-.08-.194c-.019-.076-.019-.158-.019-.32V5.681c0-.163 0-.245.019-.321a.7.7 0 0 1 .08-.193c.041-.067.099-.125.214-.24z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "M8 5.333V8m0 2.667h.007M1.334 5.682v4.636c0 .163 0 .245.018.322a.7.7 0 0 0 .08.192c.041.067.099.125.214.24l3.282 3.282c.115.116.173.173.24.215q.09.054.193.08c.076.018.158.018.321.018h4.636c.163 0 .245 0 .322-.019a.7.7 0 0 0 .192-.08c.068-.04.125-.098.24-.214l3.282-3.281c.116-.116.173-.174.215-.24a.7.7 0 0 0 .08-.194c.018-.076.018-.158.018-.32V5.681c0-.163 0-.245-.019-.321a.7.7 0 0 0-.08-.193c-.04-.067-.098-.125-.214-.24l-3.281-3.282a1.4 1.4 0 0 0-.24-.214.7.7 0 0 0-.193-.08c-.077-.019-.159-.019-.322-.019H5.682c-.163 0-.245 0-.321.019a.7.7 0 0 0-.193.08c-.067.04-.125.098-.24.214L1.646 4.928a1.4 1.4 0 0 0-.214.24.7.7 0 0 0-.08.193c-.019.076-.019.158-.019.32Z"
    }
  )
] }) }), Ig = Lg, Fg = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M10 6.667V10m0 3.333h.008m-8.341-6.23v5.795c0 .204 0 .305.023.401q.03.129.1.241c.05.084.123.156.267.3l4.102 4.103c.144.144.216.216.3.267q.113.07.241.1c.096.023.198.023.402.023h5.796c.203 0 .305 0 .401-.023a.8.8 0 0 0 .241-.1c.084-.051.156-.123.3-.267l4.103-4.103c.144-.144.216-.216.267-.3a.8.8 0 0 0 .1-.24c.023-.097.023-.199.023-.402V7.102c0-.204 0-.305-.023-.401a.8.8 0 0 0-.1-.241c-.051-.084-.123-.156-.267-.3L13.84 2.056c-.144-.144-.216-.216-.3-.268a.8.8 0 0 0-.24-.1c-.097-.022-.199-.022-.402-.022H7.102c-.204 0-.306 0-.402.023a.8.8 0 0 0-.24.1c-.085.051-.157.123-.3.267L2.056 6.16c-.144.145-.216.217-.268.3a.8.8 0 0 0-.1.242c-.022.096-.022.197-.022.401Z"
  }
) }) }), Wg = Fg, Bg = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ N("g", { children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M6.16 2.057c.143-.144.215-.216.3-.268a.8.8 0 0 1 .24-.1c.096-.022.198-.022.402-.022h5.796c.203 0 .305 0 .401.023q.129.03.241.1c.084.051.156.123.3.267l4.103 4.102c.144.145.216.217.267.3q.07.113.1.242c.023.096.023.197.023.401v5.796c0 .204 0 .305-.023.401a.8.8 0 0 1-.1.241c-.051.084-.123.156-.267.3l-4.103 4.103c-.144.144-.216.216-.3.267a.8.8 0 0 1-.24.1c-.097.023-.199.023-.402.023H7.102c-.204 0-.306 0-.402-.023a.8.8 0 0 1-.24-.1c-.085-.051-.157-.123-.3-.267L2.056 13.84c-.144-.144-.216-.216-.268-.3a.8.8 0 0 1-.1-.24c-.022-.097-.022-.199-.022-.402V7.102c0-.204 0-.305.023-.401a.8.8 0 0 1 .1-.241c.05-.084.123-.156.267-.3z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M10 6.667V10m0 3.333h.008m-8.341-6.23v5.795c0 .204 0 .305.023.401q.03.129.1.241c.05.084.123.156.267.3l4.102 4.103c.144.144.216.216.3.267q.113.07.241.1c.096.023.198.023.402.023h5.796c.203 0 .305 0 .401-.023a.8.8 0 0 0 .241-.1c.084-.051.156-.123.3-.267l4.103-4.103c.144-.144.216-.216.267-.3a.8.8 0 0 0 .1-.24c.023-.097.023-.199.023-.402V7.102c0-.204 0-.305-.023-.401a.8.8 0 0 0-.1-.241c-.051-.084-.123-.156-.267-.3L13.84 2.056c-.144-.144-.216-.216-.3-.268a.8.8 0 0 0-.24-.1c-.097-.022-.199-.022-.402-.022H7.102c-.204 0-.306 0-.402.023a.8.8 0 0 0-.24.1c-.085.051-.157.123-.3.267L2.056 6.16c-.144.145-.216.217-.268.3a.8.8 0 0 0-.1.242c-.022.096-.022.197-.022.401Z"
    }
  )
] }) }), Hg = Bg, Vg = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M12 8v4m0 4h.01M2 8.523v6.954c0 .245 0 .367.028.482a1 1 0 0 0 .12.29c.061.1.148.187.32.36l4.923 4.922c.173.173.26.26.36.322q.136.082.29.12c.115.027.237.027.482.027h6.954c.245 0 .367 0 .482-.028a1 1 0 0 0 .29-.12c.1-.061.187-.148.36-.32l4.922-4.923c.173-.173.26-.26.322-.36a1 1 0 0 0 .12-.29c.027-.115.027-.237.027-.482V8.523c0-.245 0-.367-.028-.482a1 1 0 0 0-.12-.29c-.061-.1-.148-.187-.32-.36L16.608 2.47c-.173-.173-.26-.26-.36-.322a1 1 0 0 0-.29-.12C15.844 2 15.722 2 15.477 2H8.523c-.245 0-.367 0-.482.028a1 1 0 0 0-.29.12c-.1.061-.187.148-.36.32L2.47 7.392c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C2 8.156 2 8.278 2 8.523Z"
  }
) }), Ac = Vg, Ug = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M7.391 2.469c.173-.173.26-.26.36-.322a1 1 0 0 1 .29-.12C8.156 2 8.278 2 8.523 2h6.954c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l4.922 4.923c.173.173.26.26.322.36q.082.136.12.29c.027.115.027.237.027.482v6.954c0 .245 0 .367-.028.482a1 1 0 0 1-.12.29c-.061.1-.148.187-.32.36l-4.923 4.922c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12c-.115.027-.237.027-.482.027H8.523c-.245 0-.367 0-.482-.028a1 1 0 0 1-.29-.12c-.1-.061-.187-.148-.36-.32L2.47 16.608c-.173-.173-.26-.26-.322-.36a1 1 0 0 1-.12-.29C2 15.844 2 15.722 2 15.477V8.523c0-.245 0-.367.028-.482a1 1 0 0 1 .12-.29c.061-.1.148-.187.32-.36z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M12 8v4m0 4h.01M2 8.523v6.954c0 .245 0 .367.028.482a1 1 0 0 0 .12.29c.061.1.148.187.32.36l4.923 4.922c.173.173.26.26.36.322q.136.082.29.12c.115.027.237.027.482.027h6.954c.245 0 .367 0 .482-.028a1 1 0 0 0 .29-.12c.1-.061.187-.148.36-.32l4.922-4.923c.173-.173.26-.26.322-.36a1 1 0 0 0 .12-.29c.027-.115.027-.237.027-.482V8.523c0-.245 0-.367-.028-.482a1 1 0 0 0-.12-.29c-.061-.1-.148-.187-.32-.36L16.608 2.47c-.173-.173-.26-.26-.36-.322a1 1 0 0 0-.29-.12C15.844 2 15.722 2 15.477 2H8.523c-.245 0-.367 0-.482.028a1 1 0 0 0-.29.12c-.1.061-.187.148-.36.32L2.47 7.392c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C2 8.156 2 8.278 2 8.523Z"
    }
  )
] }), Nc = Ug, jg = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Mg, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Og, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c($g, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Ig, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Wg, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Hg, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Ac, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Nc, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Ac, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Nc, { color: e }),
    [x.Filled]: (e) => null
  }
}, Ks = ({ size: e, style: t, color: n }) => jg[e][t](n), en = {
  INFO: "info",
  WARNING: "warning",
  ERROR: "error"
}, Gg = {
  [en.INFO]: "bg-khaki-100",
  [en.WARNING]: "bg-yellow-200",
  [en.ERROR]: "bg-red-300"
}, zg = {
  [en.INFO]: m0,
  [en.WARNING]: $s,
  [en.ERROR]: Ks
}, ii = {
  CALL_OUT: "callout",
  CALL_OUT_TITLE: "callout-title",
  CALL_OUT_MESSAGE: "callout-message"
}, pT = ({ message: e, severity: t, title: n = "", fluid: r = !1 }) => {
  const o = Gg[t], i = zg[t];
  return /* @__PURE__ */ N(
    "section",
    {
      "data-testid": ii.CALL_OUT,
      className: F("flex items-center gap-4 p-4 rounded", r ? "w-full" : "w-fit", o),
      children: [
        /* @__PURE__ */ c(se, { size: U.S, color: le.Khaki900, Component: i }),
        /* @__PURE__ */ N("div", { className: "flex flex-col gap-1", children: [
          n && /* @__PURE__ */ c("span", { "data-testid": ii.CALL_OUT_TITLE, className: "font-heavy text-body", children: n }),
          /* @__PURE__ */ c("span", { "data-testid": ii.CALL_OUT_MESSAGE, className: "font-medium text-small", children: e })
        ] })
      ]
    }
  );
};
function Kg(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ju(...e) {
  return (t) => e.forEach((n) => Kg(n, t));
}
function Yg(...e) {
  return a.useCallback(Ju(...e), e);
}
function qg(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, Xg(o, ...t)];
}
function Xg(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function kc(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function Qu(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function Zg({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = Jg({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = Qu(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function Jg({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = Qu(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
function Qg(e) {
  const t = a.useRef({ value: e, previous: e });
  return a.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var e2 = globalThis?.document ? a.useLayoutEffect : () => {
};
function t2(e) {
  const [t, n] = a.useState(void 0);
  return e2(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, l;
        if ("borderBoxSize" in i) {
          const u = i.borderBoxSize, d = Array.isArray(u) ? u[0] : u;
          s = d.inlineSize, l = d.blockSize;
        } else
          s = e.offsetWidth, l = e.offsetHeight;
        n({ width: s, height: l });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var ed = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(r2);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c($i, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c($i, { ...r, ref: t, children: n });
});
ed.displayName = "Slot";
var $i = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = i2(n);
    return a.cloneElement(n, {
      ...o2(r, n.props),
      // @ts-ignore
      ref: t ? Ju(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
$i.displayName = "SlotClone";
var n2 = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function r2(e) {
  return a.isValidElement(e) && e.type === n2;
}
function o2(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function i2(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var s2 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], td = s2.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? ed : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Ys = "Checkbox", [a2, hT] = qg(Ys), [c2, l2] = a2(Ys), nd = a.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: s,
      disabled: l,
      value: u = "on",
      onCheckedChange: d,
      ...h
    } = e, [f, w] = a.useState(null), g = Yg(t, (b) => w(b)), v = a.useRef(!1), p = f ? !!f.closest("form") : !0, [m = !1, C] = Zg({
      prop: o,
      defaultProp: i,
      onChange: d
    }), y = a.useRef(m);
    return a.useEffect(() => {
      const b = f?.form;
      if (b) {
        const S = () => C(y.current);
        return b.addEventListener("reset", S), () => b.removeEventListener("reset", S);
      }
    }, [f, C]), /* @__PURE__ */ N(c2, { scope: n, state: m, disabled: l, children: [
      /* @__PURE__ */ c(
        td.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": Tt(m) ? "mixed" : m,
          "aria-required": s,
          "data-state": od(m),
          "data-disabled": l ? "" : void 0,
          disabled: l,
          value: u,
          ...h,
          ref: g,
          onKeyDown: kc(e.onKeyDown, (b) => {
            b.key === "Enter" && b.preventDefault();
          }),
          onClick: kc(e.onClick, (b) => {
            C((S) => Tt(S) ? !0 : !S), p && (v.current = b.isPropagationStopped(), v.current || b.stopPropagation());
          })
        }
      ),
      p && /* @__PURE__ */ c(
        d2,
        {
          control: f,
          bubbles: !v.current,
          name: r,
          value: u,
          checked: m,
          required: s,
          disabled: l,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
nd.displayName = Ys;
var rd = "CheckboxIndicator", u2 = a.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, i = l2(rd, n);
    return /* @__PURE__ */ c(be, { present: r || Tt(i.state) || i.state === !0, children: /* @__PURE__ */ c(
      td.span,
      {
        "data-state": od(i.state),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
u2.displayName = rd;
var d2 = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, i = a.useRef(null), s = Qg(n), l = t2(t);
  return a.useEffect(() => {
    const u = i.current, d = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== n && f) {
      const w = new Event("click", { bubbles: r });
      u.indeterminate = Tt(n), f.call(u, Tt(n) ? !1 : n), u.dispatchEvent(w);
    }
  }, [s, n, r]), /* @__PURE__ */ c(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: Tt(n) ? !1 : n,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Tt(e) {
  return e === "indeterminate";
}
function od(e) {
  return Tt(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var f2 = nd;
function p2(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function h2(...e) {
  return (t) => e.forEach((n) => p2(n, t));
}
var id = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(m2);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(Li, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(Li, { ...r, ref: t, children: n });
});
id.displayName = "Slot";
var Li = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = w2(n);
    return a.cloneElement(n, {
      ...g2(r, n.props),
      // @ts-ignore
      ref: t ? h2(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Li.displayName = "SlotClone";
var v2 = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function m2(e) {
  return a.isValidElement(e) && e.type === v2;
}
function g2(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function w2(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var C2 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], y2 = C2.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? id : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), E2 = "Label", qs = a.forwardRef((e, t) => /* @__PURE__ */ c(
  y2.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      n.target.closest("button, input, select, textarea") || (e.onMouseDown?.(n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
qs.displayName = E2;
var Xs = qs;
const Ii = "indeterminate", tn = {
  CHECKED: "checked",
  UNCHECKED: "unchecked",
  INDETERMINATE: Ii
}, Ht = {
  ENABLED: "enabled",
  DISABLED: "disabled"
}, b2 = {
  [tn.CHECKED]: {
    [Ht.ENABLED]: "bg-khaki-800",
    [Ht.DISABLED]: "bg-khaki-400"
  },
  [tn.UNCHECKED]: {
    [Ht.ENABLED]: "border border-khaki-500",
    [Ht.DISABLED]: "border border-khaki-400"
  },
  [tn.INDETERMINATE]: {
    [Ht.ENABLED]: "bg-khaki-800",
    [Ht.DISABLED]: "bg-khaki-400"
  }
};
var Fi = /* @__PURE__ */ ((e) => (e.CHECKBOX = "checkbox", e.CHECKBOX_LABEL = "checkbox-label", e))(Fi || {});
const sd = Ye(
  ({
    name: e,
    checked: t,
    onChange: n,
    labelText: r,
    hideLabel: o = !1,
    disabled: i = !1,
    required: s = !1,
    testIdOverride: l = Fi.CHECKBOX
  }, u) => {
    const [d, h] = he(t), f = ie(() => t ?? d, [t, d]), w = ie(() => at(), []), g = ie(() => {
      let v;
      f === !0 ? v = tn.CHECKED : f === Ii ? v = tn.INDETERMINATE : v = tn.UNCHECKED;
      const { enabled: p, disabled: m } = b2[v];
      return i ? m : p;
    }, [f, i]);
    return (
      // Position relative is needed otherwise the sr-only below will still take up space
      /* @__PURE__ */ N("div", { className: "relative flex items-center", children: [
        /* @__PURE__ */ N(
          f2,
          {
            id: w,
            ref: u,
            checked: f,
            onCheckedChange: (v) => {
              h(v), n({ target: { name: e, value: v } });
            },
            disabled: i,
            required: s,
            "data-testid": l,
            className: F(
              "w-3.5 h-3.5 flex justify-center items-center rounded-sm",
              g,
              !o && "mr-2.5"
            ),
            onClick: (v) => v.stopPropagation(),
            children: [
              f === Ii && /* @__PURE__ */ c("svg", { width: "10", height: "2", viewBox: "0 0 10 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ c("path", { d: "M8.5 1L1.5 1", stroke: "white", strokeWidth: "1.75", strokeLinecap: "round" }) }),
              f === !0 && /* @__PURE__ */ c("svg", { width: "8", height: "7", viewBox: "0 0 8 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ c("path", { d: "M1 3.22222L2.84615 5L7 1", stroke: "white", strokeWidth: "1.75", strokeLinecap: "round" }) })
            ]
          }
        ),
        /* @__PURE__ */ c(
          Xs,
          {
            htmlFor: w,
            "data-testid": Fi.CHECKBOX_LABEL,
            className: F(
              "select-none cursor-pointer",
              i ? "text-khaki-400" : "text-khaki-800",
              o && "sr-only"
            ),
            children: r
          }
        )
      ] })
    );
  }
);
function Br(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function S2(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ad(...e) {
  return (t) => e.forEach((n) => S2(n, t));
}
function x2(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, R2(o, ...t)];
}
function R2(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function cd(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function ld({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = T2({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = cd(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function T2({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = cd(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var ud = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(N2);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(Wi, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(Wi, { ...r, ref: t, children: n });
});
ud.displayName = "Slot";
var Wi = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = P2(n);
    return a.cloneElement(n, {
      ...k2(r, n.props),
      // @ts-ignore
      ref: t ? ad(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Wi.displayName = "SlotClone";
var A2 = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function N2(e) {
  return a.isValidElement(e) && e.type === A2;
}
function k2(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function P2(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var M2 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], _2 = M2.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? ud : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function we(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function dd(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, O2(o, ...t)];
}
function O2(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function D2(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Zs(...e) {
  return (t) => e.forEach((n) => D2(n, t));
}
function kt(...e) {
  return a.useCallback(Zs(...e), e);
}
var $n = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(L2);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(Bi, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(Bi, { ...r, ref: t, children: n });
});
$n.displayName = "Slot";
var Bi = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = F2(n);
    return a.cloneElement(n, {
      ...I2(r, n.props),
      // @ts-ignore
      ref: t ? Zs(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Bi.displayName = "SlotClone";
var $2 = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function L2(e) {
  return a.isValidElement(e) && e.type === $2;
}
function I2(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function F2(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function W2(e) {
  const t = e + "CollectionProvider", [n, r] = dd(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: v, children: p } = g, m = ne.useRef(null), C = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ c(o, { scope: v, itemMap: C, collectionRef: m, children: p });
  };
  s.displayName = t;
  const l = e + "CollectionSlot", u = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m } = g, C = i(l, p), y = kt(v, C.collectionRef);
      return /* @__PURE__ */ c($n, { ref: y, children: m });
    }
  );
  u.displayName = l;
  const d = e + "CollectionItemSlot", h = "data-radix-collection-item", f = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m, ...C } = g, y = ne.useRef(null), b = kt(v, y), S = i(d, p);
      return ne.useEffect(() => (S.itemMap.set(y, { ref: y, ...C }), () => void S.itemMap.delete(y))), /* @__PURE__ */ c($n, { [h]: "", ref: b, children: m });
    }
  );
  f.displayName = d;
  function w(g) {
    const v = i(e + "CollectionConsumer", g);
    return ne.useCallback(() => {
      const m = v.collectionRef.current;
      if (!m)
        return [];
      const C = Array.from(m.querySelectorAll(`[${h}]`));
      return Array.from(v.itemMap.values()).sort(
        (S, E) => C.indexOf(S.ref.current) - C.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: u, ItemSlot: f },
    w,
    r
  ];
}
var B2 = a.createContext(void 0);
function H2(e) {
  const t = a.useContext(B2);
  return e || t || "ltr";
}
var si = 0;
function V2() {
  a.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Pc()), document.body.insertAdjacentElement("beforeend", e[1] ?? Pc()), si++, () => {
      si === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), si--;
    };
  }, []);
}
function Pc() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var U2 = globalThis?.document ? a.useLayoutEffect : () => {
}, j2 = a["useId".toString()] || (() => {
}), G2 = 0;
function Mc(e) {
  const [t, n] = a.useState(j2());
  return U2(() => {
    e || n((r) => r ?? String(G2++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const z2 = ["top", "right", "bottom", "left"], ft = Math.min, De = Math.max, Hr = Math.round, wr = Math.floor, pt = (e) => ({
  x: e,
  y: e
}), K2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Y2 = {
  start: "end",
  end: "start"
};
function Hi(e, t, n) {
  return De(e, ft(t, n));
}
function nt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function rt(e) {
  return e.split("-")[0];
}
function gn(e) {
  return e.split("-")[1];
}
function Js(e) {
  return e === "x" ? "y" : "x";
}
function Qs(e) {
  return e === "y" ? "height" : "width";
}
function wn(e) {
  return ["top", "bottom"].includes(rt(e)) ? "y" : "x";
}
function ea(e) {
  return Js(wn(e));
}
function q2(e, t, n) {
  n === void 0 && (n = !1);
  const r = gn(e), o = ea(e), i = Qs(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = Vr(s)), [s, Vr(s)];
}
function X2(e) {
  const t = Vr(e);
  return [Vi(e), t, Vi(t)];
}
function Vi(e) {
  return e.replace(/start|end/g, (t) => Y2[t]);
}
function Z2(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function J2(e, t, n, r) {
  const o = gn(e);
  let i = Z2(rt(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(Vi)))), i;
}
function Vr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => K2[t]);
}
function Q2(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function fd(e) {
  return typeof e != "number" ? Q2(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ur(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function _c(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = wn(t), s = ea(t), l = Qs(s), u = rt(t), d = i === "y", h = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, w = r[l] / 2 - o[l] / 2;
  let g;
  switch (u) {
    case "top":
      g = {
        x: h,
        y: r.y - o.height
      };
      break;
    case "bottom":
      g = {
        x: h,
        y: r.y + r.height
      };
      break;
    case "right":
      g = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      g = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      g = {
        x: r.x,
        y: r.y
      };
  }
  switch (gn(t)) {
    case "start":
      g[s] -= w * (n && d ? -1 : 1);
      break;
    case "end":
      g[s] += w * (n && d ? -1 : 1);
      break;
  }
  return g;
}
const ew = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, l = i.filter(Boolean), u = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let d = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: h,
    y: f
  } = _c(d, r, u), w = r, g = {}, v = 0;
  for (let p = 0; p < l.length; p++) {
    const {
      name: m,
      fn: C
    } = l[p], {
      x: y,
      y: b,
      data: S,
      reset: E
    } = await C({
      x: h,
      y: f,
      initialPlacement: r,
      placement: w,
      strategy: o,
      middlewareData: g,
      rects: d,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (h = y ?? h, f = b ?? f, g = {
      ...g,
      [m]: {
        ...g[m],
        ...S
      }
    }, E && v <= 50) {
      v++, typeof E == "object" && (E.placement && (w = E.placement), E.rects && (d = E.rects === !0 ? await s.getElementRects({
        reference: e,
        floating: t,
        strategy: o
      }) : E.rects), {
        x: h,
        y: f
      } = _c(d, w, u)), p = -1;
      continue;
    }
  }
  return {
    x: h,
    y: f,
    placement: w,
    strategy: o,
    middlewareData: g
  };
};
async function Ln(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: l,
    strategy: u
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: h = "viewport",
    elementContext: f = "floating",
    altBoundary: w = !1,
    padding: g = 0
  } = nt(t, e), v = fd(g), m = l[w ? f === "floating" ? "reference" : "floating" : f], C = Ur(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(m))) == null || n ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: d,
    rootBoundary: h,
    strategy: u
  })), y = f === "floating" ? {
    ...s.floating,
    x: r,
    y: o
  } : s.reference, b = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), S = await (i.isElement == null ? void 0 : i.isElement(b)) ? await (i.getScale == null ? void 0 : i.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = Ur(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: y,
    offsetParent: b,
    strategy: u
  }) : y);
  return {
    top: (C.top - E.top + v.top) / S.y,
    bottom: (E.bottom - C.bottom + v.bottom) / S.y,
    left: (C.left - E.left + v.left) / S.x,
    right: (E.right - C.right + v.right) / S.x
  };
}
const Oc = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: l
    } = t, {
      element: u,
      padding: d = 0
    } = nt(e, t) || {};
    if (u == null)
      return {};
    const h = fd(d), f = {
      x: n,
      y: r
    }, w = ea(o), g = Qs(w), v = await s.getDimensions(u), p = w === "y", m = p ? "top" : "left", C = p ? "bottom" : "right", y = p ? "clientHeight" : "clientWidth", b = i.reference[g] + i.reference[w] - f[w] - i.floating[g], S = f[w] - i.reference[w], E = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let R = E ? E[y] : 0;
    (!R || !await (s.isElement == null ? void 0 : s.isElement(E))) && (R = l.floating[y] || i.floating[g]);
    const O = b / 2 - S / 2, $ = R / 2 - v[g] / 2 - 1, H = ft(h[m], $), j = ft(h[C], $), D = H, Z = R - v[g] - j, q = R / 2 - v[g] / 2 + O, k = Hi(D, q, Z), A = gn(o) != null && q != k && i.reference[g] / 2 - (q < D ? H : j) - v[g] / 2 < 0 ? q < D ? D - q : Z - q : 0;
    return {
      [w]: f[w] - A,
      data: {
        [w]: k,
        centerOffset: q - k + A
      }
    };
  }
}), tw = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        middlewareData: o,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: h = !0,
        fallbackPlacements: f,
        fallbackStrategy: w = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: v = !0,
        ...p
      } = nt(e, t), m = rt(r), C = rt(s) === s, y = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), b = f || (C || !v ? [Vr(s)] : X2(s));
      !f && g !== "none" && b.push(...J2(s, v, g, y));
      const S = [s, ...b], E = await Ln(t, p), R = [];
      let O = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (d && R.push(E[m]), h) {
        const D = q2(r, i, y);
        R.push(E[D[0]], E[D[1]]);
      }
      if (O = [...O, {
        placement: r,
        overflows: R
      }], !R.every((D) => D <= 0)) {
        var $, H;
        const D = ((($ = o.flip) == null ? void 0 : $.index) || 0) + 1, Z = S[D];
        if (Z)
          return {
            data: {
              index: D,
              overflows: O
            },
            reset: {
              placement: Z
            }
          };
        let q = (H = O.filter((k) => k.overflows[0] <= 0).sort((k, M) => k.overflows[1] - M.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!q)
          switch (w) {
            case "bestFit": {
              var j;
              const k = (j = O.map((M) => [M.placement, M.overflows.filter((A) => A > 0).reduce((A, I) => A + I, 0)]).sort((M, A) => M[1] - A[1])[0]) == null ? void 0 : j[0];
              k && (q = k);
              break;
            }
            case "initialPlacement":
              q = s;
              break;
          }
        if (r !== q)
          return {
            reset: {
              placement: q
            }
          };
      }
      return {};
    }
  };
};
function Dc(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function $c(e) {
  return z2.some((t) => e[t] >= 0);
}
const nw = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = nt(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await Ln(t, {
            ...o,
            elementContext: "reference"
          }), s = Dc(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: $c(s)
            }
          };
        }
        case "escaped": {
          const i = await Ln(t, {
            ...o,
            altBoundary: !0
          }), s = Dc(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: $c(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function rw(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = rt(n), l = gn(n), u = wn(n) === "y", d = ["left", "top"].includes(s) ? -1 : 1, h = i && u ? -1 : 1, f = nt(t, e);
  let {
    mainAxis: w,
    crossAxis: g,
    alignmentAxis: v
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return l && typeof v == "number" && (g = l === "end" ? v * -1 : v), u ? {
    x: g * h,
    y: w * d
  } : {
    x: w * d,
    y: g * h
  };
}
const ow = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, o = await rw(t, e);
      return {
        x: n + o.x,
        y: r + o.y,
        data: o
      };
    }
  };
}, iw = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: l = {
          fn: (m) => {
            let {
              x: C,
              y
            } = m;
            return {
              x: C,
              y
            };
          }
        },
        ...u
      } = nt(e, t), d = {
        x: n,
        y: r
      }, h = await Ln(t, u), f = wn(rt(o)), w = Js(f);
      let g = d[w], v = d[f];
      if (i) {
        const m = w === "y" ? "top" : "left", C = w === "y" ? "bottom" : "right", y = g + h[m], b = g - h[C];
        g = Hi(y, g, b);
      }
      if (s) {
        const m = f === "y" ? "top" : "left", C = f === "y" ? "bottom" : "right", y = v + h[m], b = v - h[C];
        v = Hi(y, v, b);
      }
      const p = l.fn({
        ...t,
        [w]: g,
        [f]: v
      });
      return {
        ...p,
        data: {
          x: p.x - n,
          y: p.y - r
        }
      };
    }
  };
}, sw = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: l = 0,
        mainAxis: u = !0,
        crossAxis: d = !0
      } = nt(e, t), h = {
        x: n,
        y: r
      }, f = wn(o), w = Js(f);
      let g = h[w], v = h[f];
      const p = nt(l, t), m = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (u) {
        const b = w === "y" ? "height" : "width", S = i.reference[w] - i.floating[b] + m.mainAxis, E = i.reference[w] + i.reference[b] - m.mainAxis;
        g < S ? g = S : g > E && (g = E);
      }
      if (d) {
        var C, y;
        const b = w === "y" ? "width" : "height", S = ["top", "left"].includes(rt(o)), E = i.reference[f] - i.floating[b] + (S && ((C = s.offset) == null ? void 0 : C[f]) || 0) + (S ? 0 : m.crossAxis), R = i.reference[f] + i.reference[b] + (S ? 0 : ((y = s.offset) == null ? void 0 : y[f]) || 0) - (S ? m.crossAxis : 0);
        v < E ? v = E : v > R && (v = R);
      }
      return {
        [w]: g,
        [f]: v
      };
    }
  };
}, aw = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = t, {
        apply: s = () => {
        },
        ...l
      } = nt(e, t), u = await Ln(t, l), d = rt(n), h = gn(n), f = wn(n) === "y", {
        width: w,
        height: g
      } = r.floating;
      let v, p;
      d === "top" || d === "bottom" ? (v = d, p = h === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (p = d, v = h === "end" ? "top" : "bottom");
      const m = g - u[v], C = w - u[p], y = !t.middlewareData.shift;
      let b = m, S = C;
      if (f) {
        const R = w - u.left - u.right;
        S = h || y ? ft(C, R) : R;
      } else {
        const R = g - u.top - u.bottom;
        b = h || y ? ft(m, R) : R;
      }
      if (y && !h) {
        const R = De(u.left, 0), O = De(u.right, 0), $ = De(u.top, 0), H = De(u.bottom, 0);
        f ? S = w - 2 * (R !== 0 || O !== 0 ? R + O : De(u.left, u.right)) : b = g - 2 * ($ !== 0 || H !== 0 ? $ + H : De(u.top, u.bottom));
      }
      await s({
        ...t,
        availableWidth: S,
        availableHeight: b
      });
      const E = await o.getDimensions(i.floating);
      return w !== E.width || g !== E.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ht(e) {
  return pd(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function $e(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ct(e) {
  var t;
  return (t = (pd(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function pd(e) {
  return e instanceof Node || e instanceof $e(e).Node;
}
function ot(e) {
  return e instanceof Element || e instanceof $e(e).Element;
}
function Ke(e) {
  return e instanceof HTMLElement || e instanceof $e(e).HTMLElement;
}
function Lc(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof $e(e).ShadowRoot;
}
function qn(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Fe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function cw(e) {
  return ["table", "td", "th"].includes(ht(e));
}
function ta(e) {
  const t = na(), n = Fe(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function lw(e) {
  let t = sn(e);
  for (; Ke(t) && !mo(t); ) {
    if (ta(t))
      return t;
    t = sn(t);
  }
  return null;
}
function na() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function mo(e) {
  return ["html", "body", "#document"].includes(ht(e));
}
function Fe(e) {
  return $e(e).getComputedStyle(e);
}
function go(e) {
  return ot(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function sn(e) {
  if (ht(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Lc(e) && e.host || // Fallback.
    ct(e)
  );
  return Lc(t) ? t.host : t;
}
function hd(e) {
  const t = sn(e);
  return mo(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ke(t) && qn(t) ? t : hd(t);
}
function jr(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = hd(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = $e(r);
  return o ? t.concat(i, i.visualViewport || [], qn(r) ? r : []) : t.concat(r, jr(r));
}
function vd(e) {
  const t = Fe(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Ke(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, l = Hr(n) !== i || Hr(r) !== s;
  return l && (n = i, r = s), {
    width: n,
    height: r,
    $: l
  };
}
function ra(e) {
  return ot(e) ? e : e.contextElement;
}
function nn(e) {
  const t = ra(e);
  if (!Ke(t))
    return pt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = vd(t);
  let s = (i ? Hr(n.width) : n.width) / r, l = (i ? Hr(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const uw = /* @__PURE__ */ pt(0);
function md(e) {
  const t = $e(e);
  return !na() || !t.visualViewport ? uw : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function dw(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== $e(e) ? !1 : t;
}
function Pt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = ra(e);
  let s = pt(1);
  t && (r ? ot(r) && (s = nn(r)) : s = nn(e));
  const l = dw(i, n, r) ? md(i) : pt(0);
  let u = (o.left + l.x) / s.x, d = (o.top + l.y) / s.y, h = o.width / s.x, f = o.height / s.y;
  if (i) {
    const w = $e(i), g = r && ot(r) ? $e(r) : r;
    let v = w.frameElement;
    for (; v && r && g !== w; ) {
      const p = nn(v), m = v.getBoundingClientRect(), C = Fe(v), y = m.left + (v.clientLeft + parseFloat(C.paddingLeft)) * p.x, b = m.top + (v.clientTop + parseFloat(C.paddingTop)) * p.y;
      u *= p.x, d *= p.y, h *= p.x, f *= p.y, u += y, d += b, v = $e(v).frameElement;
    }
  }
  return Ur({
    width: h,
    height: f,
    x: u,
    y: d
  });
}
function fw(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const o = Ke(n), i = ct(n);
  if (n === i)
    return t;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = pt(1);
  const u = pt(0);
  if ((o || !o && r !== "fixed") && ((ht(n) !== "body" || qn(i)) && (s = go(n)), Ke(n))) {
    const d = Pt(n);
    l = nn(n), u.x = d.x + n.clientLeft, u.y = d.y + n.clientTop;
  }
  return {
    width: t.width * l.x,
    height: t.height * l.y,
    x: t.x * l.x - s.scrollLeft * l.x + u.x,
    y: t.y * l.y - s.scrollTop * l.y + u.y
  };
}
function pw(e) {
  return Array.from(e.getClientRects());
}
function gd(e) {
  return Pt(ct(e)).left + go(e).scrollLeft;
}
function hw(e) {
  const t = ct(e), n = go(e), r = e.ownerDocument.body, o = De(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = De(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + gd(e);
  const l = -n.scrollTop;
  return Fe(r).direction === "rtl" && (s += De(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: l
  };
}
function vw(e, t) {
  const n = $e(e), r = ct(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, l = 0, u = 0;
  if (o) {
    i = o.width, s = o.height;
    const d = na();
    (!d || d && t === "fixed") && (l = o.offsetLeft, u = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: l,
    y: u
  };
}
function mw(e, t) {
  const n = Pt(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Ke(e) ? nn(e) : pt(1), s = e.clientWidth * i.x, l = e.clientHeight * i.y, u = o * i.x, d = r * i.y;
  return {
    width: s,
    height: l,
    x: u,
    y: d
  };
}
function Ic(e, t, n) {
  let r;
  if (t === "viewport")
    r = vw(e, n);
  else if (t === "document")
    r = hw(ct(e));
  else if (ot(t))
    r = mw(t, n);
  else {
    const o = md(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Ur(r);
}
function wd(e, t) {
  const n = sn(e);
  return n === t || !ot(n) || mo(n) ? !1 : Fe(n).position === "fixed" || wd(n, t);
}
function gw(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = jr(e).filter((l) => ot(l) && ht(l) !== "body"), o = null;
  const i = Fe(e).position === "fixed";
  let s = i ? sn(e) : e;
  for (; ot(s) && !mo(s); ) {
    const l = Fe(s), u = ta(s);
    !u && l.position === "fixed" && (o = null), (i ? !u && !o : !u && l.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || qn(s) && !u && wd(e, s)) ? r = r.filter((h) => h !== s) : o = l, s = sn(s);
  }
  return t.set(e, r), r;
}
function ww(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? gw(t, this._c) : [].concat(n), r], l = s[0], u = s.reduce((d, h) => {
    const f = Ic(t, h, o);
    return d.top = De(f.top, d.top), d.right = ft(f.right, d.right), d.bottom = ft(f.bottom, d.bottom), d.left = De(f.left, d.left), d;
  }, Ic(t, l, o));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function Cw(e) {
  return vd(e);
}
function yw(e, t, n) {
  const r = Ke(t), o = ct(t), i = n === "fixed", s = Pt(e, !0, i, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = pt(0);
  if (r || !r && !i)
    if ((ht(t) !== "body" || qn(o)) && (l = go(t)), r) {
      const d = Pt(t, !0, i, t);
      u.x = d.x + t.clientLeft, u.y = d.y + t.clientTop;
    } else
      o && (u.x = gd(o));
  return {
    x: s.left + l.scrollLeft - u.x,
    y: s.top + l.scrollTop - u.y,
    width: s.width,
    height: s.height
  };
}
function Fc(e, t) {
  return !Ke(e) || Fe(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Cd(e, t) {
  const n = $e(e);
  if (!Ke(e))
    return n;
  let r = Fc(e, t);
  for (; r && cw(r) && Fe(r).position === "static"; )
    r = Fc(r, t);
  return r && (ht(r) === "html" || ht(r) === "body" && Fe(r).position === "static" && !ta(r)) ? n : r || lw(e) || n;
}
const Ew = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const o = this.getOffsetParent || Cd, i = this.getDimensions;
  return {
    reference: yw(t, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await i(n)
    }
  };
};
function bw(e) {
  return Fe(e).direction === "rtl";
}
const Sw = {
  convertOffsetParentRelativeRectToViewportRelativeRect: fw,
  getDocumentElement: ct,
  getClippingRect: ww,
  getOffsetParent: Cd,
  getElementRects: Ew,
  getClientRects: pw,
  getDimensions: Cw,
  getScale: nn,
  isElement: ot,
  isRTL: bw
};
function xw(e, t) {
  let n = null, r;
  const o = ct(e);
  function i() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function s(l, u) {
    l === void 0 && (l = !1), u === void 0 && (u = 1), i();
    const {
      left: d,
      top: h,
      width: f,
      height: w
    } = e.getBoundingClientRect();
    if (l || t(), !f || !w)
      return;
    const g = wr(h), v = wr(o.clientWidth - (d + f)), p = wr(o.clientHeight - (h + w)), m = wr(d), y = {
      rootMargin: -g + "px " + -v + "px " + -p + "px " + -m + "px",
      threshold: De(0, ft(1, u)) || 1
    };
    let b = !0;
    function S(E) {
      const R = E[0].intersectionRatio;
      if (R !== u) {
        if (!b)
          return s();
        R ? s(!1, R) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      b = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...y,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, y);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function Rw(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, d = ra(e), h = o || i ? [...d ? jr(d) : [], ...jr(t)] : [];
  h.forEach((C) => {
    o && C.addEventListener("scroll", n, {
      passive: !0
    }), i && C.addEventListener("resize", n);
  });
  const f = d && l ? xw(d, n) : null;
  let w = -1, g = null;
  s && (g = new ResizeObserver((C) => {
    let [y] = C;
    y && y.target === d && g && (g.unobserve(t), cancelAnimationFrame(w), w = requestAnimationFrame(() => {
      g && g.observe(t);
    })), n();
  }), d && !u && g.observe(d), g.observe(t));
  let v, p = u ? Pt(e) : null;
  u && m();
  function m() {
    const C = Pt(e);
    p && (C.x !== p.x || C.y !== p.y || C.width !== p.width || C.height !== p.height) && n(), p = C, v = requestAnimationFrame(m);
  }
  return n(), () => {
    h.forEach((C) => {
      o && C.removeEventListener("scroll", n), i && C.removeEventListener("resize", n);
    }), f && f(), g && g.disconnect(), g = null, u && cancelAnimationFrame(v);
  };
}
const Tw = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Sw,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return ew(e, t, {
    ...o,
    platform: i
  });
}, Aw = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Oc({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Oc({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var Mr = typeof document < "u" ? y0 : Pe;
function Gr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Gr(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !Gr(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function yd(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Wc(e, t) {
  const n = yd(e);
  return Math.round(t * n) / n;
}
function Bc(e) {
  const t = a.useRef(e);
  return Mr(() => {
    t.current = e;
  }), t;
}
function Nw(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: l = !0,
    whileElementsMounted: u,
    open: d
  } = e, [h, f] = a.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [w, g] = a.useState(r);
  Gr(w, r) || g(r);
  const [v, p] = a.useState(null), [m, C] = a.useState(null), y = a.useCallback((A) => {
    A != R.current && (R.current = A, p(A));
  }, [p]), b = a.useCallback((A) => {
    A !== O.current && (O.current = A, C(A));
  }, [C]), S = i || v, E = s || m, R = a.useRef(null), O = a.useRef(null), $ = a.useRef(h), H = Bc(u), j = Bc(o), D = a.useCallback(() => {
    if (!R.current || !O.current)
      return;
    const A = {
      placement: t,
      strategy: n,
      middleware: w
    };
    j.current && (A.platform = j.current), Tw(R.current, O.current, A).then((I) => {
      const P = {
        ...I,
        isPositioned: !0
      };
      Z.current && !Gr($.current, P) && ($.current = P, st.flushSync(() => {
        f(P);
      }));
    });
  }, [w, t, n, j]);
  Mr(() => {
    d === !1 && $.current.isPositioned && ($.current.isPositioned = !1, f((A) => ({
      ...A,
      isPositioned: !1
    })));
  }, [d]);
  const Z = a.useRef(!1);
  Mr(() => (Z.current = !0, () => {
    Z.current = !1;
  }), []), Mr(() => {
    if (S && (R.current = S), E && (O.current = E), S && E) {
      if (H.current)
        return H.current(S, E, D);
      D();
    }
  }, [S, E, D, H]);
  const q = a.useMemo(() => ({
    reference: R,
    floating: O,
    setReference: y,
    setFloating: b
  }), [y, b]), k = a.useMemo(() => ({
    reference: S,
    floating: E
  }), [S, E]), M = a.useMemo(() => {
    const A = {
      position: n,
      left: 0,
      top: 0
    };
    if (!k.floating)
      return A;
    const I = Wc(k.floating, h.x), P = Wc(k.floating, h.y);
    return l ? {
      ...A,
      transform: "translate(" + I + "px, " + P + "px)",
      ...yd(k.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: I,
      top: P
    };
  }, [n, l, k.floating, h.x, h.y]);
  return a.useMemo(() => ({
    ...h,
    update: D,
    refs: q,
    elements: k,
    floatingStyles: M
  }), [h, D, q, k, M]);
}
function kw(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ed(...e) {
  return (t) => e.forEach((n) => kw(n, t));
}
function bd(...e) {
  return a.useCallback(Ed(...e), e);
}
var Sd = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(Mw);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(Ui, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(Ui, { ...r, ref: t, children: n });
});
Sd.displayName = "Slot";
var Ui = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = Ow(n);
    return a.cloneElement(n, {
      ..._w(r, n.props),
      // @ts-ignore
      ref: t ? Ed(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Ui.displayName = "SlotClone";
var Pw = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function Mw(e) {
  return a.isValidElement(e) && e.type === Pw;
}
function _w(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Ow(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Dw = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], oa = Dw.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? Sd : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), $w = "Arrow", xd = a.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ c(
    oa.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ c("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
xd.displayName = $w;
var Lw = xd;
function Iw(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, Fw(o, ...t)];
}
function Fw(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Ww(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
var ji = globalThis?.document ? a.useLayoutEffect : () => {
};
function Bw(e) {
  const [t, n] = a.useState(void 0);
  return ji(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, l;
        if ("borderBoxSize" in i) {
          const u = i.borderBoxSize, d = Array.isArray(u) ? u[0] : u;
          s = d.inlineSize, l = d.blockSize;
        } else
          s = e.offsetWidth, l = e.offsetHeight;
        n({ width: s, height: l });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var ia = "Popper", [Rd, mt] = Iw(ia), [Hw, Td] = Rd(ia), Ad = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = a.useState(null);
  return /* @__PURE__ */ c(Hw, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
Ad.displayName = ia;
var Nd = "PopperAnchor", kd = a.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = Td(Nd, n), s = a.useRef(null), l = bd(t, s);
    return a.useEffect(() => {
      i.onAnchorChange(r?.current || s.current);
    }), r ? null : /* @__PURE__ */ c(oa.div, { ...o, ref: l });
  }
);
kd.displayName = Nd;
var sa = "PopperContent", [Vw, Uw] = Rd(sa), Pd = a.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: l = 0,
      avoidCollisions: u = !0,
      collisionBoundary: d = [],
      collisionPadding: h = 0,
      sticky: f = "partial",
      hideWhenDetached: w = !1,
      updatePositionStrategy: g = "optimized",
      onPlaced: v,
      ...p
    } = e, m = Td(sa, n), [C, y] = a.useState(null), b = bd(t, (W) => y(W)), [S, E] = a.useState(null), R = Bw(S), O = R?.width ?? 0, $ = R?.height ?? 0, H = r + (i !== "center" ? "-" + i : ""), j = typeof h == "number" ? h : { top: 0, right: 0, bottom: 0, left: 0, ...h }, D = Array.isArray(d) ? d : [d], Z = D.length > 0, q = {
      padding: j,
      boundary: D.filter(Gw),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: Z
    }, { refs: k, floatingStyles: M, placement: A, isPositioned: I, middlewareData: P } = Nw({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: H,
      whileElementsMounted: (...W) => Rw(...W, {
        animationFrame: g === "always"
      }),
      elements: {
        reference: m.anchor
      },
      middleware: [
        ow({ mainAxis: o + $, alignmentAxis: s }),
        u && iw({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? sw() : void 0,
          ...q
        }),
        u && tw({ ...q }),
        aw({
          ...q,
          apply: ({ elements: W, rects: J, availableWidth: te, availableHeight: K }) => {
            const { width: re, height: B } = J.reference, ce = W.floating.style;
            ce.setProperty("--radix-popper-available-width", `${te}px`), ce.setProperty("--radix-popper-available-height", `${K}px`), ce.setProperty("--radix-popper-anchor-width", `${re}px`), ce.setProperty("--radix-popper-anchor-height", `${B}px`);
          }
        }),
        S && Aw({ element: S, padding: l }),
        zw({ arrowWidth: O, arrowHeight: $ }),
        w && nw({ strategy: "referenceHidden", ...q })
      ]
    }), [_, T] = Od(A), L = Ww(v);
    ji(() => {
      I && L?.();
    }, [I, L]);
    const z = P.arrow?.x, Y = P.arrow?.y, G = P.arrow?.centerOffset !== 0, [ee, Q] = a.useState();
    return ji(() => {
      C && Q(window.getComputedStyle(C).zIndex);
    }, [C]), /* @__PURE__ */ c(
      "div",
      {
        ref: k.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...M,
          transform: I ? M.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ee,
          ["--radix-popper-transform-origin"]: [
            P.transformOrigin?.x,
            P.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...P.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ c(
          Vw,
          {
            scope: n,
            placedSide: _,
            onArrowChange: E,
            arrowX: z,
            arrowY: Y,
            shouldHideArrow: G,
            children: /* @__PURE__ */ c(
              oa.div,
              {
                "data-side": _,
                "data-align": T,
                ...p,
                ref: b,
                style: {
                  ...p.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: I ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Pd.displayName = sa;
var Md = "PopperArrow", jw = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, _d = a.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = Uw(Md, r), s = jw[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ c(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ c(
          Lw,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
_d.displayName = Md;
function Gw(e) {
  return e !== null;
}
var zw = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: r, middlewareData: o } = t, s = o.arrow?.centerOffset !== 0, l = s ? 0 : e.arrowWidth, u = s ? 0 : e.arrowHeight, [d, h] = Od(n), f = { start: "0%", center: "50%", end: "100%" }[h], w = (o.arrow?.x ?? 0) + l / 2, g = (o.arrow?.y ?? 0) + u / 2;
    let v = "", p = "";
    return d === "bottom" ? (v = s ? f : `${w}px`, p = `${-u}px`) : d === "top" ? (v = s ? f : `${w}px`, p = `${r.floating.height + u}px`) : d === "right" ? (v = `${-u}px`, p = s ? f : `${g}px`) : d === "left" && (v = `${r.floating.width + u}px`, p = s ? f : `${g}px`), { data: { x: v, y: p } };
  }
});
function Od(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Xn = Ad, Zn = kd, wo = Pd, Co = _d, Kw = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Jn = Kw.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? $n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Yw(e, t) {
  e && st.flushSync(() => e.dispatchEvent(t));
}
function rn(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function Dd(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, qw(o, ...t)];
}
function qw(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Xw(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function $d(...e) {
  return (t) => e.forEach((n) => Xw(n, t));
}
function Gi(...e) {
  return a.useCallback($d(...e), e);
}
var zr = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(Jw);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(zi, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(zi, { ...r, ref: t, children: n });
});
zr.displayName = "Slot";
var zi = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = eC(n);
    return a.cloneElement(n, {
      ...Qw(r, n.props),
      // @ts-ignore
      ref: t ? $d(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
zi.displayName = "SlotClone";
var Zw = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function Jw(e) {
  return a.isValidElement(e) && e.type === Zw;
}
function Qw(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function eC(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function tC(e) {
  const t = e + "CollectionProvider", [n, r] = Dd(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: v, children: p } = g, m = ne.useRef(null), C = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ c(o, { scope: v, itemMap: C, collectionRef: m, children: p });
  };
  s.displayName = t;
  const l = e + "CollectionSlot", u = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m } = g, C = i(l, p), y = Gi(v, C.collectionRef);
      return /* @__PURE__ */ c(zr, { ref: y, children: m });
    }
  );
  u.displayName = l;
  const d = e + "CollectionItemSlot", h = "data-radix-collection-item", f = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m, ...C } = g, y = ne.useRef(null), b = Gi(v, y), S = i(d, p);
      return ne.useEffect(() => (S.itemMap.set(y, { ref: y, ...C }), () => void S.itemMap.delete(y))), /* @__PURE__ */ c(zr, { [h]: "", ref: b, children: m });
    }
  );
  f.displayName = d;
  function w(g) {
    const v = i(e + "CollectionConsumer", g);
    return ne.useCallback(() => {
      const m = v.collectionRef.current;
      if (!m)
        return [];
      const C = Array.from(m.querySelectorAll(`[${h}]`));
      return Array.from(v.itemMap.values()).sort(
        (S, E) => C.indexOf(S.ref.current) - C.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: u, ItemSlot: f },
    w,
    r
  ];
}
var nC = globalThis?.document ? a.useLayoutEffect : () => {
}, rC = a["useId".toString()] || (() => {
}), oC = 0;
function iC(e) {
  const [t, n] = a.useState(rC());
  return nC(() => {
    e || n((r) => r ?? String(oC++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var sC = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ld = sC.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? zr : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function aa(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function aC({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = cC({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = aa(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function cC({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = aa(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var lC = a.createContext(void 0);
function uC(e) {
  const t = a.useContext(lC);
  return e || t || "ltr";
}
var ai = "rovingFocusGroup.onEntryFocus", dC = { bubbles: !1, cancelable: !0 }, yo = "RovingFocusGroup", [Ki, Id, fC] = tC(yo), [pC, Eo] = Dd(
  yo,
  [fC]
), [hC, vC] = pC(yo), Fd = a.forwardRef(
  (e, t) => /* @__PURE__ */ c(Ki.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ c(Ki.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ c(mC, { ...e, ref: t }) }) })
);
Fd.displayName = yo;
var mC = a.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: s,
    defaultCurrentTabStopId: l,
    onCurrentTabStopIdChange: u,
    onEntryFocus: d,
    preventScrollOnEntryFocus: h = !1,
    ...f
  } = e, w = a.useRef(null), g = Gi(t, w), v = uC(i), [p = null, m] = aC({
    prop: s,
    defaultProp: l,
    onChange: u
  }), [C, y] = a.useState(!1), b = aa(d), S = Id(n), E = a.useRef(!1), [R, O] = a.useState(0);
  return a.useEffect(() => {
    const $ = w.current;
    if ($)
      return $.addEventListener(ai, b), () => $.removeEventListener(ai, b);
  }, [b]), /* @__PURE__ */ c(
    hC,
    {
      scope: n,
      orientation: r,
      dir: v,
      loop: o,
      currentTabStopId: p,
      onItemFocus: a.useCallback(
        ($) => m($),
        [m]
      ),
      onItemShiftTab: a.useCallback(() => y(!0), []),
      onFocusableItemAdd: a.useCallback(
        () => O(($) => $ + 1),
        []
      ),
      onFocusableItemRemove: a.useCallback(
        () => O(($) => $ - 1),
        []
      ),
      children: /* @__PURE__ */ c(
        Ld.div,
        {
          tabIndex: C || R === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: g,
          style: { outline: "none", ...e.style },
          onMouseDown: rn(e.onMouseDown, () => {
            E.current = !0;
          }),
          onFocus: rn(e.onFocus, ($) => {
            const H = !E.current;
            if ($.target === $.currentTarget && H && !C) {
              const j = new CustomEvent(ai, dC);
              if ($.currentTarget.dispatchEvent(j), !j.defaultPrevented) {
                const D = S().filter((A) => A.focusable), Z = D.find((A) => A.active), q = D.find((A) => A.id === p), M = [Z, q, ...D].filter(
                  Boolean
                ).map((A) => A.ref.current);
                Hd(M, h);
              }
            }
            E.current = !1;
          }),
          onBlur: rn(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), Wd = "RovingFocusGroupItem", Bd = a.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      ...s
    } = e, l = iC(), u = i || l, d = vC(Wd, n), h = d.currentTabStopId === u, f = Id(n), { onFocusableItemAdd: w, onFocusableItemRemove: g } = d;
    return a.useEffect(() => {
      if (r)
        return w(), () => g();
    }, [r, w, g]), /* @__PURE__ */ c(
      Ki.ItemSlot,
      {
        scope: n,
        id: u,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ c(
          Ld.span,
          {
            tabIndex: h ? 0 : -1,
            "data-orientation": d.orientation,
            ...s,
            ref: t,
            onMouseDown: rn(e.onMouseDown, (v) => {
              r ? d.onItemFocus(u) : v.preventDefault();
            }),
            onFocus: rn(e.onFocus, () => d.onItemFocus(u)),
            onKeyDown: rn(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget)
                return;
              const p = CC(v, d.orientation, d.dir);
              if (p !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey)
                  return;
                v.preventDefault();
                let C = f().filter((y) => y.focusable).map((y) => y.ref.current);
                if (p === "last")
                  C.reverse();
                else if (p === "prev" || p === "next") {
                  p === "prev" && C.reverse();
                  const y = C.indexOf(v.currentTarget);
                  C = d.loop ? yC(C, y + 1) : C.slice(y + 1);
                }
                setTimeout(() => Hd(C));
              }
            })
          }
        )
      }
    );
  }
);
Bd.displayName = Wd;
var gC = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function wC(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function CC(e, t, n) {
  const r = wC(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return gC[r];
}
function Hd(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n))
      return;
}
function yC(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Vd = Fd, Ud = Bd;
function ca(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
var jd = uo(), ci = function() {
}, bo = a.forwardRef(function(e, t) {
  var n = a.useRef(null), r = a.useState({
    onScrollCapture: ci,
    onWheelCapture: ci,
    onTouchMoveCapture: ci
  }), o = r[0], i = r[1], s = e.forwardProps, l = e.children, u = e.className, d = e.removeScrollBar, h = e.enabled, f = e.shards, w = e.sideCar, g = e.noIsolation, v = e.inert, p = e.allowPinchZoom, m = e.as, C = m === void 0 ? "div" : m, y = e.gapMode, b = jn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = w, E = lo([n, t]), R = pe(pe({}, b), o);
  return a.createElement(
    a.Fragment,
    null,
    h && a.createElement(S, { sideCar: jd, removeScrollBar: d, shards: f, noIsolation: g, inert: v, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: y }),
    s ? a.cloneElement(a.Children.only(l), pe(pe({}, R), { ref: E })) : a.createElement(C, pe({}, R, { className: u, ref: E }), l)
  );
});
bo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
bo.classNames = {
  fullWidth: Rt,
  zeroRight: xt
};
var Yi = !1;
if (typeof window < "u")
  try {
    var Cr = Object.defineProperty({}, "passive", {
      get: function() {
        return Yi = !0, !0;
      }
    });
    window.addEventListener("test", Cr, Cr), window.removeEventListener("test", Cr, Cr);
  } catch {
    Yi = !1;
  }
var Vt = Yi ? { passive: !1 } : !1, EC = function(e) {
  return e.tagName === "TEXTAREA";
}, Gd = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !EC(e) && n[t] === "visible")
  );
}, bC = function(e) {
  return Gd(e, "overflowY");
}, SC = function(e) {
  return Gd(e, "overflowX");
}, Hc = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = zd(e, r);
    if (o) {
      var i = Kd(e, r), s = i[1], l = i[2];
      if (s > l)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, xC = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, RC = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, zd = function(e, t) {
  return e === "v" ? bC(t) : SC(t);
}, Kd = function(e, t) {
  return e === "v" ? xC(t) : RC(t);
}, TC = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, AC = function(e, t, n, r, o) {
  var i = TC(e, window.getComputedStyle(t).direction), s = i * r, l = n.target, u = t.contains(l), d = !1, h = s > 0, f = 0, w = 0;
  do {
    var g = Kd(e, l), v = g[0], p = g[1], m = g[2], C = p - m - i * v;
    (v || C) && zd(e, l) && (f += C, w += v), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !u && l !== document.body || // self content
    u && (t.contains(l) || t === l)
  );
  return (h && (o && Math.abs(f) < 1 || !o && s > f) || !h && (o && Math.abs(w) < 1 || !o && -s > w)) && (d = !0), d;
}, yr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Vc = function(e) {
  return [e.deltaX, e.deltaY];
}, Uc = function(e) {
  return e && "current" in e ? e.current : e;
}, NC = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, kC = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, PC = 0, Ut = [];
function MC(e) {
  var t = a.useRef([]), n = a.useRef([0, 0]), r = a.useRef(), o = a.useState(PC++)[0], i = a.useState(Kn)[0], s = a.useRef(e);
  a.useEffect(function() {
    s.current = e;
  }, [e]), a.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var p = on([e.lockRef.current], (e.shards || []).map(Uc), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = a.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2)
      return !s.current.allowPinchZoom;
    var C = yr(p), y = n.current, b = "deltaX" in p ? p.deltaX : y[0] - C[0], S = "deltaY" in p ? p.deltaY : y[1] - C[1], E, R = p.target, O = Math.abs(b) > Math.abs(S) ? "h" : "v";
    if ("touches" in p && O === "h" && R.type === "range")
      return !1;
    var $ = Hc(O, R);
    if (!$)
      return !0;
    if ($ ? E = O : (E = O === "v" ? "h" : "v", $ = Hc(O, R)), !$)
      return !1;
    if (!r.current && "changedTouches" in p && (b || S) && (r.current = E), !E)
      return !0;
    var H = r.current || E;
    return AC(H, m, p, H === "h" ? b : S, !0);
  }, []), u = a.useCallback(function(p) {
    var m = p;
    if (!(!Ut.length || Ut[Ut.length - 1] !== i)) {
      var C = "deltaY" in m ? Vc(m) : yr(m), y = t.current.filter(function(E) {
        return E.name === m.type && (E.target === m.target || m.target === E.shadowParent) && NC(E.delta, C);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var b = (s.current.shards || []).map(Uc).filter(Boolean).filter(function(E) {
          return E.contains(m.target);
        }), S = b.length > 0 ? l(m, b[0]) : !s.current.noIsolation;
        S && m.cancelable && m.preventDefault();
      }
    }
  }, []), d = a.useCallback(function(p, m, C, y) {
    var b = { name: p, delta: m, target: C, should: y, shadowParent: _C(C) };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== b;
      });
    }, 1);
  }, []), h = a.useCallback(function(p) {
    n.current = yr(p), r.current = void 0;
  }, []), f = a.useCallback(function(p) {
    d(p.type, Vc(p), p.target, l(p, e.lockRef.current));
  }, []), w = a.useCallback(function(p) {
    d(p.type, yr(p), p.target, l(p, e.lockRef.current));
  }, []);
  a.useEffect(function() {
    return Ut.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: w
    }), document.addEventListener("wheel", u, Vt), document.addEventListener("touchmove", u, Vt), document.addEventListener("touchstart", h, Vt), function() {
      Ut = Ut.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", u, Vt), document.removeEventListener("touchmove", u, Vt), document.removeEventListener("touchstart", h, Vt);
    };
  }, []);
  var g = e.removeScrollBar, v = e.inert;
  return a.createElement(
    a.Fragment,
    null,
    v ? a.createElement(i, { styles: kC(o) }) : null,
    g ? a.createElement(ho, { gapMode: e.gapMode }) : null
  );
}
function _C(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const OC = fo(jd, MC);
var Yd = a.forwardRef(function(e, t) {
  return a.createElement(bo, pe({}, e, { ref: t, sideCar: OC }));
});
Yd.classNames = bo.classNames;
const DC = Yd;
var qi = ["Enter", " "], $C = ["ArrowDown", "PageUp", "Home"], qd = ["ArrowUp", "PageDown", "End"], LC = [...$C, ...qd], IC = {
  ltr: [...qi, "ArrowRight"],
  rtl: [...qi, "ArrowLeft"]
}, FC = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Qn = "Menu", [In, WC, BC] = W2(Qn), [Dt, Xd] = dd(Qn, [
  BC,
  mt,
  Eo
]), er = mt(), Zd = Eo(), [Jd, gt] = Dt(Qn), [HC, tr] = Dt(Qn), Qd = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: s = !0 } = e, l = er(t), [u, d] = a.useState(null), h = a.useRef(!1), f = ca(i), w = H2(o);
  return a.useEffect(() => {
    const g = () => {
      h.current = !0, document.addEventListener("pointerdown", v, { capture: !0, once: !0 }), document.addEventListener("pointermove", v, { capture: !0, once: !0 });
    }, v = () => h.current = !1;
    return document.addEventListener("keydown", g, { capture: !0 }), () => {
      document.removeEventListener("keydown", g, { capture: !0 }), document.removeEventListener("pointerdown", v, { capture: !0 }), document.removeEventListener("pointermove", v, { capture: !0 });
    };
  }, []), /* @__PURE__ */ c(Xn, { ...l, children: /* @__PURE__ */ c(
    Jd,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: u,
      onContentChange: d,
      children: /* @__PURE__ */ c(
        HC,
        {
          scope: t,
          onClose: a.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: h,
          dir: w,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
Qd.displayName = Qn;
var VC = "MenuAnchor", la = a.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = er(n);
    return /* @__PURE__ */ c(Zn, { ...o, ...r, ref: t });
  }
);
la.displayName = VC;
var ua = "MenuPortal", [UC, ef] = Dt(ua, {
  forceMount: void 0
}), tf = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = gt(ua, t);
  return /* @__PURE__ */ c(UC, { scope: t, forceMount: n, children: /* @__PURE__ */ c(be, { present: n || i.open, children: /* @__PURE__ */ c(mn, { asChild: !0, container: o, children: r }) }) });
};
tf.displayName = ua;
var Ie = "MenuContent", [jC, da] = Dt(Ie), nf = a.forwardRef(
  (e, t) => {
    const n = ef(Ie, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = gt(Ie, e.__scopeMenu), s = tr(Ie, e.__scopeMenu);
    return /* @__PURE__ */ c(In.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ c(be, { present: r || i.open, children: /* @__PURE__ */ c(In.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ c(GC, { ...o, ref: t }) : /* @__PURE__ */ c(zC, { ...o, ref: t }) }) }) });
  }
), GC = a.forwardRef(
  (e, t) => {
    const n = gt(Ie, e.__scopeMenu), r = a.useRef(null), o = kt(t, r);
    return a.useEffect(() => {
      const i = r.current;
      if (i)
        return vo(i);
    }, []), /* @__PURE__ */ c(
      fa,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: we(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), zC = a.forwardRef((e, t) => {
  const n = gt(Ie, e.__scopeMenu);
  return /* @__PURE__ */ c(
    fa,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), fa = a.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: l,
      onEntryFocus: u,
      onEscapeKeyDown: d,
      onPointerDownOutside: h,
      onFocusOutside: f,
      onInteractOutside: w,
      onDismiss: g,
      disableOutsideScroll: v,
      ...p
    } = e, m = gt(Ie, n), C = tr(Ie, n), y = er(n), b = Zd(n), S = WC(n), [E, R] = a.useState(null), O = a.useRef(null), $ = kt(t, O, m.onContentChange), H = a.useRef(0), j = a.useRef(""), D = a.useRef(0), Z = a.useRef(null), q = a.useRef("right"), k = a.useRef(0), M = v ? DC : a.Fragment, A = v ? { as: $n, allowPinchZoom: !0 } : void 0, I = (_) => {
      const T = j.current + _, L = S().filter((W) => !W.disabled), z = document.activeElement, Y = L.find((W) => W.ref.current === z)?.textValue, G = L.map((W) => W.textValue), ee = oy(G, T, Y), Q = L.find((W) => W.textValue === ee)?.ref.current;
      (function W(J) {
        j.current = J, window.clearTimeout(H.current), J !== "" && (H.current = window.setTimeout(() => W(""), 1e3));
      })(T), Q && setTimeout(() => Q.focus());
    };
    a.useEffect(() => () => window.clearTimeout(H.current), []), V2();
    const P = a.useCallback((_) => q.current === Z.current?.side && sy(_, Z.current?.area), []);
    return /* @__PURE__ */ c(
      jC,
      {
        scope: n,
        searchRef: j,
        onItemEnter: a.useCallback(
          (_) => {
            P(_) && _.preventDefault();
          },
          [P]
        ),
        onItemLeave: a.useCallback(
          (_) => {
            P(_) || (O.current?.focus(), R(null));
          },
          [P]
        ),
        onTriggerLeave: a.useCallback(
          (_) => {
            P(_) && _.preventDefault();
          },
          [P]
        ),
        pointerGraceTimerRef: D,
        onPointerGraceIntentChange: a.useCallback((_) => {
          Z.current = _;
        }, []),
        children: /* @__PURE__ */ c(M, { ...A, children: /* @__PURE__ */ c(
          Gn,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: we(i, (_) => {
              _.preventDefault(), O.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ c(
              vt,
              {
                asChild: !0,
                disableOutsidePointerEvents: l,
                onEscapeKeyDown: d,
                onPointerDownOutside: h,
                onFocusOutside: f,
                onInteractOutside: w,
                onDismiss: g,
                children: /* @__PURE__ */ c(
                  Vd,
                  {
                    asChild: !0,
                    ...b,
                    dir: C.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: E,
                    onCurrentTabStopIdChange: R,
                    onEntryFocus: we(u, (_) => {
                      C.isUsingKeyboardRef.current || _.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ c(
                      wo,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": yf(m.open),
                        "data-radix-menu-content": "",
                        dir: C.dir,
                        ...y,
                        ...p,
                        ref: $,
                        style: { outline: "none", ...p.style },
                        onKeyDown: we(p.onKeyDown, (_) => {
                          const L = _.target.closest("[data-radix-menu-content]") === _.currentTarget, z = _.ctrlKey || _.altKey || _.metaKey, Y = _.key.length === 1;
                          L && (_.key === "Tab" && _.preventDefault(), !z && Y && I(_.key));
                          const G = O.current;
                          if (_.target !== G || !LC.includes(_.key))
                            return;
                          _.preventDefault();
                          const Q = S().filter((W) => !W.disabled).map((W) => W.ref.current);
                          qd.includes(_.key) && Q.reverse(), ny(Q);
                        }),
                        onBlur: we(e.onBlur, (_) => {
                          _.currentTarget.contains(_.target) || (window.clearTimeout(H.current), j.current = "");
                        }),
                        onPointerMove: we(
                          e.onPointerMove,
                          Fn((_) => {
                            const T = _.target, L = k.current !== _.clientX;
                            if (_.currentTarget.contains(T) && L) {
                              const z = _.clientX > k.current ? "right" : "left";
                              q.current = z, k.current = _.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
nf.displayName = Ie;
var KC = "MenuGroup", pa = a.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ c(Jn.div, { role: "group", ...r, ref: t });
  }
);
pa.displayName = KC;
var YC = "MenuLabel", rf = a.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ c(Jn.div, { ...r, ref: t });
  }
);
rf.displayName = YC;
var Kr = "MenuItem", jc = "menu.itemSelect", So = a.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = a.useRef(null), s = tr(Kr, e.__scopeMenu), l = da(Kr, e.__scopeMenu), u = kt(t, i), d = a.useRef(!1), h = () => {
      const f = i.current;
      if (!n && f) {
        const w = new CustomEvent(jc, { bubbles: !0, cancelable: !0 });
        f.addEventListener(jc, (g) => r?.(g), { once: !0 }), Yw(f, w), w.defaultPrevented ? d.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ c(
      of,
      {
        ...o,
        ref: u,
        disabled: n,
        onClick: we(e.onClick, h),
        onPointerDown: (f) => {
          e.onPointerDown?.(f), d.current = !0;
        },
        onPointerUp: we(e.onPointerUp, (f) => {
          d.current || f.currentTarget?.click();
        }),
        onKeyDown: we(e.onKeyDown, (f) => {
          const w = l.searchRef.current !== "";
          n || w && f.key === " " || qi.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
So.displayName = Kr;
var of = a.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, s = da(Kr, n), l = Zd(n), u = a.useRef(null), d = kt(t, u), [h, f] = a.useState(!1), [w, g] = a.useState("");
    return a.useEffect(() => {
      const v = u.current;
      v && g((v.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ c(
      In.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? w,
        children: /* @__PURE__ */ c(Ud, { asChild: !0, ...l, focusable: !r, children: /* @__PURE__ */ c(
          Jn.div,
          {
            role: "menuitem",
            "data-highlighted": h ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: d,
            onPointerMove: we(
              e.onPointerMove,
              Fn((v) => {
                r ? s.onItemLeave(v) : (s.onItemEnter(v), v.defaultPrevented || v.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: we(
              e.onPointerLeave,
              Fn((v) => s.onItemLeave(v))
            ),
            onFocus: we(e.onFocus, () => f(!0)),
            onBlur: we(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), qC = "MenuCheckboxItem", sf = a.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ c(df, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ c(
      So,
      {
        role: "menuitemcheckbox",
        "aria-checked": Yr(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": ma(n),
        onSelect: we(
          o.onSelect,
          () => r?.(Yr(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
sf.displayName = qC;
var af = "MenuRadioGroup", [XC, ZC] = Dt(
  af,
  { value: void 0, onValueChange: () => {
  } }
), cf = a.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = ca(r);
    return /* @__PURE__ */ c(XC, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ c(pa, { ...o, ref: t }) });
  }
);
cf.displayName = af;
var lf = "MenuRadioItem", uf = a.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = ZC(lf, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ c(df, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ c(
      So,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": ma(i),
        onSelect: we(
          r.onSelect,
          () => o.onValueChange?.(n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
uf.displayName = lf;
var ha = "MenuItemIndicator", [df, JC] = Dt(
  ha,
  { checked: !1 }
), ff = a.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = JC(ha, n);
    return /* @__PURE__ */ c(
      be,
      {
        present: r || Yr(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ c(
          Jn.span,
          {
            ...o,
            ref: t,
            "data-state": ma(i.checked)
          }
        )
      }
    );
  }
);
ff.displayName = ha;
var QC = "MenuSeparator", pf = a.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ c(
      Jn.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
pf.displayName = QC;
var ey = "MenuArrow", hf = a.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = er(n);
    return /* @__PURE__ */ c(Co, { ...o, ...r, ref: t });
  }
);
hf.displayName = ey;
var va = "MenuSub", [ty, vf] = Dt(va), mf = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, i = gt(va, t), s = er(t), [l, u] = a.useState(null), [d, h] = a.useState(null), f = ca(o);
  return a.useEffect(() => (i.open === !1 && f(!1), () => f(!1)), [i.open, f]), /* @__PURE__ */ c(Xn, { ...s, children: /* @__PURE__ */ c(
    Jd,
    {
      scope: t,
      open: r,
      onOpenChange: f,
      content: d,
      onContentChange: h,
      children: /* @__PURE__ */ c(
        ty,
        {
          scope: t,
          contentId: Mc(),
          triggerId: Mc(),
          trigger: l,
          onTriggerChange: u,
          children: n
        }
      )
    }
  ) });
};
mf.displayName = va;
var xn = "MenuSubTrigger", gf = a.forwardRef(
  (e, t) => {
    const n = gt(xn, e.__scopeMenu), r = tr(xn, e.__scopeMenu), o = vf(xn, e.__scopeMenu), i = da(xn, e.__scopeMenu), s = a.useRef(null), { pointerGraceTimerRef: l, onPointerGraceIntentChange: u } = i, d = { __scopeMenu: e.__scopeMenu }, h = a.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return a.useEffect(() => h, [h]), a.useEffect(() => {
      const f = l.current;
      return () => {
        window.clearTimeout(f), u(null);
      };
    }, [l, u]), /* @__PURE__ */ c(la, { asChild: !0, ...d, children: /* @__PURE__ */ c(
      of,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": yf(n.open),
        ...e,
        ref: Zs(t, o.onTriggerChange),
        onClick: (f) => {
          e.onClick?.(f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: we(
          e.onPointerMove,
          Fn((f) => {
            i.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !s.current && (i.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), h();
            }, 100));
          })
        ),
        onPointerLeave: we(
          e.onPointerLeave,
          Fn((f) => {
            h();
            const w = n.content?.getBoundingClientRect();
            if (w) {
              const g = n.content?.dataset.side, v = g === "right", p = v ? -5 : 5, m = w[v ? "left" : "right"], C = w[v ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + p, y: f.clientY },
                  { x: m, y: w.top },
                  { x: C, y: w.top },
                  { x: C, y: w.bottom },
                  { x: m, y: w.bottom }
                ],
                side: g
              }), window.clearTimeout(l.current), l.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(f), f.defaultPrevented)
                return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: we(e.onKeyDown, (f) => {
          const w = i.searchRef.current !== "";
          e.disabled || w && f.key === " " || IC[r.dir].includes(f.key) && (n.onOpenChange(!0), n.content?.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
gf.displayName = xn;
var wf = "MenuSubContent", Cf = a.forwardRef(
  (e, t) => {
    const n = ef(Ie, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = gt(Ie, e.__scopeMenu), s = tr(Ie, e.__scopeMenu), l = vf(wf, e.__scopeMenu), u = a.useRef(null), d = kt(t, u);
    return /* @__PURE__ */ c(In.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ c(be, { present: r || i.open, children: /* @__PURE__ */ c(In.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ c(
      fa,
      {
        id: l.contentId,
        "aria-labelledby": l.triggerId,
        ...o,
        ref: d,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (h) => {
          s.isUsingKeyboardRef.current && u.current?.focus(), h.preventDefault();
        },
        onCloseAutoFocus: (h) => h.preventDefault(),
        onFocusOutside: we(e.onFocusOutside, (h) => {
          h.target !== l.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: we(e.onEscapeKeyDown, (h) => {
          s.onClose(), h.preventDefault();
        }),
        onKeyDown: we(e.onKeyDown, (h) => {
          const f = h.currentTarget.contains(h.target), w = FC[s.dir].includes(h.key);
          f && w && (i.onOpenChange(!1), l.trigger?.focus(), h.preventDefault());
        })
      }
    ) }) }) });
  }
);
Cf.displayName = wf;
function yf(e) {
  return e ? "open" : "closed";
}
function Yr(e) {
  return e === "indeterminate";
}
function ma(e) {
  return Yr(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function ny(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function ry(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function oy(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = ry(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((d) => d !== n));
  const u = s.find(
    (d) => d.toLowerCase().startsWith(o.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function iy(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const l = t[i].x, u = t[i].y, d = t[s].x, h = t[s].y;
    u > r != h > r && n < (d - l) * (r - u) / (h - u) + l && (o = !o);
  }
  return o;
}
function sy(e, t) {
  if (!t)
    return !1;
  const n = { x: e.clientX, y: e.clientY };
  return iy(n, t);
}
function Fn(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var ay = Qd, cy = la, ly = tf, uy = nf, dy = pa, fy = rf, py = So, hy = sf, vy = cf, my = uf, gy = ff, wy = pf, Cy = hf, yy = mf, Ey = gf, by = Cf, Sy = globalThis?.document ? a.useLayoutEffect : () => {
}, xy = a["useId".toString()] || (() => {
}), Ry = 0;
function Gc(e) {
  const [t, n] = a.useState(xy());
  return Sy(() => {
    e || n((r) => r ?? String(Ry++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var ga = "DropdownMenu", [Ty, vT] = x2(
  ga,
  [Xd]
), Re = Xd(), [Ay, Ef] = Ty(ga), bf = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: i,
    onOpenChange: s,
    modal: l = !0
  } = e, u = Re(t), d = a.useRef(null), [h = !1, f] = ld({
    prop: o,
    defaultProp: i,
    onChange: s
  });
  return /* @__PURE__ */ c(
    Ay,
    {
      scope: t,
      triggerId: Gc(),
      triggerRef: d,
      contentId: Gc(),
      open: h,
      onOpenChange: f,
      onOpenToggle: a.useCallback(() => f((w) => !w), [f]),
      modal: l,
      children: /* @__PURE__ */ c(ay, { ...u, open: h, onOpenChange: f, dir: r, modal: l, children: n })
    }
  );
};
bf.displayName = ga;
var Sf = "DropdownMenuTrigger", xf = a.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = Ef(Sf, n), s = Re(n);
    return /* @__PURE__ */ c(cy, { asChild: !0, ...s, children: /* @__PURE__ */ c(
      _2.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: ad(t, i.triggerRef),
        onPointerDown: Br(e.onPointerDown, (l) => {
          !r && l.button === 0 && l.ctrlKey === !1 && (i.onOpenToggle(), i.open || l.preventDefault());
        }),
        onKeyDown: Br(e.onKeyDown, (l) => {
          r || (["Enter", " "].includes(l.key) && i.onOpenToggle(), l.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(l.key) && l.preventDefault());
        })
      }
    ) });
  }
);
xf.displayName = Sf;
var Ny = "DropdownMenuPortal", Rf = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Re(t);
  return /* @__PURE__ */ c(ly, { ...r, ...n });
};
Rf.displayName = Ny;
var Tf = "DropdownMenuContent", Af = a.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ef(Tf, n), i = Re(n), s = a.useRef(!1);
    return /* @__PURE__ */ c(
      uy,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: Br(e.onCloseAutoFocus, (l) => {
          s.current || o.triggerRef.current?.focus(), s.current = !1, l.preventDefault();
        }),
        onInteractOutside: Br(e.onInteractOutside, (l) => {
          const u = l.detail.originalEvent, d = u.button === 0 && u.ctrlKey === !0, h = u.button === 2 || d;
          (!o.modal || h) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Af.displayName = Tf;
var ky = "DropdownMenuGroup", Py = a.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Re(n);
    return /* @__PURE__ */ c(dy, { ...o, ...r, ref: t });
  }
);
Py.displayName = ky;
var My = "DropdownMenuLabel", Nf = a.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Re(n);
    return /* @__PURE__ */ c(fy, { ...o, ...r, ref: t });
  }
);
Nf.displayName = My;
var _y = "DropdownMenuItem", kf = a.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Re(n);
    return /* @__PURE__ */ c(py, { ...o, ...r, ref: t });
  }
);
kf.displayName = _y;
var Oy = "DropdownMenuCheckboxItem", Dy = a.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Re(n);
  return /* @__PURE__ */ c(hy, { ...o, ...r, ref: t });
});
Dy.displayName = Oy;
var $y = "DropdownMenuRadioGroup", Ly = a.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Re(n);
  return /* @__PURE__ */ c(vy, { ...o, ...r, ref: t });
});
Ly.displayName = $y;
var Iy = "DropdownMenuRadioItem", Fy = a.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Re(n);
  return /* @__PURE__ */ c(my, { ...o, ...r, ref: t });
});
Fy.displayName = Iy;
var Wy = "DropdownMenuItemIndicator", By = a.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Re(n);
  return /* @__PURE__ */ c(gy, { ...o, ...r, ref: t });
});
By.displayName = Wy;
var Hy = "DropdownMenuSeparator", Pf = a.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Re(n);
  return /* @__PURE__ */ c(wy, { ...o, ...r, ref: t });
});
Pf.displayName = Hy;
var Vy = "DropdownMenuArrow", Uy = a.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Re(n);
    return /* @__PURE__ */ c(Cy, { ...o, ...r, ref: t });
  }
);
Uy.displayName = Vy;
var jy = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: i } = e, s = Re(t), [l = !1, u] = ld({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ c(yy, { ...s, open: l, onOpenChange: u, children: n });
}, Gy = "DropdownMenuSubTrigger", Mf = a.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Re(n);
  return /* @__PURE__ */ c(Ey, { ...o, ...r, ref: t });
});
Mf.displayName = Gy;
var zy = "DropdownMenuSubContent", _f = a.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Re(n);
  return /* @__PURE__ */ c(
    by,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
_f.displayName = zy;
var Of = bf, Df = xf, wa = Rf, $f = Af, Ky = Nf, _r = kf, zc = Pf, Yy = jy, qy = Mf, Xy = _f, Xi = /* @__PURE__ */ ((e) => (e.DROPDOWN_MENU_BASE = "dropdown-menu-base", e.DROPDOWN_MENU_SEARCH = "dropdown-menu-search", e))(Xi || {});
const Ge = 5, Zy = {
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left"
}, Lf = {
  START: "start",
  CENTER: "center",
  END: "end"
}, Rn = {
  SELECTABLE: "selectable",
  DIVIDER: "divider",
  GROUP: "group",
  SUBMENU: "submenu"
}, Jy = ({
  children: e,
  items: t,
  position: n = Zy.BOTTOM,
  alignment: r = Lf.START,
  searchable: o = !1,
  fluid: i = !1,
  portalContainer: s,
  disabled: l = !1
}) => {
  const [u, d] = he(!1), [h, f] = he(""), w = ie(() => {
    const v = t.filter((p) => !(p.type === Rn.SELECTABLE && p.hidden));
    return h ? v.filter(
      (p) => p.label.toLowerCase().includes(h.toLowerCase())
    ) : v;
  }, [h, t]), g = !R0(w);
  return /* @__PURE__ */ N(
    Of,
    {
      open: u,
      onOpenChange: (v) => {
        d(v), f("");
      },
      children: [
        /* @__PURE__ */ c(Df, { asChild: !0, disabled: l, children: /* @__PURE__ */ c("span", { children: e }) }),
        /* @__PURE__ */ c(wa, { container: s, children: /* @__PURE__ */ N(
          $f,
          {
            "data-testid": Xi.DROPDOWN_MENU_BASE,
            sideOffset: Ge,
            side: n,
            align: r,
            collisionPadding: {
              top: Ge,
              right: Ge,
              bottom: Ge,
              left: Ge
            },
            className: F(
              "bg-white border border-khaki-400 rounded w-56 overflow-y-auto overflow-x-hidden max-h-[calc(var(--radix-dropdown-menu-content-available-height)-10px)]",
              i && "w-full",
              Yn
            ),
            children: [
              o && /* @__PURE__ */ c(
                "div",
                {
                  className: F(
                    "px-3 py-1 border-khaki-200 text-small font-medium w-full",
                    g && "border-b pb-1"
                  ),
                  onKeyDown: (v) => v.stopPropagation(),
                  children: /* @__PURE__ */ c(
                    "input",
                    {
                      autoFocus: !0,
                      "data-testid": Xi.DROPDOWN_MENU_SEARCH,
                      className: "outline-none h-7 text-khaki-800 w-full",
                      placeholder: "Search",
                      type: "text",
                      value: h,
                      onChange: (v) => {
                        v.stopPropagation(), v.preventDefault(), f(v.target.value);
                      }
                    }
                  )
                }
              ),
              g && /* @__PURE__ */ c("div", { className: "flex flex-col gap-1 p-2", children: w.map((v, p) => /* @__PURE__ */ c(
                Qy,
                {
                  item: v,
                  closeDropdown: () => d(!1)
                },
                `dropdown-menu-item-${p}`
              )) })
            ]
          }
        ) })
      ]
    }
  );
}, Qy = ({ item: e, closeDropdown: t }) => {
  switch (e.type) {
    case Rn.GROUP: {
      const n = e, { items: r, label: o, tag: i } = n;
      return /* @__PURE__ */ N("div", { className: "focus-visible:outline-none", children: [
        /* @__PURE__ */ c(zc, { className: "bg-khaki-200 h-[1px] my-1 -mx-3" }),
        /* @__PURE__ */ N(Ky, { className: "px-2 py-3 text-khaki-600 font-bold flex items-center", children: [
          /* @__PURE__ */ c("span", { className: "mr-3", children: o }),
          i
        ] }),
        /* @__PURE__ */ c("div", { className: "flex flex-col gap-1", children: r.map((s, l) => {
          const { onClick: u, disabled: d } = s;
          return /* @__PURE__ */ c(
            _r,
            {
              disabled: d,
              onSelect: (h) => {
                u?.(h), t();
              },
              className: F(
                "px-2 py-1 outline-none rounded cursor-pointer",
                u ? "cursor-pointer data-[highlighted]:bg-khaki-100" : "cursor-default",
                d && "opacity-50"
              ),
              children: /* @__PURE__ */ c("div", { className: "pl-3", children: Er(s) })
            },
            `dropdown-sub-menu-item-${l}`
          );
        }) })
      ] });
    }
    case Rn.DIVIDER:
      return /* @__PURE__ */ c(zc, { className: "bg-khaki-200 h-[1px] my-1 -mx-3" });
    case Rn.SELECTABLE: {
      const { onClick: n, disabled: r } = e;
      return /* @__PURE__ */ c(
        _r,
        {
          disabled: r,
          onSelect: (o) => {
            n?.(o), t();
          },
          className: F(
            "px-2 py-1 outline-none rounded",
            n ? "cursor-pointer data-[highlighted]:bg-khaki-100" : "cursor-default",
            r && "opacity-50"
          ),
          children: Er(e)
        }
      );
    }
    case Rn.SUBMENU: {
      const { items: n, disabled: r } = e;
      return /* @__PURE__ */ N(Yy, { children: [
        /* @__PURE__ */ c(
          qy,
          {
            className: F(
              "px-2 py-1 outline-none rounded cursor-pointer",
              "data-[highlighted]:bg-khaki-100",
              r && "opacity-50"
            ),
            children: /* @__PURE__ */ N("div", { className: "flex justify-between items-center", children: [
              Er(e),
              /* @__PURE__ */ c(se, { Component: g0, size: U.S, style: x.Line })
            ] })
          }
        ),
        /* @__PURE__ */ c(wa, { children: /* @__PURE__ */ c(
          Xy,
          {
            className: F(
              "bg-white border border-khaki-400 rounded w-56 overflow-y-auto overflow-x-hidden max-h-[calc(var(--radix-dropdown-menu-content-available-height)-10px)]",
              Yn
            ),
            children: /* @__PURE__ */ c("div", { className: "flex flex-col gap-1 p-2", children: n.map((o, i) => {
              const { onClick: s, disabled: l } = o;
              return /* @__PURE__ */ c(
                _r,
                {
                  disabled: l,
                  onSelect: (u) => {
                    s?.(u), t();
                  },
                  className: F(
                    "px-2 py-1 outline-none rounded cursor-pointer",
                    "data-[highlighted]:bg-khaki-100",
                    l && "opacity-50"
                  ),
                  children: Er(o)
                },
                `dropdown-sub-menu-item-${i}`
              );
            }) })
          }
        ) })
      ] });
    }
  }
}, Er = ({
  Icon: e,
  iconColor: t,
  textColor: n,
  label: r,
  description: o,
  testIdOverride: i
}) => /* @__PURE__ */ N("div", { className: "flex items-center gap-2", children: [
  e && /* @__PURE__ */ c("span", { className: "min-w-3.5 min-h-3.5", children: /* @__PURE__ */ c(
    se,
    {
      Component: e,
      size: U.XS,
      style: x.Line,
      color: t ?? le.Khaki800
    }
  ) }),
  /* @__PURE__ */ N(
    "span",
    {
      "data-testid": i,
      className: F("text-small font-medium text-khaki-800 flex items-center justify-between gap-2 w-full"),
      style: n ? { color: n } : void 0,
      children: [
        r,
        o
      ]
    }
  )
] }), mT = {
  SECONDARY: "secondary",
  TERTIARY: "tertiary"
};
var If = /* @__PURE__ */ ((e) => (e.FLAT_ACTION_BUTTON_BASE = "flat-action-button-base", e))(If || {});
const Ff = Ye(
  ({
    Icon: e,
    label: t,
    onClick: n = null,
    variant: r,
    active: o = !1,
    loading: i = !1,
    disabled: s = !1,
    testIdOverride: l = If.FLAT_ACTION_BUTTON_BASE
  }, u) => /* @__PURE__ */ c(
    Me,
    {
      ref: u,
      text: t,
      icon: { Component: e, position: "center" },
      active: o,
      disabled: s || i,
      onClick: n,
      variant: r,
      testIdOverride: l,
      size: "icon",
      hideLabel: !0
    }
  )
);
function jt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function e3(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Wf(...e) {
  return (t) => e.forEach((n) => e3(n, t));
}
function Bf(...e) {
  return a.useCallback(Wf(...e), e);
}
function t3(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, n3(o, ...t)];
}
function n3(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var r3 = globalThis?.document ? a.useLayoutEffect : () => {
}, o3 = a["useId".toString()] || (() => {
}), i3 = 0;
function s3(e) {
  const [t, n] = a.useState(o3());
  return r3(() => {
    e || n((r) => r ?? String(i3++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var Hf = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(a3);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(Zi, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(Zi, { ...r, ref: t, children: n });
});
Hf.displayName = "Slot";
var Zi = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = l3(n);
    return a.cloneElement(n, {
      ...c3(r, n.props),
      // @ts-ignore
      ref: t ? Wf(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Zi.displayName = "SlotClone";
var Vf = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function a3(e) {
  return a.isValidElement(e) && e.type === Vf;
}
function c3(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function l3(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var u3 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Uf = u3.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? Hf : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function jf(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function d3({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = f3({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = jf(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function f3({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = jf(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var p3 = "VisuallyHidden", Gf = a.forwardRef(
  (e, t) => /* @__PURE__ */ c(
    Uf.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Gf.displayName = p3;
var h3 = Gf, [xo, gT] = t3("Tooltip", [
  mt
]), Ro = mt(), zf = "TooltipProvider", v3 = 700, Ji = "tooltip.open", [m3, Ca] = xo(zf), Kf = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = v3,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, [s, l] = a.useState(!0), u = a.useRef(!1), d = a.useRef(0);
  return a.useEffect(() => {
    const h = d.current;
    return () => window.clearTimeout(h);
  }, []), /* @__PURE__ */ c(
    m3,
    {
      scope: t,
      isOpenDelayed: s,
      delayDuration: n,
      onOpen: a.useCallback(() => {
        window.clearTimeout(d.current), l(!1);
      }, []),
      onClose: a.useCallback(() => {
        window.clearTimeout(d.current), d.current = window.setTimeout(
          () => l(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: u,
      onPointerInTransitChange: a.useCallback((h) => {
        u.current = h;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
Kf.displayName = zf;
var To = "Tooltip", [g3, nr] = xo(To), Yf = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: i,
    disableHoverableContent: s,
    delayDuration: l
  } = e, u = Ca(To, e.__scopeTooltip), d = Ro(t), [h, f] = a.useState(null), w = s3(), g = a.useRef(0), v = s ?? u.disableHoverableContent, p = l ?? u.delayDuration, m = a.useRef(!1), [C = !1, y] = d3({
    prop: r,
    defaultProp: o,
    onChange: (O) => {
      O ? (u.onOpen(), document.dispatchEvent(new CustomEvent(Ji))) : u.onClose(), i?.(O);
    }
  }), b = a.useMemo(() => C ? m.current ? "delayed-open" : "instant-open" : "closed", [C]), S = a.useCallback(() => {
    window.clearTimeout(g.current), m.current = !1, y(!0);
  }, [y]), E = a.useCallback(() => {
    window.clearTimeout(g.current), y(!1);
  }, [y]), R = a.useCallback(() => {
    window.clearTimeout(g.current), g.current = window.setTimeout(() => {
      m.current = !0, y(!0);
    }, p);
  }, [p, y]);
  return a.useEffect(() => () => window.clearTimeout(g.current), []), /* @__PURE__ */ c(Xn, { ...d, children: /* @__PURE__ */ c(
    g3,
    {
      scope: t,
      contentId: w,
      open: C,
      stateAttribute: b,
      trigger: h,
      onTriggerChange: f,
      onTriggerEnter: a.useCallback(() => {
        u.isOpenDelayed ? R() : S();
      }, [u.isOpenDelayed, R, S]),
      onTriggerLeave: a.useCallback(() => {
        v ? E() : window.clearTimeout(g.current);
      }, [E, v]),
      onOpen: S,
      onClose: E,
      disableHoverableContent: v,
      children: n
    }
  ) });
};
Yf.displayName = To;
var Qi = "TooltipTrigger", qf = a.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = nr(Qi, n), i = Ca(Qi, n), s = Ro(n), l = a.useRef(null), u = Bf(t, l, o.onTriggerChange), d = a.useRef(!1), h = a.useRef(!1), f = a.useCallback(() => d.current = !1, []);
    return a.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ c(Zn, { asChild: !0, ...s, children: /* @__PURE__ */ c(
      Uf.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: u,
        onPointerMove: jt(e.onPointerMove, (w) => {
          w.pointerType !== "touch" && !h.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), h.current = !0);
        }),
        onPointerLeave: jt(e.onPointerLeave, () => {
          o.onTriggerLeave(), h.current = !1;
        }),
        onPointerDown: jt(e.onPointerDown, () => {
          d.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: jt(e.onFocus, () => {
          d.current || o.onOpen();
        }),
        onBlur: jt(e.onBlur, o.onClose),
        onClick: jt(e.onClick, o.onClose)
      }
    ) });
  }
);
qf.displayName = Qi;
var ya = "TooltipPortal", [w3, C3] = xo(ya, {
  forceMount: void 0
}), Xf = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = nr(ya, t);
  return /* @__PURE__ */ c(w3, { scope: t, forceMount: n, children: /* @__PURE__ */ c(be, { present: n || i.open, children: /* @__PURE__ */ c(mn, { asChild: !0, container: o, children: r }) }) });
};
Xf.displayName = ya;
var an = "TooltipContent", Zf = a.forwardRef(
  (e, t) => {
    const n = C3(an, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, s = nr(an, e.__scopeTooltip);
    return /* @__PURE__ */ c(be, { present: r || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ c(Jf, { side: o, ...i, ref: t }) : /* @__PURE__ */ c(y3, { side: o, ...i, ref: t }) });
  }
), y3 = a.forwardRef((e, t) => {
  const n = nr(an, e.__scopeTooltip), r = Ca(an, e.__scopeTooltip), o = a.useRef(null), i = Bf(t, o), [s, l] = a.useState(null), { trigger: u, onClose: d } = n, h = o.current, { onPointerInTransitChange: f } = r, w = a.useCallback(() => {
    l(null), f(!1);
  }, [f]), g = a.useCallback(
    (v, p) => {
      const m = v.currentTarget, C = { x: v.clientX, y: v.clientY }, y = S3(C, m.getBoundingClientRect()), b = x3(C, y), S = R3(p.getBoundingClientRect()), E = A3([...b, ...S]);
      l(E), f(!0);
    },
    [f]
  );
  return a.useEffect(() => () => w(), [w]), a.useEffect(() => {
    if (u && h) {
      const v = (m) => g(m, h), p = (m) => g(m, u);
      return u.addEventListener("pointerleave", v), h.addEventListener("pointerleave", p), () => {
        u.removeEventListener("pointerleave", v), h.removeEventListener("pointerleave", p);
      };
    }
  }, [u, h, g, w]), a.useEffect(() => {
    if (s) {
      const v = (p) => {
        const m = p.target, C = { x: p.clientX, y: p.clientY }, y = u?.contains(m) || h?.contains(m), b = !T3(C, s);
        y ? w() : b && (w(), d());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [u, h, s, d, w]), /* @__PURE__ */ c(Jf, { ...e, ref: i });
}), [E3, b3] = xo(To, { isInside: !1 }), Jf = a.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      ...l
    } = e, u = nr(an, n), d = Ro(n), { onClose: h } = u;
    return a.useEffect(() => (document.addEventListener(Ji, h), () => document.removeEventListener(Ji, h)), [h]), a.useEffect(() => {
      if (u.trigger) {
        const f = (w) => {
          w.target?.contains(u.trigger) && h();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [u.trigger, h]), /* @__PURE__ */ c(
      vt,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: s,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: h,
        children: /* @__PURE__ */ N(
          wo,
          {
            "data-state": u.stateAttribute,
            ...d,
            ...l,
            ref: t,
            style: {
              ...l.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ c(Vf, { children: r }),
              /* @__PURE__ */ c(E3, { scope: n, isInside: !0, children: /* @__PURE__ */ c(h3, { id: u.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
Zf.displayName = an;
var Qf = "TooltipArrow", ep = a.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Ro(n);
    return b3(
      Qf,
      n
    ).isInside ? null : /* @__PURE__ */ c(Co, { ...o, ...r, ref: t });
  }
);
ep.displayName = Qf;
function S3(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function x3(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function R3(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function T3(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const l = t[i].x, u = t[i].y, d = t[s].x, h = t[s].y;
    u > r != h > r && n < (d - l) * (r - u) / (h - u) + l && (o = !o);
  }
  return o;
}
function A3(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), N3(t);
}
function N3(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], s = t[t.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x))
        t.pop();
      else
        break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], s = n[n.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x))
        n.pop();
      else
        break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var k3 = Kf, P3 = Yf, M3 = qf, _3 = Xf, O3 = Zf, D3 = ep;
const $3 = {
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left"
}, L3 = {
  START: "start",
  CENTER: "center",
  END: "end"
}, At = {
  DARK: "dark",
  LIGHT: "light",
  ERROR: "error"
}, Sn = 5, I3 = {
  [At.DARK]: "bg-khaki-900 text-khaki-100",
  [At.LIGHT]: "bg-white text-khaki-900 border border-khaki-200",
  [At.ERROR]: "bg-red-50 text-red-600"
}, F3 = {
  [At.DARK]: "fill-khaki-900",
  [At.LIGHT]: "fill-khaki-200",
  [At.ERROR]: "fill-red-50"
}, Wn = ({
  variant: e = At.DARK,
  children: t,
  triggerComponent: n,
  position: r = $3.TOP,
  alignment: o = L3.CENTER,
  delayDuration: i = 700,
  disabled: s = !1,
  portalContainer: l,
  open: u
}) => s ? /* @__PURE__ */ c("span", { children: n }) : /* @__PURE__ */ c(k3, { children: /* @__PURE__ */ N(P3, { delayDuration: i, open: u, children: [
  /* @__PURE__ */ c(M3, { asChild: !0, children: /* @__PURE__ */ c("span", { children: n }) }),
  /* @__PURE__ */ c(_3, { container: l, children: /* @__PURE__ */ N(
    O3,
    {
      className: F(
        "text-small px-3 py-1.5 max-w-lg max-h-96 overflow-hidden",
        I3[e],
        $m
      ),
      sideOffset: Sn,
      collisionPadding: {
        top: Sn,
        right: Sn,
        bottom: Sn,
        left: Sn
      },
      side: r,
      align: o,
      children: [
        t,
        /* @__PURE__ */ c(D3, { className: F3[e] })
      ]
    }
  ) })
] }) }), Ea = "border-khaki-500 text-khaki-800 placeholder-khaki-500 caret-khaki-500", Et = "w-full h-9 rounded border px-3 py-1.5 text-small overflow-visible resize-none", li = "w-full h-9 px-3 py-1.5 text-small overflow-visible resize-none rounded-l border-b border-t border-l", W3 = "w-full h-14 rounded border px-3 py-1.5 text-small overflow-visible resize-none", Ao = "!text-khaki-400 placeholder-khaki-400 border-khaki-400 cursor-not-allowed", No = "focus:outline-none focus:ring focus:ring-indigo-200 focus:border-indigo-500", tp = "outline-none ring ring-red-200 border-red-600", np = "outline-none ring ring-yellow-200 border-yellow-500", ko = "bg-khaki-50", ba = "flex flex-col gap-2", Po = (e) => e ? "w-full" : "w-full max-w-64", Ee = {
  DEFAULT: "default",
  ERROR: "error",
  WARNING: "warning"
}, Sa = {
  [Ee.DEFAULT]: "",
  [Ee.WARNING]: np,
  [Ee.ERROR]: tp
}, St = {
  NONE: "none",
  INSIDE: "inside",
  ATTACHED: "attached"
}, Kc = {
  [St.INSIDE]: {
    [ge.SMALL]: F(Et.replace("h-9", "h-11"), "pr-28"),
    [ge.MEDIUM]: F(W3, "pr-28"),
    [ge.ICON]: F(Et, "pr-28")
  },
  [St.NONE]: {
    [ge.SMALL]: Et,
    [ge.MEDIUM]: Et,
    [ge.ICON]: Et
  },
  [St.ATTACHED]: {
    [ge.SMALL]: li,
    [ge.MEDIUM]: li,
    [ge.ICON]: li
  }
}, Bn = {
  INPUT_LABEL: "input-label"
}, Yc = {
  INPUT_MESSAGE: "input-message"
}, rp = ({ disabled: e, hidden: t }) => F(
  "flex gap-1 items-center text-small font-medium",
  e ? "text-khaki-400" : "text-khaki-700",
  t && "sr-only"
), op = ({ infoTooltip: e }) => /* @__PURE__ */ c(
  Wn,
  {
    triggerComponent: /* @__PURE__ */ c("div", { className: "cursor-pointer", children: /* @__PURE__ */ c(se, { Component: nu, size: U.S, color: le.Khaki500 }) }),
    delayDuration: 0,
    children: e
  }
), B3 = ({
  id: e,
  text: t,
  hidden: n = !1,
  disabled: r = !1,
  infoTooltip: o,
  required: i,
  testIdOverride: s = { label: Bn.INPUT_LABEL }
}) => /* @__PURE__ */ N(
  Xs,
  {
    htmlFor: e,
    "data-testid": s.label ?? Bn.INPUT_LABEL,
    className: rp({ disabled: r, hidden: n }),
    children: [
      t,
      i && /* @__PURE__ */ c("span", { className: "text-red-500", children: "*" }),
      o && /* @__PURE__ */ c(op, { infoTooltip: o })
    ]
  }
), H3 = ({
  text: e,
  hidden: t = !1,
  disabled: n = !1,
  infoTooltip: r,
  required: o,
  testIdOverride: i = { label: Bn.INPUT_LABEL }
}) => /* @__PURE__ */ N(
  "div",
  {
    "data-testid": i.label ?? Bn.INPUT_LABEL,
    className: rp({ disabled: n, hidden: t }),
    children: [
      e,
      o && /* @__PURE__ */ c("span", { className: "text-red-500", children: "*" }),
      r && /* @__PURE__ */ c(op, { infoTooltip: r })
    ]
  }
), Cn = ({
  id: e,
  text: t,
  hidden: n = !1,
  disabled: r = !1,
  infoTooltip: o,
  required: i,
  testIdOverride: s = { label: Bn.INPUT_LABEL }
}) => /* @__PURE__ */ c("span", { className: "relative", children: e ? /* @__PURE__ */ c(
  B3,
  {
    id: e,
    text: t,
    hidden: n,
    disabled: r,
    infoTooltip: o,
    required: i,
    testIdOverride: s
  }
) : /* @__PURE__ */ c(
  H3,
  {
    text: t,
    hidden: n,
    disabled: r,
    infoTooltip: o,
    required: i,
    testIdOverride: s
  }
) }), Gt = {
  INPUT: "input",
  INPUT_LABEL: "input-label",
  INPUT_MESSAGE: "input-message"
}, V3 = {
  [Ee.WARNING]: /* @__PURE__ */ c(se, { Component: $s, size: U.XS, color: le.Yellow500 }),
  [Ee.ERROR]: /* @__PURE__ */ c(se, { Component: Ks, size: U.XS, color: le.Red500 }),
  [Ee.DEFAULT]: null
}, ip = {
  [Ee.WARNING]: "text-yellow-600 font-medium",
  [Ee.ERROR]: "text-red-600 font-medium",
  [Ee.DEFAULT]: "text-khaki-600"
}, cn = ({
  text: e,
  state: t = Ee.DEFAULT,
  disabled: n = !1,
  testIdOverride: r = { message: Yc.INPUT_MESSAGE }
}) => /* @__PURE__ */ N("span", { className: "flex gap-1 items-center pl-3 text-caption", children: [
  !n && V3[t],
  /* @__PURE__ */ c(
    "span",
    {
      "data-testid": r.message ?? Yc.INPUT_MESSAGE,
      className: n ? "text-khaki-400" : ip[t],
      children: e
    }
  )
] }), sp = ({ message: e, state: t, limit: n, disabled: r, testIdOverride: o, currentLength: i }) => /* @__PURE__ */ N("div", { className: "flex items-center", children: [
  e && /* @__PURE__ */ c(cn, { text: e, state: t, disabled: r, testIdOverride: { message: o } }),
  n && /* @__PURE__ */ c("div", { className: "whitespace-nowrap ml-auto mr-3", children: /* @__PURE__ */ c(cn, { text: `${i} / ${n}` }) })
] }), wT = Ye(
  ({
    value: e,
    onChange: t,
    label: n,
    hideLabel: r = !1,
    disabled: o = !1,
    state: i = Ee.DEFAULT,
    fluid: s = !0,
    filled: l = !1,
    message: u = "",
    buttonProps: d,
    multiActionProps: h,
    labelInfoTooltip: f,
    maxLength: w,
    id: g,
    required: v,
    testIdOverride: p = {
      label: Gt.INPUT_LABEL,
      message: Gt.INPUT_MESSAGE,
      input: Gt.INPUT
    },
    ...m
  }, C) => {
    if (d && h)
      throw new Error("Cannot use both buttonProps and multiActionProps");
    const { position: y } = d ?? { position: St.NONE }, b = ie(() => g ?? at(), [g]), S = ie(() => Sa[i], [i]), E = ie(() => h ? Kc[St.INSIDE][ge.ICON] : Kc[y][d?.Button?.size ?? ge.SMALL], [d, h, y]), R = ie(() => {
      if (h)
        return /* @__PURE__ */ c("div", { className: "absolute right-0 inset-y-0 mr-2 gap-2 flex items-center", children: h.map((D, Z) => /* @__PURE__ */ c(Ff, { ...D }, Z)) });
      if (!d)
        return null;
      switch (y) {
        case St.INSIDE:
          switch (d.Button?.size ?? ge.MEDIUM) {
            case ge.SMALL:
            case ge.ICON:
              return /* @__PURE__ */ c("div", { className: "absolute right-0 inset-y-0 mr-2 flex items-center", children: /* @__PURE__ */ c(Me, { ...d.Button }) });
            case ge.MEDIUM:
              return /* @__PURE__ */ c("div", { className: "absolute right-0 inset-y-0 mr-3 flex items-center", children: /* @__PURE__ */ c(Me, { ...d.Button }) });
            default:
              return null;
          }
        case St.ATTACHED:
          return /* @__PURE__ */ c(Me, { ...d.Button, inlineAlignment: Mn.RIGHT });
        default:
          return null;
      }
    }, [d, h, y]), [O, $] = he(e?.toString().length || 0);
    Pe(() => {
      $(e?.toString().length || 0);
    }, [e]);
    const H = (D) => {
      w && $(D.target.value.length), t?.(D);
    }, j = w !== void 0 || u !== "";
    return /* @__PURE__ */ N("div", { className: F(ba, Po(s)), children: [
      /* @__PURE__ */ c(
        Cn,
        {
          id: b,
          text: n,
          disabled: o,
          hidden: r,
          testIdOverride: { label: p.label ?? Gt.INPUT_LABEL },
          infoTooltip: f,
          required: v
        }
      ),
      /* @__PURE__ */ N("div", { className: "flex relative", children: [
        /* @__PURE__ */ c(
          "input",
          {
            ref: C,
            className: F(
              E,
              No,
              o ? Ao : F(S, Ea, l && ko)
            ),
            value: e,
            onChange: H,
            disabled: o,
            "data-testid": p.input ?? Gt.INPUT,
            id: b,
            required: v,
            ...m
          }
        ),
        R
      ] }),
      j && /* @__PURE__ */ c(
        sp,
        {
          limit: w,
          currentLength: O,
          message: u,
          disabled: o,
          state: i,
          testIdOverride: p.message ?? Gt.INPUT_MESSAGE
        }
      )
    ] });
  }
), xa = ru({
  openModal: () => {
  },
  closeModal: () => {
  },
  ModalOutlet: () => null
}), U3 = ({ withOutlet: e, setWithOutlet: t, id: n }) => {
  const { ModalOutlet: r } = Is(xa);
  return Pe(() => {
    e || t(!0);
  }, [e, t]), /* @__PURE__ */ c(r, { id: n });
}, Or = "default-modal-id", CT = () => {
  const [e, t] = he(!1), n = ie(() => e ? at() : Or, [e]), { openModal: r, closeModal: o } = Is(xa), i = me(
    (u, d) => {
      r(u, d, n);
    },
    [n, r]
  ), s = me(
    () => /* @__PURE__ */ c(U3, { withOutlet: e, setWithOutlet: t, id: n }),
    [n, e]
  );
  return ie(() => ({ openModal: i, closeModal: o, ModalOutlet: s }), [s, o, i]);
}, yT = ({ children: e }) => {
  const [t, n] = he(null), [r, o] = he(Or), i = me(() => {
    n(null), o(Or);
  }, []), s = me(
    (d, h, f) => {
      n(/* @__PURE__ */ c(d, { ...h, closeModal: i })), o(f);
    },
    [i]
  ), l = me(
    ({ id: d }) => typeof document < "u" && d === r ? su(t, document.body) : null,
    [t, r]
  ), u = ie(() => ({ openModal: s, closeModal: i, ModalOutlet: l }), [s, i, l]);
  return /* @__PURE__ */ N(xa.Provider, { value: u, children: [
    /* @__PURE__ */ c(l, { id: Or }),
    e
  ] });
}, j3 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M11.667 7H2.333m0 0 3.5 3.5M2.333 7l3.5-3.5" }) }), G3 = j3, z3 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M11.667 7H2.333m0 0 3.5 3.5M2.333 7l3.5-3.5" }) }), K3 = z3, Y3 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "M13.333 8H2.667m0 0 4 4m-4-4 4-4" }) }), q3 = Y3, X3 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "M13.333 8H2.667m0 0 4 4m-4-4 4-4" }) }), Z3 = X3, J3 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M16.667 10H3.333m0 0 5 5m-5-5 5-5" }) }), Q3 = J3, eE = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M16.667 10H3.333m0 0 5 5m-5-5 5-5" }) }), tE = eE, nE = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M20 12H4m0 0 6 6m-6-6 6-6" }) }), qc = nE, rE = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M20 12H4m0 0 6 6m-6-6 6-6" }) }), Xc = rE, oE = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c(G3, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(K3, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c(q3, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Z3, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Q3, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(tE, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(qc, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Xc, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(qc, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Xc, { color: e }),
    [x.Filled]: (e) => null
  }
}, iE = ({ size: e, style: t, color: n }) => oE[e][t](n), ET = ({ onClick: e }) => /* @__PURE__ */ c("div", { className: "p-6", children: /* @__PURE__ */ c(
  Me,
  {
    variant: "tertiary",
    text: "Back",
    size: "small",
    icon: {
      Component: iE,
      position: "center"
    },
    onClick: e
  }
) });
function bT({ children: e }) {
  return /* @__PURE__ */ c("div", { className: "divide-y divide-khaki-150 flex-1 overflow-y-auto", children: e });
}
function ST({ children: e }) {
  return /* @__PURE__ */ c("div", { children: e });
}
function xT({ children: e, primaryAction: t }) {
  return /* @__PURE__ */ N("div", { className: "px-5 pt-6 pb-5 space-y-6", children: [
    /* @__PURE__ */ c("div", { children: e }),
    /* @__PURE__ */ c(
      Me,
      {
        text: t.text,
        variant: "primary",
        fluid: !0,
        icon: t.icon,
        onClick: t.onClick,
        testIdOverride: t.testIdOverride
      }
    )
  ] });
}
const Zc = "w-full text-small font-medium rounded text-khaki-800 hover:bg-khaki-50 active:bg-khaki-150 active:text-khaki-900 transition-colors duration-200 ease-in-out", Jc = "focus-visible:text-khaki-900 focus-visible:ring-2 focus-visible:ring-indigo-200 outline-none", sE = "flex items-center gap-2.5 py-[5px] pl-2.5 pr-2", ap = "flex items-center py-[3px] pl-2.5 pr-0.5 justify-between", Mo = {
  primary: F(Zc, sE, Jc),
  sub: F(Zc, ap, Jc, "!justify-start")
}, cp = "bg-khaki-150 text-khaki-900", aE = "w-full text-small font-medium text-khaki-800 rounded outline-none data-[highlighted]:bg-khaki-100", cE = "flex items-center gap-2.5 py-1 px-2";
var lp = /* @__PURE__ */ ((e) => (e.DROPDOWN_TRIGGER_CHEVRON = "dropdown-trigger-chevron", e))(lp || {});
function RT({
  label: e,
  icon: t,
  description: n,
  isActive: r,
  as: o,
  ...i
}) {
  const s = o || "a", l = {
    className: F(Mo.primary, r && cp),
    "aria-label": e,
    ...i
  };
  return /* @__PURE__ */ c("li", { children: /* @__PURE__ */ N(s, { ...l, children: [
    t && /* @__PURE__ */ c(
      se,
      {
        Component: t,
        color: le.CurrentColor,
        size: U.S,
        style: r ? x.Filled : x.Line
      }
    ),
    /* @__PURE__ */ N("span", { className: "relative", children: [
      e,
      n && /* @__PURE__ */ c("span", { className: "absolute left-full ml-2", children: n })
    ] })
  ] }) });
}
function TT({ children: e }) {
  return (
    // Removing the top padding on the first NavSection allows for the correct scroll behavior and spacing between it and the NavHeader
    /* @__PURE__ */ c("nav", { className: "px-3 py-4 first:pt-0", children: /* @__PURE__ */ c("ul", { className: "space-y-1.5", children: e }) })
  );
}
function AT({ children: e }) {
  return /* @__PURE__ */ c("div", { className: "h-full bg-khaki-25 flex flex-col justify-between border-r border-khaki-400", children: e });
}
function NT({ firstName: e, lastName: t, workspaceName: n, children: r }) {
  const [o, i] = he(!1), s = _e(null);
  return /* @__PURE__ */ c("div", { className: F("border-t border-khaki-150 px-2 py-3", o && "bg-khaki-50"), ref: s, children: /* @__PURE__ */ N(Of, { onOpenChange: i, children: [
    /* @__PURE__ */ c(Df, { asChild: !0, children: /* @__PURE__ */ c("span", { className: "w-full group", children: /* @__PURE__ */ N(
      "button",
      {
        "aria-label": "Open user profile menu",
        className: F(Mo.primary, "flex items-center"),
        children: [
          /* @__PURE__ */ N("span", { className: "flex items-center gap-3 text-left truncate", children: [
            /* @__PURE__ */ c("span", { children: /* @__PURE__ */ c(Zu, { name: `${e} ${t}`, size: "small" }) }),
            /* @__PURE__ */ N("span", { className: "truncate", children: [
              /* @__PURE__ */ c("span", { className: "block text-khaki-900 font-medium truncate", children: e }),
              /* @__PURE__ */ c("span", { className: "block text-khaki-900 font-medium text-caption truncate", children: n })
            ] })
          ] }),
          /* @__PURE__ */ c(
            "span",
            {
              className: F(
                "h-fit mt-1 ml-auto transform transition-transform duration-200 group-data-[state=open]:rotate-180"
              ),
              children: /* @__PURE__ */ c(se, { Component: Ls, size: U.S, color: le.Khaki900 })
            }
          )
        ]
      }
    ) }) }),
    /* @__PURE__ */ c(wa, { children: /* @__PURE__ */ c(
      $f,
      {
        sideOffset: 13,
        side: "top",
        align: "center",
        className: F(
          "px-2 py-1 bg-khaki-50 border-t divide-y divide-khaki-150 border-khaki-400 overflow-y-auto overflow-x-hidden max-h-[calc(var(--radix-dropdown-menu-content-available-height)-10px)]",
          "will-change-[opacity,transform] data-[side=top]:animate-slide-down data-[side=bottom]:animate-slide-up shadow-profile-dropdown",
          Yn
        ),
        style: { width: s?.current?.offsetWidth ?? "auto" },
        children: /* @__PURE__ */ c("nav", { children: /* @__PURE__ */ c("ul", { className: "space-y-1", children: r }) })
      }
    ) })
  ] }) });
}
function kT() {
  return /* @__PURE__ */ c("li", { children: /* @__PURE__ */ c("hr", { className: "-mx-2" }) });
}
function PT({
  label: e,
  icon: t,
  as: n,
  ...r
}) {
  const o = n || "a", i = {
    className: F(aE, cE),
    "aria-label": e,
    ...r
  };
  return /* @__PURE__ */ c("li", { children: /* @__PURE__ */ c(_r, { asChild: !0, children: /* @__PURE__ */ N(o, { ...i, children: [
    t && /* @__PURE__ */ c(se, { Component: t, color: le.CurrentColor, size: U.S, style: x.Line }),
    /* @__PURE__ */ c("span", { children: e })
  ] }) }) });
}
function up(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, lE(o, ...t)];
}
function lE(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function uE(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function dp(...e) {
  return (t) => e.forEach((n) => uE(n, t));
}
function es(...e) {
  return a.useCallback(dp(...e), e);
}
var qr = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(fE);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(ts, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(ts, { ...r, ref: t, children: n });
});
qr.displayName = "Slot";
var ts = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = hE(n);
    return a.cloneElement(n, {
      ...pE(r, n.props),
      // @ts-ignore
      ref: t ? dp(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
ts.displayName = "SlotClone";
var dE = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function fE(e) {
  return a.isValidElement(e) && e.type === dE;
}
function pE(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function hE(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function vE(e) {
  const t = e + "CollectionProvider", [n, r] = up(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: v, children: p } = g, m = ne.useRef(null), C = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ c(o, { scope: v, itemMap: C, collectionRef: m, children: p });
  };
  s.displayName = t;
  const l = e + "CollectionSlot", u = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m } = g, C = i(l, p), y = es(v, C.collectionRef);
      return /* @__PURE__ */ c(qr, { ref: y, children: m });
    }
  );
  u.displayName = l;
  const d = e + "CollectionItemSlot", h = "data-radix-collection-item", f = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m, ...C } = g, y = ne.useRef(null), b = es(v, y), S = i(d, p);
      return ne.useEffect(() => (S.itemMap.set(y, { ref: y, ...C }), () => void S.itemMap.delete(y))), /* @__PURE__ */ c(qr, { [h]: "", ref: b, children: m });
    }
  );
  f.displayName = d;
  function w(g) {
    const v = i(e + "CollectionConsumer", g);
    return ne.useCallback(() => {
      const m = v.collectionRef.current;
      if (!m)
        return [];
      const C = Array.from(m.querySelectorAll(`[${h}]`));
      return Array.from(v.itemMap.values()).sort(
        (S, E) => C.indexOf(S.ref.current) - C.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: u, ItemSlot: f },
    w,
    r
  ];
}
function mE(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function fp(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function pp({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = gE({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = fp(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function gE({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = fp(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var wE = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], hp = wE.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? qr : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function CE(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function yE(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, EE(o, ...t)];
}
function EE(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function vp(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function bE({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = SE({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = vp(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function SE({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = vp(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var mp = globalThis?.document ? a.useLayoutEffect : () => {
};
function xE(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function gp(...e) {
  return (t) => e.forEach((n) => xE(n, t));
}
function RE(...e) {
  return a.useCallback(gp(...e), e);
}
var wp = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(AE);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(ns, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(ns, { ...r, ref: t, children: n });
});
wp.displayName = "Slot";
var ns = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = kE(n);
    return a.cloneElement(n, {
      ...NE(r, n.props),
      // @ts-ignore
      ref: t ? gp(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
ns.displayName = "SlotClone";
var TE = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function AE(e) {
  return a.isValidElement(e) && e.type === TE;
}
function NE(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function kE(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var PE = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ra = PE.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? wp : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), ME = a["useId".toString()] || (() => {
}), _E = 0;
function OE(e) {
  const [t, n] = a.useState(ME());
  return mp(() => {
    e || n((r) => r ?? String(_E++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var Ta = "Collapsible", [DE, Cp] = yE(Ta), [$E, Aa] = DE(Ta), yp = a.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: i,
      onOpenChange: s,
      ...l
    } = e, [u = !1, d] = bE({
      prop: r,
      defaultProp: o,
      onChange: s
    });
    return /* @__PURE__ */ c(
      $E,
      {
        scope: n,
        disabled: i,
        contentId: OE(),
        open: u,
        onOpenToggle: a.useCallback(() => d((h) => !h), [d]),
        children: /* @__PURE__ */ c(
          Ra.div,
          {
            "data-state": ka(u),
            "data-disabled": i ? "" : void 0,
            ...l,
            ref: t
          }
        )
      }
    );
  }
);
yp.displayName = Ta;
var Ep = "CollapsibleTrigger", bp = a.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, o = Aa(Ep, n);
    return /* @__PURE__ */ c(
      Ra.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": ka(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: t,
        onClick: CE(e.onClick, o.onOpenToggle)
      }
    );
  }
);
bp.displayName = Ep;
var Na = "CollapsibleContent", Sp = a.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = Aa(Na, e.__scopeCollapsible);
    return /* @__PURE__ */ c(be, { present: n || o.open, children: ({ present: i }) => /* @__PURE__ */ c(LE, { ...r, ref: t, present: i }) });
  }
);
Sp.displayName = Na;
var LE = a.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...i } = e, s = Aa(Na, n), [l, u] = a.useState(r), d = a.useRef(null), h = RE(t, d), f = a.useRef(0), w = f.current, g = a.useRef(0), v = g.current, p = s.open || l, m = a.useRef(p), C = a.useRef();
  return a.useEffect(() => {
    const y = requestAnimationFrame(() => m.current = !1);
    return () => cancelAnimationFrame(y);
  }, []), mp(() => {
    const y = d.current;
    if (y) {
      C.current = C.current || {
        transitionDuration: y.style.transitionDuration,
        animationName: y.style.animationName
      }, y.style.transitionDuration = "0s", y.style.animationName = "none";
      const b = y.getBoundingClientRect();
      f.current = b.height, g.current = b.width, m.current || (y.style.transitionDuration = C.current.transitionDuration, y.style.animationName = C.current.animationName), u(r);
    }
  }, [s.open, r]), /* @__PURE__ */ c(
    Ra.div,
    {
      "data-state": ka(s.open),
      "data-disabled": s.disabled ? "" : void 0,
      id: s.contentId,
      hidden: !p,
      ...i,
      ref: h,
      style: {
        ["--radix-collapsible-content-height"]: w ? `${w}px` : void 0,
        ["--radix-collapsible-content-width"]: v ? `${v}px` : void 0,
        ...e.style
      },
      children: p && o
    }
  );
});
function ka(e) {
  return e ? "open" : "closed";
}
var IE = yp, FE = bp, WE = Sp, BE = globalThis?.document ? a.useLayoutEffect : () => {
}, HE = a["useId".toString()] || (() => {
}), VE = 0;
function UE(e) {
  const [t, n] = a.useState(HE());
  return BE(() => {
    e || n((r) => r ?? String(VE++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var jE = a.createContext(void 0);
function GE(e) {
  const t = a.useContext(jE);
  return e || t || "ltr";
}
var lt = "Accordion", zE = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Pa, KE, YE] = vE(lt), [_o, MT] = up(lt, [
  YE,
  Cp
]), Ma = Cp(), xp = ne.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, o = r, i = r;
    return /* @__PURE__ */ c(Pa.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ c(JE, { ...i, ref: t }) : /* @__PURE__ */ c(ZE, { ...o, ref: t }) });
  }
);
xp.displayName = lt;
var [Rp, qE] = _o(lt), [Tp, XE] = _o(
  lt,
  { collapsible: !1 }
), ZE = ne.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: i = !1,
      ...s
    } = e, [l, u] = pp({
      prop: n,
      defaultProp: r,
      onChange: o
    });
    return /* @__PURE__ */ c(
      Rp,
      {
        scope: e.__scopeAccordion,
        value: l ? [l] : [],
        onItemOpen: u,
        onItemClose: ne.useCallback(() => i && u(""), [i, u]),
        children: /* @__PURE__ */ c(Tp, { scope: e.__scopeAccordion, collapsible: i, children: /* @__PURE__ */ c(Ap, { ...s, ref: t }) })
      }
    );
  }
), JE = ne.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...i
  } = e, [s = [], l] = pp({
    prop: n,
    defaultProp: r,
    onChange: o
  }), u = ne.useCallback(
    (h) => l((f = []) => [...f, h]),
    [l]
  ), d = ne.useCallback(
    (h) => l((f = []) => f.filter((w) => w !== h)),
    [l]
  );
  return /* @__PURE__ */ c(
    Rp,
    {
      scope: e.__scopeAccordion,
      value: s,
      onItemOpen: u,
      onItemClose: d,
      children: /* @__PURE__ */ c(Tp, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ c(Ap, { ...i, ref: t }) })
    }
  );
}), [QE, Oo] = _o(lt), Ap = ne.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: o, orientation: i = "vertical", ...s } = e, l = ne.useRef(null), u = es(l, t), d = KE(n), f = GE(o) === "ltr", w = mE(e.onKeyDown, (g) => {
      if (!zE.includes(g.key))
        return;
      const v = g.target, p = d().filter(($) => !$.ref.current?.disabled), m = p.findIndex(($) => $.ref.current === v), C = p.length;
      if (m === -1)
        return;
      g.preventDefault();
      let y = m;
      const b = 0, S = C - 1, E = () => {
        y = m + 1, y > S && (y = b);
      }, R = () => {
        y = m - 1, y < b && (y = S);
      };
      switch (g.key) {
        case "Home":
          y = b;
          break;
        case "End":
          y = S;
          break;
        case "ArrowRight":
          i === "horizontal" && (f ? E() : R());
          break;
        case "ArrowDown":
          i === "vertical" && E();
          break;
        case "ArrowLeft":
          i === "horizontal" && (f ? R() : E());
          break;
        case "ArrowUp":
          i === "vertical" && R();
          break;
      }
      const O = y % C;
      p[O].ref.current?.focus();
    });
    return /* @__PURE__ */ c(
      QE,
      {
        scope: n,
        disabled: r,
        direction: o,
        orientation: i,
        children: /* @__PURE__ */ c(Pa.Slot, { scope: n, children: /* @__PURE__ */ c(
          hp.div,
          {
            ...s,
            "data-orientation": i,
            ref: u,
            onKeyDown: r ? void 0 : w
          }
        ) })
      }
    );
  }
), Xr = "AccordionItem", [eb, _a] = _o(Xr), Np = ne.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...o } = e, i = Oo(Xr, n), s = qE(Xr, n), l = Ma(n), u = UE(), d = r && s.value.includes(r) || !1, h = i.disabled || e.disabled;
    return /* @__PURE__ */ c(
      eb,
      {
        scope: n,
        open: d,
        disabled: h,
        triggerId: u,
        children: /* @__PURE__ */ c(
          IE,
          {
            "data-orientation": i.orientation,
            "data-state": Op(d),
            ...l,
            ...o,
            ref: t,
            disabled: h,
            open: d,
            onOpenChange: (f) => {
              f ? s.onItemOpen(r) : s.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
Np.displayName = Xr;
var kp = "AccordionHeader", tb = ne.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Oo(lt, n), i = _a(kp, n);
    return /* @__PURE__ */ c(
      hp.h3,
      {
        "data-orientation": o.orientation,
        "data-state": Op(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
tb.displayName = kp;
var rs = "AccordionTrigger", Pp = ne.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Oo(lt, n), i = _a(rs, n), s = XE(rs, n), l = Ma(n);
    return /* @__PURE__ */ c(Pa.ItemSlot, { scope: n, children: /* @__PURE__ */ c(
      FE,
      {
        "aria-disabled": i.open && !s.collapsible || void 0,
        "data-orientation": o.orientation,
        id: i.triggerId,
        ...l,
        ...r,
        ref: t
      }
    ) });
  }
);
Pp.displayName = rs;
var Mp = "AccordionContent", _p = ne.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Oo(lt, n), i = _a(Mp, n), s = Ma(n);
    return /* @__PURE__ */ c(
      WE,
      {
        role: "region",
        "aria-labelledby": i.triggerId,
        "data-orientation": o.orientation,
        ...s,
        ...r,
        ref: t,
        style: {
          ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
          ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
_p.displayName = Mp;
function Op(e) {
  return e ? "open" : "closed";
}
var nb = xp, rb = Np, ob = Pp, ib = _p;
const ui = "sub-nav-dropdown", _T = ({
  children: e,
  title: t,
  icon: n,
  collapsible: r = !0,
  isOpen: o,
  description: i,
  onToggle: s
}) => {
  const l = me(
    (d) => {
      if (!r)
        return;
      s?.(d === ui);
    },
    [r, s]
  ), u = r ? o : !0;
  return /* @__PURE__ */ c("li", { children: /* @__PURE__ */ c(
    nb,
    {
      type: "single",
      collapsible: r,
      value: u ? ui : "",
      onValueChange: l,
      disabled: !r,
      children: /* @__PURE__ */ N(rb, { value: ui, className: "space-y-1", children: [
        /* @__PURE__ */ N(
          ob,
          {
            className: F(
              Mo.primary,
              "group justify-between gap-0",
              u && "!font-heavy !text-khaki-800",
              !r && "cursor-default pointer-events-none"
            ),
            "aria-label": `${u ? "Close" : "Open"} ${t} sub navigation menu`,
            children: [
              /* @__PURE__ */ N("span", { className: "flex items-center gap-2.5", children: [
                n && /* @__PURE__ */ c(se, { Component: n, color: le.CurrentColor, size: U.S, style: x.Line }),
                /* @__PURE__ */ c("span", { children: t }),
                i && /* @__PURE__ */ c("span", { children: i })
              ] }),
              r && /* @__PURE__ */ c(
                "span",
                {
                  "data-testid": lp.DROPDOWN_TRIGGER_CHEVRON,
                  className: "transition-all group-data-[state=open]:rotate-180",
                  children: /* @__PURE__ */ c(
                    se,
                    {
                      Component: Fr,
                      color: le.CurrentColor,
                      size: U.S,
                      style: x.Line
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ c(ib, { className: "data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up overflow-hidden", children: /* @__PURE__ */ c(
          "ul",
          {
            className: F(
              "space-y-1.5 py-1.5 ml-4 mr-0.5",
              r ? "pl-3 border-l-2 border-khaki-200" : "pl-3.5"
            ),
            children: e
          }
        ) })
      ] })
    }
  ) });
};
function OT({ text: e, isError: t = !1 }) {
  return /* @__PURE__ */ c("div", { className: F(ap, "text-khaki-800 text-small leading-normal", t && "text-red-600"), children: e });
}
function DT({
  label: e,
  icon: t,
  description: n,
  isActive: r,
  onRemove: o,
  isHeavy: i,
  as: s,
  ...l
}) {
  const u = s || "a", d = {
    className: F(
      "flex items-center text-left gap-2.5 truncate grow",
      Mo.sub,
      i && "!font-heavy"
    ),
    "aria-label": e,
    ...l
  };
  return /* @__PURE__ */ N(
    "li",
    {
      className: F(
        "group flex items-center gap-1 transition-colors duration-200 ease-in-out hover:bg-khaki-50 rounded pr-[3px]",
        r && cp,
        "animate-fade-in"
      ),
      children: [
        /* @__PURE__ */ N(u, { ...d, children: [
          t && /* @__PURE__ */ c("span", { children: /* @__PURE__ */ c(se, { Component: t, color: le.CurrentColor, size: U.S, style: x.Line }) }),
          /* @__PURE__ */ c("span", { className: "truncate shrink", children: e }),
          n && /* @__PURE__ */ c("span", { children: n })
        ] }),
        o && /* @__PURE__ */ c("span", { className: "opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out focus-within:[&:has(:focus-visible)]:opacity-100", children: /* @__PURE__ */ c(Ff, { Icon: pn, label: `Remove ${e}`, onClick: o, variant: "tertiary" }) })
      ]
    }
  );
}
function $T({ width: e }) {
  return /* @__PURE__ */ c("div", { className: "py-[3px] px-2.5", children: /* @__PURE__ */ c(
    "div",
    {
      "data-testid": "subnavlink-skeleton",
      className: "h-6 rounded-lg bg-khaki-100 animate-pulse",
      style: { width: `${e}px` }
    }
  ) });
}
const sb = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "m8.75 5.25-3.5 3.5m0-3.5 3.5 3.5M12.832 7A5.833 5.833 0 1 1 1.166 7a5.833 5.833 0 0 1 11.667 0Z"
  }
) }) }), ab = sb, cb = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ N("g", { children: [
  /* @__PURE__ */ c("path", { fill: e, d: "M7 12.833A5.833 5.833 0 1 0 7 1.167a5.833 5.833 0 0 0 0 11.666", opacity: ".12" }),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "m8.75 5.25-3.5 3.5m0-3.5 3.5 3.5M12.832 7A5.833 5.833 0 1 1 1.166 7a5.833 5.833 0 0 1 11.667 0Z"
    }
  )
] }) }), lb = cb, ub = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.5",
    d: "m10 6-4 4m0-4 4 4m4.667-2A6.667 6.667 0 1 1 1.334 8a6.667 6.667 0 0 1 13.333 0Z"
  }
) }) }), db = ub, fb = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ N("g", { children: [
  /* @__PURE__ */ c("path", { fill: e, d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334", opacity: ".12" }),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "m10 6-4 4m0-4 4 4m4.667-2A6.667 6.667 0 1 1 1.334 8a6.667 6.667 0 0 1 13.333 0Z"
    }
  )
] }) }), pb = fb, hb = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "m12.5 7.5-5 5m0-5 5 5m5.833-2.5a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0Z"
  }
) }) }), vb = hb, mb = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ N("g", { children: [
  /* @__PURE__ */ c("path", { fill: e, d: "M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666", opacity: ".12" }),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "m12.5 7.5-5 5m0-5 5 5m5.833-2.5a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0Z"
    }
  )
] }) }), gb = mb, wb = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "m15 9-6 6m0-6 6 6m7-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }
) }), Qc = wb, Cb = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ c("path", { fill: e, d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10", opacity: ".12" }),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "m15 9-6 6m0-6 6 6m7-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
    }
  )
] }), el = Cb, yb = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c(ab, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(lb, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c(db, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(pb, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(vb, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(gb, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Qc, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(el, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Qc, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(el, { color: e }),
    [x.Filled]: (e) => null
  }
}, Eb = ({ size: e, style: t, color: n }) => yb[e][t](n);
var os = /* @__PURE__ */ ((e) => (e.SEARCH_BASE = "search-base", e.SEARCH_INPUT = "search-input", e))(os || {});
const bb = ({
  value: e,
  onChange: t,
  disabled: n = !1,
  fluid: r = !0,
  filled: o = !1,
  message: i = "",
  placeholder: s = "Search"
}) => {
  const l = _e(null);
  return /* @__PURE__ */ N(
    "div",
    {
      "data-testid": os.SEARCH_BASE,
      className: F(ba, Po(r)),
      onClick: () => l.current?.focus(),
      children: [
        /* @__PURE__ */ N("span", { className: "flex flex-col gap-3 relative", children: [
          /* @__PURE__ */ c("span", { className: "absolute inset-y-0 pl-3 flex items-center", children: /* @__PURE__ */ c(se, { Component: w0, color: le.Khaki800, size: U.S }) }),
          /* @__PURE__ */ c(
            "input",
            {
              ref: l,
              "data-testid": os.SEARCH_INPUT,
              className: F(
                Et,
                No,
                "pl-8 pr-8 w-full",
                n ? Ao : F(Ea, o && ko)
              ),
              type: "search",
              placeholder: s,
              value: e,
              onChange: (u) => t(u.target.value),
              disabled: n
            }
          ),
          e && /* @__PURE__ */ c("span", { className: "absolute right-0 inset-y-0 mr-3 flex items-center", children: /* @__PURE__ */ c("button", { onClick: () => t(""), className: "h4", children: /* @__PURE__ */ c(se, { Component: Eb, color: le.Khaki800, size: U.S }) }) })
        ] }),
        /* @__PURE__ */ c(cn, { text: i, state: "default", disabled: n })
      ]
    }
  );
};
function tl(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function Ne(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function Dp(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, Sb(o, ...t)];
}
function Sb(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function xb(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function $p(...e) {
  return (t) => e.forEach((n) => xb(n, t));
}
function We(...e) {
  return a.useCallback($p(...e), e);
}
var Hn = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(Tb);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(is, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(is, { ...r, ref: t, children: n });
});
Hn.displayName = "Slot";
var is = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = Nb(n);
    return a.cloneElement(n, {
      ...Ab(r, n.props),
      // @ts-ignore
      ref: t ? $p(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
is.displayName = "SlotClone";
var Rb = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function Tb(e) {
  return a.isValidElement(e) && e.type === Rb;
}
function Ab(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Nb(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function kb(e) {
  const t = e + "CollectionProvider", [n, r] = Dp(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: v, children: p } = g, m = ne.useRef(null), C = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ c(o, { scope: v, itemMap: C, collectionRef: m, children: p });
  };
  s.displayName = t;
  const l = e + "CollectionSlot", u = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m } = g, C = i(l, p), y = We(v, C.collectionRef);
      return /* @__PURE__ */ c(Hn, { ref: y, children: m });
    }
  );
  u.displayName = l;
  const d = e + "CollectionItemSlot", h = "data-radix-collection-item", f = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m, ...C } = g, y = ne.useRef(null), b = We(v, y), S = i(d, p);
      return ne.useEffect(() => (S.itemMap.set(y, { ref: y, ...C }), () => void S.itemMap.delete(y))), /* @__PURE__ */ c(Hn, { [h]: "", ref: b, children: m });
    }
  );
  f.displayName = d;
  function w(g) {
    const v = i(e + "CollectionConsumer", g);
    return ne.useCallback(() => {
      const m = v.collectionRef.current;
      if (!m)
        return [];
      const C = Array.from(m.querySelectorAll(`[${h}]`));
      return Array.from(v.itemMap.values()).sort(
        (S, E) => C.indexOf(S.ref.current) - C.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: u, ItemSlot: f },
    w,
    r
  ];
}
var Pb = a.createContext(void 0);
function Mb(e) {
  const t = a.useContext(Pb);
  return e || t || "ltr";
}
var di = 0;
function _b() {
  a.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? nl()), document.body.insertAdjacentElement("beforeend", e[1] ?? nl()), di++, () => {
      di === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), di--;
    };
  }, []);
}
function nl() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var it = globalThis?.document ? a.useLayoutEffect : () => {
}, Ob = a["useId".toString()] || (() => {
}), Db = 0;
function Oa(e) {
  const [t, n] = a.useState(Ob());
  return it(() => {
    e || n((r) => r ?? String(Db++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var $b = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Le = $b.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? Hn : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Da(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function rl({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = Lb({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = Da(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function Lb({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = Da(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
function Ib(e) {
  const t = a.useRef({ value: e, previous: e });
  return a.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var Fb = "VisuallyHidden", Lp = a.forwardRef(
  (e, t) => /* @__PURE__ */ c(
    Le.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Lp.displayName = Fb;
var Ip = uo(), fi = function() {
}, Do = a.forwardRef(function(e, t) {
  var n = a.useRef(null), r = a.useState({
    onScrollCapture: fi,
    onWheelCapture: fi,
    onTouchMoveCapture: fi
  }), o = r[0], i = r[1], s = e.forwardProps, l = e.children, u = e.className, d = e.removeScrollBar, h = e.enabled, f = e.shards, w = e.sideCar, g = e.noIsolation, v = e.inert, p = e.allowPinchZoom, m = e.as, C = m === void 0 ? "div" : m, y = e.gapMode, b = jn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = w, E = lo([n, t]), R = pe(pe({}, b), o);
  return a.createElement(
    a.Fragment,
    null,
    h && a.createElement(S, { sideCar: Ip, removeScrollBar: d, shards: f, noIsolation: g, inert: v, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: y }),
    s ? a.cloneElement(a.Children.only(l), pe(pe({}, R), { ref: E })) : a.createElement(C, pe({}, R, { className: u, ref: E }), l)
  );
});
Do.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Do.classNames = {
  fullWidth: Rt,
  zeroRight: xt
};
var ss = !1;
if (typeof window < "u")
  try {
    var br = Object.defineProperty({}, "passive", {
      get: function() {
        return ss = !0, !0;
      }
    });
    window.addEventListener("test", br, br), window.removeEventListener("test", br, br);
  } catch {
    ss = !1;
  }
var zt = ss ? { passive: !1 } : !1, Wb = function(e) {
  return e.tagName === "TEXTAREA";
}, Fp = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Wb(e) && n[t] === "visible")
  );
}, Bb = function(e) {
  return Fp(e, "overflowY");
}, Hb = function(e) {
  return Fp(e, "overflowX");
}, ol = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Wp(e, r);
    if (o) {
      var i = Bp(e, r), s = i[1], l = i[2];
      if (s > l)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Vb = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Ub = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Wp = function(e, t) {
  return e === "v" ? Bb(t) : Hb(t);
}, Bp = function(e, t) {
  return e === "v" ? Vb(t) : Ub(t);
}, jb = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Gb = function(e, t, n, r, o) {
  var i = jb(e, window.getComputedStyle(t).direction), s = i * r, l = n.target, u = t.contains(l), d = !1, h = s > 0, f = 0, w = 0;
  do {
    var g = Bp(e, l), v = g[0], p = g[1], m = g[2], C = p - m - i * v;
    (v || C) && Wp(e, l) && (f += C, w += v), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !u && l !== document.body || // self content
    u && (t.contains(l) || t === l)
  );
  return (h && (o && Math.abs(f) < 1 || !o && s > f) || !h && (o && Math.abs(w) < 1 || !o && -s > w)) && (d = !0), d;
}, Sr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, il = function(e) {
  return [e.deltaX, e.deltaY];
}, sl = function(e) {
  return e && "current" in e ? e.current : e;
}, zb = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Kb = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Yb = 0, Kt = [];
function qb(e) {
  var t = a.useRef([]), n = a.useRef([0, 0]), r = a.useRef(), o = a.useState(Yb++)[0], i = a.useState(Kn)[0], s = a.useRef(e);
  a.useEffect(function() {
    s.current = e;
  }, [e]), a.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var p = on([e.lockRef.current], (e.shards || []).map(sl), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = a.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2)
      return !s.current.allowPinchZoom;
    var C = Sr(p), y = n.current, b = "deltaX" in p ? p.deltaX : y[0] - C[0], S = "deltaY" in p ? p.deltaY : y[1] - C[1], E, R = p.target, O = Math.abs(b) > Math.abs(S) ? "h" : "v";
    if ("touches" in p && O === "h" && R.type === "range")
      return !1;
    var $ = ol(O, R);
    if (!$)
      return !0;
    if ($ ? E = O : (E = O === "v" ? "h" : "v", $ = ol(O, R)), !$)
      return !1;
    if (!r.current && "changedTouches" in p && (b || S) && (r.current = E), !E)
      return !0;
    var H = r.current || E;
    return Gb(H, m, p, H === "h" ? b : S, !0);
  }, []), u = a.useCallback(function(p) {
    var m = p;
    if (!(!Kt.length || Kt[Kt.length - 1] !== i)) {
      var C = "deltaY" in m ? il(m) : Sr(m), y = t.current.filter(function(E) {
        return E.name === m.type && (E.target === m.target || m.target === E.shadowParent) && zb(E.delta, C);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var b = (s.current.shards || []).map(sl).filter(Boolean).filter(function(E) {
          return E.contains(m.target);
        }), S = b.length > 0 ? l(m, b[0]) : !s.current.noIsolation;
        S && m.cancelable && m.preventDefault();
      }
    }
  }, []), d = a.useCallback(function(p, m, C, y) {
    var b = { name: p, delta: m, target: C, should: y, shadowParent: Xb(C) };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== b;
      });
    }, 1);
  }, []), h = a.useCallback(function(p) {
    n.current = Sr(p), r.current = void 0;
  }, []), f = a.useCallback(function(p) {
    d(p.type, il(p), p.target, l(p, e.lockRef.current));
  }, []), w = a.useCallback(function(p) {
    d(p.type, Sr(p), p.target, l(p, e.lockRef.current));
  }, []);
  a.useEffect(function() {
    return Kt.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: w
    }), document.addEventListener("wheel", u, zt), document.addEventListener("touchmove", u, zt), document.addEventListener("touchstart", h, zt), function() {
      Kt = Kt.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", u, zt), document.removeEventListener("touchmove", u, zt), document.removeEventListener("touchstart", h, zt);
    };
  }, []);
  var g = e.removeScrollBar, v = e.inert;
  return a.createElement(
    a.Fragment,
    null,
    v ? a.createElement(i, { styles: Kb(o) }) : null,
    g ? a.createElement(ho, { gapMode: e.gapMode }) : null
  );
}
function Xb(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Zb = fo(Ip, qb);
var Hp = a.forwardRef(function(e, t) {
  return a.createElement(Do, pe({}, e, { ref: t, sideCar: Zb }));
});
Hp.classNames = Do.classNames;
const Jb = Hp;
var Qb = [" ", "Enter", "ArrowUp", "ArrowDown"], eS = [" ", "Enter"], rr = "Select", [$o, Lo, tS] = kb(rr), [yn, LT] = Dp(rr, [
  tS,
  mt
]), Io = mt(), [nS, wt] = yn(rr), [rS, oS] = yn(rr), Vp = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: s,
    defaultValue: l,
    onValueChange: u,
    dir: d,
    name: h,
    autoComplete: f,
    disabled: w,
    required: g
  } = e, v = Io(t), [p, m] = a.useState(null), [C, y] = a.useState(null), [b, S] = a.useState(!1), E = Mb(d), [R = !1, O] = rl({
    prop: r,
    defaultProp: o,
    onChange: i
  }), [$, H] = rl({
    prop: s,
    defaultProp: l,
    onChange: u
  }), j = a.useRef(null), D = p ? !!p.closest("form") : !0, [Z, q] = a.useState(/* @__PURE__ */ new Set()), k = Array.from(Z).map((M) => M.props.value).join(";");
  return /* @__PURE__ */ c(Xn, { ...v, children: /* @__PURE__ */ N(
    nS,
    {
      required: g,
      scope: t,
      trigger: p,
      onTriggerChange: m,
      valueNode: C,
      onValueNodeChange: y,
      valueNodeHasChildren: b,
      onValueNodeHasChildrenChange: S,
      contentId: Oa(),
      value: $,
      onValueChange: H,
      open: R,
      onOpenChange: O,
      dir: E,
      triggerPointerDownPosRef: j,
      disabled: w,
      children: [
        /* @__PURE__ */ c($o.Provider, { scope: t, children: /* @__PURE__ */ c(
          rS,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: a.useCallback((M) => {
              q((A) => new Set(A).add(M));
            }, []),
            onNativeOptionRemove: a.useCallback((M) => {
              q((A) => {
                const I = new Set(A);
                return I.delete(M), I;
              });
            }, []),
            children: n
          }
        ) }),
        D ? /* @__PURE__ */ N(
          fh,
          {
            "aria-hidden": !0,
            required: g,
            tabIndex: -1,
            name: h,
            autoComplete: f,
            value: $,
            onChange: (M) => H(M.target.value),
            disabled: w,
            children: [
              $ === void 0 ? /* @__PURE__ */ c("option", { value: "" }) : null,
              Array.from(Z)
            ]
          },
          k
        ) : null
      ]
    }
  ) });
};
Vp.displayName = rr;
var Up = "SelectTrigger", jp = a.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = Io(n), s = wt(Up, n), l = s.disabled || r, u = We(t, s.onTriggerChange), d = Lo(n), [h, f, w] = ph((v) => {
      const p = d().filter((y) => !y.disabled), m = p.find((y) => y.value === s.value), C = hh(p, v, m);
      C !== void 0 && s.onValueChange(C.value);
    }), g = () => {
      l || (s.onOpenChange(!0), w());
    };
    return /* @__PURE__ */ c(Zn, { asChild: !0, ...i, children: /* @__PURE__ */ c(
      Le.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: l,
        "data-disabled": l ? "" : void 0,
        "data-placeholder": dh(s.value) ? "" : void 0,
        ...o,
        ref: u,
        onClick: Ne(o.onClick, (v) => {
          v.currentTarget.focus();
        }),
        onPointerDown: Ne(o.onPointerDown, (v) => {
          const p = v.target;
          p.hasPointerCapture(v.pointerId) && p.releasePointerCapture(v.pointerId), v.button === 0 && v.ctrlKey === !1 && (g(), s.triggerPointerDownPosRef.current = {
            x: Math.round(v.pageX),
            y: Math.round(v.pageY)
          }, v.preventDefault());
        }),
        onKeyDown: Ne(o.onKeyDown, (v) => {
          const p = h.current !== "";
          !(v.ctrlKey || v.altKey || v.metaKey) && v.key.length === 1 && f(v.key), !(p && v.key === " ") && Qb.includes(v.key) && (g(), v.preventDefault());
        })
      }
    ) });
  }
);
jp.displayName = Up;
var Gp = "SelectValue", zp = a.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: i, placeholder: s = "", ...l } = e, u = wt(Gp, n), { onValueNodeHasChildrenChange: d } = u, h = i !== void 0, f = We(t, u.onValueNodeChange);
    return it(() => {
      d(h);
    }, [d, h]), /* @__PURE__ */ c(
      Le.span,
      {
        ...l,
        ref: f,
        style: { pointerEvents: "none" },
        children: dh(u.value) ? /* @__PURE__ */ c(ae, { children: s }) : i
      }
    );
  }
);
zp.displayName = Gp;
var iS = "SelectIcon", Kp = a.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ c(Le.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
Kp.displayName = iS;
var sS = "SelectPortal", Yp = (e) => /* @__PURE__ */ c(mn, { asChild: !0, ...e });
Yp.displayName = sS;
var Mt = "SelectContent", qp = a.forwardRef(
  (e, t) => {
    const n = wt(Mt, e.__scopeSelect), [r, o] = a.useState();
    if (it(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? st.createPortal(
        /* @__PURE__ */ c(Xp, { scope: e.__scopeSelect, children: /* @__PURE__ */ c($o.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ c("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ c(Zp, { ...e, ref: t });
  }
);
qp.displayName = Mt;
var Je = 10, [Xp, Ct] = yn(Mt), aS = "SelectContentImpl", Zp = a.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: l,
      sideOffset: u,
      align: d,
      alignOffset: h,
      arrowPadding: f,
      collisionBoundary: w,
      collisionPadding: g,
      sticky: v,
      hideWhenDetached: p,
      avoidCollisions: m,
      //
      ...C
    } = e, y = wt(Mt, n), [b, S] = a.useState(null), [E, R] = a.useState(null), O = We(t, (W) => S(W)), [$, H] = a.useState(null), [j, D] = a.useState(
      null
    ), Z = Lo(n), [q, k] = a.useState(!1), M = a.useRef(!1);
    a.useEffect(() => {
      if (b)
        return vo(b);
    }, [b]), _b();
    const A = a.useCallback(
      (W) => {
        const [J, ...te] = Z().map((B) => B.ref.current), [K] = te.slice(-1), re = document.activeElement;
        for (const B of W)
          if (B === re || (B?.scrollIntoView({ block: "nearest" }), B === J && E && (E.scrollTop = 0), B === K && E && (E.scrollTop = E.scrollHeight), B?.focus(), document.activeElement !== re))
            return;
      },
      [Z, E]
    ), I = a.useCallback(
      () => A([$, b]),
      [A, $, b]
    );
    a.useEffect(() => {
      q && I();
    }, [q, I]);
    const { onOpenChange: P, triggerPointerDownPosRef: _ } = y;
    a.useEffect(() => {
      if (b) {
        let W = { x: 0, y: 0 };
        const J = (K) => {
          W = {
            x: Math.abs(Math.round(K.pageX) - (_.current?.x ?? 0)),
            y: Math.abs(Math.round(K.pageY) - (_.current?.y ?? 0))
          };
        }, te = (K) => {
          W.x <= 10 && W.y <= 10 ? K.preventDefault() : b.contains(K.target) || P(!1), document.removeEventListener("pointermove", J), _.current = null;
        };
        return _.current !== null && (document.addEventListener("pointermove", J), document.addEventListener("pointerup", te, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", J), document.removeEventListener("pointerup", te, { capture: !0 });
        };
      }
    }, [b, P, _]), a.useEffect(() => {
      const W = () => P(!1);
      return window.addEventListener("blur", W), window.addEventListener("resize", W), () => {
        window.removeEventListener("blur", W), window.removeEventListener("resize", W);
      };
    }, [P]);
    const [T, L] = ph((W) => {
      const J = Z().filter((re) => !re.disabled), te = J.find((re) => re.ref.current === document.activeElement), K = hh(J, W, te);
      K && setTimeout(() => K.ref.current.focus());
    }), z = a.useCallback(
      (W, J, te) => {
        const K = !M.current && !te;
        (y.value !== void 0 && y.value === J || K) && (H(W), K && (M.current = !0));
      },
      [y.value]
    ), Y = a.useCallback(() => b?.focus(), [b]), G = a.useCallback(
      (W, J, te) => {
        const K = !M.current && !te;
        (y.value !== void 0 && y.value === J || K) && D(W);
      },
      [y.value]
    ), ee = r === "popper" ? as : Jp, Q = ee === as ? {
      side: l,
      sideOffset: u,
      align: d,
      alignOffset: h,
      arrowPadding: f,
      collisionBoundary: w,
      collisionPadding: g,
      sticky: v,
      hideWhenDetached: p,
      avoidCollisions: m
    } : {};
    return /* @__PURE__ */ c(
      Xp,
      {
        scope: n,
        content: b,
        viewport: E,
        onViewportChange: R,
        itemRefCallback: z,
        selectedItem: $,
        onItemLeave: Y,
        itemTextRefCallback: G,
        focusSelectedItem: I,
        selectedItemText: j,
        position: r,
        isPositioned: q,
        searchRef: T,
        children: /* @__PURE__ */ c(Jb, { as: Hn, allowPinchZoom: !0, children: /* @__PURE__ */ c(
          Gn,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (W) => {
              W.preventDefault();
            },
            onUnmountAutoFocus: Ne(o, (W) => {
              y.trigger?.focus({ preventScroll: !0 }), W.preventDefault();
            }),
            children: /* @__PURE__ */ c(
              vt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: s,
                onFocusOutside: (W) => W.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ c(
                  ee,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (W) => W.preventDefault(),
                    ...C,
                    ...Q,
                    onPlaced: () => k(!0),
                    ref: O,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...C.style
                    },
                    onKeyDown: Ne(C.onKeyDown, (W) => {
                      const J = W.ctrlKey || W.altKey || W.metaKey;
                      if (W.key === "Tab" && W.preventDefault(), !J && W.key.length === 1 && L(W.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(W.key)) {
                        let K = Z().filter((re) => !re.disabled).map((re) => re.ref.current);
                        if (["ArrowUp", "End"].includes(W.key) && (K = K.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(W.key)) {
                          const re = W.target, B = K.indexOf(re);
                          K = K.slice(B + 1);
                        }
                        setTimeout(() => A(K)), W.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Zp.displayName = aS;
var cS = "SelectItemAlignedPosition", Jp = a.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, i = wt(Mt, n), s = Ct(Mt, n), [l, u] = a.useState(null), [d, h] = a.useState(null), f = We(t, (O) => h(O)), w = Lo(n), g = a.useRef(!1), v = a.useRef(!0), { viewport: p, selectedItem: m, selectedItemText: C, focusSelectedItem: y } = s, b = a.useCallback(() => {
    if (i.trigger && i.valueNode && l && d && p && m && C) {
      const O = i.trigger.getBoundingClientRect(), $ = d.getBoundingClientRect(), H = i.valueNode.getBoundingClientRect(), j = C.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const re = j.left - $.left, B = H.left - re, ce = O.left - B, Te = O.width + ce, Xe = Math.max(Te, $.width), Lt = window.innerWidth - Je, Ue = tl(B, [Je, Lt - Xe]);
        l.style.minWidth = Te + "px", l.style.left = Ue + "px";
      } else {
        const re = $.right - j.right, B = window.innerWidth - H.right - re, ce = window.innerWidth - O.right - B, Te = O.width + ce, Xe = Math.max(Te, $.width), Lt = window.innerWidth - Je, Ue = tl(B, [Je, Lt - Xe]);
        l.style.minWidth = Te + "px", l.style.right = Ue + "px";
      }
      const D = w(), Z = window.innerHeight - Je * 2, q = p.scrollHeight, k = window.getComputedStyle(d), M = parseInt(k.borderTopWidth, 10), A = parseInt(k.paddingTop, 10), I = parseInt(k.borderBottomWidth, 10), P = parseInt(k.paddingBottom, 10), _ = M + A + q + P + I, T = Math.min(m.offsetHeight * 5, _), L = window.getComputedStyle(p), z = parseInt(L.paddingTop, 10), Y = parseInt(L.paddingBottom, 10), G = O.top + O.height / 2 - Je, ee = Z - G, Q = m.offsetHeight / 2, W = m.offsetTop + Q, J = M + A + W, te = _ - J;
      if (J <= G) {
        const re = m === D[D.length - 1].ref.current;
        l.style.bottom = "0px";
        const B = d.clientHeight - p.offsetTop - p.offsetHeight, ce = Math.max(
          ee,
          Q + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (re ? Y : 0) + B + I
        ), Te = J + ce;
        l.style.height = Te + "px";
      } else {
        const re = m === D[0].ref.current;
        l.style.top = "0px";
        const ce = Math.max(
          G,
          M + p.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (re ? z : 0) + Q
        ) + te;
        l.style.height = ce + "px", p.scrollTop = J - G + p.offsetTop;
      }
      l.style.margin = `${Je}px 0`, l.style.minHeight = T + "px", l.style.maxHeight = Z + "px", r?.(), requestAnimationFrame(() => g.current = !0);
    }
  }, [
    w,
    i.trigger,
    i.valueNode,
    l,
    d,
    p,
    m,
    C,
    i.dir,
    r
  ]);
  it(() => b(), [b]);
  const [S, E] = a.useState();
  it(() => {
    d && E(window.getComputedStyle(d).zIndex);
  }, [d]);
  const R = a.useCallback(
    (O) => {
      O && v.current === !0 && (b(), y?.(), v.current = !1);
    },
    [b, y]
  );
  return /* @__PURE__ */ c(
    uS,
    {
      scope: n,
      contentWrapper: l,
      shouldExpandOnScrollRef: g,
      onScrollButtonChange: R,
      children: /* @__PURE__ */ c(
        "div",
        {
          ref: u,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: S
          },
          children: /* @__PURE__ */ c(
            Le.div,
            {
              ...o,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
Jp.displayName = cS;
var lS = "SelectPopperPosition", as = a.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = Je,
    ...i
  } = e, s = Io(n);
  return /* @__PURE__ */ c(
    wo,
    {
      ...s,
      ...i,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
as.displayName = lS;
var [uS, $a] = yn(Mt, {}), cs = "SelectViewport", Qp = a.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, i = Ct(cs, n), s = $a(cs, n), l = We(t, i.onViewportChange), u = a.useRef(0);
    return /* @__PURE__ */ N(ae, { children: [
      /* @__PURE__ */ c(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ c($o.Slot, { scope: n, children: /* @__PURE__ */ c(
        Le.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: l,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            overflow: "auto",
            ...o.style
          },
          onScroll: Ne(o.onScroll, (d) => {
            const h = d.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: w } = s;
            if (w?.current && f) {
              const g = Math.abs(u.current - h.scrollTop);
              if (g > 0) {
                const v = window.innerHeight - Je * 2, p = parseFloat(f.style.minHeight), m = parseFloat(f.style.height), C = Math.max(p, m);
                if (C < v) {
                  const y = C + g, b = Math.min(v, y), S = y - b;
                  f.style.height = b + "px", f.style.bottom === "0px" && (h.scrollTop = S > 0 ? S : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            u.current = h.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Qp.displayName = cs;
var eh = "SelectGroup", [dS, fS] = yn(eh), th = a.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Oa();
    return /* @__PURE__ */ c(dS, { scope: n, id: o, children: /* @__PURE__ */ c(Le.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
th.displayName = eh;
var nh = "SelectLabel", pS = a.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = fS(nh, n);
    return /* @__PURE__ */ c(Le.div, { id: o.id, ...r, ref: t });
  }
);
pS.displayName = nh;
var Zr = "SelectItem", [hS, rh] = yn(Zr), oh = a.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: i,
      ...s
    } = e, l = wt(Zr, n), u = Ct(Zr, n), d = l.value === r, [h, f] = a.useState(i ?? ""), [w, g] = a.useState(!1), v = We(
      t,
      (C) => u.itemRefCallback?.(C, r, o)
    ), p = Oa(), m = () => {
      o || (l.onValueChange(r), l.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ c(
      hS,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: p,
        isSelected: d,
        onItemTextChange: a.useCallback((C) => {
          f((y) => y || (C?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ c(
          $o.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: h,
            children: /* @__PURE__ */ c(
              Le.div,
              {
                role: "option",
                "aria-labelledby": p,
                "data-highlighted": w ? "" : void 0,
                "aria-selected": d && w,
                "data-state": d ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...s,
                ref: v,
                onFocus: Ne(s.onFocus, () => g(!0)),
                onBlur: Ne(s.onBlur, () => g(!1)),
                onPointerUp: Ne(s.onPointerUp, m),
                onPointerMove: Ne(s.onPointerMove, (C) => {
                  o ? u.onItemLeave?.() : C.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: Ne(s.onPointerLeave, (C) => {
                  C.currentTarget === document.activeElement && u.onItemLeave?.();
                }),
                onKeyDown: Ne(s.onKeyDown, (C) => {
                  u.searchRef?.current !== "" && C.key === " " || (eS.includes(C.key) && m(), C.key === " " && C.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
oh.displayName = Zr;
var Tn = "SelectItemText", ih = a.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...i } = e, s = wt(Tn, n), l = Ct(Tn, n), u = rh(Tn, n), d = oS(Tn, n), [h, f] = a.useState(null), w = We(
      t,
      (C) => f(C),
      u.onItemTextChange,
      (C) => l.itemTextRefCallback?.(C, u.value, u.disabled)
    ), g = h?.textContent, v = a.useMemo(
      () => /* @__PURE__ */ c("option", { value: u.value, disabled: u.disabled, children: g }, u.value),
      [u.disabled, u.value, g]
    ), { onNativeOptionAdd: p, onNativeOptionRemove: m } = d;
    return it(() => (p(v), () => m(v)), [p, m, v]), /* @__PURE__ */ N(ae, { children: [
      /* @__PURE__ */ c(Le.span, { id: u.textId, ...i, ref: w }),
      u.isSelected && s.valueNode && !s.valueNodeHasChildren ? st.createPortal(i.children, s.valueNode) : null
    ] });
  }
);
ih.displayName = Tn;
var sh = "SelectItemIndicator", vS = a.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return rh(sh, n).isSelected ? /* @__PURE__ */ c(Le.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
vS.displayName = sh;
var ls = "SelectScrollUpButton", ah = a.forwardRef((e, t) => {
  const n = Ct(ls, e.__scopeSelect), r = $a(ls, e.__scopeSelect), [o, i] = a.useState(!1), s = We(t, r.onScrollButtonChange);
  return it(() => {
    if (n.viewport && n.isPositioned) {
      let l = function() {
        const d = u.scrollTop > 0;
        i(d);
      };
      const u = n.viewport;
      return l(), u.addEventListener("scroll", l), () => u.removeEventListener("scroll", l);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ c(
    lh,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: u } = n;
        l && u && (l.scrollTop = l.scrollTop - u.offsetHeight);
      }
    }
  ) : null;
});
ah.displayName = ls;
var us = "SelectScrollDownButton", ch = a.forwardRef((e, t) => {
  const n = Ct(us, e.__scopeSelect), r = $a(us, e.__scopeSelect), [o, i] = a.useState(!1), s = We(t, r.onScrollButtonChange);
  return it(() => {
    if (n.viewport && n.isPositioned) {
      let l = function() {
        const d = u.scrollHeight - u.clientHeight, h = Math.ceil(u.scrollTop) < d;
        i(h);
      };
      const u = n.viewport;
      return l(), u.addEventListener("scroll", l), () => u.removeEventListener("scroll", l);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ c(
    lh,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: u } = n;
        l && u && (l.scrollTop = l.scrollTop + u.offsetHeight);
      }
    }
  ) : null;
});
ch.displayName = us;
var lh = a.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = Ct("SelectScrollButton", n), s = a.useRef(null), l = Lo(n), u = a.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return a.useEffect(() => () => u(), [u]), it(() => {
    l().find((h) => h.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [l]), /* @__PURE__ */ c(
    Le.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: Ne(o.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerMove: Ne(o.onPointerMove, () => {
        i.onItemLeave?.(), s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerLeave: Ne(o.onPointerLeave, () => {
        u();
      })
    }
  );
}), mS = "SelectSeparator", uh = a.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ c(Le.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
uh.displayName = mS;
var ds = "SelectArrow", gS = a.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Io(n), i = wt(ds, n), s = Ct(ds, n);
    return i.open && s.position === "popper" ? /* @__PURE__ */ c(Co, { ...o, ...r, ref: t }) : null;
  }
);
gS.displayName = ds;
function dh(e) {
  return e === "" || e === void 0;
}
var fh = a.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = a.useRef(null), i = We(t, o), s = Ib(n);
    return a.useEffect(() => {
      const l = o.current, u = window.HTMLSelectElement.prototype, h = Object.getOwnPropertyDescriptor(
        u,
        "value"
      ).set;
      if (s !== n && h) {
        const f = new Event("change", { bubbles: !0 });
        h.call(l, n), l.dispatchEvent(f);
      }
    }, [s, n]), /* @__PURE__ */ c(Lp, { asChild: !0, children: /* @__PURE__ */ c("select", { ...r, ref: i, defaultValue: n }) });
  }
);
fh.displayName = "BubbleSelect";
function ph(e) {
  const t = Da(e), n = a.useRef(""), r = a.useRef(0), o = a.useCallback(
    (s) => {
      const l = n.current + s;
      t(l), function u(d) {
        n.current = d, window.clearTimeout(r.current), d !== "" && (r.current = window.setTimeout(() => u(""), 1e3));
      }(l);
    },
    [t]
  ), i = a.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return a.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
function hh(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = wS(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((d) => d !== n));
  const u = s.find(
    (d) => d.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function wS(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var CS = Vp, yS = jp, ES = zp, bS = Kp, SS = Yp, xS = qp, RS = Qp, TS = th, AS = oh, NS = ih, kS = ah, PS = ch, MS = uh;
const _S = "flex items-center justify-between h-9 rounded border px-3 py-1.5 text-small [&>span:first-of-type]:max-w-[calc(var(--radix-select-content-available-width)-40px)] [&>span:first-of-type]:truncate", OS = "border-khaki-500 text-khaki-800 placeholder-khaki-500 caret-khaki-500", DS = (e, t) => t && !e ? "text-khaki-500" : "text-khaki-800", $S = (e, t) => !t && Sa[e], LS = (e) => e ? Ao : OS, IS = (e) => e && ko, pi = {
  SELECT: "select",
  LABEL: "select-label",
  MESSAGE: "select-message",
  DROPDOWN: "select-dropdown"
}, IT = Ye(
  ({
    name: e,
    onChange: t,
    dropdownItems: n,
    label: r,
    hideLabel: o = !1,
    value: i,
    placeholder: s,
    message: l,
    state: u = Ee.DEFAULT,
    disabled: d = !1,
    filled: h = !1,
    fluid: f = !1,
    maxDropdownHeight: w = 0,
    portalContainer: g,
    testIdOverride: v
  }, p) => {
    const m = ie(() => at(), []), [C, y] = he(!1);
    return /* @__PURE__ */ N("div", { className: "flex flex-col gap-2", children: [
      !o && /* @__PURE__ */ c(
        Cn,
        {
          id: m,
          text: r,
          disabled: d,
          hidden: o,
          testIdOverride: { label: v?.label ?? pi.LABEL }
        }
      ),
      /* @__PURE__ */ N(
        CS,
        {
          value: i,
          name: e,
          onValueChange: (b) => t({ target: { name: e, value: b } }),
          disabled: d,
          open: C,
          onOpenChange: y,
          children: [
            /* @__PURE__ */ N(
              yS,
              {
                id: m,
                className: F(
                  _S,
                  No,
                  Po(f),
                  DS(i, s),
                  $S(u, d),
                  LS(d),
                  IS(h)
                ),
                "data-testid": v?.select ?? pi.SELECT,
                children: [
                  /* @__PURE__ */ c(ES, { placeholder: s }),
                  /* @__PURE__ */ c(bS, { children: /* @__PURE__ */ c(se, { Component: Fr, color: le.CurrentColor }) })
                ]
              }
            ),
            /* @__PURE__ */ c(SS, { container: g, children: /* @__PURE__ */ N(
              xS,
              {
                sideOffset: Ge,
                collisionPadding: {
                  top: Ge,
                  right: Ge,
                  bottom: Ge,
                  left: Ge
                },
                position: "popper",
                sticky: "partial",
                className: F(
                  "border border-khaki-500 px-2.5 py-3 rounded bg-white w-[var(--radix-select-trigger-width)]",
                  Yn
                ),
                onKeyDown: (b) => b.stopPropagation(),
                "data-testid": v?.dropdown ?? pi.DROPDOWN,
                style: {
                  maxHeight: w > 0 ? `${w}px` : "calc(var(--radix-select-content-available-height) - 10px)"
                },
                children: [
                  /* @__PURE__ */ c(kS, { className: "flex items-center justify-center h-2 pb-1 px-2", children: /* @__PURE__ */ c(se, { Component: Ls }) }),
                  /* @__PURE__ */ c(RS, { children: /* @__PURE__ */ c(TS, { children: n.map((b, S) => b.type === "divider" ? /* @__PURE__ */ c(
                    MS,
                    {
                      className: "border-b border-khaki-200 my-2"
                    },
                    `divider-${S}`
                  ) : /* @__PURE__ */ c(
                    AS,
                    {
                      value: b.value,
                      className: "rounded text-small h-8 px-2 py-1 focus:outline-none focus:bg-khaki-100 cursor-pointer truncate",
                      onClick: () => y(!1),
                      children: /* @__PURE__ */ c(NS, { children: b.label })
                    },
                    `item-${b.value}-${S}`
                  )) }) }),
                  /* @__PURE__ */ c(PS, { className: "flex items-center justify-center h-2 pt-1 px-2", children: /* @__PURE__ */ c(se, { Component: Fr }) })
                ]
              }
            ) })
          ]
        }
      ),
      l && /* @__PURE__ */ c(cn, { text: l, state: u, disabled: d, testIdOverride: v })
    ] });
  }
), Ve = {
  ASC: "asc",
  DESC: "desc",
  NONE: "none"
}, hi = 100;
var vh = /* @__PURE__ */ ((e) => (e.INFINITE_SCROLL_LOADER = "infinite-scroll-loader", e))(vh || {});
const xr = {
  SENTENCE: "sentence",
  TITLE: "title",
  UPPER: "upper",
  LOWER: "lower"
}, mh = 400, FS = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "M4.667 7 7 9.333m0 0L9.333 7M7 9.333V4.667M3.617 12.25h6.766c.654 0 .98 0 1.23-.127.22-.112.398-.29.51-.51.127-.25.127-.576.127-1.23V3.617c0-.654 0-.98-.127-1.23a1.17 1.17 0 0 0-.51-.51c-.25-.127-.576-.127-1.23-.127H3.617c-.654 0-.98 0-1.23.127-.22.112-.398.29-.51.51-.127.25-.127.576-.127 1.23v6.766c0 .654 0 .98.127 1.23.112.22.29.398.51.51.25.127.576.127 1.23.127Z"
  }
) }), WS = FS, BS = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M1.75 3.617c0-.654 0-.98.127-1.23.112-.22.29-.398.51-.51.25-.127.576-.127 1.23-.127h6.766c.654 0 .98 0 1.23.127.22.112.398.29.51.51.127.25.127.576.127 1.23v6.766c0 .654 0 .98-.127 1.23-.112.22-.29.398-.51.51-.25.127-.576.127-1.23.127H3.617c-.654 0-.98 0-1.23-.127a1.17 1.17 0 0 1-.51-.51c-.127-.25-.127-.576-.127-1.23z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "M4.667 7 7 9.333m0 0L9.333 7M7 9.333V4.667M3.617 12.25h6.766c.654 0 .98 0 1.23-.127.22-.112.398-.29.51-.51.127-.25.127-.576.127-1.23V3.617c0-.654 0-.98-.127-1.23a1.17 1.17 0 0 0-.51-.51c-.25-.127-.576-.127-1.23-.127H3.617c-.654 0-.98 0-1.23.127-.22.112-.398.29-.51.51-.127.25-.127.576-.127 1.23v6.766c0 .654 0 .98.127 1.23.112.22.29.398.51.51.25.127.576.127 1.23.127Z"
    }
  )
] }), HS = BS, VS = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.5",
    d: "M5.333 8 8 10.667m0 0L10.667 8M8 10.667V5.333M4.133 14h7.734c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V4.133c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C12.987 2 12.613 2 11.867 2H4.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C2 3.013 2 3.387 2 4.133v7.734c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.659.145 1.405.145Z"
  }
) }), US = VS, jS = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M2 4.133c0-.746 0-1.12.145-1.405.128-.25.332-.455.583-.583C3.013 2 3.387 2 4.133 2h7.734c.746 0 1.12 0 1.405.145.25.128.455.332.583.583.145.285.145.659.145 1.405v7.734c0 .746 0 1.12-.145 1.405-.128.25-.332.455-.583.583-.285.145-.659.145-1.405.145H4.133c-.746 0-1.12 0-1.405-.145a1.33 1.33 0 0 1-.583-.583C2 12.987 2 12.613 2 11.867z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "M5.333 8 8 10.667m0 0L10.667 8M8 10.667V5.333M4.133 14h7.734c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V4.133c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C12.987 2 12.613 2 11.867 2H4.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C2 3.013 2 3.387 2 4.133v7.734c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.659.145 1.405.145Z"
    }
  )
] }), GS = jS, zS = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M6.667 10 10 13.333m0 0L13.333 10M10 13.333V6.667M5.167 17.5h9.666c.934 0 1.4 0 1.757-.182.314-.16.569-.414.728-.728.182-.357.182-.823.182-1.757V5.167c0-.934 0-1.4-.182-1.757a1.67 1.67 0 0 0-.728-.728c-.357-.182-.823-.182-1.757-.182H5.167c-.934 0-1.4 0-1.757.182-.314.16-.569.414-.728.728-.182.357-.182.823-.182 1.757v9.666c0 .934 0 1.4.182 1.757.16.314.414.569.728.728.357.182.823.182 1.757.182Z"
  }
) }), KS = zS, YS = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M2.5 5.167c0-.934 0-1.4.182-1.757.16-.314.414-.569.728-.728.357-.182.823-.182 1.757-.182h9.666c.934 0 1.4 0 1.757.182.314.16.569.414.728.728.182.357.182.823.182 1.757v9.666c0 .934 0 1.4-.182 1.757-.16.314-.414.569-.728.728-.357.182-.823.182-1.757.182H5.167c-.934 0-1.4 0-1.757-.182a1.67 1.67 0 0 1-.728-.728c-.182-.357-.182-.823-.182-1.757z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M6.667 10 10 13.333m0 0L13.333 10M10 13.333V6.667M5.167 17.5h9.666c.934 0 1.4 0 1.757-.182.314-.16.569-.414.728-.728.182-.357.182-.823.182-1.757V5.167c0-.934 0-1.4-.182-1.757a1.67 1.67 0 0 0-.728-.728c-.357-.182-.823-.182-1.757-.182H5.167c-.934 0-1.4 0-1.757.182-.314.16-.569.414-.728.728-.182.357-.182.823-.182 1.757v9.666c0 .934 0 1.4.182 1.757.16.314.414.569.728.728.357.182.823.182 1.757.182Z"
    }
  )
] }), qS = YS, XS = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "m8 12 4 4m0 0 4-4m-4 4V8M6.2 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21Z"
  }
) }), al = XS, ZS = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M3 6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 3 5.08 3 6.2 3h11.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 4.52 21 5.08 21 6.2v11.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 21 18.92 21 17.8 21H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "m8 12 4 4m0 0 4-4m-4 4V8M6.2 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21Z"
    }
  )
] }), cl = ZS, JS = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c(WS, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(HS, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c(US, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(GS, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(KS, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(qS, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(al, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(cl, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(al, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(cl, { color: e }),
    [x.Filled]: (e) => null
  }
}, QS = ({ size: e, style: t, color: n }) => JS[e][t](n), ex = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "M9.333 7 7 4.667m0 0L4.667 7M7 4.667v4.666M3.617 12.25h6.766c.654 0 .98 0 1.23-.127.22-.112.398-.29.51-.51.127-.25.127-.576.127-1.23V3.617c0-.654 0-.98-.127-1.23a1.17 1.17 0 0 0-.51-.51c-.25-.127-.576-.127-1.23-.127H3.617c-.654 0-.98 0-1.23.127-.22.112-.398.29-.51.51-.127.25-.127.576-.127 1.23v6.766c0 .654 0 .98.127 1.23.112.22.29.398.51.51.25.127.576.127 1.23.127Z"
  }
) }), tx = ex, nx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M1.75 3.617c0-.654 0-.98.127-1.23.112-.22.29-.398.51-.51.25-.127.576-.127 1.23-.127h6.766c.654 0 .98 0 1.23.127.22.112.398.29.51.51.127.25.127.576.127 1.23v6.766c0 .654 0 .98-.127 1.23-.112.22-.29.398-.51.51-.25.127-.576.127-1.23.127H3.617c-.654 0-.98 0-1.23-.127a1.17 1.17 0 0 1-.51-.51c-.127-.25-.127-.576-.127-1.23z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "M9.333 7 7 4.667m0 0L4.667 7M7 4.667v4.666M3.617 12.25h6.766c.654 0 .98 0 1.23-.127.22-.112.398-.29.51-.51.127-.25.127-.576.127-1.23V3.617c0-.654 0-.98-.127-1.23a1.17 1.17 0 0 0-.51-.51c-.25-.127-.576-.127-1.23-.127H3.617c-.654 0-.98 0-1.23.127-.22.112-.398.29-.51.51-.127.25-.127.576-.127 1.23v6.766c0 .654 0 .98.127 1.23.112.22.29.398.51.51.25.127.576.127 1.23.127Z"
    }
  )
] }), rx = nx, ox = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.5",
    d: "M10.667 8 8 5.333m0 0L5.333 8M8 5.333v5.334M4.133 14h7.734c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V4.133c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C12.987 2 12.613 2 11.867 2H4.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C2 3.013 2 3.387 2 4.133v7.734c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.659.145 1.405.145Z"
  }
) }), ix = ox, sx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M2 4.133c0-.746 0-1.12.145-1.405.128-.25.332-.455.583-.583C3.013 2 3.387 2 4.133 2h7.734c.746 0 1.12 0 1.405.145.25.128.455.332.583.583.145.285.145.659.145 1.405v7.734c0 .746 0 1.12-.145 1.405-.128.25-.332.455-.583.583-.285.145-.659.145-1.405.145H4.133c-.746 0-1.12 0-1.405-.145a1.33 1.33 0 0 1-.583-.583C2 12.987 2 12.613 2 11.867z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "M10.667 8 8 5.333m0 0L5.333 8M8 5.333v5.334M4.133 14h7.734c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V4.133c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C12.987 2 12.613 2 11.867 2H4.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C2 3.013 2 3.387 2 4.133v7.734c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.659.145 1.405.145Z"
    }
  )
] }), ax = sx, cx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M13.333 10 10 6.667m0 0L6.667 10M10 6.667v6.666M5.167 17.5h9.666c.934 0 1.4 0 1.757-.182.314-.16.569-.414.728-.728.182-.357.182-.823.182-1.757V5.167c0-.934 0-1.4-.182-1.757a1.67 1.67 0 0 0-.728-.728c-.357-.182-.823-.182-1.757-.182H5.167c-.934 0-1.4 0-1.757.182-.314.16-.569.414-.728.728-.182.357-.182.823-.182 1.757v9.666c0 .934 0 1.4.182 1.757.16.314.414.569.728.728.357.182.823.182 1.757.182Z"
  }
) }), lx = cx, ux = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M2.5 5.167c0-.934 0-1.4.182-1.757.16-.314.414-.569.728-.728.357-.182.823-.182 1.757-.182h9.666c.934 0 1.4 0 1.757.182.314.16.569.414.728.728.182.357.182.823.182 1.757v9.666c0 .934 0 1.4-.182 1.757-.16.314-.414.569-.728.728-.357.182-.823.182-1.757.182H5.167c-.934 0-1.4 0-1.757-.182a1.67 1.67 0 0 1-.728-.728c-.182-.357-.182-.823-.182-1.757z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M13.333 10 10 6.667m0 0L6.667 10M10 6.667v6.666M5.167 17.5h9.666c.934 0 1.4 0 1.757-.182.314-.16.569-.414.728-.728.182-.357.182-.823.182-1.757V5.167c0-.934 0-1.4-.182-1.757a1.67 1.67 0 0 0-.728-.728c-.357-.182-.823-.182-1.757-.182H5.167c-.934 0-1.4 0-1.757.182-.314.16-.569.414-.728.728-.182.357-.182.823-.182 1.757v9.666c0 .934 0 1.4.182 1.757.16.314.414.569.728.728.357.182.823.182 1.757.182Z"
    }
  )
] }), dx = ux, fx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "m16 12-4-4m0 0-4 4m4-4v8m-5.8 5h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21Z"
  }
) }), ll = fx, px = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M3 6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 3 5.08 3 6.2 3h11.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 4.52 21 5.08 21 6.2v11.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 21 18.92 21 17.8 21H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "m16 12-4-4m0 0-4 4m4-4v8m-5.8 5h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21Z"
    }
  )
] }), ul = px, hx = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c(tx, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(rx, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c(ix, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(ax, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(lx, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(dx, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(ll, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(ul, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(ll, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(ul, { color: e }),
    [x.Filled]: (e) => null
  }
}, vx = ({ size: e, style: t, color: n }) => hx[e][t](n), mx = ({
  sortColumn: e,
  setSortColumn: t,
  sortDirection: n,
  setSortDirection: r,
  columns: o,
  selectAllState: i,
  handleCheckAll: s,
  dataIsEmpty: l,
  hasActions: u,
  bulkActions: d,
  checkboxConfig: h,
  onSortOverride: f
}) => {
  const { width: w } = Ds(), g = me(
    (m, C) => {
      const y = n;
      let b;
      const S = e === m, E = C.defaultSortDirection ?? Ve.ASC;
      S && y === E ? b = E === Ve.ASC ? Ve.DESC : Ve.ASC : b = E, f && f(m, b), r(b), t(m);
    },
    [e, n, t, r, f]
  ), v = d || h, p = !h || h.showCheckAll;
  return w && w < mh ? null : /* @__PURE__ */ c("thead", { className: "border-b border-khaki-150", children: /* @__PURE__ */ N("tr", { children: [
    v && /* @__PURE__ */ c(
      "th",
      {
        className: F(
          "w-3 p-0 bg-khaki-50 rounded-tl-lg px-4 py-3 h-10 cursor-pointer",
          p && "hover:bg-khaki-100"
        ),
        children: /* @__PURE__ */ c("div", { children: p && /* @__PURE__ */ c(
          sd,
          {
            checked: i,
            onChange: s,
            labelText: "Select all rows",
            hideLabel: !0
          }
        ) })
      }
    ),
    o.map((m, C) => {
      const y = m.key, b = e === y && n !== Ve.NONE && !l, S = C === 0 && !d, E = C === o.length - 1 && !u;
      return /* @__PURE__ */ c(
        "th",
        {
          className: F(
            "group text-caption font-regular text-khaki-700 text-left p-0 px-4 py-3 h-10",
            S && "rounded-tl-lg",
            E && "rounded-tr-lg",
            !m.hideSort && "cursor-pointer hover:bg-khaki-100",
            b ? "bg-khaki-150" : "bg-khaki-50"
          ),
          style: m.columnWidthPercentage ? { width: `${m.columnWidthPercentage}%` } : void 0,
          onClick: () => !m.hideSort && g(y, m),
          children: /* @__PURE__ */ N("div", { className: "flex items-center gap-2", children: [
            m.label,
            b && /* @__PURE__ */ c("div", { className: "text-khaki-800 group-hover:text-khaki-600", children: /* @__PURE__ */ c(
              se,
              {
                Component: n === Ve.ASC ? QS : vx,
                color: le.CurrentColor,
                style: x.Duo
              }
            ) })
          ] })
        },
        y
      );
    }),
    u && /* @__PURE__ */ c("th", { className: "bg-khaki-50 w-3 p-0 rounded-tr-lg px-4 py-3 h-10" })
  ] }) });
}, gx = ({ displayName: e, searchText: t, clearSearch: n }) => {
  const r = ie(() => t.length > 0, [t.length]), o = ie(() => r ? `Your search "${t}" did not match any ${e}. Please try another search.` : `You currently have no ${e} to display.`, [e, r, t]);
  return /* @__PURE__ */ N("div", { className: "pt-8 pb-12", children: [
    /* @__PURE__ */ N("div", { className: "text-khaki-900 text-center text-h4", children: [
      "No ",
      e,
      " found"
    ] }),
    /* @__PURE__ */ N("div", { className: "text-khaki-600 text-center text-small", children: [
      /* @__PURE__ */ c("div", { className: "m-auto max-w-80", children: o }),
      /* @__PURE__ */ c("div", { className: "flex justify-center items-center gap-4 mt-6", children: r && /* @__PURE__ */ c(Me, { variant: et.SECONDARY, text: "Clear Search", onClick: n }) })
    ] })
  ] });
}, wx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "M9.917 5.25V4.083a2.917 2.917 0 0 0-5.833 0V5.25M7 8.167v1.166M4.2 12.25h5.6c.654 0 .98 0 1.23-.127.22-.112.398-.29.51-.51.127-.25.127-.576.127-1.23V7.117c0-.654 0-.98-.127-1.23a1.17 1.17 0 0 0-.51-.51c-.25-.127-.576-.127-1.23-.127H4.2c-.653 0-.98 0-1.23.127-.219.112-.397.29-.51.51-.127.25-.127.576-.127 1.23v3.266c0 .654 0 .98.128 1.23.112.22.29.398.51.51.25.127.576.127 1.23.127Z"
  }
) }), Cx = wx, yx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M2.334 9.033c0-1.12 0-1.68.217-2.108a2 2 0 0 1 .875-.874c.427-.218.987-.218 2.108-.218h2.933c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H5.533c-1.12 0-1.68 0-2.107-.218a2 2 0 0 1-.875-.874c-.218-.428-.218-.987-.218-2.108z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "M9.917 5.833V4.667a2.917 2.917 0 0 0-5.833 0v1.166M7 8.75v1.167m-2.8 2.916h5.6c.654 0 .98 0 1.23-.127.22-.112.398-.29.51-.51.127-.25.127-.576.127-1.23V7.7c0-.653 0-.98-.127-1.23a1.17 1.17 0 0 0-.51-.51c-.25-.127-.576-.127-1.23-.127H4.2c-.653 0-.98 0-1.23.127-.219.112-.397.29-.51.51-.127.25-.127.577-.127 1.23v3.267c0 .653 0 .98.128 1.23.112.219.29.397.51.51.25.126.576.126 1.23.126Z"
    }
  )
] }), Ex = yx, bx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.5",
    d: "M11.333 6V4.667a3.333 3.333 0 0 0-6.666 0V6M8 9.333v1.334M4.8 14h6.4c.747 0 1.12 0 1.405-.145.251-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V8.133c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C12.32 6 11.947 6 11.2 6H4.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.659-.145 1.405v3.734c0 .746 0 1.12.145 1.405.128.25.332.455.583.583C3.68 14 4.053 14 4.8 14Z"
  }
) }), Sx = bx, xx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M2.667 9.867c0-1.12 0-1.68.217-2.108a2 2 0 0 1 .875-.874c.427-.218.987-.218 2.108-.218h4.266c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.427.218.988.218 2.108v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H5.867c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.875-.874c-.217-.428-.217-.988-.217-2.108z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "M11.333 6.667V5.333a3.333 3.333 0 0 0-6.666 0v1.334M8 10v1.333m-3.2 3.334h6.4c.747 0 1.12 0 1.405-.146.251-.128.455-.332.583-.582.145-.286.145-.659.145-1.406V8.8c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.658-.145-1.405-.145H4.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.658-.145 1.405v3.733c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.658.146 1.405.146Z"
    }
  )
] }), Rx = xx, Tx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M14.167 7.5V5.833a4.167 4.167 0 0 0-8.333 0V7.5M10 11.667v1.666M6 17.5h8c.934 0 1.4 0 1.757-.182.313-.16.568-.415.728-.728.182-.357.182-.823.182-1.757v-4.666c0-.934 0-1.4-.182-1.757a1.67 1.67 0 0 0-.728-.728C15.4 7.5 14.934 7.5 14 7.5H6c-.933 0-1.4 0-1.756.182-.314.16-.57.414-.729.728-.182.356-.182.823-.182 1.757v4.666c0 .934 0 1.4.182 1.757.16.314.415.569.729.728.356.182.823.182 1.756.182Z"
  }
) }), Ax = Tx, Nx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M3.334 11.533c0-1.12 0-1.68.217-2.108a2 2 0 0 1 .875-.874c.427-.218.987-.218 2.108-.218h6.933c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H6.533c-1.12 0-1.68 0-2.107-.218a2 2 0 0 1-.875-.874c-.218-.427-.218-.988-.218-2.108z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M14.167 8.333V6.667a4.167 4.167 0 1 0-8.333 0v1.666M10 12.5v1.667m-4 4.166h8c.934 0 1.4 0 1.757-.181.313-.16.568-.415.728-.729.182-.356.182-.823.182-1.756V11c0-.933 0-1.4-.182-1.757a1.67 1.67 0 0 0-.728-.728c-.357-.182-.823-.182-1.757-.182H6c-.933 0-1.4 0-1.756.182-.314.16-.57.415-.729.728-.182.357-.182.824-.182 1.757v4.667c0 .933 0 1.4.182 1.756.16.314.415.569.729.729.356.181.823.181 1.756.181Z"
    }
  )
] }), kx = Nx, Px = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M17 9V7A5 5 0 0 0 7 7v2m5 5v2m-4.8 5h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 19.48 20 18.92 20 17.8v-5.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 9 17.92 9 16.8 9H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 10.52 4 11.08 4 12.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 21 6.08 21 7.2 21Z"
  }
) }), dl = Px, Mx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M4 13.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 10 6.08 10 7.2 10h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C20 11.52 20 12.08 20 13.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C18.48 22 17.92 22 16.8 22H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 20.48 4 19.92 4 18.8z",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M17 10V8A5 5 0 0 0 7 8v2m5 5v2m-4.8 5h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8v-5.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 10 17.92 10 16.8 10H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 11.52 4 12.08 4 13.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 22 6.08 22 7.2 22Z"
    }
  )
] }), fl = Mx, _x = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Cx, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Ex, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Sx, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Rx, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Ax, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(kx, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(dl, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(fl, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(dl, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(fl, { color: e }),
    [x.Filled]: (e) => null
  }
}, Ox = ({ size: e, style: t, color: n }) => _x[e][t](n), Dx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M7 2.917v8.166M2.917 7h8.167" }) }), $x = Dx, Lx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M7 2.917v8.166M2.917 7h8.167" }) }), Ix = Lx, Fx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "M8 3.333v9.334M3.333 8h9.333" }) }), Wx = Fx, Bx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "M8 3.333v9.334M3.333 8h9.333" }) }), Hx = Bx, Vx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M10 4.167v11.666M4.167 10h11.667" }) }), Ux = Vx, jx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M10 4.167v11.666M4.167 10h11.667" }) }), Gx = jx, zx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M12 5v14m-7-7h14" }) }), pl = zx, Kx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M12 5v14m-7-7h14" }) }), hl = Kx, Yx = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c($x, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Ix, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Wx, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Hx, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Ux, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Gx, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(pl, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(hl, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(pl, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(hl, { color: e }),
    [x.Filled]: (e) => null
  }
}, qx = ({ size: e, style: t, color: n }) => Yx[e][t](n), Xx = ({
  displayName: e,
  searchText: t,
  setSearchText: n,
  clearSearch: r,
  checkedRows: o,
  hideSearch: i,
  bulkActions: s,
  extraRightSideItems: l,
  createConfig: u
}) => {
  const { onCreate: d, disabled: h, disabledTooltip: f, buttonText: w, buttonIcon: g, testIdOverride: v } = u ?? {}, p = !h;
  return /* @__PURE__ */ N("div", { className: "flex flex-wrap justify-between overflow-visible", children: [
    /* @__PURE__ */ N("div", { className: "flex", children: [
      /* @__PURE__ */ c("div", { children: !i && /* @__PURE__ */ c(
        bb,
        {
          fluid: !1,
          value: t,
          onChange: (m) => {
            m === "" ? r() : n(m);
          }
        }
      ) }),
      s && o.length > 0 && /* @__PURE__ */ c("div", { className: F("flex gap-[10px]", !i && "ml-4"), children: s.map((m, C) => /* @__PURE__ */ c(
        Wn,
        {
          triggerComponent: /* @__PURE__ */ c(
            Me,
            {
              text: "",
              variant: et.SECONDARY,
              icon: { position: ye.CENTER, Component: m.Icon },
              onClick: () => m.onClick(o)
            }
          ),
          children: m.tooltip
        },
        `bulk-action-${C}`
      )) })
    ] }),
    /* @__PURE__ */ N("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ c("div", { children: l }),
      d && /* @__PURE__ */ c(
        Wn,
        {
          delayDuration: 0,
          disabled: p,
          triggerComponent: /* @__PURE__ */ c(
            Me,
            {
              text: w ?? `Add ${e}`,
              variant: et.KHAKI,
              icon: { position: ye.LEFT, Component: h ? Ox : g ?? qx },
              onClick: d,
              disabled: h,
              testIdOverride: v
            }
          ),
          children: f ?? `You do not have permission to create a ${e}`
        }
      )
    ] })
  ] });
}, Zx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M7 7.583a.583.583 0 1 0 0-1.166.583.583 0 0 0 0 1.166M7 3.5a.583.583 0 1 0 0-1.167A.583.583 0 0 0 7 3.5M7 11.667A.583.583 0 1 0 7 10.5a.583.583 0 0 0 0 1.167"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "M7 7.583a.583.583 0 1 0 0-1.166.583.583 0 0 0 0 1.166ZM7 3.5a.583.583 0 1 0 0-1.167A.583.583 0 0 0 7 3.5ZM7 11.667A.583.583 0 1 0 7 10.5a.583.583 0 0 0 0 1.167Z"
    }
  )
] }), Jx = Zx, Qx = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M7 7.583a.583.583 0 1 0 0-1.166.583.583 0 0 0 0 1.166M7 3.5a.583.583 0 1 0 0-1.167A.583.583 0 0 0 7 3.5M7 11.667A.583.583 0 1 0 7 10.5a.583.583 0 0 0 0 1.167"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "M7 7.583a.583.583 0 1 0 0-1.166.583.583 0 0 0 0 1.166ZM7 3.5a.583.583 0 1 0 0-1.167A.583.583 0 0 0 7 3.5ZM7 11.667A.583.583 0 1 0 7 10.5a.583.583 0 0 0 0 1.167Z"
    }
  )
] }), e6 = Qx, t6 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M8 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334M8 4a.667.667 0 1 0 0-1.333A.667.667 0 0 0 8 4M8 13.333A.667.667 0 1 0 8 12a.667.667 0 0 0 0 1.333"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "M8 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM8 4a.667.667 0 1 0 0-1.333A.667.667 0 0 0 8 4ZM8 13.333A.667.667 0 1 0 8 12a.667.667 0 0 0 0 1.333Z"
    }
  )
] }), n6 = t6, r6 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M8 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334M8 4a.667.667 0 1 0 0-1.333A.667.667 0 0 0 8 4M8 13.333A.667.667 0 1 0 8 12a.667.667 0 0 0 0 1.333"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "M8 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM8 4a.667.667 0 1 0 0-1.333A.667.667 0 0 0 8 4ZM8 13.333A.667.667 0 1 0 8 12a.667.667 0 0 0 0 1.333Z"
    }
  )
] }), o6 = r6, i6 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M10 10.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666M10 5a.833.833 0 1 0 0-1.667A.833.833 0 0 0 10 5M10 16.667A.833.833 0 1 0 10 15a.833.833 0 0 0 0 1.667"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M10 10.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666ZM10 5a.833.833 0 1 0 0-1.667A.833.833 0 0 0 10 5ZM10 16.667A.833.833 0 1 0 10 15a.833.833 0 0 0 0 1.667Z"
    }
  )
] }), s6 = i6, a6 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M10 10.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666M10 5a.833.833 0 1 0 0-1.667A.833.833 0 0 0 10 5M10 16.667A.833.833 0 1 0 10 15a.833.833 0 0 0 0 1.667"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M10 10.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666ZM10 5a.833.833 0 1 0 0-1.667A.833.833 0 0 0 10 5ZM10 16.667A.833.833 0 1 0 10 15a.833.833 0 0 0 0 1.667Z"
    }
  )
] }), c6 = a6, l6 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    }
  )
] }), vl = l6, u6 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    }
  )
] }), ml = u6, d6 = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Jx, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(e6, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c(n6, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(o6, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(s6, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(c6, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(vl, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(ml, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(vl, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(ml, { color: e }),
    [x.Filled]: (e) => null
  }
}, f6 = ({ size: e, style: t, color: n }) => d6[e][t](n);
var fs = {}, p6 = {
  get exports() {
    return fs;
  },
  set exports(e) {
    fs = e;
  }
};
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Fs, function() {
    var n = 1e3, r = 6e4, o = 36e5, i = "millisecond", s = "second", l = "minute", u = "hour", d = "day", h = "week", f = "month", w = "quarter", g = "year", v = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, C = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(k) {
      var M = ["th", "st", "nd", "rd"], A = k % 100;
      return "[" + k + (M[(A - 20) % 10] || M[A] || M[0]) + "]";
    } }, b = function(k, M, A) {
      var I = String(k);
      return !I || I.length >= M ? k : "" + Array(M + 1 - I.length).join(A) + k;
    }, S = { s: b, z: function(k) {
      var M = -k.utcOffset(), A = Math.abs(M), I = Math.floor(A / 60), P = A % 60;
      return (M <= 0 ? "+" : "-") + b(I, 2, "0") + ":" + b(P, 2, "0");
    }, m: function k(M, A) {
      if (M.date() < A.date())
        return -k(A, M);
      var I = 12 * (A.year() - M.year()) + (A.month() - M.month()), P = M.clone().add(I, f), _ = A - P < 0, T = M.clone().add(I + (_ ? -1 : 1), f);
      return +(-(I + (A - P) / (_ ? P - T : T - P)) || 0);
    }, a: function(k) {
      return k < 0 ? Math.ceil(k) || 0 : Math.floor(k);
    }, p: function(k) {
      return { M: f, y: g, w: h, d, D: v, h: u, m: l, s, ms: i, Q: w }[k] || String(k || "").toLowerCase().replace(/s$/, "");
    }, u: function(k) {
      return k === void 0;
    } }, E = "en", R = {};
    R[E] = y;
    var O = "$isDayjsObject", $ = function(k) {
      return k instanceof Z || !(!k || !k[O]);
    }, H = function k(M, A, I) {
      var P;
      if (!M)
        return E;
      if (typeof M == "string") {
        var _ = M.toLowerCase();
        R[_] && (P = _), A && (R[_] = A, P = _);
        var T = M.split("-");
        if (!P && T.length > 1)
          return k(T[0]);
      } else {
        var L = M.name;
        R[L] = M, P = L;
      }
      return !I && P && (E = P), P || !I && E;
    }, j = function(k, M) {
      if ($(k))
        return k.clone();
      var A = typeof M == "object" ? M : {};
      return A.date = k, A.args = arguments, new Z(A);
    }, D = S;
    D.l = H, D.i = $, D.w = function(k, M) {
      return j(k, { locale: M.$L, utc: M.$u, x: M.$x, $offset: M.$offset });
    };
    var Z = function() {
      function k(A) {
        this.$L = H(A.locale, null, !0), this.parse(A), this.$x = this.$x || A.x || {}, this[O] = !0;
      }
      var M = k.prototype;
      return M.parse = function(A) {
        this.$d = function(I) {
          var P = I.date, _ = I.utc;
          if (P === null)
            return /* @__PURE__ */ new Date(NaN);
          if (D.u(P))
            return /* @__PURE__ */ new Date();
          if (P instanceof Date)
            return new Date(P);
          if (typeof P == "string" && !/Z$/i.test(P)) {
            var T = P.match(m);
            if (T) {
              var L = T[2] - 1 || 0, z = (T[7] || "0").substring(0, 3);
              return _ ? new Date(Date.UTC(T[1], L, T[3] || 1, T[4] || 0, T[5] || 0, T[6] || 0, z)) : new Date(T[1], L, T[3] || 1, T[4] || 0, T[5] || 0, T[6] || 0, z);
            }
          }
          return new Date(P);
        }(A), this.init();
      }, M.init = function() {
        var A = this.$d;
        this.$y = A.getFullYear(), this.$M = A.getMonth(), this.$D = A.getDate(), this.$W = A.getDay(), this.$H = A.getHours(), this.$m = A.getMinutes(), this.$s = A.getSeconds(), this.$ms = A.getMilliseconds();
      }, M.$utils = function() {
        return D;
      }, M.isValid = function() {
        return this.$d.toString() !== p;
      }, M.isSame = function(A, I) {
        var P = j(A);
        return this.startOf(I) <= P && P <= this.endOf(I);
      }, M.isAfter = function(A, I) {
        return j(A) < this.startOf(I);
      }, M.isBefore = function(A, I) {
        return this.endOf(I) < j(A);
      }, M.$g = function(A, I, P) {
        return D.u(A) ? this[I] : this.set(P, A);
      }, M.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, M.valueOf = function() {
        return this.$d.getTime();
      }, M.startOf = function(A, I) {
        var P = this, _ = !!D.u(I) || I, T = D.p(A), L = function(te, K) {
          var re = D.w(P.$u ? Date.UTC(P.$y, K, te) : new Date(P.$y, K, te), P);
          return _ ? re : re.endOf(d);
        }, z = function(te, K) {
          return D.w(P.toDate()[te].apply(P.toDate("s"), (_ ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(K)), P);
        }, Y = this.$W, G = this.$M, ee = this.$D, Q = "set" + (this.$u ? "UTC" : "");
        switch (T) {
          case g:
            return _ ? L(1, 0) : L(31, 11);
          case f:
            return _ ? L(1, G) : L(0, G + 1);
          case h:
            var W = this.$locale().weekStart || 0, J = (Y < W ? Y + 7 : Y) - W;
            return L(_ ? ee - J : ee + (6 - J), G);
          case d:
          case v:
            return z(Q + "Hours", 0);
          case u:
            return z(Q + "Minutes", 1);
          case l:
            return z(Q + "Seconds", 2);
          case s:
            return z(Q + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, M.endOf = function(A) {
        return this.startOf(A, !1);
      }, M.$set = function(A, I) {
        var P, _ = D.p(A), T = "set" + (this.$u ? "UTC" : ""), L = (P = {}, P[d] = T + "Date", P[v] = T + "Date", P[f] = T + "Month", P[g] = T + "FullYear", P[u] = T + "Hours", P[l] = T + "Minutes", P[s] = T + "Seconds", P[i] = T + "Milliseconds", P)[_], z = _ === d ? this.$D + (I - this.$W) : I;
        if (_ === f || _ === g) {
          var Y = this.clone().set(v, 1);
          Y.$d[L](z), Y.init(), this.$d = Y.set(v, Math.min(this.$D, Y.daysInMonth())).$d;
        } else
          L && this.$d[L](z);
        return this.init(), this;
      }, M.set = function(A, I) {
        return this.clone().$set(A, I);
      }, M.get = function(A) {
        return this[D.p(A)]();
      }, M.add = function(A, I) {
        var P, _ = this;
        A = Number(A);
        var T = D.p(I), L = function(G) {
          var ee = j(_);
          return D.w(ee.date(ee.date() + Math.round(G * A)), _);
        };
        if (T === f)
          return this.set(f, this.$M + A);
        if (T === g)
          return this.set(g, this.$y + A);
        if (T === d)
          return L(1);
        if (T === h)
          return L(7);
        var z = (P = {}, P[l] = r, P[u] = o, P[s] = n, P)[T] || 1, Y = this.$d.getTime() + A * z;
        return D.w(Y, this);
      }, M.subtract = function(A, I) {
        return this.add(-1 * A, I);
      }, M.format = function(A) {
        var I = this, P = this.$locale();
        if (!this.isValid())
          return P.invalidDate || p;
        var _ = A || "YYYY-MM-DDTHH:mm:ssZ", T = D.z(this), L = this.$H, z = this.$m, Y = this.$M, G = P.weekdays, ee = P.months, Q = P.meridiem, W = function(K, re, B, ce) {
          return K && (K[re] || K(I, _)) || B[re].slice(0, ce);
        }, J = function(K) {
          return D.s(L % 12 || 12, K, "0");
        }, te = Q || function(K, re, B) {
          var ce = K < 12 ? "AM" : "PM";
          return B ? ce.toLowerCase() : ce;
        };
        return _.replace(C, function(K, re) {
          return re || function(B) {
            switch (B) {
              case "YY":
                return String(I.$y).slice(-2);
              case "YYYY":
                return D.s(I.$y, 4, "0");
              case "M":
                return Y + 1;
              case "MM":
                return D.s(Y + 1, 2, "0");
              case "MMM":
                return W(P.monthsShort, Y, ee, 3);
              case "MMMM":
                return W(ee, Y);
              case "D":
                return I.$D;
              case "DD":
                return D.s(I.$D, 2, "0");
              case "d":
                return String(I.$W);
              case "dd":
                return W(P.weekdaysMin, I.$W, G, 2);
              case "ddd":
                return W(P.weekdaysShort, I.$W, G, 3);
              case "dddd":
                return G[I.$W];
              case "H":
                return String(L);
              case "HH":
                return D.s(L, 2, "0");
              case "h":
                return J(1);
              case "hh":
                return J(2);
              case "a":
                return te(L, z, !0);
              case "A":
                return te(L, z, !1);
              case "m":
                return String(z);
              case "mm":
                return D.s(z, 2, "0");
              case "s":
                return String(I.$s);
              case "ss":
                return D.s(I.$s, 2, "0");
              case "SSS":
                return D.s(I.$ms, 3, "0");
              case "Z":
                return T;
            }
            return null;
          }(K) || T.replace(":", "");
        });
      }, M.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, M.diff = function(A, I, P) {
        var _, T = this, L = D.p(I), z = j(A), Y = (z.utcOffset() - this.utcOffset()) * r, G = this - z, ee = function() {
          return D.m(T, z);
        };
        switch (L) {
          case g:
            _ = ee() / 12;
            break;
          case f:
            _ = ee();
            break;
          case w:
            _ = ee() / 3;
            break;
          case h:
            _ = (G - Y) / 6048e5;
            break;
          case d:
            _ = (G - Y) / 864e5;
            break;
          case u:
            _ = G / o;
            break;
          case l:
            _ = G / r;
            break;
          case s:
            _ = G / n;
            break;
          default:
            _ = G;
        }
        return P ? _ : D.a(_);
      }, M.daysInMonth = function() {
        return this.endOf(f).$D;
      }, M.$locale = function() {
        return R[this.$L];
      }, M.locale = function(A, I) {
        if (!A)
          return this.$L;
        var P = this.clone(), _ = H(A, I, !0);
        return _ && (P.$L = _), P;
      }, M.clone = function() {
        return D.w(this.$d, this);
      }, M.toDate = function() {
        return new Date(this.valueOf());
      }, M.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, M.toISOString = function() {
        return this.$d.toISOString();
      }, M.toString = function() {
        return this.$d.toUTCString();
      }, k;
    }(), q = Z.prototype;
    return j.prototype = q, [["$ms", i], ["$s", s], ["$m", l], ["$H", u], ["$W", d], ["$M", f], ["$y", g], ["$D", v]].forEach(function(k) {
      q[k[1]] = function(M) {
        return this.$g(M, k[0], k[1]);
      };
    }), j.extend = function(k, M) {
      return k.$i || (k(M, Z, j), k.$i = !0), j;
    }, j.locale = H, j.isDayjs = $, j.unix = function(k) {
      return j(1e3 * k);
    }, j.en = R[E], j.Ls = R, j.p = {}, j;
  });
})(p6);
const Jr = fs;
var ps = {}, h6 = {
  get exports() {
    return ps;
  },
  set exports(e) {
    ps = e;
  }
};
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Fs, function() {
    return function(n, r, o) {
      n = n || {};
      var i = r.prototype, s = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function l(d, h, f, w) {
        return i.fromToBase(d, h, f, w);
      }
      o.en.relativeTime = s, i.fromToBase = function(d, h, f, w, g) {
        for (var v, p, m, C = f.$locale().relativeTime || s, y = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], b = y.length, S = 0; S < b; S += 1) {
          var E = y[S];
          E.d && (v = w ? o(d).diff(f, E.d, !0) : f.diff(d, E.d, !0));
          var R = (n.rounding || Math.round)(Math.abs(v));
          if (m = v > 0, R <= E.r || !E.r) {
            R <= 1 && S > 0 && (E = y[S - 1]);
            var O = C[E.l];
            g && (R = g("" + R)), p = typeof O == "string" ? O.replace("%d", R) : O(R, h, E.l, m);
            break;
          }
        }
        if (h)
          return p;
        var $ = m ? C.future : C.past;
        return typeof $ == "function" ? $(p) : $.replace("%s", p);
      }, i.to = function(d, h) {
        return l(d, h, this, !0);
      }, i.from = function(d, h) {
        return l(d, h, this);
      };
      var u = function(d) {
        return d.$u ? o.utc() : o();
      };
      i.toNow = function(d) {
        return this.to(u(this), d);
      }, i.fromNow = function(d) {
        return this.from(u(this), d);
      };
    };
  });
})(h6);
const v6 = ps;
var hs = {}, m6 = {
  get exports() {
    return hs;
  },
  set exports(e) {
    hs = e;
  }
};
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Fs, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(r, o, i) {
      var s = o.prototype, l = s.format;
      i.en.formats = n, s.format = function(u) {
        u === void 0 && (u = "YYYY-MM-DDTHH:mm:ssZ");
        var d = this.$locale().formats, h = function(f, w) {
          return f.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(g, v, p) {
            var m = p && p.toUpperCase();
            return v || w[p] || n[p] || w[m].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(C, y, b) {
              return y || b.slice(1);
            });
          });
        }(u, d === void 0 ? {} : d);
        return l.call(this, h);
      };
    };
  });
})(m6);
const g6 = hs;
Jr.extend(v6);
Jr.extend(g6);
const w6 = 7, gh = (e) => {
  const t = Jr(), n = Jr(e), r = n.diff(t, "day");
  return Math.abs(r) < w6 ? n.from(t) : n.format("ll");
}, C6 = (e, t) => {
  switch (t) {
    case xr.SENTENCE:
      return e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
    case xr.TITLE:
      return e.split(" ").map((n) => n.charAt(0).toUpperCase() + n.slice(1).toLowerCase()).join(" ");
    case xr.UPPER:
      return e.toUpperCase();
    case xr.LOWER:
      return e.toLowerCase();
    default:
      return e.toLowerCase();
  }
}, y6 = ({ label: e, value: t, onClick: n }) => /* @__PURE__ */ c("td", { className: "px-4 py-3 text-khaki-800 text-small block", onClick: () => n?.(), children: /* @__PURE__ */ N("div", { className: "flex flex-col gap-2", children: [
  /* @__PURE__ */ c("div", { className: "text-caption font-regular text-khaki-700 truncate text-nowrap", children: e }),
  /* @__PURE__ */ c("div", { className: "truncate text-nowrap", children: t })
] }) }), E6 = ({ row: e, column: t }) => {
  const n = e.data[t.key].display, r = n instanceof Date ? gh(n) : n, { truncateRef: o, showTooltip: i } = A0(e.data[t.key].value ?? r), { width: s } = Ds(), l = t.columnWidthPercentage && typeof n == "string";
  return s && s < mh ? /* @__PURE__ */ c(y6, { label: t.label, value: r, onClick: e.onClick }) : /* @__PURE__ */ c(
    "td",
    {
      className: F("px-4 py-3 text-khaki-800 text-small", l ? "max-w-1" : "text-nowrap"),
      onClick: () => e.onClick?.(),
      children: /* @__PURE__ */ c(
        Wn,
        {
          disabled: !i,
          triggerComponent: /* @__PURE__ */ c("span", { className: F("block", l && "truncate"), ref: o, children: r }),
          children: r
        }
      )
    }
  );
}, b6 = ({
  index: e,
  row: t,
  columns: n,
  bulkActions: r,
  checkboxConfig: o,
  checkedRows: i,
  handleCheckRow: s
}) => {
  const l = ie(
    () => !!i.find((f) => f.id === t.id),
    [i, t.id]
  ), u = ie(
    () => !!(o?.maxSelections && i.length >= o.maxSelections && !l),
    [o, i, l]
  ), d = !t.hideActions, h = r || o?.onChange;
  return /* @__PURE__ */ N(
    "tr",
    {
      className: F(
        t.onClick && "hover:cursor-pointer hover:bg-khaki-150",
        e !== 0 ? "border-t border-t-khaki-150" : "",
        l && "bg-khaki-100",
        u && "opacity-60"
      ),
      "data-testid": t?.testIdOverride?.row ?? `table-row-${t.id}`,
      children: [
        h && /* @__PURE__ */ c("td", { className: "px-4 py-3 text-khaki-700 w-3", children: d && /* @__PURE__ */ c(
          Wn,
          {
            disabled: !u,
            delayDuration: 0,
            triggerComponent: /* @__PURE__ */ c(
              sd,
              {
                checked: !!i.find((f) => f.id === t.id),
                onChange: (f) => s(f.target.value, t),
                labelText: `Select row ${e}`,
                hideLabel: !0,
                disabled: u,
                testIdOverride: t?.testIdOverride?.checkbox
              }
            ),
            children: "Max number of selections reached"
          }
        ) }),
        n.map((f) => /* @__PURE__ */ c(E6, { row: t, column: f }, `${t.id}-${f.key}`)),
        t.actions && /* @__PURE__ */ c("td", { className: "px-4", children: d && /* @__PURE__ */ c(Jy, { items: t.actions, alignment: Lf.END, children: /* @__PURE__ */ c(
          Me,
          {
            text: "",
            variant: et.TERTIARY,
            icon: { position: ye.CENTER, Component: f6 },
            testIdOverride: t?.testIdOverride?.actionsButton ?? `table-row-actions-button-${t.id}`
          }
        ) }) })
      ]
    }
  );
}, S6 = (e, t, n) => {
  if (!e || n.length === 0)
    return n;
  const r = t.map((o) => o.key);
  return n.filter((o) => r.some((i) => {
    const s = o.data[i].value ?? o.data[i].display;
    return typeof s == "string" || typeof s == "number" || typeof s == "boolean" ? s.toString().toLowerCase().includes(e.toLowerCase()) : s instanceof Date ? gh(s).toLowerCase().includes(e.toLowerCase()) : !1;
  }));
}, x6 = (e, t, n) => !t || !n ? e : e.slice().sort((r, o) => {
  const i = r.data[t], s = o.data[t], l = typeof i.display == "string" ? i.display.toLocaleLowerCase() : i.display, u = typeof s.display == "string" ? s.display.toLocaleLowerCase() : s.display, d = i.value?.toLocaleLowerCase() ?? l, h = s.value?.toLocaleLowerCase() ?? u;
  return d === h || n === Ve.NONE || gl(d) || gl(h) ? 0 : n === Ve.ASC ? d > h ? 1 : -1 : d < h ? 1 : -1;
}), gl = (e) => e == null, R6 = (e, t) => e.slice(0, t), T6 = ({ children: e, dataLength: t, next: n, hasMore: r, loader: o }) => {
  const i = _e(), s = _e(null), [l, u] = he(!1);
  return Pe(() => {
    if (t > 0 && !l && r) {
      const d = s.current;
      return d && (i.current = new IntersectionObserver((h) => {
        h[0].isIntersecting && (u(!0), n());
      }), i.current.observe(d)), () => {
        i.current && i.current.disconnect();
      };
    }
  }, [t, l, r, n]), Pe(() => {
    u(!1);
  }, [t]), /* @__PURE__ */ N("div", { children: [
    t > 0 && /* @__PURE__ */ N(ae, { children: [
      e,
      /* @__PURE__ */ c("div", { ref: s })
    ] }),
    r && /* @__PURE__ */ c("div", { children: o })
  ] });
}, FT = ({
  columns: e,
  rows: t,
  displayName: n,
  displayNameCase: r = "lower",
  defaultSortColumn: o,
  bulkActions: i,
  checkboxConfig: s,
  hideSearch: l = !1,
  createConfig: u,
  extraRightSideItems: d,
  rowManagementOverride: h,
  loading: f = !1
}) => {
  const [w, g] = he(() => s?.initialCheckedRows ?? []), [v, p] = he(), [m, C] = he(Ve.NONE), [y, b] = he(hi), [S, E] = he(""), R = i?.filter((P) => !P.hidden) ?? [], O = R.length ? R : void 0, $ = C6(n, r), H = _e(!0), j = me(
    (P, _) => {
      let T = [];
      P ? T = [...w, _] : T = w.filter((L) => L.id !== _.id), s?.onChange?.(T), g(T);
    },
    [w, g, s]
  ), D = me(
    (P) => {
      E(P), h?.onSearchOverride ? h?.onSearchOverride(P) : (b(hi), C(Ve.NONE));
    },
    [h, C]
  );
  Pe(() => {
    const P = T0(() => {
      H.current ? H.current = !1 : D(S);
    }, 300);
    return P(), () => P.cancel();
  }, [S]), Pe(() => {
    if (!v && o) {
      p(o);
      const P = e.find((_) => _.key === o)?.defaultSortDirection;
      C(P ?? Ve.ASC);
    }
  }, [e, o, v, p, C]);
  const Z = ie(() => h?.onSearchOverride ? t : S6(S, e, t), [h, S, e, t]), q = ie(() => {
    if (h)
      return Z;
    const P = x6(Z, v, m);
    return R6(P, y);
  }, [h, Z, v, m, y]), k = ie(() => q.filter((P) => !P.hideActions), [q]), M = ie(() => k.length > 0 && w.length === k.length ? !0 : w.length === 0 ? !1 : "indeterminate", [w, k.length]), A = me(
    (P) => {
      const _ = P.target.value;
      let T = [];
      _ === !0 ? T = k : _ === !1 && (T = []), s?.onChange?.(T), g(T);
    },
    [k, g, s]
  );
  Pe(() => {
    i && g((P) => {
      const _ = P.filter(
        (T) => q.some((L) => L.id === T.id)
      );
      return s?.onChange?.(_), _;
    });
  }, [q, i, s]);
  const I = ie(() => t.some((P) => !!P.actions), [t]);
  return /* @__PURE__ */ N("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ c(
      Xx,
      {
        displayName: $,
        searchText: S,
        setSearchText: E,
        clearSearch: () => E(""),
        checkedRows: w,
        hideSearch: l,
        bulkActions: O,
        extraRightSideItems: d,
        createConfig: u
      }
    ),
    /* @__PURE__ */ N("div", { className: "outline outline-1 outline-khaki-400 rounded-lg overflow-x-auto", children: [
      f ? /* @__PURE__ */ c("div", { className: "flex justify-center my-12", children: /* @__PURE__ */ c(Dn, {}) }) : /* @__PURE__ */ c(
        T6,
        {
          dataLength: q.length,
          next: () => {
            h?.infiniteScrollOverride ? h?.infiniteScrollOverride.onNextPageScroll() : b(y + hi);
          },
          hasMore: h?.infiniteScrollOverride.hasMore || q.length < Z.length,
          loader: /* @__PURE__ */ c("div", { "data-testid": vh.INFINITE_SCROLL_LOADER, className: "flex justify-center my-4", children: /* @__PURE__ */ c(Dn, { size: "small" }) }),
          children: /* @__PURE__ */ N("table", { className: "min-w-full", children: [
            e.every((P) => P.columnWidthPercentage) && /* @__PURE__ */ N("colgroup", { children: [
              (O || s) && /* @__PURE__ */ c("col", { width: "3%" }),
              e.map((P, _) => /* @__PURE__ */ c("col", { width: `${P.columnWidthPercentage}%` }, `table-col-${_}`)),
              I && /* @__PURE__ */ c("col", { width: "3%" })
            ] }),
            /* @__PURE__ */ c(
              mx,
              {
                sortColumn: v,
                setSortColumn: p,
                sortDirection: m,
                setSortDirection: C,
                columns: e,
                selectAllState: M,
                handleCheckAll: A,
                dataIsEmpty: q.length === 0,
                hasActions: I,
                bulkActions: O,
                checkboxConfig: s,
                onSortOverride: h?.onSortOverride
              }
            ),
            /* @__PURE__ */ c("tbody", { className: "overflow-x-scroll", children: q.map((P, _) => /* @__PURE__ */ c(
              b6,
              {
                index: _,
                row: P,
                columns: e,
                bulkActions: O,
                handleCheckRow: j,
                checkboxConfig: s,
                checkedRows: w
              },
              `table-row-${_}`
            )) })
          ] })
        }
      ),
      q.length === 0 && /* @__PURE__ */ c(
        gx,
        {
          displayName: $,
          searchText: S,
          clearSearch: () => E("")
        }
      )
    ] })
  ] });
};
function wh(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, A6(o, ...t)];
}
function A6(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function ke(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function N6(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function La(...e) {
  return (t) => e.forEach((n) => N6(n, t));
}
function _t(...e) {
  return a.useCallback(La(...e), e);
}
var Qr = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(P6);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(vs, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(vs, { ...r, ref: t, children: n });
});
Qr.displayName = "Slot";
var vs = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = _6(n);
    return a.cloneElement(n, {
      ...M6(r, n.props),
      // @ts-ignore
      ref: t ? La(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
vs.displayName = "SlotClone";
var k6 = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function P6(e) {
  return a.isValidElement(e) && e.type === k6;
}
function M6(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function _6(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var O6 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Be = O6.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? Qr : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function wl(e, t) {
  e && st.flushSync(() => e.dispatchEvent(t));
}
function Qe(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function Ch({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = D6({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = Qe(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function D6({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = Qe(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var $6 = a.createContext(void 0);
function L6(e) {
  const t = a.useContext($6);
  return e || t || "ltr";
}
var eo = globalThis?.document ? a.useLayoutEffect : () => {
}, I6 = a["useId".toString()] || (() => {
}), F6 = 0;
function yh(e) {
  const [t, n] = a.useState(I6());
  return eo(() => {
    e || n((r) => r ?? String(F6++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function Eh(e) {
  const t = e + "CollectionProvider", [n, r] = wh(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: v, children: p } = g, m = ne.useRef(null), C = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ c(o, { scope: v, itemMap: C, collectionRef: m, children: p });
  };
  s.displayName = t;
  const l = e + "CollectionSlot", u = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m } = g, C = i(l, p), y = _t(v, C.collectionRef);
      return /* @__PURE__ */ c(Qr, { ref: y, children: m });
    }
  );
  u.displayName = l;
  const d = e + "CollectionItemSlot", h = "data-radix-collection-item", f = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m, ...C } = g, y = ne.useRef(null), b = _t(v, y), S = i(d, p);
      return ne.useEffect(() => (S.itemMap.set(y, { ref: y, ...C }), () => void S.itemMap.delete(y))), /* @__PURE__ */ c(Qr, { [h]: "", ref: b, children: m });
    }
  );
  f.displayName = d;
  function w(g) {
    const v = i(e + "CollectionConsumer", g);
    return ne.useCallback(() => {
      const m = v.collectionRef.current;
      if (!m)
        return [];
      const C = Array.from(m.querySelectorAll(`[${h}]`));
      return Array.from(v.itemMap.values()).sort(
        (S, E) => C.indexOf(S.ref.current) - C.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: u, ItemSlot: f },
    w,
    r
  ];
}
function W6(e) {
  const t = a.useRef({ value: e, previous: e });
  return a.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var B6 = "VisuallyHidden", bh = a.forwardRef(
  (e, t) => /* @__PURE__ */ c(
    Be.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
bh.displayName = B6;
var H6 = bh, En = "NavigationMenu", [Ia, Sh, V6] = Eh(En), [ms, U6, j6] = Eh(En), [Fa, WT] = wh(
  En,
  [V6, j6]
), [G6, He] = Fa(En), [z6, K6] = Fa(En), xh = a.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      delayDuration: s = 200,
      skipDelayDuration: l = 300,
      orientation: u = "horizontal",
      dir: d,
      ...h
    } = e, [f, w] = a.useState(null), g = _t(t, (H) => w(H)), v = L6(d), p = a.useRef(0), m = a.useRef(0), C = a.useRef(0), [y, b] = a.useState(!0), [S = "", E] = Ch({
      prop: r,
      onChange: (H) => {
        const j = H !== "", D = l > 0;
        j ? (window.clearTimeout(C.current), D && b(!1)) : (window.clearTimeout(C.current), C.current = window.setTimeout(
          () => b(!0),
          l
        )), o?.(H);
      },
      defaultProp: i
    }), R = a.useCallback(() => {
      window.clearTimeout(m.current), m.current = window.setTimeout(() => E(""), 150);
    }, [E]), O = a.useCallback(
      (H) => {
        window.clearTimeout(m.current), E(H);
      },
      [E]
    ), $ = a.useCallback(
      (H) => {
        S === H ? window.clearTimeout(m.current) : p.current = window.setTimeout(() => {
          window.clearTimeout(m.current), E(H);
        }, s);
      },
      [S, E, s]
    );
    return a.useEffect(() => () => {
      window.clearTimeout(p.current), window.clearTimeout(m.current), window.clearTimeout(C.current);
    }, []), /* @__PURE__ */ c(
      Th,
      {
        scope: n,
        isRootMenu: !0,
        value: S,
        dir: v,
        orientation: u,
        rootNavigationMenu: f,
        onTriggerEnter: (H) => {
          window.clearTimeout(p.current), y ? $(H) : O(H);
        },
        onTriggerLeave: () => {
          window.clearTimeout(p.current), R();
        },
        onContentEnter: () => window.clearTimeout(m.current),
        onContentLeave: R,
        onItemSelect: (H) => {
          E((j) => j === H ? "" : H);
        },
        onItemDismiss: () => E(""),
        children: /* @__PURE__ */ c(
          Be.nav,
          {
            "aria-label": "Main",
            "data-orientation": u,
            dir: v,
            ...h,
            ref: g
          }
        )
      }
    );
  }
);
xh.displayName = En;
var Rh = "NavigationMenuSub", Y6 = a.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      orientation: s = "horizontal",
      ...l
    } = e, u = He(Rh, n), [d = "", h] = Ch({
      prop: r,
      onChange: o,
      defaultProp: i
    });
    return /* @__PURE__ */ c(
      Th,
      {
        scope: n,
        isRootMenu: !1,
        value: d,
        dir: u.dir,
        orientation: s,
        rootNavigationMenu: u.rootNavigationMenu,
        onTriggerEnter: (f) => h(f),
        onItemSelect: (f) => h(f),
        onItemDismiss: () => h(""),
        children: /* @__PURE__ */ c(Be.div, { "data-orientation": s, ...l, ref: t })
      }
    );
  }
);
Y6.displayName = Rh;
var Th = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: r,
    dir: o,
    orientation: i,
    children: s,
    value: l,
    onItemSelect: u,
    onItemDismiss: d,
    onTriggerEnter: h,
    onTriggerLeave: f,
    onContentEnter: w,
    onContentLeave: g
  } = e, [v, p] = a.useState(null), [m, C] = a.useState(/* @__PURE__ */ new Map()), [y, b] = a.useState(null);
  return /* @__PURE__ */ c(
    G6,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: r,
      value: l,
      previousValue: W6(l),
      baseId: yh(),
      dir: o,
      orientation: i,
      viewport: v,
      onViewportChange: p,
      indicatorTrack: y,
      onIndicatorTrackChange: b,
      onTriggerEnter: Qe(h),
      onTriggerLeave: Qe(f),
      onContentEnter: Qe(w),
      onContentLeave: Qe(g),
      onItemSelect: Qe(u),
      onItemDismiss: Qe(d),
      onViewportContentChange: a.useCallback((S, E) => {
        C((R) => (R.set(S, E), new Map(R)));
      }, []),
      onViewportContentRemove: a.useCallback((S) => {
        C((E) => E.has(S) ? (E.delete(S), new Map(E)) : E);
      }, []),
      children: /* @__PURE__ */ c(Ia.Provider, { scope: t, children: /* @__PURE__ */ c(z6, { scope: t, items: m, children: s }) })
    }
  );
}, Ah = "NavigationMenuList", Nh = a.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = He(Ah, n), i = /* @__PURE__ */ c(Be.ul, { "data-orientation": o.orientation, ...r, ref: t });
    return /* @__PURE__ */ c(Be.div, { style: { position: "relative" }, ref: o.onIndicatorTrackChange, children: /* @__PURE__ */ c(Ia.Slot, { scope: n, children: o.isRootMenu ? /* @__PURE__ */ c(Dh, { asChild: !0, children: i }) : i }) });
  }
);
Nh.displayName = Ah;
var kh = "NavigationMenuItem", [q6, Ph] = Fa(kh), Mh = a.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: r, ...o } = e, i = yh(), s = r || i || "LEGACY_REACT_AUTO_VALUE", l = a.useRef(null), u = a.useRef(null), d = a.useRef(null), h = a.useRef(() => {
    }), f = a.useRef(!1), w = a.useCallback((v = "start") => {
      if (l.current) {
        h.current();
        const p = ws(l.current);
        p.length && Ha(v === "start" ? p : p.reverse());
      }
    }, []), g = a.useCallback(() => {
      if (l.current) {
        const v = ws(l.current);
        v.length && (h.current = s5(v));
      }
    }, []);
    return /* @__PURE__ */ c(
      q6,
      {
        scope: n,
        value: s,
        triggerRef: u,
        contentRef: l,
        focusProxyRef: d,
        wasEscapeCloseRef: f,
        onEntryKeyDown: w,
        onFocusProxyEnter: w,
        onRootContentClose: g,
        onContentFocusOutside: g,
        children: /* @__PURE__ */ c(Be.li, { ...o, ref: t })
      }
    );
  }
);
Mh.displayName = kh;
var gs = "NavigationMenuTrigger", _h = a.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: r, ...o } = e, i = He(gs, e.__scopeNavigationMenu), s = Ph(gs, e.__scopeNavigationMenu), l = a.useRef(null), u = _t(l, s.triggerRef, t), d = Lh(i.baseId, s.value), h = Ih(i.baseId, s.value), f = a.useRef(!1), w = a.useRef(!1), g = s.value === i.value;
  return /* @__PURE__ */ N(ae, { children: [
    /* @__PURE__ */ c(Ia.ItemSlot, { scope: n, value: s.value, children: /* @__PURE__ */ c($h, { asChild: !0, children: /* @__PURE__ */ c(
      Be.button,
      {
        id: d,
        disabled: r,
        "data-disabled": r ? "" : void 0,
        "data-state": Va(g),
        "aria-expanded": g,
        "aria-controls": h,
        ...o,
        ref: u,
        onPointerEnter: ke(e.onPointerEnter, () => {
          w.current = !1, s.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: ke(
          e.onPointerMove,
          to(() => {
            r || w.current || s.wasEscapeCloseRef.current || f.current || (i.onTriggerEnter(s.value), f.current = !0);
          })
        ),
        onPointerLeave: ke(
          e.onPointerLeave,
          to(() => {
            r || (i.onTriggerLeave(), f.current = !1);
          })
        ),
        onClick: ke(e.onClick, () => {
          i.onItemSelect(s.value), w.current = g;
        }),
        onKeyDown: ke(e.onKeyDown, (v) => {
          const m = { horizontal: "ArrowDown", vertical: i.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[i.orientation];
          g && v.key === m && (s.onEntryKeyDown(), v.preventDefault());
        })
      }
    ) }) }),
    g && /* @__PURE__ */ N(ae, { children: [
      /* @__PURE__ */ c(
        H6,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: s.focusProxyRef,
          onFocus: (v) => {
            const p = s.contentRef.current, m = v.relatedTarget, C = m === l.current, y = p?.contains(m);
            (C || !y) && s.onFocusProxyEnter(C ? "start" : "end");
          }
        }
      ),
      i.viewport && /* @__PURE__ */ c("span", { "aria-owns": h })
    ] })
  ] });
});
_h.displayName = gs;
var X6 = "NavigationMenuLink", Cl = "navigationMenu.linkSelect", Z6 = a.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: r, onSelect: o, ...i } = e;
    return /* @__PURE__ */ c($h, { asChild: !0, children: /* @__PURE__ */ c(
      Be.a,
      {
        "data-active": r ? "" : void 0,
        "aria-current": r ? "page" : void 0,
        ...i,
        ref: t,
        onClick: ke(
          e.onClick,
          (s) => {
            const l = s.target, u = new CustomEvent(Cl, {
              bubbles: !0,
              cancelable: !0
            });
            if (l.addEventListener(Cl, (d) => o?.(d), { once: !0 }), wl(l, u), !u.defaultPrevented && !s.metaKey) {
              const d = new CustomEvent(Dr, {
                bubbles: !0,
                cancelable: !0
              });
              wl(l, d);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Z6.displayName = X6;
var Wa = "NavigationMenuIndicator", J6 = a.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = He(Wa, e.__scopeNavigationMenu), i = !!o.value;
  return o.indicatorTrack ? iu.createPortal(
    /* @__PURE__ */ c(be, { present: n || i, children: /* @__PURE__ */ c(Q6, { ...r, ref: t }) }),
    o.indicatorTrack
  ) : null;
});
J6.displayName = Wa;
var Q6 = a.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, o = He(Wa, n), i = Sh(n), [s, l] = a.useState(
    null
  ), [u, d] = a.useState(null), h = o.orientation === "horizontal", f = !!o.value;
  a.useEffect(() => {
    const v = i().find((p) => p.value === o.value)?.ref.current;
    v && l(v);
  }, [i, o.value]);
  const w = () => {
    s && d({
      size: h ? s.offsetWidth : s.offsetHeight,
      offset: h ? s.offsetLeft : s.offsetTop
    });
  };
  return Cs(s, w), Cs(o.indicatorTrack, w), u ? /* @__PURE__ */ c(
    Be.div,
    {
      "aria-hidden": !0,
      "data-state": f ? "visible" : "hidden",
      "data-orientation": o.orientation,
      ...r,
      ref: t,
      style: {
        position: "absolute",
        ...h ? {
          left: 0,
          width: u.size + "px",
          transform: `translateX(${u.offset}px)`
        } : {
          top: 0,
          height: u.size + "px",
          transform: `translateY(${u.offset}px)`
        },
        ...r.style
      }
    }
  ) : null;
}), ln = "NavigationMenuContent", e5 = a.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = He(ln, e.__scopeNavigationMenu), i = Ph(ln, e.__scopeNavigationMenu), s = _t(i.contentRef, t), l = i.value === o.value, u = {
    value: i.value,
    triggerRef: i.triggerRef,
    focusProxyRef: i.focusProxyRef,
    wasEscapeCloseRef: i.wasEscapeCloseRef,
    onContentFocusOutside: i.onContentFocusOutside,
    onRootContentClose: i.onRootContentClose,
    ...r
  };
  return o.viewport ? /* @__PURE__ */ c(t5, { forceMount: n, ...u, ref: s }) : /* @__PURE__ */ c(be, { present: n || l, children: /* @__PURE__ */ c(
    Oh,
    {
      "data-state": Va(l),
      ...u,
      ref: s,
      onPointerEnter: ke(e.onPointerEnter, o.onContentEnter),
      onPointerLeave: ke(
        e.onPointerLeave,
        to(o.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !l && o.isRootMenu ? "none" : void 0,
        ...u.style
      }
    }
  ) });
});
e5.displayName = ln;
var t5 = a.forwardRef((e, t) => {
  const n = He(ln, e.__scopeNavigationMenu), { onViewportContentChange: r, onViewportContentRemove: o } = n;
  return eo(() => {
    r(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, r]), eo(() => () => o(e.value), [e.value, o]), null;
}), Dr = "navigationMenu.rootContentDismiss", Oh = a.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: r,
    triggerRef: o,
    focusProxyRef: i,
    wasEscapeCloseRef: s,
    onRootContentClose: l,
    onContentFocusOutside: u,
    ...d
  } = e, h = He(ln, n), f = a.useRef(null), w = _t(f, t), g = Lh(h.baseId, r), v = Ih(h.baseId, r), p = Sh(n), m = a.useRef(null), { onItemDismiss: C } = h;
  a.useEffect(() => {
    const b = f.current;
    if (h.isRootMenu && b) {
      const S = () => {
        C(), l(), b.contains(document.activeElement) && o.current?.focus();
      };
      return b.addEventListener(Dr, S), () => b.removeEventListener(Dr, S);
    }
  }, [h.isRootMenu, e.value, o, C, l]);
  const y = a.useMemo(() => {
    const S = p().map((j) => j.value);
    h.dir === "rtl" && S.reverse();
    const E = S.indexOf(h.value), R = S.indexOf(h.previousValue), O = r === h.value, $ = R === S.indexOf(r);
    if (!O && !$)
      return m.current;
    const H = (() => {
      if (E !== R) {
        if (O && R !== -1)
          return E > R ? "from-end" : "from-start";
        if ($ && E !== -1)
          return E > R ? "to-start" : "to-end";
      }
      return null;
    })();
    return m.current = H, H;
  }, [h.previousValue, h.value, h.dir, p, r]);
  return /* @__PURE__ */ c(Dh, { asChild: !0, children: /* @__PURE__ */ c(
    vt,
    {
      id: v,
      "aria-labelledby": g,
      "data-motion": y,
      "data-orientation": h.orientation,
      ...d,
      ref: w,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        const b = new Event(Dr, {
          bubbles: !0,
          cancelable: !0
        });
        f.current?.dispatchEvent(b);
      },
      onFocusOutside: ke(e.onFocusOutside, (b) => {
        u();
        const S = b.target;
        h.rootNavigationMenu?.contains(S) && b.preventDefault();
      }),
      onPointerDownOutside: ke(e.onPointerDownOutside, (b) => {
        const S = b.target, E = p().some((O) => O.ref.current?.contains(S)), R = h.isRootMenu && h.viewport?.contains(S);
        (E || R || !h.isRootMenu) && b.preventDefault();
      }),
      onKeyDown: ke(e.onKeyDown, (b) => {
        const S = b.altKey || b.ctrlKey || b.metaKey;
        if (b.key === "Tab" && !S) {
          const R = ws(b.currentTarget), O = document.activeElement, $ = R.findIndex((D) => D === O), j = b.shiftKey ? R.slice(0, $).reverse() : R.slice($ + 1, R.length);
          Ha(j) ? b.preventDefault() : i.current?.focus();
        }
      }),
      onEscapeKeyDown: ke(e.onEscapeKeyDown, (b) => {
        s.current = !0;
      })
    }
  ) });
}), Ba = "NavigationMenuViewport", n5 = a.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = !!He(Ba, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ c(be, { present: n || i, children: /* @__PURE__ */ c(r5, { ...r, ref: t }) });
});
n5.displayName = Ba;
var r5 = a.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: r, ...o } = e, i = He(Ba, n), s = _t(t, i.onViewportChange), l = K6(
    ln,
    e.__scopeNavigationMenu
  ), [u, d] = a.useState(null), [h, f] = a.useState(null), w = u ? u?.width + "px" : void 0, g = u ? u?.height + "px" : void 0, v = !!i.value, p = v ? i.value : i.previousValue;
  return Cs(h, () => {
    h && d({ width: h.offsetWidth, height: h.offsetHeight });
  }), /* @__PURE__ */ c(
    Be.div,
    {
      "data-state": Va(v),
      "data-orientation": i.orientation,
      ...o,
      ref: s,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !v && i.isRootMenu ? "none" : void 0,
        ["--radix-navigation-menu-viewport-width"]: w,
        ["--radix-navigation-menu-viewport-height"]: g,
        ...o.style
      },
      onPointerEnter: ke(e.onPointerEnter, i.onContentEnter),
      onPointerLeave: ke(e.onPointerLeave, to(i.onContentLeave)),
      children: Array.from(l.items).map(([C, { ref: y, forceMount: b, ...S }]) => {
        const E = p === C;
        return /* @__PURE__ */ c(be, { present: b || E, children: /* @__PURE__ */ c(
          Oh,
          {
            ...S,
            ref: La(y, (R) => {
              E && R && f(R);
            })
          }
        ) }, C);
      })
    }
  );
}), o5 = "FocusGroup", Dh = a.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = He(o5, n);
    return /* @__PURE__ */ c(ms.Provider, { scope: n, children: /* @__PURE__ */ c(ms.Slot, { scope: n, children: /* @__PURE__ */ c(Be.div, { dir: o.dir, ...r, ref: t }) }) });
  }
), yl = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], i5 = "FocusGroupItem", $h = a.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = U6(n), i = He(i5, n);
    return /* @__PURE__ */ c(ms.ItemSlot, { scope: n, children: /* @__PURE__ */ c(
      Be.button,
      {
        ...r,
        ref: t,
        onKeyDown: ke(e.onKeyDown, (s) => {
          if (["Home", "End", ...yl].includes(s.key)) {
            let u = o().map((f) => f.ref.current);
            if ([i.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(s.key) && u.reverse(), yl.includes(s.key)) {
              const f = u.indexOf(s.currentTarget);
              u = u.slice(f + 1);
            }
            setTimeout(() => Ha(u)), s.preventDefault();
          }
        })
      }
    ) });
  }
);
function ws(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Ha(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function s5(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function Cs(e, t) {
  const n = Qe(t);
  eo(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
function Va(e) {
  return e ? "open" : "closed";
}
function Lh(e, t) {
  return `${e}-trigger-${t}`;
}
function Ih(e, t) {
  return `${e}-content-${t}`;
}
function to(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var a5 = xh, c5 = Nh, l5 = Mh, u5 = _h;
const Ot = {
  SMALL: "small",
  MEDIUM: "medium"
}, xe = {
  KHAKI: "khaki",
  RED: "red",
  YELLOW: "yellow",
  GREEN: "green",
  INDIGO: "indigo",
  PINK: "pink",
  ORANGE: "orange",
  TEAL: "teal"
}, $r = {
  DEFAULT: "default",
  ROUNDED: "rounded",
  OUTLINE: "outline"
}, ut = "w-1.5 h-1.5 rounded-full", d5 = {
  [xe.INDIGO]: F("bg-indigo-600", ut),
  [xe.KHAKI]: F("bg-khaki-600", ut),
  [xe.GREEN]: F("bg-green-600", ut),
  [xe.YELLOW]: F("bg-yellow-600", ut),
  [xe.PINK]: F("bg-pink-600", ut),
  [xe.RED]: F("bg-red-600", ut),
  [xe.ORANGE]: F("bg-orange-600", ut),
  [xe.TEAL]: F("bg-teal-600", ut)
}, f5 = {
  [Ot.SMALL]: "flex items-center px-2 gap-1 py-1 h-auto w-fit max-w-full text-caption text-wrap font-medium",
  [Ot.MEDIUM]: "flex items-center px-3 gap-1 py-1 h-auto w-fit max-w-full text-small text-wrap font-medium"
}, p5 = {
  [Ot.SMALL]: U.XS,
  [Ot.MEDIUM]: U.S
}, h5 = {
  [xe.KHAKI]: "bg-khaki-150 text-khaki-800 border-khaki-600",
  [xe.RED]: "bg-red-200 text-red-700 border-red-600",
  [xe.YELLOW]: "bg-yellow-200 text-yellow-800 border-yellow-600",
  [xe.GREEN]: "bg-green-200 text-green-800 border-green-600",
  [xe.INDIGO]: "bg-indigo-200 text-indigo-700 border-indigo-600",
  [xe.PINK]: "bg-pink-200 text-pink-700 border-pink-600",
  [xe.ORANGE]: "bg-orange-200 text-orange-700 border-orange-600",
  [xe.TEAL]: "text-teal-800 bg-teal-200 border-teal-600"
}, v5 = {
  [$r.DEFAULT]: "border-0 rounded-none",
  [$r.ROUNDED]: "border-0 rounded",
  [$r.OUTLINE]: "border rounded"
};
var An = /* @__PURE__ */ ((e) => (e.TAG_BASE = "tag-base", e.TAG_TEXT = "tag-text", e.TAG_REMOVE = "tag-remove", e.TAG_BULLET = "tag-bullet", e))(An || {});
const Ua = ({
  text: e,
  size: t,
  color: n,
  variant: r = $r.DEFAULT,
  onRemove: o = null,
  icon: i = null,
  bulleted: s = !1
}) => {
  const l = f5[t], u = h5[n], d = v5[r], h = p5[t], f = d5[n];
  return /* @__PURE__ */ N("div", { "data-testid": An.TAG_BASE, className: F(l, u, d), children: [
    i && /* @__PURE__ */ c(se, { Component: i, color: le.CurrentColor, size: h }),
    s && /* @__PURE__ */ c("span", { "data-testid": An.TAG_BULLET, className: f }),
    /* @__PURE__ */ c("span", { "data-testid": An.TAG_TEXT, children: e }),
    o && /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        "data-testid": An.TAG_REMOVE,
        onClick: (w) => {
          w.stopPropagation(), o();
        },
        className: "cursor-pointer",
        children: /* @__PURE__ */ c(se, { Component: pn, color: le.CurrentColor, size: h })
      }
    )
  ] });
};
var Lr = /* @__PURE__ */ ((e) => (e.TabBase = "tab-base", e.TabLabel = "tab-label", e.TabCount = "tab-count", e))(Lr || {});
function BT({ tabs: e, activeTab: t, onTabChange: n }) {
  return /* @__PURE__ */ c(a5, { value: t, children: /* @__PURE__ */ c(c5, { className: "flex items-center gap-4 h-10 py-2", children: e.map((r) => {
    const o = r.key === t;
    return /* @__PURE__ */ c(
      l5,
      {
        className: F("flex items-center px-1 pb-2", o && "border-b border-khaki-900"),
        value: r.key,
        "data-testid": Lr.TabBase,
        children: /* @__PURE__ */ N(u5, { className: "flex items-center gap-2", onClick: () => n(r.key), children: [
          /* @__PURE__ */ c(
            "span",
            {
              "data-testid": Lr.TabLabel,
              className: F("text-small", o ? "font-medium text-khaki-900" : "text-khaki-600"),
              children: r.label
            }
          ),
          r.count && /* @__PURE__ */ c(
            "span",
            {
              "data-testid": Lr.TabCount,
              className: F(
                "flex items-center h-5 p-1.5 border border-khaki-200 rounded font-medium text-caption",
                o ? "bg-khaki-200" : "bg-white"
              ),
              children: r.count
            }
          ),
          r.tag && /* @__PURE__ */ c(Ua, { text: r.tag.label, size: Ot.SMALL, color: r.tag.color, variant: r.tag.variant })
        ] })
      },
      r.key
    );
  }) }) });
}
function ze(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function m5(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Fh(...e) {
  return (t) => e.forEach((n) => m5(n, t));
}
function no(...e) {
  return a.useCallback(Fh(...e), e);
}
function Wh(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, g5(o, ...t)];
}
function g5(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var ro = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(C5);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(ys, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(ys, { ...r, ref: t, children: n });
});
ro.displayName = "Slot";
var ys = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = E5(n);
    return a.cloneElement(n, {
      ...y5(r, n.props),
      // @ts-ignore
      ref: t ? Fh(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
ys.displayName = "SlotClone";
var w5 = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function C5(e) {
  return a.isValidElement(e) && e.type === w5;
}
function y5(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function E5(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function b5(e) {
  const t = e + "CollectionProvider", [n, r] = Wh(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: v, children: p } = g, m = ne.useRef(null), C = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ c(o, { scope: v, itemMap: C, collectionRef: m, children: p });
  };
  s.displayName = t;
  const l = e + "CollectionSlot", u = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m } = g, C = i(l, p), y = no(v, C.collectionRef);
      return /* @__PURE__ */ c(ro, { ref: y, children: m });
    }
  );
  u.displayName = l;
  const d = e + "CollectionItemSlot", h = "data-radix-collection-item", f = ne.forwardRef(
    (g, v) => {
      const { scope: p, children: m, ...C } = g, y = ne.useRef(null), b = no(v, y), S = i(d, p);
      return ne.useEffect(() => (S.itemMap.set(y, { ref: y, ...C }), () => void S.itemMap.delete(y))), /* @__PURE__ */ c(ro, { [h]: "", ref: b, children: m });
    }
  );
  f.displayName = d;
  function w(g) {
    const v = i(e + "CollectionConsumer", g);
    return ne.useCallback(() => {
      const m = v.collectionRef.current;
      if (!m)
        return [];
      const C = Array.from(m.querySelectorAll(`[${h}]`));
      return Array.from(v.itemMap.values()).sort(
        (S, E) => C.indexOf(S.ref.current) - C.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: u, ItemSlot: f },
    w,
    r
  ];
}
var S5 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], $t = S5.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? ro : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function x5(e, t) {
  e && st.flushSync(() => e.dispatchEvent(t));
}
function un(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function R5({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = T5({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = un(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function T5({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = un(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var A5 = globalThis?.document ? a.useLayoutEffect : () => {
}, N5 = "VisuallyHidden", ja = a.forwardRef(
  (e, t) => /* @__PURE__ */ c(
    $t.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
ja.displayName = N5;
var Ga = "ToastProvider", [za, k5, P5] = b5("Toast"), [Bh, HT] = Wh("Toast", [P5]), [M5, Fo] = Bh(Ga), Hh = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: i = 50,
    children: s
  } = e, [l, u] = a.useState(null), [d, h] = a.useState(0), f = a.useRef(!1), w = a.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Ga}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ c(za.Provider, { scope: t, children: /* @__PURE__ */ c(
    M5,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: i,
      toastCount: d,
      viewport: l,
      onViewportChange: u,
      onToastAdd: a.useCallback(() => h((g) => g + 1), []),
      onToastRemove: a.useCallback(() => h((g) => g - 1), []),
      isFocusedToastEscapeKeyDownRef: f,
      isClosePausedRef: w,
      children: s
    }
  ) });
};
Hh.displayName = Ga;
var Vh = "ToastViewport", _5 = ["F8"], Es = "toast.viewportPause", bs = "toast.viewportResume", Uh = a.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = _5,
      label: o = "Notifications ({hotkey})",
      ...i
    } = e, s = Fo(Vh, n), l = k5(n), u = a.useRef(null), d = a.useRef(null), h = a.useRef(null), f = a.useRef(null), w = no(t, f, s.onViewportChange), g = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), v = s.toastCount > 0;
    a.useEffect(() => {
      const m = (C) => {
        r.every((b) => C[b] || C.code === b) && f.current?.focus();
      };
      return document.addEventListener("keydown", m), () => document.removeEventListener("keydown", m);
    }, [r]), a.useEffect(() => {
      const m = u.current, C = f.current;
      if (v && m && C) {
        const y = () => {
          if (!s.isClosePausedRef.current) {
            const R = new CustomEvent(Es);
            C.dispatchEvent(R), s.isClosePausedRef.current = !0;
          }
        }, b = () => {
          if (s.isClosePausedRef.current) {
            const R = new CustomEvent(bs);
            C.dispatchEvent(R), s.isClosePausedRef.current = !1;
          }
        }, S = (R) => {
          !m.contains(R.relatedTarget) && b();
        }, E = () => {
          m.contains(document.activeElement) || b();
        };
        return m.addEventListener("focusin", y), m.addEventListener("focusout", S), m.addEventListener("pointermove", y), m.addEventListener("pointerleave", E), window.addEventListener("blur", y), window.addEventListener("focus", b), () => {
          m.removeEventListener("focusin", y), m.removeEventListener("focusout", S), m.removeEventListener("pointermove", y), m.removeEventListener("pointerleave", E), window.removeEventListener("blur", y), window.removeEventListener("focus", b);
        };
      }
    }, [v, s.isClosePausedRef]);
    const p = a.useCallback(
      ({ tabbingDirection: m }) => {
        const y = l().map((b) => {
          const S = b.ref.current, E = [S, ...z5(S)];
          return m === "forwards" ? E : E.reverse();
        });
        return (m === "forwards" ? y.reverse() : y).flat();
      },
      [l]
    );
    return a.useEffect(() => {
      const m = f.current;
      if (m) {
        const C = (y) => {
          const b = y.altKey || y.ctrlKey || y.metaKey;
          if (y.key === "Tab" && !b) {
            const E = document.activeElement, R = y.shiftKey;
            if (y.target === m && R) {
              d.current?.focus();
              return;
            }
            const H = p({ tabbingDirection: R ? "backwards" : "forwards" }), j = H.findIndex((D) => D === E);
            vi(H.slice(j + 1)) ? y.preventDefault() : R ? d.current?.focus() : h.current?.focus();
          }
        };
        return m.addEventListener("keydown", C), () => m.removeEventListener("keydown", C);
      }
    }, [l, p]), /* @__PURE__ */ N(
      J0,
      {
        ref: u,
        role: "region",
        "aria-label": o.replace("{hotkey}", g),
        tabIndex: -1,
        style: { pointerEvents: v ? void 0 : "none" },
        children: [
          v && /* @__PURE__ */ c(
            Ss,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const m = p({
                  tabbingDirection: "forwards"
                });
                vi(m);
              }
            }
          ),
          /* @__PURE__ */ c(za.Slot, { scope: n, children: /* @__PURE__ */ c($t.ol, { tabIndex: -1, ...i, ref: w }) }),
          v && /* @__PURE__ */ c(
            Ss,
            {
              ref: h,
              onFocusFromOutsideViewport: () => {
                const m = p({
                  tabbingDirection: "backwards"
                });
                vi(m);
              }
            }
          )
        ]
      }
    );
  }
);
Uh.displayName = Vh;
var jh = "ToastFocusProxy", Ss = a.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, i = Fo(jh, n);
    return /* @__PURE__ */ c(
      ja,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (s) => {
          const l = s.relatedTarget;
          !i.viewport?.contains(l) && r();
        }
      }
    );
  }
);
Ss.displayName = jh;
var Wo = "Toast", O5 = "toast.swipeStart", D5 = "toast.swipeMove", $5 = "toast.swipeCancel", L5 = "toast.swipeEnd", Gh = a.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: i, ...s } = e, [l = !0, u] = R5({
      prop: r,
      defaultProp: o,
      onChange: i
    });
    return /* @__PURE__ */ c(be, { present: n || l, children: /* @__PURE__ */ c(
      W5,
      {
        open: l,
        ...s,
        ref: t,
        onClose: () => u(!1),
        onPause: un(e.onPause),
        onResume: un(e.onResume),
        onSwipeStart: ze(e.onSwipeStart, (d) => {
          d.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: ze(e.onSwipeMove, (d) => {
          const { x: h, y: f } = d.detail.delta;
          d.currentTarget.setAttribute("data-swipe", "move"), d.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${h}px`), d.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${f}px`);
        }),
        onSwipeCancel: ze(e.onSwipeCancel, (d) => {
          d.currentTarget.setAttribute("data-swipe", "cancel"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), d.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), d.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: ze(e.onSwipeEnd, (d) => {
          const { x: h, y: f } = d.detail.delta;
          d.currentTarget.setAttribute("data-swipe", "end"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), d.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${h}px`), d.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${f}px`), u(!1);
        })
      }
    ) });
  }
);
Gh.displayName = Wo;
var [I5, F5] = Bh(Wo, {
  onClose() {
  }
}), W5 = a.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: i,
      onClose: s,
      onEscapeKeyDown: l,
      onPause: u,
      onResume: d,
      onSwipeStart: h,
      onSwipeMove: f,
      onSwipeCancel: w,
      onSwipeEnd: g,
      ...v
    } = e, p = Fo(Wo, n), [m, C] = a.useState(null), y = no(t, (k) => C(k)), b = a.useRef(null), S = a.useRef(null), E = o || p.duration, R = a.useRef(0), O = a.useRef(E), $ = a.useRef(0), { onToastAdd: H, onToastRemove: j } = p, D = un(() => {
      m?.contains(document.activeElement) && p.viewport?.focus(), s();
    }), Z = a.useCallback(
      (k) => {
        !k || k === 1 / 0 || (window.clearTimeout($.current), R.current = (/* @__PURE__ */ new Date()).getTime(), $.current = window.setTimeout(D, k));
      },
      [D]
    );
    a.useEffect(() => {
      const k = p.viewport;
      if (k) {
        const M = () => {
          Z(O.current), d?.();
        }, A = () => {
          const I = (/* @__PURE__ */ new Date()).getTime() - R.current;
          O.current = O.current - I, window.clearTimeout($.current), u?.();
        };
        return k.addEventListener(Es, A), k.addEventListener(bs, M), () => {
          k.removeEventListener(Es, A), k.removeEventListener(bs, M);
        };
      }
    }, [p.viewport, E, u, d, Z]), a.useEffect(() => {
      i && !p.isClosePausedRef.current && Z(E);
    }, [i, E, p.isClosePausedRef, Z]), a.useEffect(() => (H(), () => j()), [H, j]);
    const q = a.useMemo(() => m ? Zh(m) : null, [m]);
    return p.viewport ? /* @__PURE__ */ N(ae, { children: [
      q && /* @__PURE__ */ c(
        B5,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: q
        }
      ),
      /* @__PURE__ */ c(I5, { scope: n, onClose: D, children: st.createPortal(
        /* @__PURE__ */ c(za.ItemSlot, { scope: n, children: /* @__PURE__ */ c(
          Z0,
          {
            asChild: !0,
            onEscapeKeyDown: ze(l, () => {
              p.isFocusedToastEscapeKeyDownRef.current || D(), p.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ c(
              $t.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": i ? "open" : "closed",
                "data-swipe-direction": p.swipeDirection,
                ...v,
                ref: y,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: ze(e.onKeyDown, (k) => {
                  k.key === "Escape" && (l?.(k.nativeEvent), k.nativeEvent.defaultPrevented || (p.isFocusedToastEscapeKeyDownRef.current = !0, D()));
                }),
                onPointerDown: ze(e.onPointerDown, (k) => {
                  k.button === 0 && (b.current = { x: k.clientX, y: k.clientY });
                }),
                onPointerMove: ze(e.onPointerMove, (k) => {
                  if (!b.current)
                    return;
                  const M = k.clientX - b.current.x, A = k.clientY - b.current.y, I = !!S.current, P = ["left", "right"].includes(p.swipeDirection), _ = ["left", "up"].includes(p.swipeDirection) ? Math.min : Math.max, T = P ? _(0, M) : 0, L = P ? 0 : _(0, A), z = k.pointerType === "touch" ? 10 : 2, Y = { x: T, y: L }, G = { originalEvent: k, delta: Y };
                  I ? (S.current = Y, Rr(D5, f, G, {
                    discrete: !1
                  })) : El(Y, p.swipeDirection, z) ? (S.current = Y, Rr(O5, h, G, {
                    discrete: !1
                  }), k.target.setPointerCapture(k.pointerId)) : (Math.abs(M) > z || Math.abs(A) > z) && (b.current = null);
                }),
                onPointerUp: ze(e.onPointerUp, (k) => {
                  const M = S.current, A = k.target;
                  if (A.hasPointerCapture(k.pointerId) && A.releasePointerCapture(k.pointerId), S.current = null, b.current = null, M) {
                    const I = k.currentTarget, P = { originalEvent: k, delta: M };
                    El(M, p.swipeDirection, p.swipeThreshold) ? Rr(L5, g, P, {
                      discrete: !0
                    }) : Rr(
                      $5,
                      w,
                      P,
                      {
                        discrete: !0
                      }
                    ), I.addEventListener("click", (_) => _.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        p.viewport
      ) })
    ] }) : null;
  }
), B5 = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = Fo(Wo, t), [i, s] = a.useState(!1), [l, u] = a.useState(!1);
  return j5(() => s(!0)), a.useEffect(() => {
    const d = window.setTimeout(() => u(!0), 1e3);
    return () => window.clearTimeout(d);
  }, []), l ? null : /* @__PURE__ */ c(mn, { asChild: !0, children: /* @__PURE__ */ c(ja, { ...r, children: i && /* @__PURE__ */ N(ae, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, H5 = "ToastTitle", V5 = a.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ c($t.div, { ...r, ref: t });
  }
);
V5.displayName = H5;
var U5 = "ToastDescription", zh = a.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ c($t.div, { ...r, ref: t });
  }
);
zh.displayName = U5;
var Kh = "ToastAction", Yh = a.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ c(Xh, { altText: n, asChild: !0, children: /* @__PURE__ */ c(Ka, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${Kh}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
Yh.displayName = Kh;
var qh = "ToastClose", Ka = a.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = F5(qh, n);
    return /* @__PURE__ */ c(Xh, { asChild: !0, children: /* @__PURE__ */ c(
      $t.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: ze(e.onClick, o.onClose)
      }
    ) });
  }
);
Ka.displayName = qh;
var Xh = a.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ c(
    $t.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function Zh(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), G5(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", i = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (i) {
          const s = r.dataset.radixToastAnnounceAlt;
          s && t.push(s);
        } else
          t.push(...Zh(r));
    }
  }), t;
}
function Rr(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, i = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? x5(o, i) : o.dispatchEvent(i);
}
var El = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), i = r > o;
  return t === "left" || t === "right" ? i && r > n : !i && o > n;
};
function j5(e = () => {
}) {
  const t = un(e);
  A5(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function G5(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function z5(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function vi(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var K5 = Hh, Y5 = Uh, q5 = Gh, X5 = zh, Z5 = Yh, J5 = Ka;
const Q5 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M11.667 3.5 5.25 9.917 2.333 7" }) }), e8 = Q5, t8 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M11.667 3.5 5.25 9.917 2.333 7" }) }), n8 = t8, r8 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "M13.333 4 6 11.333 2.667 8" }) }), o8 = r8, i8 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "M13.333 4 6 11.333 2.667 8" }) }), s8 = i8, a8 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M16.667 5 7.5 14.167 3.333 10" }) }), c8 = a8, l8 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M16.667 5 7.5 14.167 3.333 10" }) }), u8 = l8, d8 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M20 6 9 17l-5-5" }) }), bl = d8, f8 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M20 6 9 17l-5-5" }) }), Sl = f8, p8 = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c(e8, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(n8, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c(o8, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(s8, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(c8, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(u8, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(bl, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Sl, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(bl, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Sl, { color: e }),
    [x.Filled]: (e) => null
  }
}, h8 = ({ size: e, style: t, color: n }) => p8[e][t](n), v8 = 5e3, m8 = 1e3;
var tt = /* @__PURE__ */ ((e) => (e.Success = "Success", e.Warning = "Warning", e.Error = "Error", e.Info = "Info", e))(tt || {}), Nn = /* @__PURE__ */ ((e) => (e.TOAST_CONTAINER = "toast-container", e.TOAST_MESSAGE = "toast-message", e.TOAST_ACTION = "toast-action", e.TOAST_CLOSE = "toast-close", e))(Nn || {});
const g8 = {
  [tt.Success]: {
    icon: /* @__PURE__ */ c(se, { Component: h8, size: U.S, color: le.Khaki800 }),
    background: "bg-green-400"
  },
  [tt.Warning]: {
    icon: /* @__PURE__ */ c(se, { Component: $s, size: U.S, color: le.Khaki800 }),
    background: "bg-yellow-300"
  },
  [tt.Error]: {
    icon: /* @__PURE__ */ c(se, { Component: Ks, size: U.S, color: le.Khaki800 }),
    background: "bg-red-500"
  },
  [tt.Info]: {
    icon: /* @__PURE__ */ c(se, { Component: nu, size: U.S, color: le.Khaki800 }),
    background: "bg-khaki-200"
  }
}, w8 = "box-shadow:10px_10px_44px_7px_rgba(0,_0,_0,_0.06),_0px_4px_8px_0px_rgba(0,_0,_0,_0.15)", C8 = "transition-all animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=open]:slide-in-from-bottom-full duration-300", y8 = ({ id: e, type: t, message: n, open: r, action: o, closeToast: i }) => {
  const { icon: s, background: l } = g8[t], { message: u = "", onClick: d = () => null, required: h = !1 } = o ?? {}, f = () => {
    d(), i(e);
  };
  return /* @__PURE__ */ c(
    q5,
    {
      open: r,
      onClick: (w) => w.stopPropagation(),
      className: F("w-full", C8),
      "data-testid": Nn.TOAST_CONTAINER,
      children: /* @__PURE__ */ N(
        "div",
        {
          className: F(
            "rounded flex w-full h-auto min-h-14 items-center gap-3.5 justify-between px-4 py-3.5 bg-khaki-900 pointer-events-auto",
            w8
          ),
          children: [
            /* @__PURE__ */ N("div", { className: "flex items-center gap-3.5", children: [
              /* @__PURE__ */ c("div", { className: F("flex items-center justify-center h-6 w-6 shrink-0", l), children: s }),
              /* @__PURE__ */ c(
                X5,
                {
                  "data-testid": Nn.TOAST_MESSAGE,
                  className: "text-small font-medium text-khaki-25",
                  children: n
                }
              )
            ] }),
            /* @__PURE__ */ N("div", { className: "flex items-center gap-3.5", children: [
              o && /* @__PURE__ */ c(
                Z5,
                {
                  "data-testid": Nn.TOAST_ACTION,
                  className: "flex h-7 justify-center items-center py-1.5 px-3.5 rounded-sm border border-khaki-25",
                  onClick: f,
                  altText: u,
                  children: /* @__PURE__ */ c("span", { className: "text-caption font-medium text-khaki-25", children: u })
                }
              ),
              !h && /* @__PURE__ */ c(
                J5,
                {
                  "data-testid": Nn.TOAST_CLOSE,
                  className: "cursor-pointer",
                  onClick: (w) => {
                    w.stopPropagation(), i(e);
                  },
                  children: /* @__PURE__ */ c(se, { Component: pn, size: U.S, color: le.Khaki025 })
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, Jh = ru(void 0), E8 = () => {
  const e = Is(Jh);
  if (!e)
    throw new Error("Missing ToastContext.Provider");
  return e;
}, VT = ({ children: e, duration: t = v8 }) => {
  const [n, r] = he([]), o = (w) => {
    r(
      (g) => g.reduce((v, p) => p.id === w ? [...v, { ...p, open: !1 }] : [...v, p], [])
    ), setTimeout(() => {
      r((g) => g.filter((v) => v.id !== w));
    }, m8);
  }, i = (w, g) => {
    setTimeout(() => {
      o(w);
    }, g ?? t);
  }, s = (w, g) => {
    const { message: v, action: p } = g, m = at();
    r((C) => [...C, { id: m, type: w, message: v, action: p, open: !0 }]), g.action?.required || i(m, g.duration);
  }, f = {
    toast: {
      success: (w) => s(tt.Success, w),
      warning: (w) => s(tt.Warning, w),
      error: (w) => s(tt.Error, w),
      info: (w) => s(tt.Info, w)
    }
  };
  return /* @__PURE__ */ N(K5, { duration: t, label: "Notification", children: [
    /* @__PURE__ */ c("div", { className: "relative", children: /* @__PURE__ */ c(
      Y5,
      {
        className: F(
          "fixed transition-transform duration-300 ease-in-out bottom-0 left-1/2 transform -translate-x-1/2 flex max-h-screen flex-col gap-2 m-4 w-9/12 sm:max-w-xl",
          Lm
        )
      }
    ) }),
    /* @__PURE__ */ N(Jh.Provider, { value: f, children: [
      n.map(({ id: w, ...g }) => /* @__PURE__ */ c("div", { className: Im, children: /* @__PURE__ */ c(y8, { closeToast: o, id: w, ...g }) }, w)),
      e
    ] })
  ] });
}, b8 = "relative flex flex-wrap items-center my-2 px-3 py-[5px] min-h-9 max-h-28 overflow-y-auto gap-y-2 border rounded text-small w-full outline-none", Vn = {
  label: "tag-input-label",
  textarea: "tag-textarea",
  dropdown: "tag-input-dropdown",
  message: "tag-input-message",
  helperAddText: "tag-input-helper-add-text"
}, S8 = () => navigator.userAgent.includes("Mac") ? "Return" : "Enter", x8 = () => /* @__PURE__ */ N("div", { className: "text-khaki-800 text-small mx-4 my-2.5", "data-testid": Vn.helperAddText, children: [
  "Press",
  " ",
  /* @__PURE__ */ c("span", { className: "border border-khaki-200 rounded-sm px-1.5 text-khaki-900 font-medium", children: S8() }),
  " ",
  "to add a new tag"
] });
function _n(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function R8(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Qh(...e) {
  return (t) => e.forEach((n) => R8(n, t));
}
function e1(...e) {
  return a.useCallback(Qh(...e), e);
}
function T8(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, A8(o, ...t)];
}
function A8(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var mi = 0;
function N8() {
  a.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? xl()), document.body.insertAdjacentElement("beforeend", e[1] ?? xl()), mi++, () => {
      mi === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), mi--;
    };
  }, []);
}
function xl() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var k8 = globalThis?.document ? a.useLayoutEffect : () => {
}, P8 = a["useId".toString()] || (() => {
}), M8 = 0;
function _8(e) {
  const [t, n] = a.useState(P8());
  return k8(() => {
    e || n((r) => r ?? String(M8++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var Ya = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(D8);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(xs, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(xs, { ...r, ref: t, children: n });
});
Ya.displayName = "Slot";
var xs = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = L8(n);
    return a.cloneElement(n, {
      ...$8(r, n.props),
      // @ts-ignore
      ref: t ? Qh(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
xs.displayName = "SlotClone";
var O8 = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function D8(e) {
  return a.isValidElement(e) && e.type === O8;
}
function $8(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function L8(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var I8 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], t1 = I8.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? Ya : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function n1(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function F8({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = W8({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = n1(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function W8({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = n1(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var r1 = uo(), gi = function() {
}, Bo = a.forwardRef(function(e, t) {
  var n = a.useRef(null), r = a.useState({
    onScrollCapture: gi,
    onWheelCapture: gi,
    onTouchMoveCapture: gi
  }), o = r[0], i = r[1], s = e.forwardProps, l = e.children, u = e.className, d = e.removeScrollBar, h = e.enabled, f = e.shards, w = e.sideCar, g = e.noIsolation, v = e.inert, p = e.allowPinchZoom, m = e.as, C = m === void 0 ? "div" : m, y = e.gapMode, b = jn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = w, E = lo([n, t]), R = pe(pe({}, b), o);
  return a.createElement(
    a.Fragment,
    null,
    h && a.createElement(S, { sideCar: r1, removeScrollBar: d, shards: f, noIsolation: g, inert: v, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: y }),
    s ? a.cloneElement(a.Children.only(l), pe(pe({}, R), { ref: E })) : a.createElement(C, pe({}, R, { className: u, ref: E }), l)
  );
});
Bo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Bo.classNames = {
  fullWidth: Rt,
  zeroRight: xt
};
var Rs = !1;
if (typeof window < "u")
  try {
    var Tr = Object.defineProperty({}, "passive", {
      get: function() {
        return Rs = !0, !0;
      }
    });
    window.addEventListener("test", Tr, Tr), window.removeEventListener("test", Tr, Tr);
  } catch {
    Rs = !1;
  }
var Yt = Rs ? { passive: !1 } : !1, B8 = function(e) {
  return e.tagName === "TEXTAREA";
}, o1 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !B8(e) && n[t] === "visible")
  );
}, H8 = function(e) {
  return o1(e, "overflowY");
}, V8 = function(e) {
  return o1(e, "overflowX");
}, Rl = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = i1(e, r);
    if (o) {
      var i = s1(e, r), s = i[1], l = i[2];
      if (s > l)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, U8 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, j8 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, i1 = function(e, t) {
  return e === "v" ? H8(t) : V8(t);
}, s1 = function(e, t) {
  return e === "v" ? U8(t) : j8(t);
}, G8 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, z8 = function(e, t, n, r, o) {
  var i = G8(e, window.getComputedStyle(t).direction), s = i * r, l = n.target, u = t.contains(l), d = !1, h = s > 0, f = 0, w = 0;
  do {
    var g = s1(e, l), v = g[0], p = g[1], m = g[2], C = p - m - i * v;
    (v || C) && i1(e, l) && (f += C, w += v), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !u && l !== document.body || // self content
    u && (t.contains(l) || t === l)
  );
  return (h && (o && Math.abs(f) < 1 || !o && s > f) || !h && (o && Math.abs(w) < 1 || !o && -s > w)) && (d = !0), d;
}, Ar = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Tl = function(e) {
  return [e.deltaX, e.deltaY];
}, Al = function(e) {
  return e && "current" in e ? e.current : e;
}, K8 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Y8 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, q8 = 0, qt = [];
function X8(e) {
  var t = a.useRef([]), n = a.useRef([0, 0]), r = a.useRef(), o = a.useState(q8++)[0], i = a.useState(Kn)[0], s = a.useRef(e);
  a.useEffect(function() {
    s.current = e;
  }, [e]), a.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var p = on([e.lockRef.current], (e.shards || []).map(Al), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = a.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2)
      return !s.current.allowPinchZoom;
    var C = Ar(p), y = n.current, b = "deltaX" in p ? p.deltaX : y[0] - C[0], S = "deltaY" in p ? p.deltaY : y[1] - C[1], E, R = p.target, O = Math.abs(b) > Math.abs(S) ? "h" : "v";
    if ("touches" in p && O === "h" && R.type === "range")
      return !1;
    var $ = Rl(O, R);
    if (!$)
      return !0;
    if ($ ? E = O : (E = O === "v" ? "h" : "v", $ = Rl(O, R)), !$)
      return !1;
    if (!r.current && "changedTouches" in p && (b || S) && (r.current = E), !E)
      return !0;
    var H = r.current || E;
    return z8(H, m, p, H === "h" ? b : S, !0);
  }, []), u = a.useCallback(function(p) {
    var m = p;
    if (!(!qt.length || qt[qt.length - 1] !== i)) {
      var C = "deltaY" in m ? Tl(m) : Ar(m), y = t.current.filter(function(E) {
        return E.name === m.type && (E.target === m.target || m.target === E.shadowParent) && K8(E.delta, C);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var b = (s.current.shards || []).map(Al).filter(Boolean).filter(function(E) {
          return E.contains(m.target);
        }), S = b.length > 0 ? l(m, b[0]) : !s.current.noIsolation;
        S && m.cancelable && m.preventDefault();
      }
    }
  }, []), d = a.useCallback(function(p, m, C, y) {
    var b = { name: p, delta: m, target: C, should: y, shadowParent: Z8(C) };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== b;
      });
    }, 1);
  }, []), h = a.useCallback(function(p) {
    n.current = Ar(p), r.current = void 0;
  }, []), f = a.useCallback(function(p) {
    d(p.type, Tl(p), p.target, l(p, e.lockRef.current));
  }, []), w = a.useCallback(function(p) {
    d(p.type, Ar(p), p.target, l(p, e.lockRef.current));
  }, []);
  a.useEffect(function() {
    return qt.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: w
    }), document.addEventListener("wheel", u, Yt), document.addEventListener("touchmove", u, Yt), document.addEventListener("touchstart", h, Yt), function() {
      qt = qt.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", u, Yt), document.removeEventListener("touchmove", u, Yt), document.removeEventListener("touchstart", h, Yt);
    };
  }, []);
  var g = e.removeScrollBar, v = e.inert;
  return a.createElement(
    a.Fragment,
    null,
    v ? a.createElement(i, { styles: Y8(o) }) : null,
    g ? a.createElement(ho, { gapMode: e.gapMode }) : null
  );
}
function Z8(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const J8 = fo(r1, X8);
var a1 = a.forwardRef(function(e, t) {
  return a.createElement(Bo, pe({}, e, { ref: t, sideCar: J8 }));
});
a1.classNames = Bo.classNames;
const Q8 = a1;
var qa = "Popover", [c1, UT] = T8(qa, [
  mt
]), or = mt(), [eR, yt] = c1(qa), l1 = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !1
  } = e, l = or(t), u = a.useRef(null), [d, h] = a.useState(!1), [f = !1, w] = F8({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ c(Xn, { ...l, children: /* @__PURE__ */ c(
    eR,
    {
      scope: t,
      contentId: _8(),
      triggerRef: u,
      open: f,
      onOpenChange: w,
      onOpenToggle: a.useCallback(() => w((g) => !g), [w]),
      hasCustomAnchor: d,
      onCustomAnchorAdd: a.useCallback(() => h(!0), []),
      onCustomAnchorRemove: a.useCallback(() => h(!1), []),
      modal: s,
      children: n
    }
  ) });
};
l1.displayName = qa;
var u1 = "PopoverAnchor", d1 = a.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = yt(u1, n), i = or(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: l } = o;
    return a.useEffect(() => (s(), () => l()), [s, l]), /* @__PURE__ */ c(Zn, { ...i, ...r, ref: t });
  }
);
d1.displayName = u1;
var f1 = "PopoverTrigger", p1 = a.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = yt(f1, n), i = or(n), s = e1(t, o.triggerRef), l = /* @__PURE__ */ c(
      t1.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": w1(o.open),
        ...r,
        ref: s,
        onClick: _n(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? l : /* @__PURE__ */ c(Zn, { asChild: !0, ...i, children: l });
  }
);
p1.displayName = f1;
var Xa = "PopoverPortal", [tR, nR] = c1(Xa, {
  forceMount: void 0
}), h1 = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = yt(Xa, t);
  return /* @__PURE__ */ c(tR, { scope: t, forceMount: n, children: /* @__PURE__ */ c(be, { present: n || i.open, children: /* @__PURE__ */ c(mn, { asChild: !0, container: o, children: r }) }) });
};
h1.displayName = Xa;
var dn = "PopoverContent", v1 = a.forwardRef(
  (e, t) => {
    const n = nR(dn, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, i = yt(dn, e.__scopePopover);
    return /* @__PURE__ */ c(be, { present: r || i.open, children: i.modal ? /* @__PURE__ */ c(rR, { ...o, ref: t }) : /* @__PURE__ */ c(oR, { ...o, ref: t }) });
  }
);
v1.displayName = dn;
var rR = a.forwardRef(
  (e, t) => {
    const n = yt(dn, e.__scopePopover), r = a.useRef(null), o = e1(t, r), i = a.useRef(!1);
    return a.useEffect(() => {
      const s = r.current;
      if (s)
        return vo(s);
    }, []), /* @__PURE__ */ c(Q8, { as: Ya, allowPinchZoom: !0, children: /* @__PURE__ */ c(
      m1,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: _n(e.onCloseAutoFocus, (s) => {
          s.preventDefault(), i.current || n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: _n(
          e.onPointerDownOutside,
          (s) => {
            const l = s.detail.originalEvent, u = l.button === 0 && l.ctrlKey === !0, d = l.button === 2 || u;
            i.current = d;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: _n(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), oR = a.forwardRef(
  (e, t) => {
    const n = yt(dn, e.__scopePopover), r = a.useRef(!1), o = a.useRef(!1);
    return /* @__PURE__ */ c(
      m1,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (r.current || n.triggerRef.current?.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          n.triggerRef.current?.contains(s) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), m1 = a.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: l,
      onPointerDownOutside: u,
      onFocusOutside: d,
      onInteractOutside: h,
      ...f
    } = e, w = yt(dn, n), g = or(n);
    return N8(), /* @__PURE__ */ c(
      Gn,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ c(
          vt,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: h,
            onEscapeKeyDown: l,
            onPointerDownOutside: u,
            onFocusOutside: d,
            onDismiss: () => w.onOpenChange(!1),
            children: /* @__PURE__ */ c(
              wo,
              {
                "data-state": w1(w.open),
                role: "dialog",
                id: w.contentId,
                ...g,
                ...f,
                ref: t,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), g1 = "PopoverClose", iR = a.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = yt(g1, n);
    return /* @__PURE__ */ c(
      t1.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: _n(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
iR.displayName = g1;
var sR = "PopoverArrow", aR = a.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = or(n);
    return /* @__PURE__ */ c(Co, { ...o, ...r, ref: t });
  }
);
aR.displayName = sR;
function w1(e) {
  return e ? "open" : "closed";
}
var cR = l1, lR = d1, uR = p1, dR = h1, fR = v1;
const wi = (e) => e.toLowerCase().replace(/\s+/g, " "), pR = Ye(
  ({
    selectedTags: e,
    dropdownTags: t,
    onSelected: n,
    searchValue: r,
    setTagValue: o,
    width: i,
    testIdOverride: s,
    disableAddTags: l
  }, u) => {
    const d = ie(() => t.filter(
      (g, v, p) => v === p.findIndex((m) => m.value === g.value)
    ).filter(
      (g) => !e.some((v) => v.value.toLowerCase() === g.value.toLowerCase())
    ).filter((g) => {
      const v = wi(r), p = wi(g.value).includes(v), m = g.searchableText?.some((C) => wi(C).includes(v));
      return p || m;
    }), [t, r, e]);
    return d.length ? /* @__PURE__ */ c(dR, { children: /* @__PURE__ */ c(fR, { onOpenAutoFocus: (h) => h.preventDefault(), sideOffset: 8, asChild: !0, children: /* @__PURE__ */ c(
      "div",
      {
        className: Yn,
        ref: u,
        tabIndex: 0,
        "data-testid": s?.dropdown ?? Vn.dropdown,
        style: { width: i },
        children: /* @__PURE__ */ N("div", { className: "bg-white shadow-lg rounded-lg border border-khaki-200 space-y-1 max-h-[250px] overflow-auto pt-2", children: [
          !l && /* @__PURE__ */ c(x8, {}),
          /* @__PURE__ */ c("div", { className: "py-2 px-4 flex flex-wrap gap-3", children: d.map((h, f) => /* @__PURE__ */ c(
            "button",
            {
              type: "button",
              onClick: (w) => {
                w.stopPropagation(), n(h.value), o("");
              },
              children: /* @__PURE__ */ c(Ua, { text: h.displayText ?? h.value, color: h.color, size: Ot.SMALL })
            },
            `dropdown-tag-${h.value}-${f}`
          )) })
        ] })
      }
    ) }) }) : null;
  }
), hR = Ye(
  ({
    tags: e,
    addTags: t,
    onTagRemoved: n,
    state: r,
    disabled: o,
    disableAddTags: i,
    placeholder: s,
    filled: l,
    tagValue: u,
    setTagValue: d,
    showDropdown: h,
    tagDropdownRef: f,
    tagDropdownOpen: w,
    setTagDropdownOpen: g,
    testIdOverride: v
  }, p) => {
    const [m, C] = he(!1), y = _e(null);
    Pe(() => {
      if (y.current) {
        if (!m) {
          y.current.textContent = u;
          return;
        }
        const D = () => {
          const k = window.getSelection();
          if ((k?.rangeCount ?? 0) > 0) {
            const M = k?.getRangeAt(0);
            if (M && y.current) {
              const A = M.cloneRange();
              A.selectNodeContents(y.current), A.setEnd(M.startContainer, M.startOffset);
              const I = A.toString().length;
              return { start: I, end: I + M.toString().length };
            }
          }
          return null;
        }, Z = (k) => {
          const M = window.getSelection();
          if (!M || !k || !y.current)
            return;
          let A = 0;
          const I = document.createRange();
          I.setStart(y.current, 0), I.collapse(!0);
          const P = y.current.childNodes?.[0];
          let _ = !1;
          if (P && P.nodeType === Node.TEXT_NODE && P.textContent) {
            const T = A + P.textContent.length;
            !_ && k.start >= A && k.start <= T && (I.setStart(P, k.start - A), _ = !0), _ && k.end >= A && k.end <= T && I.setEnd(P, k.end - A), A = T;
          }
          M.removeAllRanges(), M.addRange(I);
        }, q = D();
        y.current.textContent = u, Z(q);
      }
    }, [u, m]);
    const b = (D) => {
      if (D.key === "Enter" || D.key === "Tab") {
        if (D.preventDefault(), i)
          return;
        u && (d(""), t([u]));
      }
      D.key === "Backspace" && !u && e.length > 0 && n(e[e.length - 1].value);
    }, S = (D) => {
      D.preventDefault();
      const q = D.clipboardData.getData("Text").split(/[\n,]+/).filter((M) => M), k = [...new Set(q)];
      t(k);
    }, E = (D) => {
      D.preventDefault();
      const Z = D.target;
      d(Z.textContent || "");
    }, R = (D) => {
      if (p && "current" in p && p.current) {
        if (D.relatedTarget !== null && (D.relatedTarget === p?.current || D.relatedTarget === f.current || f.current?.contains(D.relatedTarget) || p.current?.contains(D.relatedTarget))) {
          y.current?.focus();
          return;
        }
        u && (d(""), i || t([u])), g(!1), C(!1);
      }
    }, O = ie(() => o ? "border-khaki-300" : r === Ee.ERROR ? tp : r === Ee.WARNING ? np : m ? "ring ring-indigo-200 border-indigo-500" : "border-khaki-500", [r, o, m]), $ = ie(() => o ? "text-khaki-400" : "text-khaki-900", [o]), H = ie(() => o ? "cursor-not-allowed" : "cursor-text", [o]), j = ie(() => l ? "bg-khaki-50" : "bg-white", [l]);
    return /* @__PURE__ */ c(uR, { asChild: !0, children: /* @__PURE__ */ N(
      "div",
      {
        ref: p,
        tabIndex: 0,
        className: F(b8, O, $, H, j),
        onClick: () => {
          if (o)
            return;
          const D = y.current;
          if (D) {
            const Z = document.createRange(), q = window.getSelection();
            Z.selectNodeContents(D), Z.collapse(!1), q?.removeAllRanges(), q?.addRange(Z), D.focus();
          }
        },
        children: [
          e?.map((D, Z) => /* @__PURE__ */ c("div", { className: F("mr-2", o && "opacity-60"), children: /* @__PURE__ */ c(
            Ua,
            {
              text: D.displayText ?? D.value,
              color: D.color,
              size: Ot.SMALL,
              onRemove: o ? void 0 : () => n(D.value)
            }
          ) }, `selected-tag-${D.value}-${Z}`)),
          /* @__PURE__ */ c(
            "div",
            {
              ref: y,
              className: "outline-none",
              contentEditable: !o,
              onClick: (D) => D.stopPropagation(),
              onFocus: () => {
                C(!0), g(!0);
              },
              onInput: E,
              onKeyDown: b,
              onBlur: R,
              onPaste: S,
              tabIndex: 0,
              "data-testid": v?.textarea ?? Vn.textarea
            }
          ),
          s && !e.length && !u && !w && /* @__PURE__ */ c("span", { className: F("text-khaki-600 select-none", o && "text-khaki-300"), children: s }),
          h && /* @__PURE__ */ c(
            "button",
            {
              className: "absolute right-2",
              onClick: () => g((D) => !D),
              type: "button",
              "aria-label": "Toggle tag dropdown",
              children: /* @__PURE__ */ c(se, { Component: w ? Ls : Fr })
            }
          )
        ]
      }
    ) });
  }
), jT = ({
  tags: e,
  onTagsAdded: t,
  onTagRemoved: n,
  label: r,
  hideLabel: o,
  dropdownTags: i = [],
  state: s = Ee.DEFAULT,
  disabled: l,
  disableAddTags: u = !1,
  placeholder: d,
  filled: h = !1,
  message: f,
  tagCountMax: w,
  testIdOverride: g
}) => {
  const v = ie(() => at(), []), [p, m] = he(!1), [C, y] = he(""), b = _e(null), S = _e(null), { toast: E } = E8(), R = ($) => {
    if (e.some((H) => $.map((j) => j.toLowerCase()).includes(H.value.toLowerCase()))) {
      E.warning({ message: `Tag ${C} already exists.` });
      return;
    }
    t($);
  }, O = ($) => {
    R([$]);
  };
  return /* @__PURE__ */ c("div", { children: /* @__PURE__ */ N(cR, { open: p, children: [
    /* @__PURE__ */ c(
      Cn,
      {
        id: v,
        text: r,
        disabled: l,
        hidden: o,
        testIdOverride: { label: g?.label ?? Vn.label }
      }
    ),
    /* @__PURE__ */ c(lR, { children: /* @__PURE__ */ c(
      hR,
      {
        ref: b,
        tags: e,
        addTags: R,
        onTagRemoved: n,
        state: s,
        disabled: l,
        disableAddTags: u,
        placeholder: d,
        filled: h,
        tagValue: C,
        setTagValue: y,
        showDropdown: i.length > 0,
        tagDropdownRef: S,
        tagDropdownOpen: p,
        setTagDropdownOpen: m,
        testIdOverride: g
      }
    ) }),
    i && p && /* @__PURE__ */ c(
      pR,
      {
        ref: S,
        selectedTags: e,
        dropdownTags: i,
        disableAddTags: u,
        onSelected: O,
        searchValue: C,
        setTagValue: y,
        width: b.current?.clientWidth + "px",
        testIdOverride: g
      }
    ),
    /* @__PURE__ */ N("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ c("span", { children: f && /* @__PURE__ */ c(
        cn,
        {
          text: f,
          state: s,
          disabled: l,
          testIdOverride: { message: g?.message ?? Vn.message }
        }
      ) }),
      w && /* @__PURE__ */ N("span", { className: F("text-caption", l ? "text-khaki-400" : ip[s]), children: [
        e.length,
        "/",
        w
      ] })
    ] })
  ] }) });
}, Xt = {
  TEXTAREA_LABEL: "textarea-label",
  TEXTAREA_MESSAGE: "textarea-message",
  TEXTAREA: "textarea"
}, GT = Ye(
  ({
    value: e,
    onChange: t,
    label: n,
    hideLabel: r = !1,
    state: o = Ee.DEFAULT,
    fluid: i = !0,
    filled: s = !1,
    message: l = "",
    rows: u = 3,
    maxHeight: d,
    maxLength: h,
    labelInfoTooltip: f,
    disabled: w,
    required: g,
    testIdOverride: v = {
      label: Xt.TEXTAREA_LABEL,
      message: Xt.TEXTAREA_MESSAGE,
      textarea: Xt.TEXTAREA
    },
    ...p
  }, m) => {
    const C = ie(() => at(), []), y = ie(() => Sa[o], [o]), [b, S] = he(e?.length || 0);
    Pe(() => {
      S(e?.length || 0);
    }, [e]);
    const E = (R) => {
      h && S(R.target.value.length), t?.(R);
    };
    return /* @__PURE__ */ N("div", { className: F(ba, Po(i)), children: [
      /* @__PURE__ */ c(
        Cn,
        {
          id: `${C}-label`,
          text: n,
          disabled: w,
          hidden: r,
          testIdOverride: { label: v.label ?? Xt.TEXTAREA_LABEL },
          infoTooltip: f,
          required: g
        }
      ),
      /* @__PURE__ */ c(
        C0,
        {
          ref: m,
          id: C,
          rows: u,
          className: F(
            Et,
            Ea,
            No,
            w ? Ao : y,
            s && ko
          ),
          style: { maxHeight: d ? `${d}px` : "none" },
          disabled: w,
          value: e,
          onChange: (R) => E(R),
          required: g,
          "data-testid": v.textarea ?? Xt.TEXTAREA,
          ...p
        }
      ),
      /* @__PURE__ */ c(
        sp,
        {
          limit: h,
          currentLength: b,
          message: l,
          disabled: w,
          state: o,
          testIdOverride: v.message ?? Xt.TEXTAREA_MESSAGE
        }
      )
    ] });
  }
);
function vR(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function mR(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function C1(...e) {
  return (t) => e.forEach((n) => mR(n, t));
}
function gR(...e) {
  return a.useCallback(C1(...e), e);
}
function wR(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, CR(o, ...t)];
}
function CR(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function y1(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function yR({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = ER({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = y1(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function ER({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = y1(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
function bR(e) {
  const t = a.useRef({ value: e, previous: e });
  return a.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var SR = globalThis?.document ? a.useLayoutEffect : () => {
};
function xR(e) {
  const [t, n] = a.useState(void 0);
  return SR(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, l;
        if ("borderBoxSize" in i) {
          const u = i.borderBoxSize, d = Array.isArray(u) ? u[0] : u;
          s = d.inlineSize, l = d.blockSize;
        } else
          s = e.offsetWidth, l = e.offsetHeight;
        n({ width: s, height: l });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var E1 = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(TR);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(Ts, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(Ts, { ...r, ref: t, children: n });
});
E1.displayName = "Slot";
var Ts = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = NR(n);
    return a.cloneElement(n, {
      ...AR(r, n.props),
      // @ts-ignore
      ref: t ? C1(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Ts.displayName = "SlotClone";
var RR = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function TR(e) {
  return a.isValidElement(e) && e.type === RR;
}
function AR(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function NR(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var kR = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], b1 = kR.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? E1 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Za = "Switch", [PR, zT] = wR(Za), [MR, _R] = PR(Za), S1 = a.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: s,
      disabled: l,
      value: u = "on",
      onCheckedChange: d,
      ...h
    } = e, [f, w] = a.useState(null), g = gR(t, (y) => w(y)), v = a.useRef(!1), p = f ? !!f.closest("form") : !0, [m = !1, C] = yR({
      prop: o,
      defaultProp: i,
      onChange: d
    });
    return /* @__PURE__ */ N(MR, { scope: n, checked: m, disabled: l, children: [
      /* @__PURE__ */ c(
        b1.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": m,
          "aria-required": s,
          "data-state": T1(m),
          "data-disabled": l ? "" : void 0,
          disabled: l,
          value: u,
          ...h,
          ref: g,
          onClick: vR(e.onClick, (y) => {
            C((b) => !b), p && (v.current = y.isPropagationStopped(), v.current || y.stopPropagation());
          })
        }
      ),
      p && /* @__PURE__ */ c(
        OR,
        {
          control: f,
          bubbles: !v.current,
          name: r,
          value: u,
          checked: m,
          required: s,
          disabled: l,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
S1.displayName = Za;
var x1 = "SwitchThumb", R1 = a.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = _R(x1, n);
    return /* @__PURE__ */ c(
      b1.span,
      {
        "data-state": T1(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
R1.displayName = x1;
var OR = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, i = a.useRef(null), s = bR(n), l = xR(t);
  return a.useEffect(() => {
    const u = i.current, d = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== n && f) {
      const w = new Event("click", { bubbles: r });
      f.call(u, n), u.dispatchEvent(w);
    }
  }, [s, n, r]), /* @__PURE__ */ c(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function T1(e) {
  return e ? "checked" : "unchecked";
}
var DR = S1, $R = R1;
const oo = {
  CHECKED: "checked",
  UNCHECKED: "unchecked"
}, fn = {
  ENABLED: "enabled",
  DISABLED: "disabled"
}, Nl = "bg-khaki-50 w-9 h-5 rounded-[4px] border border-khaki-500 focus:ring-2 focus:ring-indigo-200 outline-none shrink-0", LR = {
  [fn.ENABLED]: `${Nl}`,
  [fn.DISABLED]: `${Nl} opacity-60`
}, kl = "block w-3.5 h-3.5 rounded-sm transition-transform duration-100", IR = {
  [oo.CHECKED]: `${kl} bg-indigo-600 translate-x-[18px]`,
  [oo.UNCHECKED]: `${kl} bg-khaki-400 translate-x-[2px]`
}, Pl = "select-none cursor-pointer khaki-900 ml-2.5 text-small", FR = {
  [fn.ENABLED]: `${Pl}`,
  [fn.DISABLED]: `${Pl} opacity-60`
}, Ml = {
  TOGGLE_BUTTON: "toggle-button",
  TOGGLE_LABEL: "toggle-label"
}, KT = ({
  onChange: e,
  labelText: t,
  hideLabel: n = !1,
  checked: r,
  name: o,
  disabled: i = !1,
  testIdOverride: s
}) => {
  const [l, u] = he(r), d = ie(() => r ?? l, [r, l]), h = ie(() => at(), []), { rootTheme: f, thumbTheme: w, labelTheme: g } = ie(() => {
    const p = d ? oo.CHECKED : oo.UNCHECKED, m = i ? fn.DISABLED : fn.ENABLED, C = LR[m], y = IR[p], b = FR[m];
    return { rootTheme: C, thumbTheme: y, labelTheme: b };
  }, [d, i]), v = (p) => ({ target: { name: o, value: p } });
  return /* @__PURE__ */ N("div", { className: "flex items-center relative", children: [
    /* @__PURE__ */ c(
      DR,
      {
        id: h,
        checked: d,
        className: f,
        disabled: i,
        onCheckedChange: (p) => {
          u(p), e(v(p));
        },
        "data-testid": s?.toggle ?? Ml.TOGGLE_BUTTON,
        children: /* @__PURE__ */ c($R, { className: w })
      }
    ),
    /* @__PURE__ */ c(
      Xs,
      {
        htmlFor: h,
        "data-testid": s?.toggleLabel ?? Ml.TOGGLE_LABEL,
        onClick: () => !i && e(v(!d)),
        className: F(g, n && "sr-only"),
        children: t
      }
    )
  ] });
}, A1 = ({ children: e }) => /* @__PURE__ */ c("div", { className: "py-4 px-4 sm:px-10 flex-grow", children: e }), WR = ({ message: e, retry: t }) => /* @__PURE__ */ c("div", { className: "flex items-center justify-center h-full g", children: /* @__PURE__ */ N("div", { className: "flex flex-col items-center justify-center gap-5 max-w-md", children: [
  /* @__PURE__ */ c("h2", { className: "text-h2 font-medium text-center", children: "Oops, there was an issue loading your content." }),
  /* @__PURE__ */ c("p", { className: "text-small text-center", children: e || "An error occurred. Please try again later." }),
  t && /* @__PURE__ */ c(Me, { fluid: !0, variant: "secondary", text: "Retry", onClick: t })
] }) });
var kn = /* @__PURE__ */ ((e) => (e.PAGE_HEADER_BASE = "page-header-base", e.PAGE_HEADER_TITLE = "page-header-title", e.PAGE_HEADER_SUBTITLE = "page-header-subtitle", e.PAGE_HEADER_ACTIONS = "page-header-actions", e))(kn || {});
function BR({ breadcrumbs: e, title: t }) {
  return /* @__PURE__ */ N("div", { className: "flex items-center gap-1 font-medium text-khaki-800", children: [
    e && e.length > 0 && e?.map((n) => /* @__PURE__ */ N("span", { className: "flex items-center gap-1", children: [
      /* @__PURE__ */ c("button", { className: "hover:text-khaki-600", onClick: n.onClick, role: "link", children: n.text }),
      /* @__PURE__ */ c("span", { className: "text-center w-4", children: "/" })
    ] }, n.text)),
    /* @__PURE__ */ c("h1", { className: "font-medium text-khaki-800", children: t })
  ] });
}
const HR = ({
  title: e,
  subtitle: t,
  hideActions: n,
  actions: r,
  children: o,
  breadcrumbs: i,
  isChildPage: s = !1
}) => /* @__PURE__ */ N("div", { className: "flex flex-col h-full", children: [
  /* @__PURE__ */ N(
    "div",
    {
      className: F(
        "flex gap-4 flex-wrap w-full  px-4 sm:px-10 mb-4 justify-between items-center border-b border-khaki-200",
        s ? "py-2.5" : "py-4"
      ),
      "data-testid": kn.PAGE_HEADER_BASE,
      children: [
        s ? /* @__PURE__ */ c(BR, { title: e, breadcrumbs: i }) : /* @__PURE__ */ N("div", { className: "grow", children: [
          /* @__PURE__ */ c(
            "h1",
            {
              className: "flex items-center text-h4 font-bold text-khaki-900",
              "data-testid": kn.PAGE_HEADER_TITLE,
              children: e
            }
          ),
          t && /* @__PURE__ */ c("h2", { className: "text-sm text-khaki-600", "data-testid": kn.PAGE_HEADER_SUBTITLE, children: t })
        ] }),
        /* @__PURE__ */ c(
          "div",
          {
            className: F("flex gap-4 items-end", n && "invisible"),
            "data-testid": kn.PAGE_HEADER_ACTIONS,
            children: r && r
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ c(A1, { children: o })
] }), VR = () => /* @__PURE__ */ c("div", { className: "h-full w-full flex items-center justify-center text-khaki-400", children: /* @__PURE__ */ c(Dn, {}) }), UR = () => /* @__PURE__ */ c("div", { className: "flex items-center justify-center h-full g", children: /* @__PURE__ */ N("div", { className: "flex flex-col items-center justify-center gap-5 max-w-md", children: [
  /* @__PURE__ */ c("h2", { className: "text-h2 font-medium text-center", children: "You do not have access to this page." }),
  /* @__PURE__ */ c("p", { className: "text-small text-center", children: "If you believe this is an error, please contact your administrator." })
] }) }), YT = ({
  title: e,
  subtitle: t,
  actions: n,
  children: r,
  hasAccess: o,
  loading: i,
  error: s,
  pageMetaTitle: l,
  isChildPage: u,
  breadcrumbs: d,
  asPageContainer: h
}) => {
  const f = ie(() => i ? /* @__PURE__ */ c(VR, {}) : o ? s.show ? /* @__PURE__ */ c(WR, { message: s.message, retry: s.retry }) : r : /* @__PURE__ */ c(UR, {}), [r, o, i, s.show, s.message, s.retry]);
  return h ? /* @__PURE__ */ c(A1, { children: r }) : /* @__PURE__ */ N(ae, { children: [
    l,
    /* @__PURE__ */ c(
      HR,
      {
        title: e,
        subtitle: t,
        hideActions: !o || i || s.show,
        actions: n,
        breadcrumbs: d,
        isChildPage: u,
        children: f
      }
    )
  ] });
};
var fe = {}, _l = {
  get exports() {
    return fe;
  },
  set exports(e) {
    fe = e;
  }
}, io = {}, jR = {
  get exports() {
    return io;
  },
  set exports(e) {
    io = e;
  }
}, ue = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ol;
function GR() {
  if (Ol)
    return ue;
  Ol = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, w = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function b(E) {
    if (typeof E == "object" && E !== null) {
      var R = E.$$typeof;
      switch (R) {
        case t:
          switch (E = E.type, E) {
            case u:
            case d:
            case r:
            case i:
            case o:
            case f:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case l:
                case h:
                case v:
                case g:
                case s:
                  return E;
                default:
                  return R;
              }
          }
        case n:
          return R;
      }
    }
  }
  function S(E) {
    return b(E) === d;
  }
  return ue.AsyncMode = u, ue.ConcurrentMode = d, ue.ContextConsumer = l, ue.ContextProvider = s, ue.Element = t, ue.ForwardRef = h, ue.Fragment = r, ue.Lazy = v, ue.Memo = g, ue.Portal = n, ue.Profiler = i, ue.StrictMode = o, ue.Suspense = f, ue.isAsyncMode = function(E) {
    return S(E) || b(E) === u;
  }, ue.isConcurrentMode = S, ue.isContextConsumer = function(E) {
    return b(E) === l;
  }, ue.isContextProvider = function(E) {
    return b(E) === s;
  }, ue.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === t;
  }, ue.isForwardRef = function(E) {
    return b(E) === h;
  }, ue.isFragment = function(E) {
    return b(E) === r;
  }, ue.isLazy = function(E) {
    return b(E) === v;
  }, ue.isMemo = function(E) {
    return b(E) === g;
  }, ue.isPortal = function(E) {
    return b(E) === n;
  }, ue.isProfiler = function(E) {
    return b(E) === i;
  }, ue.isStrictMode = function(E) {
    return b(E) === o;
  }, ue.isSuspense = function(E) {
    return b(E) === f;
  }, ue.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === d || E === i || E === o || E === f || E === w || typeof E == "object" && E !== null && (E.$$typeof === v || E.$$typeof === g || E.$$typeof === s || E.$$typeof === l || E.$$typeof === h || E.$$typeof === m || E.$$typeof === C || E.$$typeof === y || E.$$typeof === p);
  }, ue.typeOf = b, ue;
}
var de = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dl;
function zR() {
  return Dl || (Dl = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, w = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function b(B) {
      return typeof B == "string" || typeof B == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      B === r || B === d || B === i || B === o || B === f || B === w || typeof B == "object" && B !== null && (B.$$typeof === v || B.$$typeof === g || B.$$typeof === s || B.$$typeof === l || B.$$typeof === h || B.$$typeof === m || B.$$typeof === C || B.$$typeof === y || B.$$typeof === p);
    }
    function S(B) {
      if (typeof B == "object" && B !== null) {
        var ce = B.$$typeof;
        switch (ce) {
          case t:
            var Te = B.type;
            switch (Te) {
              case u:
              case d:
              case r:
              case i:
              case o:
              case f:
                return Te;
              default:
                var Xe = Te && Te.$$typeof;
                switch (Xe) {
                  case l:
                  case h:
                  case v:
                  case g:
                  case s:
                    return Xe;
                  default:
                    return ce;
                }
            }
          case n:
            return ce;
        }
      }
    }
    var E = u, R = d, O = l, $ = s, H = t, j = h, D = r, Z = v, q = g, k = n, M = i, A = o, I = f, P = !1;
    function _(B) {
      return P || (P = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), T(B) || S(B) === u;
    }
    function T(B) {
      return S(B) === d;
    }
    function L(B) {
      return S(B) === l;
    }
    function z(B) {
      return S(B) === s;
    }
    function Y(B) {
      return typeof B == "object" && B !== null && B.$$typeof === t;
    }
    function G(B) {
      return S(B) === h;
    }
    function ee(B) {
      return S(B) === r;
    }
    function Q(B) {
      return S(B) === v;
    }
    function W(B) {
      return S(B) === g;
    }
    function J(B) {
      return S(B) === n;
    }
    function te(B) {
      return S(B) === i;
    }
    function K(B) {
      return S(B) === o;
    }
    function re(B) {
      return S(B) === f;
    }
    de.AsyncMode = E, de.ConcurrentMode = R, de.ContextConsumer = O, de.ContextProvider = $, de.Element = H, de.ForwardRef = j, de.Fragment = D, de.Lazy = Z, de.Memo = q, de.Portal = k, de.Profiler = M, de.StrictMode = A, de.Suspense = I, de.isAsyncMode = _, de.isConcurrentMode = T, de.isContextConsumer = L, de.isContextProvider = z, de.isElement = Y, de.isForwardRef = G, de.isFragment = ee, de.isLazy = Q, de.isMemo = W, de.isPortal = J, de.isProfiler = te, de.isStrictMode = K, de.isSuspense = re, de.isValidElementType = b, de.typeOf = S;
  }()), de;
}
var $l;
function N1() {
  return $l || ($l = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = GR() : e.exports = zR();
  }(jR)), io;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ci, Ll;
function KR() {
  if (Ll)
    return Ci;
  Ll = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, l = 0; l < 10; l++)
        s["_" + String.fromCharCode(l)] = l;
      var u = Object.getOwnPropertyNames(s).map(function(h) {
        return s[h];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        d[h] = h;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ci = o() ? Object.assign : function(i, s) {
    for (var l, u = r(i), d, h = 1; h < arguments.length; h++) {
      l = Object(arguments[h]);
      for (var f in l)
        t.call(l, f) && (u[f] = l[f]);
      if (e) {
        d = e(l);
        for (var w = 0; w < d.length; w++)
          n.call(l, d[w]) && (u[d[w]] = l[d[w]]);
      }
    }
    return u;
  }, Ci;
}
var yi, Il;
function Ja() {
  if (Il)
    return yi;
  Il = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return yi = e, yi;
}
var Ei, Fl;
function k1() {
  return Fl || (Fl = 1, Ei = Function.call.bind(Object.prototype.hasOwnProperty)), Ei;
}
var bi, Wl;
function YR() {
  if (Wl)
    return bi;
  Wl = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Ja(), n = {}, r = k1();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, l, u, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in i)
        if (r(i, h)) {
          var f;
          try {
            if (typeof i[h] != "function") {
              var w = Error(
                (u || "React class") + ": " + l + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw w.name = "Invariant Violation", w;
            }
            f = i[h](s, h, u, l, null, t);
          } catch (v) {
            f = v;
          }
          if (f && !(f instanceof Error) && e(
            (u || "React class") + ": type specification of " + l + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var g = d ? d() : "";
            e(
              "Failed " + l + " type: " + f.message + (g ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, bi = o, bi;
}
var Si, Bl;
function qR() {
  if (Bl)
    return Si;
  Bl = 1;
  var e = N1(), t = KR(), n = Ja(), r = k1(), o = YR(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var u = "Warning: " + l;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Si = function(l, u) {
    var d = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function f(T) {
      var L = T && (d && T[d] || T[h]);
      if (typeof L == "function")
        return L;
    }
    var w = "<<anonymous>>", g = {
      array: C("array"),
      bigint: C("bigint"),
      bool: C("boolean"),
      func: C("function"),
      number: C("number"),
      object: C("object"),
      string: C("string"),
      symbol: C("symbol"),
      any: y(),
      arrayOf: b,
      element: S(),
      elementType: E(),
      instanceOf: R,
      node: j(),
      objectOf: $,
      oneOf: O,
      oneOfType: H,
      shape: Z,
      exact: q
    };
    function v(T, L) {
      return T === L ? T !== 0 || 1 / T === 1 / L : T !== T && L !== L;
    }
    function p(T, L) {
      this.message = T, this.data = L && typeof L == "object" ? L : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function m(T) {
      if (process.env.NODE_ENV !== "production")
        var L = {}, z = 0;
      function Y(ee, Q, W, J, te, K, re) {
        if (J = J || w, K = K || W, re !== n) {
          if (u) {
            var B = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw B.name = "Invariant Violation", B;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ce = J + ":" + W;
            !L[ce] && // Avoid spamming the console because they are often not actionable except for lib authors
            z < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + K + "` prop on `" + J + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), L[ce] = !0, z++);
          }
        }
        return Q[W] == null ? ee ? Q[W] === null ? new p("The " + te + " `" + K + "` is marked as required " + ("in `" + J + "`, but its value is `null`.")) : new p("The " + te + " `" + K + "` is marked as required in " + ("`" + J + "`, but its value is `undefined`.")) : null : T(Q, W, J, te, K);
      }
      var G = Y.bind(null, !1);
      return G.isRequired = Y.bind(null, !0), G;
    }
    function C(T) {
      function L(z, Y, G, ee, Q, W) {
        var J = z[Y], te = A(J);
        if (te !== T) {
          var K = I(J);
          return new p(
            "Invalid " + ee + " `" + Q + "` of type " + ("`" + K + "` supplied to `" + G + "`, expected ") + ("`" + T + "`."),
            { expectedType: T }
          );
        }
        return null;
      }
      return m(L);
    }
    function y() {
      return m(s);
    }
    function b(T) {
      function L(z, Y, G, ee, Q) {
        if (typeof T != "function")
          return new p("Property `" + Q + "` of component `" + G + "` has invalid PropType notation inside arrayOf.");
        var W = z[Y];
        if (!Array.isArray(W)) {
          var J = A(W);
          return new p("Invalid " + ee + " `" + Q + "` of type " + ("`" + J + "` supplied to `" + G + "`, expected an array."));
        }
        for (var te = 0; te < W.length; te++) {
          var K = T(W, te, G, ee, Q + "[" + te + "]", n);
          if (K instanceof Error)
            return K;
        }
        return null;
      }
      return m(L);
    }
    function S() {
      function T(L, z, Y, G, ee) {
        var Q = L[z];
        if (!l(Q)) {
          var W = A(Q);
          return new p("Invalid " + G + " `" + ee + "` of type " + ("`" + W + "` supplied to `" + Y + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(T);
    }
    function E() {
      function T(L, z, Y, G, ee) {
        var Q = L[z];
        if (!e.isValidElementType(Q)) {
          var W = A(Q);
          return new p("Invalid " + G + " `" + ee + "` of type " + ("`" + W + "` supplied to `" + Y + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(T);
    }
    function R(T) {
      function L(z, Y, G, ee, Q) {
        if (!(z[Y] instanceof T)) {
          var W = T.name || w, J = _(z[Y]);
          return new p("Invalid " + ee + " `" + Q + "` of type " + ("`" + J + "` supplied to `" + G + "`, expected ") + ("instance of `" + W + "`."));
        }
        return null;
      }
      return m(L);
    }
    function O(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function L(z, Y, G, ee, Q) {
        for (var W = z[Y], J = 0; J < T.length; J++)
          if (v(W, T[J]))
            return null;
        var te = JSON.stringify(T, function(re, B) {
          var ce = I(B);
          return ce === "symbol" ? String(B) : B;
        });
        return new p("Invalid " + ee + " `" + Q + "` of value `" + String(W) + "` " + ("supplied to `" + G + "`, expected one of " + te + "."));
      }
      return m(L);
    }
    function $(T) {
      function L(z, Y, G, ee, Q) {
        if (typeof T != "function")
          return new p("Property `" + Q + "` of component `" + G + "` has invalid PropType notation inside objectOf.");
        var W = z[Y], J = A(W);
        if (J !== "object")
          return new p("Invalid " + ee + " `" + Q + "` of type " + ("`" + J + "` supplied to `" + G + "`, expected an object."));
        for (var te in W)
          if (r(W, te)) {
            var K = T(W, te, G, ee, Q + "." + te, n);
            if (K instanceof Error)
              return K;
          }
        return null;
      }
      return m(L);
    }
    function H(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var L = 0; L < T.length; L++) {
        var z = T[L];
        if (typeof z != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + P(z) + " at index " + L + "."
          ), s;
      }
      function Y(G, ee, Q, W, J) {
        for (var te = [], K = 0; K < T.length; K++) {
          var re = T[K], B = re(G, ee, Q, W, J, n);
          if (B == null)
            return null;
          B.data && r(B.data, "expectedType") && te.push(B.data.expectedType);
        }
        var ce = te.length > 0 ? ", expected one of type [" + te.join(", ") + "]" : "";
        return new p("Invalid " + W + " `" + J + "` supplied to " + ("`" + Q + "`" + ce + "."));
      }
      return m(Y);
    }
    function j() {
      function T(L, z, Y, G, ee) {
        return k(L[z]) ? null : new p("Invalid " + G + " `" + ee + "` supplied to " + ("`" + Y + "`, expected a ReactNode."));
      }
      return m(T);
    }
    function D(T, L, z, Y, G) {
      return new p(
        (T || "React class") + ": " + L + " type `" + z + "." + Y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + G + "`."
      );
    }
    function Z(T) {
      function L(z, Y, G, ee, Q) {
        var W = z[Y], J = A(W);
        if (J !== "object")
          return new p("Invalid " + ee + " `" + Q + "` of type `" + J + "` " + ("supplied to `" + G + "`, expected `object`."));
        for (var te in T) {
          var K = T[te];
          if (typeof K != "function")
            return D(G, ee, Q, te, I(K));
          var re = K(W, te, G, ee, Q + "." + te, n);
          if (re)
            return re;
        }
        return null;
      }
      return m(L);
    }
    function q(T) {
      function L(z, Y, G, ee, Q) {
        var W = z[Y], J = A(W);
        if (J !== "object")
          return new p("Invalid " + ee + " `" + Q + "` of type `" + J + "` " + ("supplied to `" + G + "`, expected `object`."));
        var te = t({}, z[Y], T);
        for (var K in te) {
          var re = T[K];
          if (r(T, K) && typeof re != "function")
            return D(G, ee, Q, K, I(re));
          if (!re)
            return new p(
              "Invalid " + ee + " `" + Q + "` key `" + K + "` supplied to `" + G + "`.\nBad object: " + JSON.stringify(z[Y], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(T), null, "  ")
            );
          var B = re(W, K, G, ee, Q + "." + K, n);
          if (B)
            return B;
        }
        return null;
      }
      return m(L);
    }
    function k(T) {
      switch (typeof T) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !T;
        case "object":
          if (Array.isArray(T))
            return T.every(k);
          if (T === null || l(T))
            return !0;
          var L = f(T);
          if (L) {
            var z = L.call(T), Y;
            if (L !== T.entries) {
              for (; !(Y = z.next()).done; )
                if (!k(Y.value))
                  return !1;
            } else
              for (; !(Y = z.next()).done; ) {
                var G = Y.value;
                if (G && !k(G[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function M(T, L) {
      return T === "symbol" ? !0 : L ? L["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && L instanceof Symbol : !1;
    }
    function A(T) {
      var L = typeof T;
      return Array.isArray(T) ? "array" : T instanceof RegExp ? "object" : M(L, T) ? "symbol" : L;
    }
    function I(T) {
      if (typeof T > "u" || T === null)
        return "" + T;
      var L = A(T);
      if (L === "object") {
        if (T instanceof Date)
          return "date";
        if (T instanceof RegExp)
          return "regexp";
      }
      return L;
    }
    function P(T) {
      var L = I(T);
      switch (L) {
        case "array":
        case "object":
          return "an " + L;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + L;
        default:
          return L;
      }
    }
    function _(T) {
      return !T.constructor || !T.constructor.name ? w : T.constructor.name;
    }
    return g.checkPropTypes = o, g.resetWarningCache = o.resetWarningCache, g.PropTypes = g, g;
  }, Si;
}
var xi, Hl;
function XR() {
  if (Hl)
    return xi;
  Hl = 1;
  var e = Ja();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, xi = function() {
    function r(s, l, u, d, h, f) {
      if (f !== e) {
        var w = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw w.name = "Invariant Violation", w;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, xi;
}
if (process.env.NODE_ENV !== "production") {
  var ZR = N1(), JR = !0;
  _l.exports = qR()(ZR.isElement, JR);
} else
  _l.exports = XR()();
var QR = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function ir(e, t) {
  var n = e4(e);
  if (typeof n.path != "string") {
    var r = e.webkitRelativePath;
    Object.defineProperty(n, "path", {
      value: typeof t == "string" ? t : typeof r == "string" && r.length > 0 ? r : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return n;
}
function e4(e) {
  var t = e.name, n = t && t.lastIndexOf(".") !== -1;
  if (n && !e.type) {
    var r = t.split(".").pop().toLowerCase(), o = QR.get(r);
    o && Object.defineProperty(e, "type", {
      value: o,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var t4 = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function n4(e) {
  return hn(this, void 0, void 0, function() {
    return vn(this, function(t) {
      return so(e) && r4(e.dataTransfer) ? [2, a4(e.dataTransfer, e.type)] : o4(e) ? [2, i4(e)] : Array.isArray(e) && e.every(function(n) {
        return "getFile" in n && typeof n.getFile == "function";
      }) ? [2, s4(e)] : [2, []];
    });
  });
}
function r4(e) {
  return so(e);
}
function o4(e) {
  return so(e) && so(e.target);
}
function so(e) {
  return typeof e == "object" && e !== null;
}
function i4(e) {
  return As(e.target.files).map(function(t) {
    return ir(t);
  });
}
function s4(e) {
  return hn(this, void 0, void 0, function() {
    var t;
    return vn(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, Promise.all(e.map(function(r) {
            return r.getFile();
          }))];
        case 1:
          return t = n.sent(), [2, t.map(function(r) {
            return ir(r);
          })];
      }
    });
  });
}
function a4(e, t) {
  return hn(this, void 0, void 0, function() {
    var n, r;
    return vn(this, function(o) {
      switch (o.label) {
        case 0:
          return e.items ? (n = As(e.items).filter(function(i) {
            return i.kind === "file";
          }), t !== "drop" ? [2, n] : [4, Promise.all(n.map(c4))]) : [3, 2];
        case 1:
          return r = o.sent(), [2, Vl(P1(r))];
        case 2:
          return [2, Vl(As(e.files).map(function(i) {
            return ir(i);
          }))];
      }
    });
  });
}
function Vl(e) {
  return e.filter(function(t) {
    return t4.indexOf(t.name) === -1;
  });
}
function As(e) {
  if (e === null)
    return [];
  for (var t = [], n = 0; n < e.length; n++) {
    var r = e[n];
    t.push(r);
  }
  return t;
}
function c4(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return Ul(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? M1(t) : Ul(e);
}
function P1(e) {
  return e.reduce(function(t, n) {
    return on(on([], rc(t), !1), rc(Array.isArray(n) ? P1(n) : [n]), !1);
  }, []);
}
function Ul(e) {
  var t = e.getAsFile();
  if (!t)
    return Promise.reject("".concat(e, " is not a File"));
  var n = ir(t);
  return Promise.resolve(n);
}
function l4(e) {
  return hn(this, void 0, void 0, function() {
    return vn(this, function(t) {
      return [2, e.isDirectory ? M1(e) : u4(e)];
    });
  });
}
function M1(e) {
  var t = e.createReader();
  return new Promise(function(n, r) {
    var o = [];
    function i() {
      var s = this;
      t.readEntries(function(l) {
        return hn(s, void 0, void 0, function() {
          var u, d, h;
          return vn(this, function(f) {
            switch (f.label) {
              case 0:
                if (l.length)
                  return [3, 5];
                f.label = 1;
              case 1:
                return f.trys.push([1, 3, , 4]), [4, Promise.all(o)];
              case 2:
                return u = f.sent(), n(u), [3, 4];
              case 3:
                return d = f.sent(), r(d), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                h = Promise.all(l.map(l4)), o.push(h), i(), f.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(l) {
        r(l);
      });
    }
    i();
  });
}
function u4(e) {
  return hn(this, void 0, void 0, function() {
    return vn(this, function(t) {
      return [2, new Promise(function(n, r) {
        e.file(function(o) {
          var i = ir(o, e.fullPath);
          n(i);
        }, function(o) {
          r(o);
        });
      })];
    });
  });
}
var d4 = function(e, t) {
  if (e && t) {
    var n = Array.isArray(t) ? t : t.split(","), r = e.name || "", o = (e.type || "").toLowerCase(), i = o.replace(/\/.*$/, "");
    return n.some(function(s) {
      var l = s.trim().toLowerCase();
      return l.charAt(0) === "." ? r.toLowerCase().endsWith(l) : l.endsWith("/*") ? i === l.replace(/\/.*$/, "") : o === l;
    });
  }
  return !0;
};
function jl(e) {
  return h4(e) || p4(e) || O1(e) || f4();
}
function f4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p4(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function h4(e) {
  if (Array.isArray(e))
    return Ns(e);
}
function Gl(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gl(Object(n), !0).forEach(function(r) {
      _1(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gl(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _1(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Un(e, t) {
  return g4(e) || m4(e, t) || O1(e, t) || v4();
}
function v4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O1(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ns(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Ns(e, t);
  }
}
function Ns(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function m4(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, s, l;
    try {
      for (n = n.call(e); !(o = (s = n.next()).done) && (r.push(s.value), !(t && r.length === t)); o = !0)
        ;
    } catch (u) {
      i = !0, l = u;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i)
          throw l;
      }
    }
    return r;
  }
}
function g4(e) {
  if (Array.isArray(e))
    return e;
}
var D1 = "file-invalid-type", $1 = "file-too-large", L1 = "file-too-small", I1 = "too-many-files", Nr = {
  FileInvalidType: D1,
  FileTooLarge: $1,
  FileTooSmall: L1,
  TooManyFiles: I1
}, w4 = function(t) {
  t = Array.isArray(t) && t.length === 1 ? t[0] : t;
  var n = Array.isArray(t) ? "one of ".concat(t.join(", ")) : t;
  return {
    code: D1,
    message: "File type must be ".concat(n)
  };
}, Kl = function(t) {
  return {
    code: $1,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, Yl = function(t) {
  return {
    code: L1,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, C4 = {
  code: I1,
  message: "Too many files"
};
function F1(e, t) {
  var n = e.type === "application/x-moz-file" || d4(e, t);
  return [n, n ? null : w4(t)];
}
function W1(e, t, n) {
  if (bt(e.size))
    if (bt(t) && bt(n)) {
      if (e.size > n)
        return [!1, Kl(n)];
      if (e.size < t)
        return [!1, Yl(t)];
    } else {
      if (bt(t) && e.size < t)
        return [!1, Yl(t)];
      if (bt(n) && e.size > n)
        return [!1, Kl(n)];
    }
  return [!0, null];
}
function bt(e) {
  return e != null;
}
function y4(e) {
  var t = e.files, n = e.accept, r = e.minSize, o = e.maxSize, i = e.multiple, s = e.maxFiles, l = e.validator;
  return !i && t.length > 1 || i && s >= 1 && t.length > s ? !1 : t.every(function(u) {
    var d = F1(u, n), h = Un(d, 1), f = h[0], w = W1(u, r, o), g = Un(w, 1), v = g[0], p = l ? l(u) : null;
    return f && v && !p;
  });
}
function ao(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function kr(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function ql(e) {
  e.preventDefault();
}
function E4(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function b4(e) {
  return e.indexOf("Edge/") !== -1;
}
function S4() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return E4(e) || b4(e);
}
function je() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
      i[s - 1] = arguments[s];
    return t.some(function(l) {
      return !ao(r) && l && l.apply(void 0, [r].concat(i)), ao(r);
    });
  };
}
function x4() {
  return "showOpenFilePicker" in window;
}
function R4(e) {
  if (bt(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = Un(n, 2), o = r[0], i = r[1], s = !0;
      return B1(o) || (console.warn('Skipped "'.concat(o, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), s = !1), (!Array.isArray(i) || !i.every(H1)) && (console.warn('Skipped "'.concat(o, '" because an invalid file extension was provided.')), s = !1), s;
    }).reduce(function(n, r) {
      var o = Un(r, 2), i = o[0], s = o[1];
      return zl(zl({}, n), {}, _1({}, i, s));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function T4(e) {
  if (bt(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = Un(n, 2), o = r[0], i = r[1];
      return [].concat(jl(t), [o], jl(i));
    }, []).filter(function(t) {
      return B1(t) || H1(t);
    }).join(",");
}
function A4(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function N4(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function B1(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function H1(e) {
  return /^.*\.[\w]+$/.test(e);
}
var k4 = ["children"], P4 = ["open"], M4 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], _4 = ["refKey", "onChange", "onClick"];
function O4(e) {
  return L4(e) || $4(e) || V1(e) || D4();
}
function D4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $4(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function L4(e) {
  if (Array.isArray(e))
    return ks(e);
}
function Ri(e, t) {
  return W4(e) || F4(e, t) || V1(e, t) || I4();
}
function I4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function V1(e, t) {
  if (e) {
    if (typeof e == "string")
      return ks(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return ks(e, t);
  }
}
function ks(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function F4(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, s, l;
    try {
      for (n = n.call(e); !(o = (s = n.next()).done) && (r.push(s.value), !(t && r.length === t)); o = !0)
        ;
    } catch (u) {
      i = !0, l = u;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i)
          throw l;
      }
    }
    return r;
  }
}
function W4(e) {
  if (Array.isArray(e))
    return e;
}
function Xl(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ve(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xl(Object(n), !0).forEach(function(r) {
      Ps(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xl(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ps(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function co(e, t) {
  if (e == null)
    return {};
  var n = B4(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function B4(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var Qa = /* @__PURE__ */ Ye(function(e, t) {
  var n = e.children, r = co(e, k4), o = j1(r), i = o.open, s = co(o, P4);
  return ou(t, function() {
    return {
      open: i
    };
  }, [i]), /* @__PURE__ */ ne.createElement(b0, null, n(ve(ve({}, s), {}, {
    open: i
  })));
});
Qa.displayName = "Dropzone";
var U1 = {
  disabled: !1,
  getFilesFromEvent: n4,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
Qa.defaultProps = U1;
Qa.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: fe.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: fe.objectOf(fe.arrayOf(fe.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: fe.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: fe.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: fe.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: fe.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: fe.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: fe.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: fe.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: fe.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: fe.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: fe.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: fe.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: fe.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: fe.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: fe.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: fe.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: fe.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: fe.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: fe.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: fe.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: fe.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: fe.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: fe.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: fe.func
};
var Ms = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function j1() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = ve(ve({}, U1), e), n = t.accept, r = t.disabled, o = t.getFilesFromEvent, i = t.maxSize, s = t.minSize, l = t.multiple, u = t.maxFiles, d = t.onDragEnter, h = t.onDragLeave, f = t.onDragOver, w = t.onDrop, g = t.onDropAccepted, v = t.onDropRejected, p = t.onFileDialogCancel, m = t.onFileDialogOpen, C = t.useFsAccessApi, y = t.autoFocus, b = t.preventDropOnDocument, S = t.noClick, E = t.noKeyboard, R = t.noDrag, O = t.noDragEventsBubbling, $ = t.onError, H = t.validator, j = ie(function() {
    return T4(n);
  }, [n]), D = ie(function() {
    return R4(n);
  }, [n]), Z = ie(function() {
    return typeof m == "function" ? m : Zl;
  }, [m]), q = ie(function() {
    return typeof p == "function" ? p : Zl;
  }, [p]), k = _e(null), M = _e(null), A = E0(H4, Ms), I = Ri(A, 2), P = I[0], _ = I[1], T = P.isFocused, L = P.isFileDialogActive, z = _e(typeof window < "u" && window.isSecureContext && C && x4()), Y = function() {
    !z.current && L && setTimeout(function() {
      if (M.current) {
        var oe = M.current.files;
        oe.length || (_({
          type: "closeDialog"
        }), q());
      }
    }, 300);
  };
  Pe(function() {
    return window.addEventListener("focus", Y, !1), function() {
      window.removeEventListener("focus", Y, !1);
    };
  }, [M, L, q, z]);
  var G = _e([]), ee = function(oe) {
    k.current && k.current.contains(oe.target) || (oe.preventDefault(), G.current = []);
  };
  Pe(function() {
    return b && (document.addEventListener("dragover", ql, !1), document.addEventListener("drop", ee, !1)), function() {
      b && (document.removeEventListener("dragover", ql), document.removeEventListener("drop", ee));
    };
  }, [k, b]), Pe(function() {
    return !r && y && k.current && k.current.focus(), function() {
    };
  }, [k, y, r]);
  var Q = me(function(X) {
    $ ? $(X) : console.error(X);
  }, [$]), W = me(function(X) {
    X.preventDefault(), X.persist(), ar(X), G.current = [].concat(O4(G.current), [X.target]), kr(X) && Promise.resolve(o(X)).then(function(oe) {
      if (!(ao(X) && !O)) {
        var Ce = oe.length, Se = Ce > 0 && y4({
          files: oe,
          accept: j,
          minSize: s,
          maxSize: i,
          multiple: l,
          maxFiles: u,
          validator: H
        }), Oe = Ce > 0 && !Se;
        _({
          isDragAccept: Se,
          isDragReject: Oe,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), d && d(X);
      }
    }).catch(function(oe) {
      return Q(oe);
    });
  }, [o, d, Q, O, j, s, i, l, u, H]), J = me(function(X) {
    X.preventDefault(), X.persist(), ar(X);
    var oe = kr(X);
    if (oe && X.dataTransfer)
      try {
        X.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return oe && f && f(X), !1;
  }, [f, O]), te = me(function(X) {
    X.preventDefault(), X.persist(), ar(X);
    var oe = G.current.filter(function(Se) {
      return k.current && k.current.contains(Se);
    }), Ce = oe.indexOf(X.target);
    Ce !== -1 && oe.splice(Ce, 1), G.current = oe, !(oe.length > 0) && (_({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), kr(X) && h && h(X));
  }, [k, h, O]), K = me(function(X, oe) {
    var Ce = [], Se = [];
    X.forEach(function(Oe) {
      var bn = F1(Oe, j), It = Ri(bn, 2), Vo = It[0], Uo = It[1], jo = W1(Oe, s, i), cr = Ri(jo, 2), Go = cr[0], zo = cr[1], Ko = H ? H(Oe) : null;
      if (Vo && Go && !Ko)
        Ce.push(Oe);
      else {
        var Yo = [Uo, zo];
        Ko && (Yo = Yo.concat(Ko)), Se.push({
          file: Oe,
          errors: Yo.filter(function(p0) {
            return p0;
          })
        });
      }
    }), (!l && Ce.length > 1 || l && u >= 1 && Ce.length > u) && (Ce.forEach(function(Oe) {
      Se.push({
        file: Oe,
        errors: [C4]
      });
    }), Ce.splice(0)), _({
      acceptedFiles: Ce,
      fileRejections: Se,
      type: "setFiles"
    }), w && w(Ce, Se, oe), Se.length > 0 && v && v(Se, oe), Ce.length > 0 && g && g(Ce, oe);
  }, [_, l, j, s, i, u, w, g, v, H]), re = me(function(X) {
    X.preventDefault(), X.persist(), ar(X), G.current = [], kr(X) && Promise.resolve(o(X)).then(function(oe) {
      ao(X) && !O || K(oe, X);
    }).catch(function(oe) {
      return Q(oe);
    }), _({
      type: "reset"
    });
  }, [o, K, Q, O]), B = me(function() {
    if (z.current) {
      _({
        type: "openDialog"
      }), Z();
      var X = {
        multiple: l,
        types: D
      };
      window.showOpenFilePicker(X).then(function(oe) {
        return o(oe);
      }).then(function(oe) {
        K(oe, null), _({
          type: "closeDialog"
        });
      }).catch(function(oe) {
        A4(oe) ? (q(oe), _({
          type: "closeDialog"
        })) : N4(oe) ? (z.current = !1, M.current ? (M.current.value = null, M.current.click()) : Q(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : Q(oe);
      });
      return;
    }
    M.current && (_({
      type: "openDialog"
    }), Z(), M.current.value = null, M.current.click());
  }, [_, Z, q, C, K, Q, D, l]), ce = me(function(X) {
    !k.current || !k.current.isEqualNode(X.target) || (X.key === " " || X.key === "Enter" || X.keyCode === 32 || X.keyCode === 13) && (X.preventDefault(), B());
  }, [k, B]), Te = me(function() {
    _({
      type: "focus"
    });
  }, []), Xe = me(function() {
    _({
      type: "blur"
    });
  }, []), Lt = me(function() {
    S || (S4() ? setTimeout(B, 0) : B());
  }, [S, B]), Ue = function(oe) {
    return r ? null : oe;
  }, Ho = function(oe) {
    return E ? null : Ue(oe);
  }, sr = function(oe) {
    return R ? null : Ue(oe);
  }, ar = function(oe) {
    O && oe.stopPropagation();
  }, u0 = ie(function() {
    return function() {
      var X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, oe = X.refKey, Ce = oe === void 0 ? "ref" : oe, Se = X.role, Oe = X.onKeyDown, bn = X.onFocus, It = X.onBlur, Vo = X.onClick, Uo = X.onDragEnter, jo = X.onDragOver, cr = X.onDragLeave, Go = X.onDrop, zo = co(X, M4);
      return ve(ve(Ps({
        onKeyDown: Ho(je(Oe, ce)),
        onFocus: Ho(je(bn, Te)),
        onBlur: Ho(je(It, Xe)),
        onClick: Ue(je(Vo, Lt)),
        onDragEnter: sr(je(Uo, W)),
        onDragOver: sr(je(jo, J)),
        onDragLeave: sr(je(cr, te)),
        onDrop: sr(je(Go, re)),
        role: typeof Se == "string" && Se !== "" ? Se : "presentation"
      }, Ce, k), !r && !E ? {
        tabIndex: 0
      } : {}), zo);
    };
  }, [k, ce, Te, Xe, Lt, W, J, te, re, E, R, r]), d0 = me(function(X) {
    X.stopPropagation();
  }, []), f0 = ie(function() {
    return function() {
      var X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, oe = X.refKey, Ce = oe === void 0 ? "ref" : oe, Se = X.onChange, Oe = X.onClick, bn = co(X, _4), It = Ps({
        accept: j,
        multiple: l,
        type: "file",
        style: {
          display: "none"
        },
        onChange: Ue(je(Se, re)),
        onClick: Ue(je(Oe, d0)),
        tabIndex: -1
      }, Ce, M);
      return ve(ve({}, It), bn);
    };
  }, [M, n, l, re, r]);
  return ve(ve({}, P), {}, {
    isFocused: T && !r,
    getRootProps: u0,
    getInputProps: f0,
    rootRef: k,
    inputRef: M,
    open: Ue(B)
  });
}
function H4(e, t) {
  switch (t.type) {
    case "focus":
      return ve(ve({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return ve(ve({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return ve(ve({}, Ms), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return ve(ve({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return ve(ve({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return ve(ve({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections
      });
    case "reset":
      return ve({}, Ms);
    default:
      return e;
  }
}
function Zl() {
}
const V4 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "M2.333 9.475a2.625 2.625 0 0 1 1.213-4.797 3.501 3.501 0 0 1 6.907 0 2.625 2.625 0 0 1 1.213 4.797m-7-.142L6.999 7m0 0 2.334 2.333M6.999 7v5.25"
  }
) }), U4 = V4, j4 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M1.166 7.292a2.625 2.625 0 0 1 2.38-2.614 3.501 3.501 0 0 1 6.907 0 2.625 2.625 0 0 1 1.213 4.797H9.333v-.142L6.999 7.141 4.666 9.333v.142H2.333a2.62 2.62 0 0 1-1.167-2.183",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "M2.333 9.475a2.625 2.625 0 0 1 1.213-4.797 3.501 3.501 0 0 1 6.907 0 2.625 2.625 0 0 1 1.213 4.797m-7-.142L6.999 7m0 0 2.334 2.333M6.999 7v5.25"
    }
  )
] }), G4 = j4, z4 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.5",
    d: "M2.667 10.828a3 3 0 0 1 1.386-5.482 4.001 4.001 0 0 1 7.895 0 3 3 0 0 1 1.386 5.482m-8-.161L8.001 8m0 0 2.666 2.667M8.001 8v6"
  }
) }), K4 = z4, Y4 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M1.334 8.333a3 3 0 0 1 2.72-2.987 4.001 4.001 0 0 1 7.893 0 3 3 0 0 1 1.387 5.482h-2.667v-.161L8.001 8.16l-2.667 2.506v.161H2.667a3 3 0 0 1-1.333-2.495",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "M2.667 10.828a3 3 0 0 1 1.386-5.482 4.001 4.001 0 0 1 7.895 0 3 3 0 0 1 1.386 5.482m-8-.161L8.001 8m0 0 2.666 2.667M8.001 8v6"
    }
  )
] }), q4 = Y4, X4 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M3.333 13.535a3.75 3.75 0 0 1 1.733-6.852 5.001 5.001 0 0 1 9.867 0 3.75 3.75 0 0 1 1.733 6.852m-10-.202L9.999 10m0 0 3.334 3.333M9.999 10v7.5"
  }
) }), Z4 = X4, J4 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M1.666 10.417a3.75 3.75 0 0 1 3.4-3.734 5.001 5.001 0 0 1 9.867 0 3.75 3.75 0 0 1 1.733 6.852h-3.333v-.202l-3.334-3.131-3.333 3.131v.202H3.333a3.75 3.75 0 0 1-1.667-3.118",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M3.333 13.535a3.75 3.75 0 0 1 1.733-6.852 5.001 5.001 0 0 1 9.867 0 3.75 3.75 0 0 1 1.733 6.852m-10-.202L9.999 10m0 0 3.334 3.333M9.999 10v7.5"
    }
  )
] }), Q4 = J4, e7 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M4 16.242A4.5 4.5 0 0 1 6.08 8.02a6.002 6.002 0 0 1 11.84 0A4.5 4.5 0 0 1 20 16.242M8 16l4-4m0 0 4 4m-4-4v9"
  }
) }), Jl = e7, t7 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M2 12.5a4.5 4.5 0 0 1 4.08-4.48 6.002 6.002 0 0 1 11.84 0A4.5 4.5 0 0 1 20 16.241h-4V16l-4-3.758L8 16v.242H4A4.5 4.5 0 0 1 2 12.5",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M4 16.242A4.5 4.5 0 0 1 6.08 8.02a6.002 6.002 0 0 1 11.84 0A4.5 4.5 0 0 1 20 16.242M8 16l4-4m0 0 4 4m-4-4v9"
    }
  )
] }), Ql = t7, n7 = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c(U4, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(G4, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c(K4, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(q4, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Z4, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Q4, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Jl, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Ql, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(Jl, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(Ql, { color: e }),
    [x.Filled]: (e) => null
  }
}, G1 = ({ size: e, style: t, color: n }) => n7[e][t](n), r7 = 15e6, z1 = {
  input: "uploader-input",
  overlay: "uploader-overlay"
}, o7 = ({ active: e, dropzoneProps: t }) => e ? /* @__PURE__ */ N(
  "div",
  {
    "data-testid": z1.overlay,
    className: "absolute inset-0 flex flex-col items-center justify-center text-center p-4 bg-white opacity-85 z-[500]",
    ...t,
    children: [
      /* @__PURE__ */ c(se, { Component: G1, size: U.L, color: le.Khaki900 }),
      /* @__PURE__ */ c("p", { className: "pt-1 text-h4 font-medium", children: "Drop to upload to Jasper" })
    ]
  }
) : null, i7 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M8.167 1.324v2.41c0 .326 0 .49.063.614.056.11.146.2.255.255.125.064.288.064.615.064h2.41m-3.343-3.5H4.2c-.653 0-.98 0-1.23.127-.219.112-.397.29-.51.51-.127.25-.127.576-.127 1.23v7.933c0 .653 0 .98.128 1.23.112.219.29.397.51.51.25.126.576.126 1.23.126h5.6c.653 0 .98 0 1.229-.127.22-.112.398-.29.51-.51.127-.25.127-.576.127-1.23v-6.3z"
  }
) }), s7 = i7, a7 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M11.154 4.154 8.679 1.68a1.8 1.8 0 0 0-.513-.355v2.41c0 .326 0 .49.064.614.056.11.145.2.255.255.125.064.288.064.615.064h2.41a1.8 1.8 0 0 0-.356-.513",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25",
      d: "M8.167 1.324v2.41c0 .326 0 .49.063.614.056.11.146.2.255.255.125.064.288.064.615.064h2.41m-3.343-3.5H4.2c-.653 0-.98 0-1.23.127-.219.112-.397.29-.51.51-.127.25-.127.576-.127 1.23v7.933c0 .653 0 .98.128 1.23.112.219.29.397.51.51.25.126.576.126 1.23.126h5.6c.653 0 .98 0 1.229-.127.22-.112.398-.29.51-.51.127-.25.127-.576.127-1.23v-6.3z"
    }
  )
] }), c7 = a7, l7 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M9.333 1.513v2.754c0 .373 0 .56.073.702a.67.67 0 0 0 .291.292c.143.072.33.072.703.072h2.753m-3.82-4H4.8c-.747 0-1.12 0-1.405.146-.251.127-.455.331-.583.582-.145.285-.145.659-.145 1.406v9.066c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.658.146 1.405.146h6.4c.747 0 1.12 0 1.405-.146.251-.128.455-.332.583-.582.145-.286.145-.659.145-1.406v-7.2z"
  }
) }), u7 = l7, d7 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M12.748 4.748 9.919 1.919a2 2 0 0 0-.585-.406v2.754c0 .373 0 .56.072.702a.67.67 0 0 0 .291.292c.143.072.33.072.703.072h2.754a2 2 0 0 0-.406-.585",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      d: "M9.333 1.513v2.754c0 .373 0 .56.073.702a.67.67 0 0 0 .291.292c.143.072.33.072.703.072h2.753m-3.82-4H4.8c-.747 0-1.12 0-1.405.146-.251.127-.455.331-.583.582-.145.285-.145.659-.145 1.406v9.066c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.658.146 1.405.146h6.4c.747 0 1.12 0 1.405-.146.251-.128.455-.332.583-.582.145-.286.145-.659.145-1.406v-7.2z"
    }
  )
] }), f7 = d7, p7 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.75",
    d: "M11.667 1.891v3.442c0 .467 0 .7.09.879.08.157.208.284.365.364.178.09.412.09.878.09h3.442m-4.775-5H6c-.933 0-1.4 0-1.756.182-.314.16-.57.415-.729.729-.182.356-.182.823-.182 1.756v11.334c0 .933 0 1.4.182 1.756.16.314.415.569.729.729.356.181.823.181 1.756.181h8c.934 0 1.4 0 1.757-.181.313-.16.568-.415.728-.729.182-.356.182-.823.182-1.756v-9z"
  }
) }), h7 = p7, v7 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M15.934 5.935 12.4 2.399a2.5 2.5 0 0 0-.732-.508v3.442c0 .467 0 .7.09.879.08.157.208.284.364.364.179.09.412.09.879.09h3.442a2.5 2.5 0 0 0-.508-.731",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.75",
      d: "M11.667 1.891v3.442c0 .467 0 .7.09.879.08.157.208.284.365.364.178.09.412.09.878.09h3.442m-4.775-5H6c-.933 0-1.4 0-1.756.182-.314.16-.57.415-.729.729-.182.356-.182.823-.182 1.756v11.334c0 .933 0 1.4.182 1.756.16.314.415.569.729.729.356.181.823.181 1.756.181h8c.934 0 1.4 0 1.757-.181.313-.16.568-.415.728-.729.182-.356.182-.823.182-1.756v-9z"
    }
  )
] }), m7 = v7, g7 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ c(
  "path",
  {
    stroke: e,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.75",
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M14 2H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 3.52 4 4.08 4 5.2v13.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 22 6.08 22 7.2 22h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8V8z"
  }
) }), eu = g7, w7 = ({ color: e = V.CurrentColor }) => /* @__PURE__ */ N("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ c(
    "path",
    {
      fill: e,
      d: "M19.121 7.121 14.88 2.88a3 3 0 0 0-.879-.61V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13a3 3 0 0 0-.609-.88",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ c(
    "path",
    {
      stroke: e,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.75",
      d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M14 2H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 3.52 4 4.08 4 5.2v13.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 22 6.08 22 7.2 22h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8V8z"
    }
  )
] }), tu = w7, C7 = {
  [U.XS]: {
    [x.Line]: (e) => /* @__PURE__ */ c(s7, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(c7, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.S]: {
    [x.Line]: (e) => /* @__PURE__ */ c(u7, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(f7, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.M]: {
    [x.Line]: (e) => /* @__PURE__ */ c(h7, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(m7, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.L]: {
    [x.Line]: (e) => /* @__PURE__ */ c(eu, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(tu, { color: e }),
    [x.Filled]: (e) => null
  },
  [U.XL]: {
    [x.Line]: (e) => /* @__PURE__ */ c(eu, { color: e }),
    [x.Duo]: (e) => /* @__PURE__ */ c(tu, { color: e }),
    [x.Filled]: (e) => null
  }
}, y7 = ({ size: e, style: t, color: n }) => C7[e][t](n), K1 = (e, t = !0, n = 1) => {
  const r = t ? 1e3 : 1024;
  if (Math.abs(e) < r)
    return e + " B";
  const o = t ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let i = -1;
  const s = 10 ** n;
  do
    e /= r, ++i;
  while (Math.round(Math.abs(e) * s) / s >= r && i < o.length - 1);
  return `${e.toFixed(n)}${o[i]}`;
}, E7 = (e, t) => {
  switch (e) {
    case Nr.FileInvalidType:
      return t ? "Invalid file types" : "Invalid file type";
    case Nr.FileTooLarge:
      return t ? "Files are too large" : "File is too large";
    case Nr.FileTooSmall:
      return t ? "Files are too small" : "File is too small";
    case Nr.TooManyFiles:
      return "Too many files";
  }
}, b7 = (e, t) => {
  const n = /* @__PURE__ */ new Map();
  for (const o of t)
    o.errors.forEach((i) => {
      const s = i.code, l = n.get(s) || [];
      n.set(s, [...l, o.file.name]);
    });
  const r = [];
  return n.size > 0 && n.forEach((o, i) => {
    const s = new Error("File upload error"), l = o.length > 1;
    s.message = `Failed to upload file${l ? "s" : ""}: ${o.join(
      ", "
    )}. ${E7(i, l)}.`, r.push(s);
  }), {
    errors: r,
    acceptedFiles: e
  };
}, S7 = ({ fileName: e, fileSize: t, onRemove: n, itemsRemovable: r }) => /* @__PURE__ */ N("div", { className: "py-3 px-4 space-y-2 rounded-[4px] text-khaki-900 border border-khaki-400 bg-white", children: [
  /* @__PURE__ */ N("div", { className: "flex", children: [
    /* @__PURE__ */ N("div", { className: "flex items-center mr-auto", children: [
      /* @__PURE__ */ c(se, { Component: y7, size: U.M }),
      /* @__PURE__ */ c("span", { className: "ml-2 text-body font-medium", children: e })
    ] }),
    r && /* @__PURE__ */ c(
      Me,
      {
        onClick: n,
        variant: "tertiary",
        text: "Remove",
        icon: {
          Component: pn,
          position: "left"
        }
      }
    )
  ] }),
  t && /* @__PURE__ */ c("div", { className: "flex ml-[28px] text-caption font-regular text-khaki-600", children: /* @__PURE__ */ c("span", { className: "mr-auto", children: K1(t) }) })
] }), qT = Ye(
  ({
    accept: e,
    files: t,
    onFilesChange: n,
    state: r = Ee.DEFAULT,
    allowMultiple: o = !1,
    disabled: i,
    maxFiles: s,
    maxSize: l = r7,
    minSize: u = 0,
    message: d = "",
    label: h,
    hideLabel: f = !1,
    hideFileList: w = !1,
    hidden: g = !1,
    overlayContainerRef: v,
    itemsRemovable: p = !0,
    testIdOverride: m,
    onDragStart: C,
    onDragEnd: y,
    onError: b
  }, S) => {
    const [E, R] = he(), O = ie(() => at(), []), $ = _e(t);
    Pe(() => {
      $.current = t;
    }, [t]);
    const H = me(
      async (...A) => {
        y?.();
        const { acceptedFiles: I, errors: P } = b7(...A);
        if (P.length > 0 ? (b?.(P[0].message), R(P[0].message)) : R(void 0), I.length > 0) {
          if (s && $.current.length + I.length > s) {
            b?.(`You can only select up to ${s} files.`);
            return;
          }
          n(o ? [...$.current, ...I] : I);
        }
      },
      [n, y, b, o, s]
    ), { getRootProps: j, getInputProps: D, open: Z, isDragActive: q } = j1({
      accept: e,
      disabled: i,
      maxSize: l,
      minSize: u,
      noDragEventsBubbling: !0,
      noClick: !0,
      noKeyboard: !0,
      onDrop: H,
      onDragEnter: C,
      onDragLeave: y
    });
    ou(
      S,
      () => ({
        open: Z,
        getRootProps: j
      }),
      [Z, j]
    );
    const k = ie(
      () => /* @__PURE__ */ c(o7, { active: q, dropzoneProps: j() }),
      [j, q]
    ), M = () => E || r === Ee.ERROR ? "border-red-600 bg-red-50" : r === Ee.WARNING ? "border-yellow-400 bg-yellow-50" : "border-indigo-500 bg-indigo-50";
    return g ? null : /* @__PURE__ */ N(ae, { children: [
      /* @__PURE__ */ N("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ c(Cn, { id: O, text: h, disabled: i, hidden: f }),
        /* @__PURE__ */ N(
          "div",
          {
            "data-testid": m,
            className: `relative text-khaki-900 ${i ? "opacity-50 cursor-not-allowed" : ""}`,
            children: [
              /* @__PURE__ */ N(
                "div",
                {
                  className: F(
                    "flex flex-col items-center justify-center p-4 pt-10 pb-12 text-center rounded border-dashed border-2 ",
                    M()
                  ),
                  ...S ? {} : j(),
                  children: [
                    /* @__PURE__ */ c(se, { Component: G1, size: U.L, color: le.Indigo600 }),
                    /* @__PURE__ */ N("p", { className: "pt-2 text-small font-medium", children: [
                      "Drag & drop or",
                      " ",
                      /* @__PURE__ */ c(
                        "button",
                        {
                          type: "button",
                          className: `underline ${i ? "cursor-not-allowed" : "cursor-pointer"}`,
                          onClick: Z,
                          disabled: i,
                          children: "browse"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ N("p", { className: "pt-1 text-caption font-regular text-indigo-600", children: [
                      "Max file size: ",
                      K1(l)
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ c("input", { ...D(), "data-testid": z1.input }),
              !v?.current && k
            ]
          }
        ),
        (E ?? d) && /* @__PURE__ */ c(
          cn,
          {
            text: E ?? d,
            state: E ? Ee.ERROR : r,
            disabled: i,
            testIdOverride: { message: m }
          }
        )
      ] }),
      v?.current && su(k, v.current),
      !w && /* @__PURE__ */ c("div", { className: "flex flex-col gap-3 mt-3", children: t.map((A, I) => /* @__PURE__ */ c(
        S7,
        {
          fileName: A.name,
          fileSize: A.size,
          onRemove: () => n(t.filter((P) => P !== A)),
          itemsRemovable: p
        },
        `selected-file-${I}`
      )) })
    ] });
  }
), Ir = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
}, x7 = {
  [Ir.SMALL]: "h-1",
  [Ir.MEDIUM]: "h-1.5",
  [Ir.LARGE]: "h-2"
}, R7 = (e) => Math.round(Math.min(Math.max(e, 0), 100)), XT = ({
  fillPercent: e = 0,
  fillColor: t,
  backgroundColor: n,
  size: r = Ir.MEDIUM
}) => {
  const o = R7(e), i = x7[r];
  return /* @__PURE__ */ N("div", { className: "w-full relative bg-inherit", children: [
    /* @__PURE__ */ c(
      "div",
      {
        className: `absolute w-full rounded-full ${i} ${n}`,
        style: { backgroundColor: n }
      }
    ),
    /* @__PURE__ */ c(
      "div",
      {
        className: `absolute rounded-full transition-all ${i}`,
        style: { width: `${o}%`, backgroundColor: t }
      }
    )
  ] });
};
function _s(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function T7(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Y1(...e) {
  return (t) => e.forEach((n) => T7(n, t));
}
function q1(...e) {
  return a.useCallback(Y1(...e), e);
}
function X1(e, t = []) {
  let n = [];
  function r(i, s) {
    const l = a.createContext(s), u = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: w, children: g, ...v } = f, p = w?.[e][u] || l, m = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ c(p.Provider, { value: m, children: g });
    }
    function h(f, w) {
      const g = w?.[e][u] || l, v = a.useContext(g);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, h];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(l) {
      const u = l?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return o.scopeName = e, [r, A7(o, ...t)];
}
function A7(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Z1 = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(k7);
  if (i) {
    const s = i.props.children, l = o.map((u) => u === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ c(Os, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ c(Os, { ...r, ref: t, children: n });
});
Z1.displayName = "Slot";
var Os = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = M7(n);
    return a.cloneElement(n, {
      ...P7(r, n.props),
      // @ts-ignore
      ref: t ? Y1(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Os.displayName = "SlotClone";
var N7 = ({ children: e }) => /* @__PURE__ */ c(ae, { children: e });
function k7(e) {
  return a.isValidElement(e) && e.type === N7;
}
function P7(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function M7(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var _7 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ec = _7.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, l = i ? Z1 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function J1(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => t.current?.(...n), []);
}
function O7({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = D7({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, l = J1(n), u = a.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        o(d);
    },
    [i, e, o, l]
  );
  return [s, u];
}
function D7({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = J1(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var $7 = a.createContext(void 0);
function L7(e) {
  const t = a.useContext($7);
  return e || t || "ltr";
}
var I7 = globalThis?.document ? a.useLayoutEffect : () => {
};
function F7(e) {
  const [t, n] = a.useState(void 0);
  return I7(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, l;
        if ("borderBoxSize" in i) {
          const u = i.borderBoxSize, d = Array.isArray(u) ? u[0] : u;
          s = d.inlineSize, l = d.blockSize;
        } else
          s = e.offsetWidth, l = e.offsetHeight;
        n({ width: s, height: l });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function W7(e) {
  const t = a.useRef({ value: e, previous: e });
  return a.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var tc = "Radio", [B7, Q1] = X1(tc), [H7, V7] = B7(tc), e0 = a.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: i,
      disabled: s,
      value: l = "on",
      onCheck: u,
      ...d
    } = e, [h, f] = a.useState(null), w = q1(t, (p) => f(p)), g = a.useRef(!1), v = h ? !!h.closest("form") : !0;
    return /* @__PURE__ */ N(H7, { scope: n, checked: o, disabled: s, children: [
      /* @__PURE__ */ c(
        ec.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": r0(o),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...d,
          ref: w,
          onClick: _s(e.onClick, (p) => {
            o || u?.(), v && (g.current = p.isPropagationStopped(), g.current || p.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ c(
        U7,
        {
          control: h,
          bubbles: !g.current,
          name: r,
          value: l,
          checked: o,
          required: i,
          disabled: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
e0.displayName = tc;
var t0 = "RadioIndicator", n0 = a.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...o } = e, i = V7(t0, n);
    return /* @__PURE__ */ c(be, { present: r || i.checked, children: /* @__PURE__ */ c(
      ec.span,
      {
        "data-state": r0(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
n0.displayName = t0;
var U7 = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, i = a.useRef(null), s = W7(n), l = F7(t);
  return a.useEffect(() => {
    const u = i.current, d = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== n && f) {
      const w = new Event("click", { bubbles: r });
      f.call(u, n), u.dispatchEvent(w);
    }
  }, [s, n, r]), /* @__PURE__ */ c(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function r0(e) {
  return e ? "checked" : "unchecked";
}
var j7 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], nc = "RadioGroup", [G7, ZT] = X1(nc, [
  Eo,
  Q1
]), o0 = Eo(), i0 = Q1(), [z7, K7] = G7(nc), s0 = a.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: i,
      required: s = !1,
      disabled: l = !1,
      orientation: u,
      dir: d,
      loop: h = !0,
      onValueChange: f,
      ...w
    } = e, g = o0(n), v = L7(d), [p, m] = O7({
      prop: i,
      defaultProp: o,
      onChange: f
    });
    return /* @__PURE__ */ c(
      z7,
      {
        scope: n,
        name: r,
        required: s,
        disabled: l,
        value: p,
        onValueChange: m,
        children: /* @__PURE__ */ c(
          Vd,
          {
            asChild: !0,
            ...g,
            orientation: u,
            dir: v,
            loop: h,
            children: /* @__PURE__ */ c(
              ec.div,
              {
                role: "radiogroup",
                "aria-required": s,
                "aria-orientation": u,
                "data-disabled": l ? "" : void 0,
                dir: v,
                ...w,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
s0.displayName = nc;
var a0 = "RadioGroupItem", c0 = a.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = e, i = K7(a0, n), s = i.disabled || r, l = o0(n), u = i0(n), d = a.useRef(null), h = q1(t, d), f = i.value === o.value, w = a.useRef(!1);
    return a.useEffect(() => {
      const g = (p) => {
        j7.includes(p.key) && (w.current = !0);
      }, v = () => w.current = !1;
      return document.addEventListener("keydown", g), document.addEventListener("keyup", v), () => {
        document.removeEventListener("keydown", g), document.removeEventListener("keyup", v);
      };
    }, []), /* @__PURE__ */ c(
      Ud,
      {
        asChild: !0,
        ...l,
        focusable: !s,
        active: f,
        children: /* @__PURE__ */ c(
          e0,
          {
            disabled: s,
            required: i.required,
            checked: f,
            ...u,
            ...o,
            name: i.name,
            ref: h,
            onCheck: () => i.onValueChange(o.value),
            onKeyDown: _s((g) => {
              g.key === "Enter" && g.preventDefault();
            }),
            onFocus: _s(o.onFocus, () => {
              w.current && d.current?.click();
            })
          }
        )
      }
    );
  }
);
c0.displayName = a0;
var Y7 = "RadioGroupIndicator", l0 = a.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, o = i0(n);
    return /* @__PURE__ */ c(n0, { ...o, ...r, ref: t });
  }
);
l0.displayName = Y7;
var q7 = s0, X7 = c0, Z7 = l0;
const J7 = "flex justify-center items-center bg-white w-4 h-4 rounded-full shadow-sm border focus:outline-none focus:ring-2 focus:ring-indigo-200", Q7 = "flex items-center justify-center w-2.5 h-2.5 rounded-full", JT = ({
  title: e,
  ariaLabel: t,
  radioButtons: n,
  selectedKey: r,
  onChange: o,
  disabled: i = !1
}) => /* @__PURE__ */ c("fieldset", { children: /* @__PURE__ */ N(
  q7,
  {
    value: r,
    className: "flex flex-col gap-1.5",
    "aria-label": t,
    onValueChange: o,
    disabled: i,
    children: [
      e && /* @__PURE__ */ c("legend", { children: /* @__PURE__ */ c(Cn, { text: e, disabled: i }) }),
      n.map(({ key: s, label: l, disabled: u }) => {
        const d = i || u;
        return /* @__PURE__ */ N("div", { className: "flex items-center", children: [
          /* @__PURE__ */ c(
            X7,
            {
              id: s,
              value: s,
              className: F(J7, d ? "border-khaki-200" : "border-khaki-500"),
              disabled: u,
              children: /* @__PURE__ */ c(
                Z7,
                {
                  className: F(Q7, d ? "bg-khaki-400" : "bg-khaki-800")
                }
              )
            }
          ),
          /* @__PURE__ */ c(
            qs,
            {
              className: F("ml-2.5", d ? "text-khaki-400" : "text-khaki-800 cursor-pointer"),
              htmlFor: s,
              children: l
            }
          )
        ] }, s);
      })
    ]
  }
) });
export {
  Qt as AVATAR_SIZE,
  uT as AlertModal,
  Zu as Avatar,
  fT as AvatarGroup,
  hr as BANNER_TYPE,
  ye as BUTTON_ICON_POSITION,
  ge as BUTTON_SIZE,
  et as BUTTON_VARIANT,
  dg as Banner,
  Me as Button,
  en as CALLOUT_SEVERITY,
  pT as Callout,
  sd as Checkbox,
  Rn as DROPDOWN_ITEM_TYPES,
  Lf as DROPDOWN_MENU_ALIGNMENT,
  Zy as DROPDOWN_MENU_POSITION,
  Jy as DropdownMenu,
  z1 as FILE_SELECTOR_TEST_IDS,
  mT as FLAT_ACTION_BUTTON_VARIANT,
  qT as FileSelector,
  Ff as FlatActionButton,
  Ee as INPUT_STATES,
  wT as Input,
  Pr as LOADER_SIZES,
  ag as LOADER_TEST_ID,
  Cn as Label,
  Dn as Loader,
  Mm as MODAL_SIZE,
  pg as Modal,
  yT as ModalProvider,
  ET as NavBack,
  bT as NavContent,
  ST as NavFooter,
  xT as NavHeader,
  RT as NavLink,
  TT as NavSection,
  AT as Navigation,
  Ir as PROGRESS_BAR_SIZE,
  YT as Page,
  NT as ProfileDropdownMenu,
  kT as ProfileDropdownMenuDivider,
  PT as ProfileDropdownMenuLink,
  XT as ProgressBar,
  JT as RadioGroup,
  os as SEARCH_TEST_IDS,
  pi as SELECT_TEST_IDS,
  Ve as SORT_DIRECTION,
  bb as Search,
  IT as Select,
  _T as SubNavDropdown,
  DT as SubNavLink,
  $T as SubNavLinkSkeleton,
  OT as SubNavMessageState,
  xe as TAG_COLOR,
  Vn as TAG_INPUT_TEST_IDS,
  Ot as TAG_SIZE,
  An as TAG_TEST_IDS,
  $r as TAG_VARIANT,
  Nn as TOAST_TEST_IDS,
  Ml as TOGGLE_TEST_IDS,
  L3 as TOOLTIP_ALIGNMENT,
  $3 as TOOLTIP_POSITION,
  FT as Table,
  BT as Tabs,
  Ua as Tag,
  jT as TagInput,
  x8 as TagInputAddNewTagText,
  GT as Textarea,
  VT as ToastProvider,
  KT as ToggleSwitch,
  Wn as Tooltip,
  CT as useModalContext,
  E8 as useToastContext
};
